import moment from "moment";

export const Workload_List_Response = {
  Limit: 10,
  PageNumber: 1,
  WorkloadSummaries: [
    {
      AnsweredQuestions: 57,
      CreatedAt: "2023-10-12 19:17:19",
      Description: "Acme Inc's primary application, Dev Environment",
      DiagramURL: null,
      Environment: "PREPRODUCTION",
      ImprovementStatus: "NOT_APPLICABLE",
      InSync: 1,
      Industry: null,
      IndustryType: null,
      Lenses: "AWS Well-Architected Framework",
      Owner: "Douglas",
      RegionCode: "us-east-1",
      RiskCounts: {
        High: 42,
        Medium: 12,
      },
      Scope: [
        {
          Applications: [
            "a6fcb744-5777-43ec-bfd3-2026b5749452",
            "be23455c-5361-427a-bbb4-b8af60d53c54",
          ],
          Department: "ae03391d-7ce9-4a73-adbf-61a3ed260e0f",
        },
      ],
      Status: "PENDING",
      TotalQuestions: 57,
      UpdatedAt: "2023-11-18 12:42:42",
      WorkloadArn:
        "arn:aws:wellarchitected:us-east-1:984532411092:workload/580c38257d8c018ec5a8585eb95a455d",
      WorkloadId: "580c38257d8c018ec5a8585eb95a455d",
      WorkloadName: "AcmeApp_Dev",
    },
    {
      AnsweredQuestions: 25,
      CreatedAt: "2023-09-26 19:38:07",
      Description: "Acme Inc's primary application, Staging Environment",
      DiagramURL: null,
      Environment: "PREPRODUCTION",
      ImprovementStatus: "NOT_APPLICABLE",
      InSync: 1,
      Industry: "Environmental_Protection",
      IndustryType: "Environmental_Protection",
      Lenses: "AWS Well-Architected Framework",
      Owner: "Marv",
      RegionCode: "us-east-1",
      RiskCounts: {
        High: 21,
        Medium: 4,
      },
      Scope: [
        {
          AccountNumber: "100197857259",
          Regions: ["us-east-1"],
        },
      ],
      Status: "PENDING",
      TotalQuestions: 60,
      UpdatedAt: "2023-11-18 12:44:17",
      WorkloadArn:
        "arn:aws:wellarchitected:us-east-1:984532411092:workload/70e6ae7a140de130360d1d6ad17e5467",
      WorkloadId: "70e6ae7a140de130360d1d6ad17e5467",
      WorkloadName: "AcmeApp_Staging",
    },
    {
      AnsweredQuestions: 10,
      CreatedAt: "2023-09-21 01:00:51",
      Description: "Acme Inc's primary application, Prod Environment",
      DiagramURL: null,
      Environment: "PREPRODUCTION",
      ImprovementStatus: "NOT_APPLICABLE",
      InSync: 0,
      Industry: "Power_Utilities_Other",
      IndustryType: "Power_Utilities",
      Lenses: "AWS Well-Architected Framework",
      Owner: "Adams",
      RegionCode: "ap-south-1",
      RiskCounts: {
        High: 7,
        Medium: 3,
      },
      Scope: [
        {
          Applications: ["86bf0411-eaea-41b6-b173-a3a3bd55a794"],
          Department: "7bc676d3-deff-4c6c-973b-ac87cfcb75f5",
        },
      ],
      Status: "PENDING",
      TotalQuestions: 60,
      UpdatedAt: "2023-11-18 12:39:45",
      WorkloadArn:
        "arn:aws:wellarchitected:ap-south-1:984532411092:workload/74f82e17cc7736c5203ad1774f5c25f6",
      WorkloadId: "74f82e17cc7736c5203ad1774f5c25f6",
      WorkloadName: "AcmeApp_Prod",
    },
    {
      AnsweredQuestions: 0,
      CreatedAt: "2023-09-18 10:51:02",
      Description: "Acme Inc's  research team's development environment ",
      DiagramURL: null,
      Environment: "PREPRODUCTION",
      ImprovementStatus: "NOT_APPLICABLE",
      InSync: 0,
      Industry: "Environmental_Protection",
      IndustryType: "Environmental_Protection",
      Lenses: "AWS Well-Architected Framework",
      Owner: "Tagore",
      RegionCode: "us-east-1",
      RiskCounts: {
        High: 0,
        Medium: 0,
      },
      Scope: [
        {
          Applications: ["33984c96-720a-40c9-891d-1b07d9f18611"],
          Department: "7bc676d3-deff-4c6c-973b-ac87cfcb75f5",
        },
      ],
      Status: "PENDING",
      TotalQuestions: 60,
      UpdatedAt: "2023-11-18 06:38:30",
      WorkloadArn:
        "arn:aws:wellarchitected:us-east-1:984532411092:workload/77d6a9af2e801f2d1c2a69d123f594eb",
      WorkloadId: "77d6a9af2e801f2d1c2a69d123f594eb",
      WorkloadName: "Acme_Research_App",
    },
  ],
};

export const Comleted_Workload_List_Response = {
  Limit: 10,
  PageNumber: 1,
  WorkloadSummaries: [],
};

export const Workload_Count_Summary_MockData = (pendingCount) => {
  return [
    {
      Status: "COMPLETED",
      StatusCount: 1,
    },
    {
      Status: "PENDING",
      StatusCount: 4,
    },
  ];
};

export const Workload_Checks_Summary_MockData = {
  CheckExecutionStatus: "COMPLETED",
  Error: 2,
  Failed: 215,
  LastRun: moment().subtract(1, "days"),
  Passed: 217,
};

export const Pending_Workload_Pillar_Summary_MockData = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2023-04-10",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 10,
        MEDIUM: 0,
        NONE: 1,
        NOT_APPLICABLE: 0,
        UNANSWERED: 0,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 3,
        MEDIUM: 2,
        NONE: 3,
        NOT_APPLICABLE: 0,
        UNANSWERED: 0,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 3,
        MEDIUM: 1,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 7,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 3,
        NONE: 3,
        NOT_APPLICABLE: 0,
        UNANSWERED: 0,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 16,
    MEDIUM: 6,
    NONE: 7,
    NOT_APPLICABLE: 0,
    UNANSWERED: 31,
  },
  UpdatedAt: moment().subtract(1, "days"),
  WorkloadSummary: {
    AnsweredQuestions: 29,
    CreatedAt: moment().subtract(1, "days"),
    Description: "HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: "Infotech_Other",
    IndustryType: "InfoTech",
    Lenses: "AWS Well-Architected Framework",
    Owner: "Cibi",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 16,
      Medium: 6,
    },
    Scope: [
      {
        AccountNumber: "181570489212",
        Regions: ["us-east-1"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 60,
    UpdatedAt: moment().subtract(1, "days"),
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:984532411092:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Workload_Check_Performace_Efficiency_MockData = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 17,
  Passed: 20,
};

export const Workload_Checks_Security_Mockdata = {
  CheckExecutionStatus: "COMPLETED",
  Error: 1,
  Failed: 123,
  Passed: 135,
};

export const Workload_Reliability_Checks_MockData = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 42,
  Passed: 27,
};

export const Workload_CostOptimization_Checks_MockData = {
  CheckExecutionStatus: "COMPLETED",
  Error: 1,
  Failed: 10,
  Passed: 11,
};

export const Workload_Operational_Excellence_Checks_MockData = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 13,
  Passed: 18,
};

export const Workload_Sustainability_Checks_MockData = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 10,
  Passed: 6,
};

export const AcmeAppDev_Workload_Checks_Summary_MockData = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0, // Adjusted based on the image, no errors on summary level
  Failed: 33, // Total Failed from the workload level summary
  LastRun: moment().subtract(1, "days"),
  Passed: 340, // Total Passed from the workload level summary
};

export const AcmeAppDev_Workload_Reliability_Checks_MockData = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0, // Adjusted based on the image
  Failed: 4, // 'Issues' found under Reliability
  Passed: 64, // Assuming Passed + Failed should equal the number of questions, which is 13
};

export const AcmeAppDev_Workload_Sustainability_Checks_MockData = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0, // Adjusted based on the image
  Failed: 0, // 'Issues' found under Sustainability
  Passed: 16, // Assuming Passed + Failed should equal the number of questions, which is 6
};

export const AcmeAppDev_Workload_Operational_Excellence_Checks_MockData = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0, // Adjusted based on the image
  Failed: 0, // No 'Issues' found under Operational Excellence
  Passed: 11, // Assuming Passed + Failed should equal the number of questions, which is 11
};

export const AcmeAppDev_Workload_CostOptimization_Checks_MockData = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0, // 'Medium Risk' issues under Cost Optimization
  Failed: 0, // 'High Risk' issues under Cost Optimization
  Passed: 22, // Assuming Passed + Error + Failed should equal the number of questions, which is 11
};

export const AcmeAppDev_Workload_Checks_Security_Mockdata = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0, // 'Medium Risk' issues under Security
  Failed: 29, // 'High Risk' issues under Security
  Passed: 229, // Assuming Passed + Error + Failed should equal the number of questions, which is 11
};

export const AcmeAppDev_Workload_Check_Performace_Efficiency_MockData = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0, // Adjusted based on the image
  Failed: 0, // No 'Issues' found under Performance Efficiency
  Passed: 4, // Assuming Passed + Failed should equal the number of questions, which is 5
};


export const Workload_Limit_MockData = {
  Limit: 5,
  MilestonesList: [],
  PageNumber: 1,
  TotalRecords: 0,
};

export const Workload_MetaData_MockData = {
  ImprovementStatus: {
    Complete: "COMPLETE",
    "In Progress": "IN_PROGRESS",
    None: "NOT_APPLICABLE",
    "Not Started": "NOT_STARTED",
    "Risk Acknowledged": "RISK_ACKNOWLEDGED",
  },
  Industry: {
    Agriculture: {
      Agriculture: "Agriculture",
    },
    Automotive: {
      Automotive: "Automotive",
    },
    Design_And_Engineering: {
      "Architecture & Construction": "Architecture_Construction",
      "Design and Engineering - Other": "Design_And_Engineering_Other",
      "Electronic Design Automation": "Electronic_Design_Automation",
    },
    Digital_Advertising: {
      "Ad Exchange": "Ad_Exchange",
      "Ad Network": "Ad_Network",
      Advertiser: "Advertiser",
      Agency: "Agency",
      "Data Provider": "Data_Provider",
      "Digital Advertising - Other": "Digital_Advertising_Other",
      Display: "Display",
      Mobile: "Mobile",
      Publisher: "Publisher",
      Search: "Search",
      Social: "Social",
      Video: "Video",
    },
    Education: {
      "Education - Other": "Education_Other",
      "Higher Ed & Research": "Higher_Ed_Research",
      "Primary & K-12": "Primary_K_12",
      Publishers: "Publishers",
      "Technology & Tools": "Technology_Tools",
    },
    Environmental_Protection: {
      "Environmental Protection": "Environmental_Protection",
    },
    Financial_Services: {
      "Capital Markets/Securities": "Capital_Markets_Securities",
      "Commercial Banking & Payments": "Commercial_Banking_Payments",
      "Financial Services - Other": "Financial_Services_Other",
      "Insurance (other than health)": "Insurance_Other_Than_Health",
      "Service Providers": "Service_Providers",
    },
    Gaming: {
      "Advertising, User Acquisition, and Monetization":
        "Advertising_User_Acquisition_And_Monetization",
      "Game Distribution": "Game_Distribution",
      "Game Production & Tools": "Game_Production_Tools",
      "Game Publishing": "Game_Publishing",
      "Gaming - Other": "Gaming_Other",
      "Gaming Platforms": "Gaming_Platforms",
      "Live Ops and Business Intelligence":
        "Live_Ops_And_Business_Intelligence",
    },
    General_Public_Services: {
      "General Public Services": "General_Public_Services",
    },
    Healthcare: {
      "Healthcare - Other": "Healthcare_Other",
      "Healthcare Providers": "Healthcare_Providers",
      "Independent Software Vendor - Consumer":
        "Independent_Software_Vendor_Consumer",
      "Independent Software Vendor - Providers":
        "Independent_Software_Vendor_Providers",
      "Independent Software Vendor - Public, Private Health Insurer or Health Authority":
        "Independent_Software_Vendor_Public_Private_Health_Insurer_Or_Health_Authority",
      "Insurer - Public, Private Health Insurer or Health Authority":
        "Insurer_Public_Private_Health_Insurer_Or_Health_Authority",
      "Solution Integrator": "Solution_Integrator",
    },
    Hospitality: {
      "Food Services": "Food_Services",
      "Hospitality - Other": "Hospitality_Other",
      "Hotels & Accommodations": "Hotels_Accommodations",
    },
    InfoTech: {
      "Computer & Electronics": "Computer_Electronics",
      "Infotech - Other": "Infotech_Other",
      Internet: "Internet",
      Semiconductors: "Semiconductors",
      Software: "Software",
    },
    Justice_And_Public_Safety: {
      "Justice and Public Safety": "Justice_And_Public_Safety",
    },
    Life_Sciences: {
      BioPharma: "BioPharma",
      Genomics: "Genomics",
      "Independent Software Vendor - Biopharma, Medical Device":
        "Independent_Software_Vendor_Biopharma_Medical_Device",
      "Independent Software Vendor - Genomics":
        "Independent_Software_Vendor_Genomics",
      "Life Sciences - Other": "Life_Sciences_Other",
      "Medical Device Manufacturer": "Medical_Device_Manufacturer",
      "Solution Integrator": "Solution_Integrator",
    },
    Manufacturing: {
      Aerospace: "Aerospace",
      Chemicals: "Chemicals",
      "Consumer/Packaged Goods": "Consumer_Packaged_Goods",
      "Food & Beverage": "Food_Beverage",
      "High Tech Manufacturing": "High_Tech_Manufacturing",
      "Industrial Manufacturing": "Industrial_Manufacturing",
      "Manufacturing - Other": "Manufacturing_Other",
      Metals: "Metals",
    },
    Media_Entertainment: {
      "Content Delivery: Broadcast & Over-the-top (OTT)":
        "Content_Delivery_Broadcast_Over_The_Top_OTT",
      "Content Production": "Content_Production",
      "Digital Publishing": "Digital_Publishing",
      "Media & Entertainment- Other": "Media_Entertainment_Other",
    },
    Mining_Resources: {
      Mining: "Mining",
      "Mining & Resources - Other": "Mining_Resources_Other",
      "Natural Resources": "Natural_Resources",
    },
    Oil_Gas: {
      "Downstream Oil & Gas Operations": "Downstream_Oil_Gas_Operations",
      "Integrated Oil & Gas Operations": "Integrated_Oil_Gas_Operations",
      "Midstream Oil & Gas Operations": "Midstream_Oil_Gas_Operations",
      "Oil & Gas - Other": "Oil_Gas_Other",
      "Oilfield Services & Equipment": "Oilfield_Services_Equipment",
      "Upstream Oil & Gas Operations": "Upstream_Oil_Gas_Operations",
    },
    Other: {},
    Power_Utilities: {
      "Diversified Utilities": "Diversified_Utilities",
      "Electric Utilities": "Electric_Utilities",
      "Independent Power Producers (IPP)": "Independent_Power_Producers_IPP",
      "Natural Gas Utilities": "Natural_Gas_Utilities",
      "Power & Utilities - Other": "Power_Utilities_Other",
      "Utility Services & Equipment": "Utility_Services_Equipment",
    },
    Professional_Services: {
      Accounting: "Accounting",
      "Consulting services/outsourcing": "Consulting_Services_Outsourcing",
      "Customer care": "Customer_Care",
      Legal: "Legal",
      "Professional Services - Other": "Professional_Services_Other",
      "Real Estate": "Real_Estate",
    },
    Real_Estate_Construction: {
      Construction: "Construction",
      "Real Estate": "Real_Estate",
      "Real Estate & Construction - Other": "Real_Estate_Construction_Other",
    },
    Retail_Wholesale: {
      "General Retail": "General_Retail",
      Grocery: "Grocery",
      "Retail & Wholesale - Other": "Retail_Wholesale_Other",
      "Specialty/Luxury": "Specialty_Luxury",
      Wholesale: "Wholesale",
      eCommerce: "ECommerce",
    },
    Social_Protection: {
      "Social Protection": "Social_Protection",
    },
    Telecommunications: {
      "Communication Service Provider - Communication as a Service (CaaS)":
        "Communication_Service_Provider_Communication_As_A_Service_CaaS",
      "Communication Service Provider Carrier - Infrastructure operator":
        "Communication_Service_Provider_Carrier_Infrastructure_Operator",
      "Communication Service Provider Carrier - Network provider":
        "Communication_Service_Provider_Carrier_Network_Provider",
      "Communication Service Provider Carrier - Satellite":
        "Communication_Service_Provider_Carrier_Satellite",
      "Communication Service Provider Carrier - Telecom":
        "Communication_Service_Provider_Carrier_Telecom",
      "Supplier, End-user side": "Supplier_End_User_Side",
      "Supplier, Provider side": "Supplier_Provider_Side",
      "Telecom Systems Integrator (SI) & Managed Service Provider (MSP)":
        "Telecom_Systems_Integrator_SI_Managed_Service_Provider_MSP",
      "Telecommunications - Other": "Telecommunications_Other",
    },
    Travel_Transportation_Logistics: {
      Airlines: "Airlines",
      Airports: "Airports",
      "Highway and Motor": "Highway_And_Motor",
      "Marine & Ports": "Travel_Marine_Ports",
      "Metropolitan and National Transit": "Metropolitan_And_National_Transit",
      "Postal/Intermodal": "Postal_Intermodal",
      Rail: "Rail",
      "Travel, Transportation & Logistics - Other":
        "Travel_Transportation_Logistics_Other",
      "Warehousing & Distribution": "Warehousing_Distribution",
    },
  },
  IndustryTypes: {
    "-": "-",
    Agriculture: "Agriculture",
    Automotive: "Automotive",
    Defense: "Defense",
    "Design and Engineering": "Design_And_Engineering",
    "Digital Advertising": "Digital_Advertising",
    Education: "Education",
    "Environmental Protection": "Environmental_Protection",
    "Financial Services": "Financial_Services",
    Gaming: "Gaming",
    "General Public Services": "General_Public_Services",
    Healthcare: "Healthcare",
    Hospitality: "Hospitality",
    InfoTech: "InfoTech",
    "Justice and Public Safety": "Justice_And_Public_Safety",
    "Life Sciences": "Life_Sciences",
    Manufacturing: "Manufacturing",
    "Media & Entertainment": "Media_Entertainment",
    "Mining & Resources": "Mining_Resources",
    "Oil & Gas": "Oil_Gas",
    Other: "Other",
    "Power & Utilities": "Power_Utilities",
    "Professional Services": "Professional_Services",
    "Real Estate & Construction": "Real_Estate_Construction",
    "Retail & Wholesale": "Retail_Wholesale",
    "Social Protection": "Social_Protection",
    Telecommunications: "Telecommunications",
    "Travel, Transportation & Logistics": "Travel_Transportation_Logistics",
  },
  Reasons: {
    "-": "NONE",
    "Architecture Constraints": "ARCHITECTURE_CONSTRAINTS",
    "Business Priorities": "BUSINESS_PRIORITIES",
    Other: "OTHER",
    "Out of Scope": "OUT_OF_SCOPE",
  },
};

export const Day2_Context_MockData = {
  Items: [],
};

export const Security_Question_List = [
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "sec_securely_operate_multi_accounts",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_securely_operate_aws_account",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_securely_operate_updated_threats",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_securely_operate_updated_recommendations",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sec_securely_operate_multi_accounts",
        Description:
          " Establish common guardrails and isolation between environments (such as production, development, and test) and workloads through a multi-account strategy. Account-level separation is strongly recommended, as it provides a strong isolation boundary for security, billing, and access. ",
        Title: "Separate workloads using accounts",
      },
      {
        ChoiceId: "sec_securely_operate_aws_account",
        Description:
          " The root user is the most privileged user in an AWS account, with full administrative access to all resources within the account, and in some cases cannot be constrained by security policies. Disabling programmatic access to the root user, establishing appropriate controls for the root user, and avoiding routine use of the root user helps reduce the risk of inadvertent exposure of the root credentials and subsequent compromise of the cloud environment. ",
        Title: "Secure account root user and properties",
      },
      {
        ChoiceId: "sec_securely_operate_control_objectives",
        Description:
          " Based on your compliance requirements and risks identified from your threat model, derive and validate the control objectives and controls that you need to apply to your workload. Ongoing validation of control objectives and controls help you measure the effectiveness of risk mitigation. ",
        Title: "Identify and validate control objectives",
      },
      {
        ChoiceId: "sec_securely_operate_updated_threats",
        Description:
          " To help you define and implement appropriate controls, recognize attack vectors by staying up to date with the latest security threats. Consume AWS Managed Services to make it easier to receive notification of unexpected or unusual behavior in your AWS accounts. Investigate using AWS Partner tools or third-party threat information feeds as part of your security information flow. The Common Vulnerabilities and Exposures (CVE) List list contains publicly disclosed cyber security vulnerabilities that you can use to stay up to date. ",
        Title: "Keep up-to-date with security threats ",
      },
      {
        ChoiceId: "sec_securely_operate_updated_recommendations",
        Description:
          " Stay up-to-date with both AWS and industry security recommendations to evolve the security posture of your workload. AWS Security Bulletins contain important information about security and privacy notifications. ",
        Title: "Keep up-to-date with security recommendations",
      },
      {
        ChoiceId: "sec_securely_operate_threat_model",
        Description:
          " Perform threat modeling to identify and maintain an up-to-date register of potential threats and associated mitigations for your workload. Prioritize your threats and adapt your security control mitigations to prevent, detect, and respond. Revisit and maintain this in the context of your workload, and the evolving security landscape. ",
        Title:
          "Identify threats and prioritize mitigations using a threat model",
      },
      {
        ChoiceId: "sec_securely_operate_implement_services_features",
        Description:
          " Evaluate and implement security services and features from AWS and AWS Partners that allow you to evolve the security posture of your workload. The AWS Security Blog highlights new AWS services and features, implementation guides, and general security guidance. What's New with AWS? is a great way to stay up to date with all new AWS features, services, and announcements. ",
        Title:
          "Evaluate and implement new security services and features regularly",
      },
      {
        ChoiceId: "sec_securely_operate_test_validate_pipeline",
        Description:
          " Establish secure baselines and templates for security mechanisms that are tested and validated as part of your build, pipelines, and processes. Use tools and automation to test and validate all security controls continuously. For example, scan items such as machine images and infrastructure-as-code templates for security vulnerabilities, irregularities, and drift from an established baseline at each stage. AWS CloudFormation Guard can help you verify that CloudFormation templates are safe, save you time, and reduce the risk of configuration error. ",
        Title:
          "Automate testing and validation of security controls in pipelines",
      },
      {
        ChoiceId: "sec_securely_operate_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "securely-operate",
    QuestionTitle: "How do you securely operate your workload?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "sec_securely_operate_multi_accounts",
      "sec_securely_operate_aws_account",
      "sec_securely_operate_updated_threats",
      "sec_securely_operate_updated_recommendations",
    ],
  },
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "sec_identities_unique",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_identities_secrets",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_identities_identity_provider",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_identities_audit",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sec_identities_enforce_mechanisms",
        Description:
          "Sign-ins (authentication using sign-in credentials) can present risks when not using mechanisms like multi-factor authentication (MFA), especially in situations where sign-in credentials have been inadvertently disclosed or are easily guessed. Use strong sign-in mechanisms to reduce these risks by requiring MFA and strong password policies. ",
        Title: "Use strong sign-in mechanisms",
      },
      {
        ChoiceId: "sec_identities_unique",
        Description:
          " When doing any type of authentication, it’s best to use temporary credentials instead of long-term credentials to reduce or eliminate risks, such as credentials being inadvertently disclosed, shared, or stolen. ",
        Title: "Use temporary credentials",
      },
      {
        ChoiceId: "sec_identities_secrets",
        Description:
          " A workload requires an automated capability to prove its identity to databases, resources, and third-party services. This is accomplished using secret access credentials, such as API access keys, passwords, and OAuth tokens. Using a purpose-built service to store, manage, and rotate these credentials helps reduce the likelihood that those credentials become compromised. ",
        Title: "Store and use secrets securely",
      },
      {
        ChoiceId: "sec_identities_identity_provider",
        Description:
          " For workforce identities, rely on an identity provider that enables you to manage identities in a centralized place. This makes it easier to manage access across multiple applications and services, because you are creating, managing, and revoking access from a single location. For example, if someone leaves your organization, you can revoke access for all applications and services (including AWS) from one location. This reduces the need for multiple credentials and provides an opportunity to integrate with existing human resources (HR) processes. ",
        Title: "Rely on a centralized identity provider",
      },
      {
        ChoiceId: "sec_identities_groups_attributes",
        Description:
          " As the number of users you manage grows, you will need to determine ways to organize them so that you can manage them at scale. Place users with common security requirements in groups defined by your identity provider, and put mechanisms in place to ensure that user attributes that may be used for access control (for example, department or location) are correct and updated. Use these groups and attributes to control access, rather than individual users. This allows you to manage access centrally by changing a user’s group membership or attributes once with a permission set, rather than updating many individual policies when a user’s access needs change.",
        Title: "Leverage user groups and attributes",
      },
      {
        ChoiceId: "sec_identities_audit",
        Description:
          "Audit and rotate credentials periodically to limit how long the credentials can be used to access your resources. Long-term credentials create many risks, and these risks can be reduced by rotating long-term credentials regularly.",
        Title: "Audit and rotate credentials periodically",
      },
      {
        ChoiceId: "sec_identities_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "identities",
    QuestionTitle: "How do you manage identities for people and machines?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "sec_identities_unique",
      "sec_identities_secrets",
      "sec_identities_identity_provider",
      "sec_identities_audit",
    ],
  },
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "sec_permissions_least_privileges",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_permissions_emergency_process",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_permissions_continuous_reduction",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_permissions_define_guardrails",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_permissions_lifecycle",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sec_permissions_define",
        Description:
          "Each component or resource of your workload needs to be accessed by administrators, end users, or other components. Have a clear definition of who or what should have access to each component, choose the appropriate identity type and method of authentication and authorization.",
        Title: "Define access requirements",
      },
      {
        ChoiceId: "sec_permissions_least_privileges",
        Description:
          " It's a best practice to grant only the access that identities require to perform specific actions on specific resources under specific conditions. Use group and identity attributes to dynamically set permissions at scale, rather than defining permissions for individual users. For example, you can allow a group of developers access to manage only resources for their project. This way, if a developer leaves the project, the developer’s access is automatically revoked without changing the underlying access policies. ",
        Title: "Grant least privilege access",
      },
      {
        ChoiceId: "sec_permissions_lifecycle",
        Description:
          " Integrate access controls with operator and application lifecycle and your centralized federation provider. For example, remove a user’s access when they leave the organization or change roles. ",
        Title: "Manage access based on life cycle",
      },
      {
        ChoiceId: "sec_permissions_analyze_cross_account",
        Description:
          "Continually monitor findings that highlight public and cross-account access. Reduce public access and cross-account access to only the specific resources that require this access.",
        Title: "Analyze public and cross-account access",
      },
      {
        ChoiceId: "sec_permissions_emergency_process",
        Description:
          " A process that allows emergency access to your workload in the unlikely event of an automated process or pipeline issue. This will help you rely on least privilege access, but ensure users can obtain the right level of access when they require it. For example, establish a process for administrators to verify and approve their request, such as an emergency AWS cross-account role for access, or a specific process for administrators to follow to validate and approve an emergency request. ",
        Title: "Establish emergency access process",
      },
      {
        ChoiceId: "sec_permissions_continuous_reduction",
        Description:
          "As your teams determine what access is required, remove unneeded permissions and establish review processes to achieve least privilege permissions. Continually monitor and remove unused identities and permissions for both human and machine access.",
        Title: "Reduce permissions continuously",
      },
      {
        ChoiceId: "sec_permissions_define_guardrails",
        Description:
          " Establish common controls that restrict access to all identities in your organization. For example, you can restrict access to specific AWS Regions, or prevent your operators from deleting common resources, such as an IAM role used for your central security team. ",
        Title: "Define permission guardrails for your organization",
      },
      {
        ChoiceId: "sec_permissions_share_securely",
        Description:
          "As the number of workloads grows, you might need to share access to resources in those workloads or provision the resources multiple times across multiple accounts. You might have constructs to compartmentalize your environment, such as having development, testing, and production environments. However, having separation constructs does not limit you from being able to share securely. By sharing components that overlap, you can reduce operational overhead and allow for a consistent experience without guessing what you might have missed while creating the same resource multiple times. ",
        Title: "Share resources securely within your organization",
      },
      {
        ChoiceId: "sec_permissions_share_securely_third_party",
        Description:
          " The security of your cloud environment doesn’t stop at your organization. Your organization might rely on a third party to manage a portion of your data. The permission management for the third-party managed system should follow the practice of just-in-time access using the principle of least privilege with temporary credentials. By working closely with a third party, you can reduce the scope of impact and risk of unintended access together. ",
        Title: "Share resources securely with a third party",
      },
      {
        ChoiceId: "sec_permissions_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "permissions",
    QuestionTitle: "How do you manage permissions for people and machines?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "sec_permissions_least_privileges",
      "sec_permissions_emergency_process",
      "sec_permissions_continuous_reduction",
      "sec_permissions_define_guardrails",
      "sec_permissions_lifecycle",
    ],
  },
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "sec_detect_investigate_events_analyze_all",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_detect_investigate_events_actionable_events",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_detect_investigate_events_auto_response",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sec_detect_investigate_events_app_service_logging",
        Description:
          "Retain security event logs from services and applications. This is a fundamental principle of security for audit, investigations, and operational use cases, and a common security requirement driven by governance, risk, and compliance (GRC) standards, policies, and procedures.",
        Title: "Configure service and application logging",
      },
      {
        ChoiceId: "sec_detect_investigate_events_analyze_all",
        Description:
          " Security operations teams rely on the collection of logs and the use of search tools to discover potential events of interest, which might indicate unauthorized activity or unintentional change. However, simply analyzing collected data and manually processing information is insufficient to keep up with the volume of information flowing from complex architectures. Analysis and reporting alone don’t facilitate the assignment of the right resources to work an event in a timely fashion. ",
        Title: "Analyze logs, findings, and metrics centrally",
      },
      {
        ChoiceId: "sec_detect_investigate_events_actionable_events",
        Description:
          " Create alerts that are sent to and can be actioned by your team. Ensure that alerts include relevant information for the team to take action. For each detective mechanism you have, you should also have a process, in the form of a runbook or playbook, to investigate. For example, when you enable Amazon GuardDuty, it generates different findings. You should have a runbook entry for each finding type, for example, if a trojan is discovered, your runbook has simple instructions that instruct someone to investigate and remediate. ",
        Title: "Implement actionable security events",
      },
      {
        ChoiceId: "sec_detect_investigate_events_auto_response",
        Description:
          " Using automation to investigate and remediate events reduces human effort and error, and enables you to scale investigation capabilities. Regular reviews will help you tune automation tools, and continuously iterate. ",
        Title: "Automate response to events",
      },
      {
        ChoiceId: "sec_detect_investigate_events_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "detect-investigate-events",
    QuestionTitle: "How do you detect and investigate security events?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "sec_detect_investigate_events_analyze_all",
      "sec_detect_investigate_events_actionable_events",
      "sec_detect_investigate_events_auto_response",
    ],
  },
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "sec_network_protection_layered",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_network_protection_inspection",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_network_protection_auto_protect",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sec_network_protection_create_layers",
        Description:
          "Group components that share sensitivity requirements into layers to minimize the potential scope of impact of unauthorized access. For example, a database cluster in a virtual private cloud (VPC) with no need for internet access should be placed in subnets with no route to or from the internet. Traffic should only flow from the adjacent next least sensitive resource. Consider a web application sitting behind a load balancer. Your database should not be accessible directly from the load balancer. Only the business logic or web server should have direct access to your database. ",
        Title: "Create network layers",
      },
      {
        ChoiceId: "sec_network_protection_layered",
        Description:
          "  When architecting your network topology, you should examine the connectivity requirements of each component. For example, if a component requires internet accessibility (inbound and outbound), connectivity to VPCs, edge services, and external data centers. ",
        Title: "Control traffic at all layers",
      },
      {
        ChoiceId: "sec_network_protection_inspection",
        Description:
          " Inspect and filter your traffic at each layer. You can inspect your VPC configurations for potential unintended access using VPC Network Access Analyzer. You can specify your network access requirements and identify potential network paths that do not meet them. For components transacting over HTTP-based protocols, a web application firewall can help protect from common attacks. AWS WAF is a web application firewall that lets you monitor and block HTTP(s) requests that match your configurable rules that are forwarded to an Amazon API Gateway API, Amazon CloudFront, or an Application Load Balancer. To get started with AWS WAF, you can use AWS Managed Rules in combination with your own, or use existing partner integrations. ",
        Title: "Implement inspection and protection",
      },
      {
        ChoiceId: "sec_network_protection_auto_protect",
        Description:
          " Automate protection mechanisms to provide a self-defending network based on threat intelligence and anomaly detection. For example, intrusion detection and prevention tools that can adapt to current threats and reduce their impact. A web application firewall is an example of where you can automate network protection, for example, by using the AWS WAF Security Automations solution to automatically block requests originating from IP addresses associated with known threat actors. ",
        Title: "Automate network protection",
      },
      {
        ChoiceId: "sec_network_protection_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "network-protection",
    QuestionTitle: "How do you protect your network resources?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "sec_network_protection_layered",
      "sec_network_protection_inspection",
      "sec_network_protection_auto_protect",
    ],
  },
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "sec_protect_compute_reduce_surface",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_protect_compute_implement_managed_services",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_protect_compute_actions_distance",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_protect_compute_auto_protection",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sec_protect_compute_vulnerability_management",
        Description:
          "Frequently scan and patch for vulnerabilities in your code, dependencies, and in your infrastructure to help protect against new threats.",
        Title: "Perform vulnerability management",
      },
      {
        ChoiceId: "sec_protect_compute_reduce_surface",
        Description:
          " Reduce your exposure to unintended access by hardening operating systems and minimizing the components, libraries, and externally consumable services in use. Start by reducing unused components, whether they are operating system packages or applications, for Amazon Elastic Compute Cloud (Amazon EC2)-based workloads, or external software modules in your code, for all workloads. You can find many hardening and security configuration guides for common operating systems and server software. For example, you can start with the Center for Internet Security and iterate.",
        Title: "Reduce attack surface",
      },
      {
        ChoiceId: "sec_protect_compute_actions_distance",
        Description:
          " Removing the ability for interactive access reduces the risk of human error, and the potential for manual configuration or management. For example, use a change management workflow to deploy Amazon Elastic Compute Cloud (Amazon EC2) instances using infrastructure-as-code, then manage Amazon EC2 instances using tools such as AWS Systems Manager instead of allowing direct access or through a bastion host. AWS Systems Manager can automate a variety of maintenance and deployment tasks, using features including automation workflows, documents (playbooks), and the run command. AWS CloudFormation stacks build from pipelines and can automate your infrastructure deployment and management tasks without using the AWS Management Console or APIs directly. ",
        Title: "Enable people to perform actions at a distance",
      },
      {
        ChoiceId: "sec_protect_compute_validate_software_integrity",
        Description:
          " Implement mechanisms (for example, code signing) to validate that the software, code and libraries used in the workload are from trusted sources and have not been tampered with. For example, you should verify the code signing certificate of binaries and scripts to confirm the author, and ensure it has not been tampered with since created by the author. AWS Signer can help ensure the trust and integrity of your code by centrally managing the code- signing lifecycle, including signing certification and public and private keys. You can learn how to use advanced patterns and best practices for code signing with AWS Lambda. Additionally, a checksum of software that you download, compared to that of the checksum from the provider, can help ensure it has not been tampered with. ",
        Title: "Validate software integrity",
      },
      {
        ChoiceId: "sec_protect_compute_implement_managed_services",
        Description:
          " Implement services that manage resources, such as Amazon Relational Database Service (Amazon RDS), AWS Lambda, and Amazon Elastic Container Service (Amazon ECS), to reduce your security maintenance tasks as part of the shared responsibility model. For example, Amazon RDS helps you set up, operate, and scale a relational database, automates administration tasks such as hardware provisioning, database setup, patching, and backups. This means you have more free time to focus on securing your application in other ways described in the AWS Well-Architected Framework. Lambda lets you run code without provisioning or managing servers, so you only need to focus on the connectivity, invocation, and security at the code level–not the infrastructure or operating system. ",
        Title: "Implement managed services",
      },
      {
        ChoiceId: "sec_protect_compute_auto_protection",
        Description:
          " Automate your protective compute mechanisms including vulnerability management, reduction in attack surface, and management of resources. The automation will help you invest time in securing other aspects of your workload, and reduce the risk of human error. ",
        Title: "Automate compute protection",
      },
      {
        ChoiceId: "sec_protect_compute_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-compute",
    QuestionTitle: "How do you protect your compute resources?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "sec_protect_compute_reduce_surface",
      "sec_protect_compute_implement_managed_services",
      "sec_protect_compute_actions_distance",
      "sec_protect_compute_auto_protection",
    ],
  },
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "sec_data_classification_define_protection",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_data_classification_lifecycle_management",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sec_data_classification_identify_data",
        Description:
          "It’s critical to understand the type and classification of data your workload is processing, the associated business processes, where the data is stored, and who is the data owner. You should also have an understanding of the applicable legal and compliance requirements of your workload, and what data controls need to be enforced. Identifying data is the first step in the data classification journey. ",
        Title: "Identify the data within your workload",
      },
      {
        ChoiceId: "sec_data_classification_define_protection",
        Description:
          " Protect data according to its classification level. For example, secure data classified as public by using relevant recommendations while protecting sensitive data with additional controls. ",
        Title: "Define data protection controls",
      },
      {
        ChoiceId: "sec_data_classification_lifecycle_management",
        Description:
          " Your defined lifecycle strategy should be based on sensitivity level as well as legal and organization requirements. Aspects including the duration for which you retain data, data destruction processes, data access management, data transformation, and data sharing should be considered. When choosing a data classification methodology, balance usability versus access. You should also accommodate the multiple levels of access and nuances for implementing a secure, but still usable, approach for each level. Always use a defense in depth approach and reduce human access to data and mechanisms for transforming, deleting, or copying data. For example, require users to strongly authenticate to an application, and give the application, rather than the users, the requisite access permission to perform action at a distance. In addition, ensure that users come from a trusted network path and require access to the decryption keys. Use tools, such as dashboards and automated reporting, to give users information from the data rather than giving them direct access to the data. ",
        Title: "Define data lifecycle management",
      },
      {
        ChoiceId: "sec_data_classification_auto_classification",
        Description:
          " Automating the identification and classification of data can help you implement the correct controls. Using automation for this instead of direct access from a person reduces the risk of human error and exposure. You should evaluate using a tool, such as Amazon Macie, that uses machine learning to automatically discover, classify, and protect sensitive data in AWS. Amazon Macie recognizes sensitive data, such as personally identifiable information (PII) or intellectual property, and provides you with dashboards and alerts that give visibility into how this data is being accessed or moved. ",
        Title: "Automate identification and classification",
      },
      {
        ChoiceId: "sec_data_classification_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "data-classification",
    QuestionTitle: "How do you classify your data?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "sec_data_classification_define_protection",
      "sec_data_classification_lifecycle_management",
    ],
  },
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "sec_protect_data_rest_encrypt",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_protect_data_rest_access_control",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_protect_data_rest_use_people_away",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_protect_data_rest_automate_protection",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sec_protect_data_rest_key_mgmt",
        Description:
          " By defining an encryption approach that includes the storage, rotation, and access control of keys, you can help provide protection for your content against unauthorized users and against unnecessary exposure to authorized users. AWS Key Management Service (AWS KMS) helps you manage encryption keys and integrates with many AWS services. This service provides durable, secure, and redundant storage for your AWS KMS keys. You can define your key aliases as well as key-level policies. The policies help you define key administrators as well as key users. Additionally, AWS CloudHSM is a cloud-based hardware security module (HSM) that enables you to easily generate and use your own encryption keys in the AWS Cloud. It helps you meet corporate, contractual, and regulatory compliance requirements for data security by using FIPS 140-2 Level 3 validated HSMs. ",
        Title: "Implement secure key management",
      },
      {
        ChoiceId: "sec_protect_data_rest_encrypt",
        Description:
          " You should enforce the use of encryption for data at rest. Encryption maintains the confidentiality of sensitive data in the event of unauthorized access or accidental disclosure. ",
        Title: "Enforce encryption at rest",
      },
      {
        ChoiceId: "sec_protect_data_rest_access_control",
        Description:
          " To help protect your data at rest, enforce access control using mechanisms, such as isolation and versioning, and apply the principle of least privilege. Prevent the granting of public access to your data. ",
        Title: "Enforce access control",
      },
      {
        ChoiceId: "sec_protect_data_rest_use_people_away",
        Description:
          " Keep all users away from directly accessing sensitive data and systems under normal operational circumstances. For example, use a change management workflow to manage Amazon Elastic Compute Cloud (Amazon EC2) instances using tools instead of allowing direct access or a bastion host. This can be achieved using AWS Systems Manager Automation, which uses automation documents that contain steps you use to perform tasks. These documents can be stored in source control, be peer reviewed before running, and tested thoroughly to minimize risk compared to shell access. Business users could have a dashboard instead of direct access to a data store to run queries. Where CI/CD pipelines are not used, determine which controls and processes are required to adequately provide a normally disabled break-glass access mechanism. ",
        Title: "Use mechanisms to keep people away from data",
      },
      {
        ChoiceId: "sec_protect_data_rest_automate_protection",
        Description:
          " Use automated tools to validate and enforce data at rest controls continuously, for example, verify that there are only encrypted storage resources. You can automate validation that all EBS volumes are encrypted using AWS Config Rules. AWS Security Hub can also verify several different controls through automated checks against security standards. Additionally, your AWS Config Rules can automatically remediate noncompliant resources. ",
        Title: "Automate data at rest protection",
      },
      {
        ChoiceId: "sec_protect_data_rest_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-data-rest",
    QuestionTitle: "How do you protect your data at rest?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "sec_protect_data_rest_encrypt",
      "sec_protect_data_rest_access_control",
      "sec_protect_data_rest_use_people_away",
      "sec_protect_data_rest_automate_protection",
    ],
  },
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "sec_protect_data_transit_encrypt",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_protect_data_transit_authentication",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_protect_data_transit_auto_unintended_access",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sec_protect_data_transit_key_cert_mgmt",
        Description:
          " Store encryption keys and certificates securely and rotate them at appropriate time intervals with strict access control. The best way to accomplish this is to use a managed service, such as AWS Certificate Manager (ACM). It lets you easily provision, manage, and deploy public and private Transport Layer Security (TLS) certificates for use with AWS services and your internal connected resources. TLS certificates are used to secure network communications and establish the identity of websites over the internet as well as resources on private networks. ACM integrates with AWS resources, such as Elastic Load Balancers (ELBs), AWS distributions, and APIs on API Gateway, also handling automatic certificate renewals. If you use ACM to deploy a private root CA, both certificates and private keys can be provided by it for use in Amazon Elastic Compute Cloud (Amazon EC2) instances, containers, and so on. ",
        Title:
          "Implement secure key and certificate\n               management",
      },
      {
        ChoiceId: "sec_protect_data_transit_encrypt",
        Description:
          "Enforce your defined encryption requirements based on your organization’s policies, regulatory obligations and standards to help meet organizational, legal, and compliance requirements. Only use protocols with encryption when transmitting sensitive data outside of your virtual private cloud (VPC). Encryption helps maintain data confidentiality even when the data transits untrusted networks.",
        Title: "Enforce encryption in transit",
      },
      {
        ChoiceId: "sec_protect_data_transit_authentication",
        Description:
          " Verify the identity of communications by using protocols that support authentication, such as Transport Layer Security (TLS) or IPsec. ",
        Title: "Authenticate network communications",
      },
      {
        ChoiceId: "sec_protect_data_transit_auto_unintended_access",
        Description:
          " Use tools such as Amazon GuardDuty to automatically detect suspicious activity or attempts to move data outside of defined boundaries. For example, GuardDuty can detect Amazon Simple Storage Service (Amazon S3) read activity that is unusual with the Exfiltration:S3/AnomalousBehavior finding. In addition to GuardDuty, Amazon VPC Flow Logs, which capture network traffic information, can be used with Amazon EventBridge to trigger detection of abnormal connections–both successful and denied. Amazon S3 Access Analyzer can help assess what data is accessible to who in your Amazon S3 buckets. ",
        Title: "Automate detection of unintended data\n               access",
      },
      {
        ChoiceId: "sec_protect_data_transit_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-data-transit",
    QuestionTitle: "How do you protect your data in transit?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "sec_protect_data_transit_encrypt",
      "sec_protect_data_transit_authentication",
      "sec_protect_data_transit_auto_unintended_access",
    ],
  },
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "sec_incident_response_identify_personnel",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_incident_response_develop_management_plans",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_incident_response_pre_deploy_tools",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_incident_response_run_game_days",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_incident_response_prepare_forensic",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_incident_response_auto_contain",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_incident_response_pre_provision_access",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sec_incident_response_identify_personnel",
        Description:
          " Identify internal and external personnel, resources, and legal obligations that would help your organization respond to an incident. ",
        Title: "Identify key personnel and external resources",
      },
      {
        ChoiceId: "sec_incident_response_develop_management_plans",
        Description:
          " Create plans to help you respond to, communicate during, and recover from an incident. For example, you can start an incident response plan with the most likely scenarios for your workload and organization. Include how you would communicate and escalate both internally and externally. ",
        Title: "Develop incident management plans",
      },
      {
        ChoiceId: "sec_incident_response_pre_deploy_tools",
        Description:
          " Ensure that security personnel have the right tools pre-deployed into AWS to reduce the time for investigation through to recovery. ",
        Title: "Pre-deploy tools",
      },
      {
        ChoiceId: "sec_incident_response_run_game_days",
        Description:
          "Game days, also known as simulations or exercises, are internal events that provide a structured opportunity to practice your incident management plans and procedures during a realistic scenario. These events should exercise responders using the same tools and techniques that would be used in a real-world scenario - even mimicking real-world environments. Game days are fundamentally about being prepared and iteratively improving your response capabilities. Some of the reasons you might find value in performing game day activities include: ",
        Title: "Run game days",
      },
      {
        ChoiceId: "sec_incident_response_prepare_forensic",
        Description:
          " It’s important for your incident responders to understand when and how the forensic investigation fits into your response plan. Your organization should define what evidence is collected and what tools are used in the process. Identify and prepare forensic investigation capabilities that are suitable, including external specialists, tools, and automation. A key decision that you should make upfront is if you will collect data from a live system. Some data, such as the contents of volatile memory or active network connections, will be lost if the system is powered off or rebooted. ",
        Title: "Prepare forensic capabilities",
      },
      {
        ChoiceId: "sec_incident_response_auto_contain",
        Description:
          "Automate containment and recovery of an incident to reduce response times and organizational impact.",
        Title: "Automate containment capability",
      },
      {
        ChoiceId: "sec_incident_response_pre_provision_access",
        Description:
          "Verify that incident responders have the correct access pre-provisioned in AWS to reduce the time needed for investigation through to recovery.",
        Title: "Pre-provision access",
      },
      {
        ChoiceId: "sec_incident_response_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "incident-response",
    QuestionTitle:
      "How do you anticipate, respond to, and recover from incidents?",
    Reason: "NONE",
    Risk: "NONE",
    SelectedChoices: [
      "sec_incident_response_identify_personnel",
      "sec_incident_response_develop_management_plans",
      "sec_incident_response_pre_deploy_tools",
      "sec_incident_response_run_game_days",
      "sec_incident_response_prepare_forensic",
      "sec_incident_response_auto_contain",
      "sec_incident_response_pre_provision_access",
    ],
  },
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "sec_appsec_perform_regular_penetration_testing",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId:
          "sec_appsec_regularly_assess_security_properties_of_pipelines",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId:
          "sec_appsec_build_program_that_embeds_security_ownership_in_teams",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_appsec_train_for_application_security",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sec_appsec_perform_regular_penetration_testing",
        Description:
          "Perform regular penetration testing of your software. This mechanism helps identify potential software issues that cannot be detected by automated testing or a manual code review. It can also help you understand the efficacy of your detective controls. Penetration testing should try to determine if the software can be made to perform in unexpected ways, such as exposing data that should be protected, or granting broader permissions than expected.",
        Title: "Perform regular penetration testing",
      },
      {
        ChoiceId: "sec_appsec_deploy_software_programmatically",
        Description:
          "Perform software deployments programmatically where possible. This approach reduces the likelihood that a deployment fails or an unexpected issue is introduced due to human error.",
        Title: "Deploy software programmatically",
      },
      {
        ChoiceId:
          "sec_appsec_regularly_assess_security_properties_of_pipelines",
        Description:
          "Apply the principles of the Well-Architected Security Pillar to your pipelines, with particular attention to the separation of permissions. Regularly assess the security properties of your pipeline infrastructure. Effectively managing the security of the pipelines allows you to deliver the security of the software that passes through the pipelines. ",
        Title: "Regularly assess security properties of the pipelines",
      },
      {
        ChoiceId:
          "sec_appsec_build_program_that_embeds_security_ownership_in_teams",
        Description:
          "Build a program or mechanism that empowers builder teams to make security decisions about the software that they create. Your security team still needs to validate these decisions during a review, but embedding security ownership in builder teams allows for faster, more secure workloads to be built. This mechanism also promotes a culture of ownership that positively impacts the operation of the systems you build.",
        Title:
          "Build a program that embeds security ownership in workload teams",
      },
      {
        ChoiceId: "sec_appsec_train_for_application_security",
        Description:
          "Provide training to the builders in your organization on common practices for the secure development and operation of applications. Adopting security focused development practices helps reduce the likelihood of issues that are only detected at the security review stage. ",
        Title: "Train for application security",
      },
      {
        ChoiceId: "sec_appsec_automate_testing_throughout_lifecycle",
        Description:
          " Automate the testing for security properties throughout the development and release lifecycle. Automation makes it easier to consistently and repeatably identify potential issues in software prior to release, which reduces the risk of security issues in the software being provided. ",
        Title:
          "Automate testing throughout the development and release lifecycle",
      },
      {
        ChoiceId: "sec_appsec_manual_code_reviews",
        Description:
          "Perform a manual code review of the software that you produce. This process helps verify that the person who wrote the code is not the only one checking the code quality.",
        Title: "Manual code reviews",
      },
      {
        ChoiceId:
          "sec_appsec_centralize_services_for_packages_and_dependencies",
        Description:
          "Provide centralized services for builder teams to obtain software packages and other dependencies. This allows the validation of packages before they are included in the software that you write, and provides a source of data for the analysis of the software being used in your organization.",
        Title: "Centralize services for packages and dependencies",
      },
      {
        ChoiceId: "sec_application_security_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "application-security",
    QuestionTitle:
      "How do you incorporate and validate the security properties of applications throughout the design, development, and deployment lifecycle?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "sec_appsec_perform_regular_penetration_testing",
      "sec_appsec_regularly_assess_security_properties_of_pipelines",
      "sec_appsec_build_program_that_embeds_security_ownership_in_teams",
      "sec_appsec_train_for_application_security",
    ],
  },
];

export const Security_Metadata_MockData = {
  ImprovementStatus: {
    Complete: "COMPLETE",
    "In Progress": "IN_PROGRESS",
    None: "NOT_APPLICABLE",
    "Not Started": "NOT_STARTED",
    "Risk Acknowledged": "RISK_ACKNOWLEDGED",
  },
  Industry: {
    Agriculture: {
      Agriculture: "Agriculture",
    },
    Automotive: {
      Automotive: "Automotive",
    },
    Design_And_Engineering: {
      "Architecture & Construction": "Architecture_Construction",
      "Design and Engineering - Other": "Design_And_Engineering_Other",
      "Electronic Design Automation": "Electronic_Design_Automation",
    },
    Digital_Advertising: {
      "Ad Exchange": "Ad_Exchange",
      "Ad Network": "Ad_Network",
      Advertiser: "Advertiser",
      Agency: "Agency",
      "Data Provider": "Data_Provider",
      "Digital Advertising - Other": "Digital_Advertising_Other",
      Display: "Display",
      Mobile: "Mobile",
      Publisher: "Publisher",
      Search: "Search",
      Social: "Social",
      Video: "Video",
    },
    Education: {
      "Education - Other": "Education_Other",
      "Higher Ed & Research": "Higher_Ed_Research",
      "Primary & K-12": "Primary_K_12",
      Publishers: "Publishers",
      "Technology & Tools": "Technology_Tools",
    },
    Environmental_Protection: {
      "Environmental Protection": "Environmental_Protection",
    },
    Financial_Services: {
      "Capital Markets/Securities": "Capital_Markets_Securities",
      "Commercial Banking & Payments": "Commercial_Banking_Payments",
      "Financial Services - Other": "Financial_Services_Other",
      "Insurance (other than health)": "Insurance_Other_Than_Health",
      "Service Providers": "Service_Providers",
    },
    Gaming: {
      "Advertising, User Acquisition, and Monetization":
        "Advertising_User_Acquisition_And_Monetization",
      "Game Distribution": "Game_Distribution",
      "Game Production & Tools": "Game_Production_Tools",
      "Game Publishing": "Game_Publishing",
      "Gaming - Other": "Gaming_Other",
      "Gaming Platforms": "Gaming_Platforms",
      "Live Ops and Business Intelligence":
        "Live_Ops_And_Business_Intelligence",
    },
    General_Public_Services: {
      "General Public Services": "General_Public_Services",
    },
    Healthcare: {
      "Healthcare - Other": "Healthcare_Other",
      "Healthcare Providers": "Healthcare_Providers",
      "Independent Software Vendor - Consumer":
        "Independent_Software_Vendor_Consumer",
      "Independent Software Vendor - Providers":
        "Independent_Software_Vendor_Providers",
      "Independent Software Vendor - Public, Private Health Insurer or Health Authority":
        "Independent_Software_Vendor_Public_Private_Health_Insurer_Or_Health_Authority",
      "Insurer - Public, Private Health Insurer or Health Authority":
        "Insurer_Public_Private_Health_Insurer_Or_Health_Authority",
      "Solution Integrator": "Solution_Integrator",
    },
    Hospitality: {
      "Food Services": "Food_Services",
      "Hospitality - Other": "Hospitality_Other",
      "Hotels & Accommodations": "Hotels_Accommodations",
    },
    InfoTech: {
      "Computer & Electronics": "Computer_Electronics",
      "Infotech - Other": "Infotech_Other",
      Internet: "Internet",
      Semiconductors: "Semiconductors",
      Software: "Software",
    },
    Justice_And_Public_Safety: {
      "Justice and Public Safety": "Justice_And_Public_Safety",
    },
    Life_Sciences: {
      BioPharma: "BioPharma",
      Genomics: "Genomics",
      "Independent Software Vendor - Biopharma, Medical Device":
        "Independent_Software_Vendor_Biopharma_Medical_Device",
      "Independent Software Vendor - Genomics":
        "Independent_Software_Vendor_Genomics",
      "Life Sciences - Other": "Life_Sciences_Other",
      "Medical Device Manufacturer": "Medical_Device_Manufacturer",
      "Solution Integrator": "Solution_Integrator",
    },
    Manufacturing: {
      Aerospace: "Aerospace",
      Chemicals: "Chemicals",
      "Consumer/Packaged Goods": "Consumer_Packaged_Goods",
      "Food & Beverage": "Food_Beverage",
      "High Tech Manufacturing": "High_Tech_Manufacturing",
      "Industrial Manufacturing": "Industrial_Manufacturing",
      "Manufacturing - Other": "Manufacturing_Other",
      Metals: "Metals",
    },
    Media_Entertainment: {
      "Content Delivery: Broadcast & Over-the-top (OTT)":
        "Content_Delivery_Broadcast_Over_The_Top_OTT",
      "Content Production": "Content_Production",
      "Digital Publishing": "Digital_Publishing",
      "Media & Entertainment- Other": "Media_Entertainment_Other",
    },
    Mining_Resources: {
      Mining: "Mining",
      "Mining & Resources - Other": "Mining_Resources_Other",
      "Natural Resources": "Natural_Resources",
    },
    Oil_Gas: {
      "Downstream Oil & Gas Operations": "Downstream_Oil_Gas_Operations",
      "Integrated Oil & Gas Operations": "Integrated_Oil_Gas_Operations",
      "Midstream Oil & Gas Operations": "Midstream_Oil_Gas_Operations",
      "Oil & Gas - Other": "Oil_Gas_Other",
      "Oilfield Services & Equipment": "Oilfield_Services_Equipment",
      "Upstream Oil & Gas Operations": "Upstream_Oil_Gas_Operations",
    },
    Other: {},
    Power_Utilities: {
      "Diversified Utilities": "Diversified_Utilities",
      "Electric Utilities": "Electric_Utilities",
      "Independent Power Producers (IPP)": "Independent_Power_Producers_IPP",
      "Natural Gas Utilities": "Natural_Gas_Utilities",
      "Power & Utilities - Other": "Power_Utilities_Other",
      "Utility Services & Equipment": "Utility_Services_Equipment",
    },
    Professional_Services: {
      Accounting: "Accounting",
      "Consulting services/outsourcing": "Consulting_Services_Outsourcing",
      "Customer care": "Customer_Care",
      Legal: "Legal",
      "Professional Services - Other": "Professional_Services_Other",
      "Real Estate": "Real_Estate",
    },
    Real_Estate_Construction: {
      Construction: "Construction",
      "Real Estate": "Real_Estate",
      "Real Estate & Construction - Other": "Real_Estate_Construction_Other",
    },
    Retail_Wholesale: {
      "General Retail": "General_Retail",
      Grocery: "Grocery",
      "Retail & Wholesale - Other": "Retail_Wholesale_Other",
      "Specialty/Luxury": "Specialty_Luxury",
      Wholesale: "Wholesale",
      eCommerce: "ECommerce",
    },
    Social_Protection: {
      "Social Protection": "Social_Protection",
    },
    Telecommunications: {
      "Communication Service Provider - Communication as a Service (CaaS)":
        "Communication_Service_Provider_Communication_As_A_Service_CaaS",
      "Communication Service Provider Carrier - Infrastructure operator":
        "Communication_Service_Provider_Carrier_Infrastructure_Operator",
      "Communication Service Provider Carrier - Network provider":
        "Communication_Service_Provider_Carrier_Network_Provider",
      "Communication Service Provider Carrier - Satellite":
        "Communication_Service_Provider_Carrier_Satellite",
      "Communication Service Provider Carrier - Telecom":
        "Communication_Service_Provider_Carrier_Telecom",
      "Supplier, End-user side": "Supplier_End_User_Side",
      "Supplier, Provider side": "Supplier_Provider_Side",
      "Telecom Systems Integrator (SI) & Managed Service Provider (MSP)":
        "Telecom_Systems_Integrator_SI_Managed_Service_Provider_MSP",
      "Telecommunications - Other": "Telecommunications_Other",
    },
    Travel_Transportation_Logistics: {
      Airlines: "Airlines",
      Airports: "Airports",
      "Highway and Motor": "Highway_And_Motor",
      "Marine & Ports": "Travel_Marine_Ports",
      "Metropolitan and National Transit": "Metropolitan_And_National_Transit",
      "Postal/Intermodal": "Postal_Intermodal",
      Rail: "Rail",
      "Travel, Transportation & Logistics - Other":
        "Travel_Transportation_Logistics_Other",
      "Warehousing & Distribution": "Warehousing_Distribution",
    },
  },
  IndustryTypes: {
    "-": "-",
    Agriculture: "Agriculture",
    Automotive: "Automotive",
    Defense: "Defense",
    "Design and Engineering": "Design_And_Engineering",
    "Digital Advertising": "Digital_Advertising",
    Education: "Education",
    "Environmental Protection": "Environmental_Protection",
    "Financial Services": "Financial_Services",
    Gaming: "Gaming",
    "General Public Services": "General_Public_Services",
    Healthcare: "Healthcare",
    Hospitality: "Hospitality",
    InfoTech: "InfoTech",
    "Justice and Public Safety": "Justice_And_Public_Safety",
    "Life Sciences": "Life_Sciences",
    Manufacturing: "Manufacturing",
    "Media & Entertainment": "Media_Entertainment",
    "Mining & Resources": "Mining_Resources",
    "Oil & Gas": "Oil_Gas",
    Other: "Other",
    "Power & Utilities": "Power_Utilities",
    "Professional Services": "Professional_Services",
    "Real Estate & Construction": "Real_Estate_Construction",
    "Retail & Wholesale": "Retail_Wholesale",
    "Social Protection": "Social_Protection",
    Telecommunications: "Telecommunications",
    "Travel, Transportation & Logistics": "Travel_Transportation_Logistics",
  },
  Reasons: {
    "-": "NONE",
    "Architecture Constraints": "ARCHITECTURE_CONSTRAINTS",
    "Business Priorities": "BUSINESS_PRIORITIES",
    Other: "OTHER",
    "Out of Scope": "OUT_OF_SCOPE",
  },
};

export const Security_MockData_Securely_Operate = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "sec_securely_operate_multi_accounts",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_securely_operate_aws_account",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_securely_operate_updated_threats",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_securely_operate_updated_recommendations",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sec_securely_operate_multi_accounts",
        Description:
          " Establish common guardrails and isolation between environments (such as production, development, and test) and workloads through a multi-account strategy. Account-level separation is strongly recommended, as it provides a strong isolation boundary for security, billing, and access. ",
        Title: "Separate workloads using accounts",
      },
      {
        ChoiceId: "sec_securely_operate_aws_account",
        Description:
          " The root user is the most privileged user in an AWS account, with full administrative access to all resources within the account, and in some cases cannot be constrained by security policies. Disabling programmatic access to the root user, establishing appropriate controls for the root user, and avoiding routine use of the root user helps reduce the risk of inadvertent exposure of the root credentials and subsequent compromise of the cloud environment. ",
        Title: "Secure account root user and properties",
      },
      {
        ChoiceId: "sec_securely_operate_control_objectives",
        Description:
          " Based on your compliance requirements and risks identified from your threat model, derive and validate the control objectives and controls that you need to apply to your workload. Ongoing validation of control objectives and controls help you measure the effectiveness of risk mitigation. ",
        Title: "Identify and validate control objectives",
      },
      {
        ChoiceId: "sec_securely_operate_updated_threats",
        Description:
          " To help you define and implement appropriate controls, recognize attack vectors by staying up to date with the latest security threats. Consume AWS Managed Services to make it easier to receive notification of unexpected or unusual behavior in your AWS accounts. Investigate using AWS Partner tools or third-party threat information feeds as part of your security information flow. The Common Vulnerabilities and Exposures (CVE) List list contains publicly disclosed cyber security vulnerabilities that you can use to stay up to date. ",
        Title: "Keep up-to-date with security threats ",
      },
      {
        ChoiceId: "sec_securely_operate_updated_recommendations",
        Description:
          " Stay up-to-date with both AWS and industry security recommendations to evolve the security posture of your workload. AWS Security Bulletins contain important information about security and privacy notifications. ",
        Title: "Keep up-to-date with security recommendations",
      },
      {
        ChoiceId: "sec_securely_operate_threat_model",
        Description:
          " Perform threat modeling to identify and maintain an up-to-date register of potential threats and associated mitigations for your workload. Prioritize your threats and adapt your security control mitigations to prevent, detect, and respond. Revisit and maintain this in the context of your workload, and the evolving security landscape. ",
        Title:
          "Identify threats and prioritize mitigations using a threat model",
      },
      {
        ChoiceId: "sec_securely_operate_implement_services_features",
        Description:
          " Evaluate and implement security services and features from AWS and AWS Partners that allow you to evolve the security posture of your workload. The AWS Security Blog highlights new AWS services and features, implementation guides, and general security guidance. What's New with AWS? is a great way to stay up to date with all new AWS features, services, and announcements. ",
        Title:
          "Evaluate and implement new security services and features regularly",
      },
      {
        ChoiceId: "sec_securely_operate_test_validate_pipeline",
        Description:
          " Establish secure baselines and templates for security mechanisms that are tested and validated as part of your build, pipelines, and processes. Use tools and automation to test and validate all security controls continuously. For example, scan items such as machine images and infrastructure-as-code templates for security vulnerabilities, irregularities, and drift from an established baseline at each stage. AWS CloudFormation Guard can help you verify that CloudFormation templates are safe, save you time, and reduce the risk of configuration error. ",
        Title:
          "Automate testing and validation of security controls in pipelines",
      },
      {
        ChoiceId: "sec_securely_operate_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.securely-operate.helpful-resources.en.html",
    ImprovementPlanUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.securely-operate.improvement-plan.en.html",
    IsApplicable: true,
    PillarId: "security",
    QuestionDescription:
      "To operate your workload securely, you must apply overarching best practices to every area of security. Take requirements and processes that you have defined in operational excellence at an organizational and workload level, and apply them to all areas. Staying up to date with AWS and industry recommendations and threat intelligence helps you evolve your threat model and control objectives. Automating security processes, testing, and validation allow you to scale your security operations.",
    QuestionId: "securely-operate",
    QuestionTitle: "How do you securely operate your workload?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "sec_securely_operate_multi_accounts",
      "sec_securely_operate_aws_account",
      "sec_securely_operate_updated_threats",
      "sec_securely_operate_updated_recommendations",
    ],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Security_Check_Execution_Status = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 15,
  Passed: 10,
};

export const Security_Check_Execution_Status_Q11 = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Security_Pillar_Q2 = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "sec_identities_unique",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_identities_secrets",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_identities_identity_provider",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_identities_audit",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sec_identities_enforce_mechanisms",
        Description:
          "Sign-ins (authentication using sign-in credentials) can present risks when not using mechanisms like multi-factor authentication (MFA), especially in situations where sign-in credentials have been inadvertently disclosed or are easily guessed. Use strong sign-in mechanisms to reduce these risks by requiring MFA and strong password policies. ",
        Title: "Use strong sign-in mechanisms",
      },
      {
        ChoiceId: "sec_identities_unique",
        Description:
          " When doing any type of authentication, it’s best to use temporary credentials instead of long-term credentials to reduce or eliminate risks, such as credentials being inadvertently disclosed, shared, or stolen. ",
        Title: "Use temporary credentials",
      },
      {
        ChoiceId: "sec_identities_secrets",
        Description:
          " A workload requires an automated capability to prove its identity to databases, resources, and third-party services. This is accomplished using secret access credentials, such as API access keys, passwords, and OAuth tokens. Using a purpose-built service to store, manage, and rotate these credentials helps reduce the likelihood that those credentials become compromised. ",
        Title: "Store and use secrets securely",
      },
      {
        ChoiceId: "sec_identities_identity_provider",
        Description:
          " For workforce identities, rely on an identity provider that enables you to manage identities in a centralized place. This makes it easier to manage access across multiple applications and services, because you are creating, managing, and revoking access from a single location. For example, if someone leaves your organization, you can revoke access for all applications and services (including AWS) from one location. This reduces the need for multiple credentials and provides an opportunity to integrate with existing human resources (HR) processes. ",
        Title: "Rely on a centralized identity provider",
      },
      {
        ChoiceId: "sec_identities_groups_attributes",
        Description:
          " As the number of users you manage grows, you will need to determine ways to organize them so that you can manage them at scale. Place users with common security requirements in groups defined by your identity provider, and put mechanisms in place to ensure that user attributes that may be used for access control (for example, department or location) are correct and updated. Use these groups and attributes to control access, rather than individual users. This allows you to manage access centrally by changing a user’s group membership or attributes once with a permission set, rather than updating many individual policies when a user’s access needs change.",
        Title: "Leverage user groups and attributes",
      },
      {
        ChoiceId: "sec_identities_audit",
        Description:
          "Audit and rotate credentials periodically to limit how long the credentials can be used to access your resources. Long-term credentials create many risks, and these risks can be reduced by rotating long-term credentials regularly.",
        Title: "Audit and rotate credentials periodically",
      },
      {
        ChoiceId: "sec_identities_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.identities.helpful-resources.en.html",
    ImprovementPlanUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.identities.improvement-plan.en.html",
    IsApplicable: true,
    PillarId: "security",
    QuestionDescription:
      "There are two types of identities you need to manage when approaching operating secure AWS workloads. Understanding the type of identity you need to manage and grant access helps you ensure the right identities have access to the right resources under the right conditions. Human Identities: Your administrators, developers, operators, and end users require an identity to access your AWS environments and applications. These are members of your organization, or external users with whom you collaborate, and who interact with your AWS resources via a web browser, client application, or interactive command-line tools. Machine Identities: Your service applications, operational tools, and workloads require an identity to make requests to AWS services - for example, to read data. These identities include machines running in your AWS environment such as Amazon EC2 instances or AWS Lambda functions. You may also manage machine identities for external parties who need access. Additionally, you may also have machines outside of AWS that need access to your AWS environment.",
    QuestionId: "identities",
    QuestionTitle: "How do you manage identities for people and machines?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "sec_identities_unique",
      "sec_identities_secrets",
      "sec_identities_identity_provider",
      "sec_identities_audit",
    ],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Security_Check_Q2_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 3,
  Passed: 5,
};

export const Security_Check_Q2_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: moment().subtract(1, "days"),
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-04-03 09:14:19",
    Description: "Test",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "yameen",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: moment().subtract(1, "days"),
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Security_Check_Q2_Answer_Summaries = [
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_securely_operate_multi_accounts",
        Description:
          "Organize workloads in separate accounts and group accounts based on function or a common set of controls rather than mirroring your company’s reporting structure. Start with security and infrastructure in mind to enable your organization to set common guardrails as your workloads grow.",
        Title: "Separate workloads using accounts",
      },
      {
        ChoiceId: "sec_securely_operate_aws_account",
        Description:
          "Secure access to your accounts, for example by enabling MFA and restrict use of the root user, and configure account contacts.",
        Title: "Secure AWS account",
      },
      {
        ChoiceId: "sec_securely_operate_control_objectives",
        Description:
          "Based on your compliance requirements and risks identified from your threat model, derive and validate the control objectives and controls that you need to apply to your workload. Ongoing validation of control objectives and controls help you measure the effectiveness of risk mitigation.",
        Title: "Identify and validate control objectives",
      },
      {
        ChoiceId: "sec_securely_operate_updated_threats",
        Description:
          "Recognize attack vectors by staying up to date with the latest security threats to help you define and implement appropriate controls.",
        Title: "Keep up to date with security threats",
      },
      {
        ChoiceId: "sec_securely_operate_updated_recommendations",
        Description:
          "Stay up to date with both AWS and industry security recommendations to evolve the security posture of your workload. ",
        Title: "Keep up to date with security recommendations",
      },
      {
        ChoiceId: "sec_securely_operate_test_validate_pipeline",
        Description:
          "Establish secure baselines and templates for security mechanisms that are tested and validated as part of your build, pipelines, and processes. Use tools and automation to test and validate all security controls continuously. For example, scan items such as machine images and infrastructure as code templates for security vulnerabilities, irregularities, and drift from an established baseline at each stage.",
        Title:
          "Automate testing and validation of security controls in pipelines",
      },
      {
        ChoiceId: "sec_securely_operate_threat_model",
        Description:
          "Use a threat model to identify and maintain an up-to-date register of potential threats. Prioritize your threats and adapt your security controls to prevent, detect, and respond. Revisit and maintain this in the context of the evolving security landscape.",
        Title: "Identify and prioritize risks using a threat model",
      },
      {
        ChoiceId: "sec_securely_operate_implement_services_features",
        Description:
          "AWS and APN Partners constantly release new features and services that allow you to evolve the security posture of your workload.",
        Title:
          "Evaluate and implement new security services and features regularly",
      },
      {
        ChoiceId: "sec_securely_operate_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "securely-operate",
    QuestionTitle: "How do you securely operate your workload?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_identities_enforce_mechanisms",
        Description:
          "Enforce minimum password length, and educate users to avoid common or re-used passwords. Enforce multi-factor authentication (MFA) with software or hardware mechanisms to provide an additional layer.",
        Title: "Use strong sign-in mechanisms",
      },
      {
        ChoiceId: "sec_identities_unique",
        Description:
          "Require identities to dynamically acquire temporary credentials. For workforce identities, use AWS Single Sign-On, or federation with IAM roles to access AWS accounts. For machine identities, require the use of IAM roles instead of long term access keys.",
        Title: "Use temporary credentials",
      },
      {
        ChoiceId: "sec_identities_secrets",
        Description:
          "For workforce and machine identities that require secrets such as passwords to third party applications, store them with automatic rotation using the latest industry standards in a specialized service.",
        Title: "Store and use secrets securely",
      },
      {
        ChoiceId: "sec_identities_identity_provider",
        Description:
          "For workforce identities, rely on an identity provider that enables you to manage identities in a centralized place. This enables you to create, manage, and revoke access from a single location making it easier to manage access. This reduces the requirement for multiple credentials and provides an opportunity to integrate with HR processes.",
        Title: "Rely on a centralized identity provider",
      },
      {
        ChoiceId: "sec_identities_audit",
        Description:
          "When you cannot rely on temporary credentials and require long term credentials, audit credentials to ensure that the defined controls (for example, MFA) are enforced, rotated regularly, and have appropriate access level.",
        Title: "Audit and rotate credentials periodically",
      },
      {
        ChoiceId: "sec_identities_groups_attributes",
        Description:
          "Place users with common security requirements in groups defined by your identity provider, and put mechanisms in place to ensure that user attributes that may be used for access control (e.g., department or location) are correct and updated. Use these groups and attributes, rather than individual users, to control access. This allows you to manage access centrally by changing a user’s group membership or attributes once, rather than updating many individual policies when a user’s access needs change.",
        Title: "Leverage user groups and attributes",
      },
      {
        ChoiceId: "sec_identities_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "identities",
    QuestionTitle: "How do you manage identities for people and machines?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_permissions_define",
        Description:
          "Each component or resource of your workload needs to be accessed by administrators, end users, or other components. Have a clear definition of who or what should have access to each component, choose the appropriate identity type and method of authentication and authorization.",
        Title: "Define access requirements",
      },
      {
        ChoiceId: "sec_permissions_least_privileges",
        Description:
          "Grant only the access that identities require by allowing access to specific actions on specific AWS resources under specific conditions. Rely on groups and identity attributes to dynamically set permissions at scale, rather than defining permissions for individual users. For example, you can allow a group of developers access to manage only resources for their project. This way, when a developer is removed from the group, access for the developer is revoked everywhere that group was used for access control, without requiring any changes to the access policies.",
        Title: "Grant least privilege access",
      },
      {
        ChoiceId: "sec_permissions_emergency_process",
        Description:
          "A process that allows emergency access to your workload in the unlikely event of an automated process or pipeline issue. This will help you rely on least privilege access, but ensure users can obtain the right level of access when they require it. For example, establish a process for administrators to verify and approve their request.",
        Title: "Establish emergency access process",
      },
      {
        ChoiceId: "sec_permissions_continuous_reduction",
        Description:
          "As teams and workloads determine what access they need, remove permissions they no longer use and establish review processes to achieve least privilege permissions. Continuously monitor and reduce unused identities and permissions.",
        Title: "Reduce permissions continuously",
      },
      {
        ChoiceId: "sec_permissions_define_guardrails",
        Description:
          "Establish common controls that restrict access to all identities in your organization. For example, you can restrict access to specific AWS Regions, or prevent your operators from deleting common resources, such as an IAM role used for your central security team.",
        Title: "Define permission guardrails for your organization",
      },
      {
        ChoiceId: "sec_permissions_lifecycle",
        Description:
          "Integrate access controls with operator and application life cycle and your centralized federation provider. For example, remove a user’s access when they leave the organization or change roles.",
        Title: "Manage access based on life cycle",
      },
      {
        ChoiceId: "sec_permissions_analyze_cross_account",
        Description:
          "Continuously monitor findings that highlight public and cross account access. Reduce public access and cross account access to only resources that require this type of access.",
        Title: "Analyze public and cross account access",
      },
      {
        ChoiceId: "sec_permissions_share_securely",
        Description:
          "Govern the consumption of shared resources across accounts or within your AWS Organization. Monitor shared resources and review shared resource access.",
        Title: "Share resources securely",
      },
      {
        ChoiceId: "sec_permissions_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "permissions",
    QuestionTitle: "How do you manage permissions for people and machines?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_detect_investigate_events_app_service_logging",
        Description:
          "Configure logging throughout the workload, including application logs, resource logs, and AWS service logs. For example, ensure that AWS CloudTrail, Amazon CloudWatch Logs, Amazon GuardDuty and AWS Security Hub are enabled for all accounts within your organization.",
        Title: "Configure service and application logging",
      },
      {
        ChoiceId: "sec_detect_investigate_events_analyze_all",
        Description:
          "All logs, metrics, and telemetry should be collected centrally, and automatically analyzed to detect anomalies and indicators of unauthorized activity. A dashboard can provide you easy to access insight into real-time health. For example, ensure that Amazon GuardDuty and Security Hub logs are sent to a central location for alerting and analysis.",
        Title: "Analyze logs, findings, and metrics centrally",
      },
      {
        ChoiceId: "sec_detect_investigate_events_auto_response",
        Description:
          "Using automation to investigate and remediate events reduces human effort and error, and enables you to scale investigation capabilities. Regular reviews will help you tune automation tools, and continuously iterate. For example, automate responses to Amazon GuardDuty events by automating the first investigation step, then iterate to gradually remove human effort.",
        Title: "Automate response to events",
      },
      {
        ChoiceId: "sec_detect_investigate_events_actionable_events",
        Description:
          "Create alerts that are sent to and can be actioned by your team. Ensure that alerts include relevant information for the team to take action. For example, ensure that Amazon GuardDuty and AWS Security Hub alerts are sent to the team to action, or sent to response automation tooling with the team remaining informed by messaging from the automation framework.",
        Title: "Implement actionable security events",
      },
      {
        ChoiceId: "sec_detect_investigate_events_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "detect-investigate-events",
    QuestionTitle: "How do you detect and investigate security events?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_network_protection_create_layers",
        Description:
          "Group components that share reachability requirements into layers. For example, a database cluster in a VPC with no need for internet access should be placed in subnets with no route to or from the internet. In a serverless workload operating without a VPC, similar layering and segmentation with microservices can achieve the same goal.",
        Title: "Create network layers",
      },
      {
        ChoiceId: "sec_network_protection_layered",
        Description:
          "Apply controls with a defense in depth approach for both inbound and outbound traffic. For example, for Amazon Virtual Private Cloud (VPC) this includes security groups, Network ACLs, and subnets. For AWS Lambda, consider running in your private VPC with VPC-based controls.",
        Title: "Control traffic at all layers",
      },
      {
        ChoiceId: "sec_network_protection_auto_protect",
        Description:
          "Automate protection mechanisms to provide a self-defending network based on threat intelligence and anomaly detection. For example, intrusion detection and prevention tools that can pro-actively adapt to current threats and reduce their impact.",
        Title: "Automate network protection",
      },
      {
        ChoiceId: "sec_network_protection_inspection",
        Description:
          "Inspect and filter your traffic at each layer. For example, use a web application firewall to help protect against inadvertent access at the application network layer. For Lambda functions, third-party tools can add application-layer firewalling to your runtime environment.",
        Title: "Implement inspection and protection",
      },
      {
        ChoiceId: "sec_network_protection_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "network-protection",
    QuestionTitle: "How do you protect your network resources?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_protect_compute_vulnerability_management",
        Description:
          "Frequently scan and patch for vulnerabilities in your code, dependencies, and in your infrastructure to help protect against new threats.",
        Title: "Perform vulnerability management",
      },
      {
        ChoiceId: "sec_protect_compute_reduce_surface",
        Description:
          "Reduce your attack surface by hardening operating systems, minimizing components, libraries, and externally consumable services in use.",
        Title: "Reduce attack surface",
      },
      {
        ChoiceId: "sec_protect_compute_implement_managed_services",
        Description:
          "Implement services that manage resources, such as Amazon RDS, AWS Lambda, and Amazon ECS, to reduce your security maintenance tasks as part of the shared responsibility model.",
        Title: "Implement managed services",
      },
      {
        ChoiceId: "sec_protect_compute_auto_protection",
        Description:
          "Automate your protective compute mechanisms including vulnerability management, reduction in attack surface, and management of resources.",
        Title: "Automate compute protection",
      },
      {
        ChoiceId: "sec_protect_compute_actions_distance",
        Description:
          "Removing the ability for interactive access reduces the risk of human error, and the potential for manual configuration or management. For example, use a change management workflow to deploy EC2 instances using infrastructure as code, then manage EC2 instances using tools instead of allowing direct access or a bastion host.",
        Title: "Enable people to perform actions at a distance",
      },
      {
        ChoiceId: "sec_protect_compute_validate_software_integrity",
        Description:
          "Implement mechanisms (for example, code signing) to validate that the software, code, and libraries used in the workload are from trusted sources and have not been tampered with.",
        Title: "Validate software integrity",
      },
      {
        ChoiceId: "sec_protect_compute_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-compute",
    QuestionTitle: "How do you protect your compute resources?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_data_classification_identify_data",
        Description:
          "This includes the type and classification of data, the associated business processes. data owner, applicable legal and compliance requirements, where it’s stored, and the resulting controls that are needed to be enforced. This may include classifications to indicate if the data is intended to be publicly available, if the data is internal use only such as customer personally identifiable information (PII), or if the data is for more restricted access such as intellectual property, legally privileged or marked sensititve, and more.",
        Title: "Identify the data within your workload",
      },
      {
        ChoiceId: "sec_data_classification_define_protection",
        Description:
          "Protect data according to its classification level. For example, secure data classified as public by using relevant recommendations while protecting sensitive data with additional controls.",
        Title: "Define data protection controls",
      },
      {
        ChoiceId: "sec_data_classification_auto_classification",
        Description:
          "Automate identification and classification of data to reduce the risk of human error from manual interactions.",
        Title: "Automate identification and classification",
      },
      {
        ChoiceId: "sec_data_classification_lifecycle_management",
        Description:
          "Your defined lifecycle strategy should be based on sensitivity level, as well as legal and organization requirements. Aspects including the duration you retain data for, data destruction, data access management, data transformation, and data sharing should be considered.",
        Title: "Define data lifecycle management",
      },
      {
        ChoiceId: "sec_data_classification_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "data-classification",
    QuestionTitle: "How do you classify your data?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_protect_data_rest_key_mgmt",
        Description:
          "Encryption keys must be stored securely, withstrict access control, for example, by using a key management service such as AWSKMS. Consider using different keys, and access control to the keys, combined with theAWS IAM and resource policies, to align with data classification levels andsegregation requirements.",
        Title: "Implement secure key management",
      },
      {
        ChoiceId: "sec_protect_data_rest_encrypt",
        Description:
          "Enforce your encryption requirements based on thelatest standards and recommendations to help protect your data at rest.",
        Title: "Enforce encryption at rest",
      },
      {
        ChoiceId: "sec_protect_data_rest_automate_protection",
        Description:
          "Use automated tools to validate and enforce data atrest protection continuously, for example, verify that there are only encryptedstorage resources.",
        Title: "Automate data at rest protection",
      },
      {
        ChoiceId: "sec_protect_data_rest_access_control",
        Description:
          "Enforce access control with least privileges andmechanisms, including backups, isolation, and versioning, to help protect your dataat rest. Prevent operators from granting public access to your data.",
        Title: "Enforce access control",
      },
      {
        ChoiceId: "sec_protect_data_rest_use_people_away",
        Description:
          "Keep all users away from directly accessingsensitive data and systems under normal operational circumstances. For example,provide a dashboard instead of direct access to a data store to run queries. WhereCI/CD pipelines are not used, determine which controls and processes are required toadequately provide a normally disabled break-glass access mechanism.",
        Title: "Use mechanisms to keep people away from data",
      },
      {
        ChoiceId: "sec_protect_data_rest_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-data-rest",
    QuestionTitle: "How do you protect your data at rest?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_protect_data_transit_key_cert_mgmt",
        Description:
          "Store encryption keys and certificates securely androtate them at appropriate time intervals while applying strict access control; forexample, by using a certificate management service, such as AWS Certificate Manager(ACM).",
        Title: "Implement secure key and certificatemanagement",
      },
      {
        ChoiceId: "sec_protect_data_transit_encrypt",
        Description:
          "Enforce your defined encryption requirements basedon appropriate standards and recommendations to help you meet your organizational,legal, and compliance requirements.",
        Title: "Enforce encryption in transit",
      },
      {
        ChoiceId: "sec_protect_data_transit_auto_unintended_access",
        Description:
          "Use tools such as GuardDuty to automatically detectattempts to move data outside of defined boundaries based on data classificationlevel, for example, to detect a trojan that is copying data to an unknown oruntrusted network using the DNS protocol.",
        Title: "Automate detection of unintended dataaccess",
      },
      {
        ChoiceId: "sec_protect_data_transit_authentication",
        Description:
          "Verify the identity of communications by usingprotocols that support authentication, such as Transport Layer Security (TLS) orIPsec.",
        Title: "Authenticate network communications",
      },
      {
        ChoiceId: "sec_protect_data_transit_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-data-transit",
    QuestionTitle: "How do you protect your data in transit?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_incident_response_identify_personnel",
        Description:
          "Identify internal and external personnel, resources, and legal obligations that would help your organization respond to an incident.",
        Title: "Identify key personnel and external resources",
      },
      {
        ChoiceId: "sec_incident_response_develop_management_plans",
        Description:
          "Create plans to help you respond to, communicate during, and recover from an incident. For example, you can start an incident response plan with the most likely scenarios for your workload and organization. Include how you would communicate and escalate both internally and externally.",
        Title: "Develop incident management plans",
      },
      {
        ChoiceId: "sec_incident_response_prepare_forensic",
        Description:
          "Identify and prepare forensic investigation capabilities that are suitable, including external specialists, tools, and automation.",
        Title: "Prepare forensic capabilities",
      },
      {
        ChoiceId: "sec_incident_response_auto_contain",
        Description:
          "Automate containment and recovery of an incident to reduce response times and organizational impact.",
        Title: "Automate containment capability",
      },
      {
        ChoiceId: "sec_incident_response_pre_provision_access",
        Description:
          "Ensure that incident responders have the correct access pre-provisioned into AWS to reduce the time for investigation through to recovery.",
        Title: "Pre-provision access",
      },
      {
        ChoiceId: "sec_incident_response_pre_deploy_tools",
        Description:
          "Ensure that security personnel have the right tools pre-deployed into AWS to reduce the time for investigation through to recovery.",
        Title: "Pre-deploy tools",
      },
      {
        ChoiceId: "sec_incident_response_run_game_days",
        Description:
          "Practice incident response game days (simulations) regularly, incorporate lessons learned into your incident management plans, and continuously improve.",
        Title: "Run game days",
      },
      {
        ChoiceId: "sec_incident_response_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "incident-response",
    QuestionTitle:
      "How do you anticipate, respond to, and recover from incidents?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
];

export const Security_Pillar_Q3 = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "sec_permissions_least_privileges",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_permissions_emergency_process",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_permissions_continuous_reduction",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_permissions_define_guardrails",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_permissions_lifecycle",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sec_permissions_define",
        Description:
          "Each component or resource of your workload needs to be accessed by administrators, end users, or other components. Have a clear definition of who or what should have access to each component, choose the appropriate identity type and method of authentication and authorization.",
        Title: "Define access requirements",
      },
      {
        ChoiceId: "sec_permissions_least_privileges",
        Description:
          " It's a best practice to grant only the access that identities require to perform specific actions on specific resources under specific conditions. Use group and identity attributes to dynamically set permissions at scale, rather than defining permissions for individual users. For example, you can allow a group of developers access to manage only resources for their project. This way, if a developer leaves the project, the developer’s access is automatically revoked without changing the underlying access policies. ",
        Title: "Grant least privilege access",
      },
      {
        ChoiceId: "sec_permissions_lifecycle",
        Description:
          " Integrate access controls with operator and application lifecycle and your centralized federation provider. For example, remove a user’s access when they leave the organization or change roles. ",
        Title: "Manage access based on life cycle",
      },
      {
        ChoiceId: "sec_permissions_analyze_cross_account",
        Description:
          "Continually monitor findings that highlight public and cross-account access. Reduce public access and cross-account access to only the specific resources that require this access.",
        Title: "Analyze public and cross-account access",
      },
      {
        ChoiceId: "sec_permissions_emergency_process",
        Description:
          " A process that allows emergency access to your workload in the unlikely event of an automated process or pipeline issue. This will help you rely on least privilege access, but ensure users can obtain the right level of access when they require it. For example, establish a process for administrators to verify and approve their request, such as an emergency AWS cross-account role for access, or a specific process for administrators to follow to validate and approve an emergency request. ",
        Title: "Establish emergency access process",
      },
      {
        ChoiceId: "sec_permissions_continuous_reduction",
        Description:
          "As your teams determine what access is required, remove unneeded permissions and establish review processes to achieve least privilege permissions. Continually monitor and remove unused identities and permissions for both human and machine access.",
        Title: "Reduce permissions continuously",
      },
      {
        ChoiceId: "sec_permissions_define_guardrails",
        Description:
          " Establish common controls that restrict access to all identities in your organization. For example, you can restrict access to specific AWS Regions, or prevent your operators from deleting common resources, such as an IAM role used for your central security team. ",
        Title: "Define permission guardrails for your organization",
      },
      {
        ChoiceId: "sec_permissions_share_securely",
        Description:
          "As the number of workloads grows, you might need to share access to resources in those workloads or provision the resources multiple times across multiple accounts. You might have constructs to compartmentalize your environment, such as having development, testing, and production environments. However, having separation constructs does not limit you from being able to share securely. By sharing components that overlap, you can reduce operational overhead and allow for a consistent experience without guessing what you might have missed while creating the same resource multiple times. ",
        Title: "Share resources securely within your organization",
      },
      {
        ChoiceId: "sec_permissions_share_securely_third_party",
        Description:
          " The security of your cloud environment doesn’t stop at your organization. Your organization might rely on a third party to manage a portion of your data. The permission management for the third-party managed system should follow the practice of just-in-time access using the principle of least privilege with temporary credentials. By working closely with a third party, you can reduce the scope of impact and risk of unintended access together. ",
        Title: "Share resources securely with a third party",
      },
      {
        ChoiceId: "sec_permissions_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.permissions.helpful-resources.en.html",
    ImprovementPlanUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.permissions.improvement-plan.en.html",
    IsApplicable: true,
    PillarId: "security",
    QuestionDescription:
      "Manage permissions to control access to people and machine identities that require access to AWS and your workload. Permissions control who can access what, and under what conditions.",
    QuestionId: "permissions",
    QuestionTitle: "How do you manage permissions for people and machines?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "sec_permissions_least_privileges",
      "sec_permissions_emergency_process",
      "sec_permissions_continuous_reduction",
      "sec_permissions_define_guardrails",
      "sec_permissions_lifecycle",
    ],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Security_Check_Q3_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 21,
  Passed: 11,
};

export const Security_Check_Q3_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: moment().subtract(1, "days"),
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-04-03 09:14:19",
    Description: "Test",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "yameen",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: moment().subtract(1, "days"),
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Security_Check_Q3_Answer_Summaries = [
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_securely_operate_multi_accounts",
        Description:
          "Organize workloads in separate accounts and group accounts based on function or a common set of controls rather than mirroring your company’s reporting structure. Start with security and infrastructure in mind to enable your organization to set common guardrails as your workloads grow.",
        Title: "Separate workloads using accounts",
      },
      {
        ChoiceId: "sec_securely_operate_aws_account",
        Description:
          "Secure access to your accounts, for example by enabling MFA and restrict use of the root user, and configure account contacts.",
        Title: "Secure AWS account",
      },
      {
        ChoiceId: "sec_securely_operate_control_objectives",
        Description:
          "Based on your compliance requirements and risks identified from your threat model, derive and validate the control objectives and controls that you need to apply to your workload. Ongoing validation of control objectives and controls help you measure the effectiveness of risk mitigation.",
        Title: "Identify and validate control objectives",
      },
      {
        ChoiceId: "sec_securely_operate_updated_threats",
        Description:
          "Recognize attack vectors by staying up to date with the latest security threats to help you define and implement appropriate controls.",
        Title: "Keep up to date with security threats",
      },
      {
        ChoiceId: "sec_securely_operate_updated_recommendations",
        Description:
          "Stay up to date with both AWS and industry security recommendations to evolve the security posture of your workload. ",
        Title: "Keep up to date with security recommendations",
      },
      {
        ChoiceId: "sec_securely_operate_test_validate_pipeline",
        Description:
          "Establish secure baselines and templates for security mechanisms that are tested and validated as part of your build, pipelines, and processes. Use tools and automation to test and validate all security controls continuously. For example, scan items such as machine images and infrastructure as code templates for security vulnerabilities, irregularities, and drift from an established baseline at each stage.",
        Title:
          "Automate testing and validation of security controls in pipelines",
      },
      {
        ChoiceId: "sec_securely_operate_threat_model",
        Description:
          "Use a threat model to identify and maintain an up-to-date register of potential threats. Prioritize your threats and adapt your security controls to prevent, detect, and respond. Revisit and maintain this in the context of the evolving security landscape.",
        Title: "Identify and prioritize risks using a threat model",
      },
      {
        ChoiceId: "sec_securely_operate_implement_services_features",
        Description:
          "AWS and APN Partners constantly release new features and services that allow you to evolve the security posture of your workload.",
        Title:
          "Evaluate and implement new security services and features regularly",
      },
      {
        ChoiceId: "sec_securely_operate_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "securely-operate",
    QuestionTitle: "How do you securely operate your workload?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_identities_enforce_mechanisms",
        Description:
          "Enforce minimum password length, and educate users to avoid common or re-used passwords. Enforce multi-factor authentication (MFA) with software or hardware mechanisms to provide an additional layer.",
        Title: "Use strong sign-in mechanisms",
      },
      {
        ChoiceId: "sec_identities_unique",
        Description:
          "Require identities to dynamically acquire temporary credentials. For workforce identities, use AWS Single Sign-On, or federation with IAM roles to access AWS accounts. For machine identities, require the use of IAM roles instead of long term access keys.",
        Title: "Use temporary credentials",
      },
      {
        ChoiceId: "sec_identities_secrets",
        Description:
          "For workforce and machine identities that require secrets such as passwords to third party applications, store them with automatic rotation using the latest industry standards in a specialized service.",
        Title: "Store and use secrets securely",
      },
      {
        ChoiceId: "sec_identities_identity_provider",
        Description:
          "For workforce identities, rely on an identity provider that enables you to manage identities in a centralized place. This enables you to create, manage, and revoke access from a single location making it easier to manage access. This reduces the requirement for multiple credentials and provides an opportunity to integrate with HR processes.",
        Title: "Rely on a centralized identity provider",
      },
      {
        ChoiceId: "sec_identities_audit",
        Description:
          "When you cannot rely on temporary credentials and require long term credentials, audit credentials to ensure that the defined controls (for example, MFA) are enforced, rotated regularly, and have appropriate access level.",
        Title: "Audit and rotate credentials periodically",
      },
      {
        ChoiceId: "sec_identities_groups_attributes",
        Description:
          "Place users with common security requirements in groups defined by your identity provider, and put mechanisms in place to ensure that user attributes that may be used for access control (e.g., department or location) are correct and updated. Use these groups and attributes, rather than individual users, to control access. This allows you to manage access centrally by changing a user’s group membership or attributes once, rather than updating many individual policies when a user’s access needs change.",
        Title: "Leverage user groups and attributes",
      },
      {
        ChoiceId: "sec_identities_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "identities",
    QuestionTitle: "How do you manage identities for people and machines?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_permissions_define",
        Description:
          "Each component or resource of your workload needs to be accessed by administrators, end users, or other components. Have a clear definition of who or what should have access to each component, choose the appropriate identity type and method of authentication and authorization.",
        Title: "Define access requirements",
      },
      {
        ChoiceId: "sec_permissions_least_privileges",
        Description:
          "Grant only the access that identities require by allowing access to specific actions on specific AWS resources under specific conditions. Rely on groups and identity attributes to dynamically set permissions at scale, rather than defining permissions for individual users. For example, you can allow a group of developers access to manage only resources for their project. This way, when a developer is removed from the group, access for the developer is revoked everywhere that group was used for access control, without requiring any changes to the access policies.",
        Title: "Grant least privilege access",
      },
      {
        ChoiceId: "sec_permissions_emergency_process",
        Description:
          "A process that allows emergency access to your workload in the unlikely event of an automated process or pipeline issue. This will help you rely on least privilege access, but ensure users can obtain the right level of access when they require it. For example, establish a process for administrators to verify and approve their request.",
        Title: "Establish emergency access process",
      },
      {
        ChoiceId: "sec_permissions_continuous_reduction",
        Description:
          "As teams and workloads determine what access they need, remove permissions they no longer use and establish review processes to achieve least privilege permissions. Continuously monitor and reduce unused identities and permissions.",
        Title: "Reduce permissions continuously",
      },
      {
        ChoiceId: "sec_permissions_define_guardrails",
        Description:
          "Establish common controls that restrict access to all identities in your organization. For example, you can restrict access to specific AWS Regions, or prevent your operators from deleting common resources, such as an IAM role used for your central security team.",
        Title: "Define permission guardrails for your organization",
      },
      {
        ChoiceId: "sec_permissions_lifecycle",
        Description:
          "Integrate access controls with operator and application life cycle and your centralized federation provider. For example, remove a user’s access when they leave the organization or change roles.",
        Title: "Manage access based on life cycle",
      },
      {
        ChoiceId: "sec_permissions_analyze_cross_account",
        Description:
          "Continuously monitor findings that highlight public and cross account access. Reduce public access and cross account access to only resources that require this type of access.",
        Title: "Analyze public and cross account access",
      },
      {
        ChoiceId: "sec_permissions_share_securely",
        Description:
          "Govern the consumption of shared resources across accounts or within your AWS Organization. Monitor shared resources and review shared resource access.",
        Title: "Share resources securely",
      },
      {
        ChoiceId: "sec_permissions_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "permissions",
    QuestionTitle: "How do you manage permissions for people and machines?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_detect_investigate_events_app_service_logging",
        Description:
          "Configure logging throughout the workload, including application logs, resource logs, and AWS service logs. For example, ensure that AWS CloudTrail, Amazon CloudWatch Logs, Amazon GuardDuty and AWS Security Hub are enabled for all accounts within your organization.",
        Title: "Configure service and application logging",
      },
      {
        ChoiceId: "sec_detect_investigate_events_analyze_all",
        Description:
          "All logs, metrics, and telemetry should be collected centrally, and automatically analyzed to detect anomalies and indicators of unauthorized activity. A dashboard can provide you easy to access insight into real-time health. For example, ensure that Amazon GuardDuty and Security Hub logs are sent to a central location for alerting and analysis.",
        Title: "Analyze logs, findings, and metrics centrally",
      },
      {
        ChoiceId: "sec_detect_investigate_events_auto_response",
        Description:
          "Using automation to investigate and remediate events reduces human effort and error, and enables you to scale investigation capabilities. Regular reviews will help you tune automation tools, and continuously iterate. For example, automate responses to Amazon GuardDuty events by automating the first investigation step, then iterate to gradually remove human effort.",
        Title: "Automate response to events",
      },
      {
        ChoiceId: "sec_detect_investigate_events_actionable_events",
        Description:
          "Create alerts that are sent to and can be actioned by your team. Ensure that alerts include relevant information for the team to take action. For example, ensure that Amazon GuardDuty and AWS Security Hub alerts are sent to the team to action, or sent to response automation tooling with the team remaining informed by messaging from the automation framework.",
        Title: "Implement actionable security events",
      },
      {
        ChoiceId: "sec_detect_investigate_events_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "detect-investigate-events",
    QuestionTitle: "How do you detect and investigate security events?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_network_protection_create_layers",
        Description:
          "Group components that share reachability requirements into layers. For example, a database cluster in a VPC with no need for internet access should be placed in subnets with no route to or from the internet. In a serverless workload operating without a VPC, similar layering and segmentation with microservices can achieve the same goal.",
        Title: "Create network layers",
      },
      {
        ChoiceId: "sec_network_protection_layered",
        Description:
          "Apply controls with a defense in depth approach for both inbound and outbound traffic. For example, for Amazon Virtual Private Cloud (VPC) this includes security groups, Network ACLs, and subnets. For AWS Lambda, consider running in your private VPC with VPC-based controls.",
        Title: "Control traffic at all layers",
      },
      {
        ChoiceId: "sec_network_protection_auto_protect",
        Description:
          "Automate protection mechanisms to provide a self-defending network based on threat intelligence and anomaly detection. For example, intrusion detection and prevention tools that can pro-actively adapt to current threats and reduce their impact.",
        Title: "Automate network protection",
      },
      {
        ChoiceId: "sec_network_protection_inspection",
        Description:
          "Inspect and filter your traffic at each layer. For example, use a web application firewall to help protect against inadvertent access at the application network layer. For Lambda functions, third-party tools can add application-layer firewalling to your runtime environment.",
        Title: "Implement inspection and protection",
      },
      {
        ChoiceId: "sec_network_protection_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "network-protection",
    QuestionTitle: "How do you protect your network resources?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_protect_compute_vulnerability_management",
        Description:
          "Frequently scan and patch for vulnerabilities in your code, dependencies, and in your infrastructure to help protect against new threats.",
        Title: "Perform vulnerability management",
      },
      {
        ChoiceId: "sec_protect_compute_reduce_surface",
        Description:
          "Reduce your attack surface by hardening operating systems, minimizing components, libraries, and externally consumable services in use.",
        Title: "Reduce attack surface",
      },
      {
        ChoiceId: "sec_protect_compute_implement_managed_services",
        Description:
          "Implement services that manage resources, such as Amazon RDS, AWS Lambda, and Amazon ECS, to reduce your security maintenance tasks as part of the shared responsibility model.",
        Title: "Implement managed services",
      },
      {
        ChoiceId: "sec_protect_compute_auto_protection",
        Description:
          "Automate your protective compute mechanisms including vulnerability management, reduction in attack surface, and management of resources.",
        Title: "Automate compute protection",
      },
      {
        ChoiceId: "sec_protect_compute_actions_distance",
        Description:
          "Removing the ability for interactive access reduces the risk of human error, and the potential for manual configuration or management. For example, use a change management workflow to deploy EC2 instances using infrastructure as code, then manage EC2 instances using tools instead of allowing direct access or a bastion host.",
        Title: "Enable people to perform actions at a distance",
      },
      {
        ChoiceId: "sec_protect_compute_validate_software_integrity",
        Description:
          "Implement mechanisms (for example, code signing) to validate that the software, code, and libraries used in the workload are from trusted sources and have not been tampered with.",
        Title: "Validate software integrity",
      },
      {
        ChoiceId: "sec_protect_compute_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-compute",
    QuestionTitle: "How do you protect your compute resources?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_data_classification_identify_data",
        Description:
          "This includes the type and classification of data, the associated business processes. data owner, applicable legal and compliance requirements, where it’s stored, and the resulting controls that are needed to be enforced. This may include classifications to indicate if the data is intended to be publicly available, if the data is internal use only such as customer personally identifiable information (PII), or if the data is for more restricted access such as intellectual property, legally privileged or marked sensititve, and more.",
        Title: "Identify the data within your workload",
      },
      {
        ChoiceId: "sec_data_classification_define_protection",
        Description:
          "Protect data according to its classification level. For example, secure data classified as public by using relevant recommendations while protecting sensitive data with additional controls.",
        Title: "Define data protection controls",
      },
      {
        ChoiceId: "sec_data_classification_auto_classification",
        Description:
          "Automate identification and classification of data to reduce the risk of human error from manual interactions.",
        Title: "Automate identification and classification",
      },
      {
        ChoiceId: "sec_data_classification_lifecycle_management",
        Description:
          "Your defined lifecycle strategy should be based on sensitivity level, as well as legal and organization requirements. Aspects including the duration you retain data for, data destruction, data access management, data transformation, and data sharing should be considered.",
        Title: "Define data lifecycle management",
      },
      {
        ChoiceId: "sec_data_classification_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "data-classification",
    QuestionTitle: "How do you classify your data?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_protect_data_rest_key_mgmt",
        Description:
          "Encryption keys must be stored securely, withstrict access control, for example, by using a key management service such as AWSKMS. Consider using different keys, and access control to the keys, combined with theAWS IAM and resource policies, to align with data classification levels andsegregation requirements.",
        Title: "Implement secure key management",
      },
      {
        ChoiceId: "sec_protect_data_rest_encrypt",
        Description:
          "Enforce your encryption requirements based on thelatest standards and recommendations to help protect your data at rest.",
        Title: "Enforce encryption at rest",
      },
      {
        ChoiceId: "sec_protect_data_rest_automate_protection",
        Description:
          "Use automated tools to validate and enforce data atrest protection continuously, for example, verify that there are only encryptedstorage resources.",
        Title: "Automate data at rest protection",
      },
      {
        ChoiceId: "sec_protect_data_rest_access_control",
        Description:
          "Enforce access control with least privileges andmechanisms, including backups, isolation, and versioning, to help protect your dataat rest. Prevent operators from granting public access to your data.",
        Title: "Enforce access control",
      },
      {
        ChoiceId: "sec_protect_data_rest_use_people_away",
        Description:
          "Keep all users away from directly accessingsensitive data and systems under normal operational circumstances. For example,provide a dashboard instead of direct access to a data store to run queries. WhereCI/CD pipelines are not used, determine which controls and processes are required toadequately provide a normally disabled break-glass access mechanism.",
        Title: "Use mechanisms to keep people away from data",
      },
      {
        ChoiceId: "sec_protect_data_rest_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-data-rest",
    QuestionTitle: "How do you protect your data at rest?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_protect_data_transit_key_cert_mgmt",
        Description:
          "Store encryption keys and certificates securely androtate them at appropriate time intervals while applying strict access control; forexample, by using a certificate management service, such as AWS Certificate Manager(ACM).",
        Title: "Implement secure key and certificatemanagement",
      },
      {
        ChoiceId: "sec_protect_data_transit_encrypt",
        Description:
          "Enforce your defined encryption requirements basedon appropriate standards and recommendations to help you meet your organizational,legal, and compliance requirements.",
        Title: "Enforce encryption in transit",
      },
      {
        ChoiceId: "sec_protect_data_transit_auto_unintended_access",
        Description:
          "Use tools such as GuardDuty to automatically detectattempts to move data outside of defined boundaries based on data classificationlevel, for example, to detect a trojan that is copying data to an unknown oruntrusted network using the DNS protocol.",
        Title: "Automate detection of unintended dataaccess",
      },
      {
        ChoiceId: "sec_protect_data_transit_authentication",
        Description:
          "Verify the identity of communications by usingprotocols that support authentication, such as Transport Layer Security (TLS) orIPsec.",
        Title: "Authenticate network communications",
      },
      {
        ChoiceId: "sec_protect_data_transit_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-data-transit",
    QuestionTitle: "How do you protect your data in transit?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_incident_response_identify_personnel",
        Description:
          "Identify internal and external personnel, resources, and legal obligations that would help your organization respond to an incident.",
        Title: "Identify key personnel and external resources",
      },
      {
        ChoiceId: "sec_incident_response_develop_management_plans",
        Description:
          "Create plans to help you respond to, communicate during, and recover from an incident. For example, you can start an incident response plan with the most likely scenarios for your workload and organization. Include how you would communicate and escalate both internally and externally.",
        Title: "Develop incident management plans",
      },
      {
        ChoiceId: "sec_incident_response_prepare_forensic",
        Description:
          "Identify and prepare forensic investigation capabilities that are suitable, including external specialists, tools, and automation.",
        Title: "Prepare forensic capabilities",
      },
      {
        ChoiceId: "sec_incident_response_auto_contain",
        Description:
          "Automate containment and recovery of an incident to reduce response times and organizational impact.",
        Title: "Automate containment capability",
      },
      {
        ChoiceId: "sec_incident_response_pre_provision_access",
        Description:
          "Ensure that incident responders have the correct access pre-provisioned into AWS to reduce the time for investigation through to recovery.",
        Title: "Pre-provision access",
      },
      {
        ChoiceId: "sec_incident_response_pre_deploy_tools",
        Description:
          "Ensure that security personnel have the right tools pre-deployed into AWS to reduce the time for investigation through to recovery.",
        Title: "Pre-deploy tools",
      },
      {
        ChoiceId: "sec_incident_response_run_game_days",
        Description:
          "Practice incident response game days (simulations) regularly, incorporate lessons learned into your incident management plans, and continuously improve.",
        Title: "Run game days",
      },
      {
        ChoiceId: "sec_incident_response_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "incident-response",
    QuestionTitle:
      "How do you anticipate, respond to, and recover from incidents?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
];

export const Security_Pillar_Q4 = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "sec_detect_investigate_events_analyze_all",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_detect_investigate_events_actionable_events",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_detect_investigate_events_auto_response",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sec_detect_investigate_events_app_service_logging",
        Description:
          "Retain security event logs from services and applications. This is a fundamental principle of security for audit, investigations, and operational use cases, and a common security requirement driven by governance, risk, and compliance (GRC) standards, policies, and procedures.",
        Title: "Configure service and application logging",
      },
      {
        ChoiceId: "sec_detect_investigate_events_analyze_all",
        Description:
          " Security operations teams rely on the collection of logs and the use of search tools to discover potential events of interest, which might indicate unauthorized activity or unintentional change. However, simply analyzing collected data and manually processing information is insufficient to keep up with the volume of information flowing from complex architectures. Analysis and reporting alone don’t facilitate the assignment of the right resources to work an event in a timely fashion. ",
        Title: "Analyze logs, findings, and metrics centrally",
      },
      {
        ChoiceId: "sec_detect_investigate_events_actionable_events",
        Description:
          " Create alerts that are sent to and can be actioned by your team. Ensure that alerts include relevant information for the team to take action. For each detective mechanism you have, you should also have a process, in the form of a runbook or playbook, to investigate. For example, when you enable Amazon GuardDuty, it generates different findings. You should have a runbook entry for each finding type, for example, if a trojan is discovered, your runbook has simple instructions that instruct someone to investigate and remediate. ",
        Title: "Implement actionable security events",
      },
      {
        ChoiceId: "sec_detect_investigate_events_auto_response",
        Description:
          " Using automation to investigate and remediate events reduces human effort and error, and enables you to scale investigation capabilities. Regular reviews will help you tune automation tools, and continuously iterate. ",
        Title: "Automate response to events",
      },
      {
        ChoiceId: "sec_detect_investigate_events_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.detect-investigate-events.helpful-resources.en.html",
    ImprovementPlanUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.detect-investigate-events.improvement-plan.en.html",
    IsApplicable: true,
    PillarId: "security",
    QuestionDescription:
      "Capture and analyze events from logs and metrics to gain visibility. Take action on security events and potential threats to help secure your workload.",
    QuestionId: "detect-investigate-events",
    QuestionTitle: "How do you detect and investigate security events?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "sec_detect_investigate_events_analyze_all",
      "sec_detect_investigate_events_actionable_events",
      "sec_detect_investigate_events_auto_response",
    ],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Security_Check_Q4ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 34,
  Passed: 21,
};

export const Security_Check_Q4_Summaries = [
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_securely_operate_multi_accounts",
        Description:
          "Organize workloads in separate accounts and group accounts based on function or a common set of controls rather than mirroring your company’s reporting structure. Start with security and infrastructure in mind to enable your organization to set common guardrails as your workloads grow.",
        Title: "Separate workloads using accounts",
      },
      {
        ChoiceId: "sec_securely_operate_aws_account",
        Description:
          "Secure access to your accounts, for example by enabling MFA and restrict use of the root user, and configure account contacts.",
        Title: "Secure AWS account",
      },
      {
        ChoiceId: "sec_securely_operate_control_objectives",
        Description:
          "Based on your compliance requirements and risks identified from your threat model, derive and validate the control objectives and controls that you need to apply to your workload. Ongoing validation of control objectives and controls help you measure the effectiveness of risk mitigation.",
        Title: "Identify and validate control objectives",
      },
      {
        ChoiceId: "sec_securely_operate_updated_threats",
        Description:
          "Recognize attack vectors by staying up to date with the latest security threats to help you define and implement appropriate controls.",
        Title: "Keep up to date with security threats",
      },
      {
        ChoiceId: "sec_securely_operate_updated_recommendations",
        Description:
          "Stay up to date with both AWS and industry security recommendations to evolve the security posture of your workload. ",
        Title: "Keep up to date with security recommendations",
      },
      {
        ChoiceId: "sec_securely_operate_test_validate_pipeline",
        Description:
          "Establish secure baselines and templates for security mechanisms that are tested and validated as part of your build, pipelines, and processes. Use tools and automation to test and validate all security controls continuously. For example, scan items such as machine images and infrastructure as code templates for security vulnerabilities, irregularities, and drift from an established baseline at each stage.",
        Title:
          "Automate testing and validation of security controls in pipelines",
      },
      {
        ChoiceId: "sec_securely_operate_threat_model",
        Description:
          "Use a threat model to identify and maintain an up-to-date register of potential threats. Prioritize your threats and adapt your security controls to prevent, detect, and respond. Revisit and maintain this in the context of the evolving security landscape.",
        Title: "Identify and prioritize risks using a threat model",
      },
      {
        ChoiceId: "sec_securely_operate_implement_services_features",
        Description:
          "AWS and APN Partners constantly release new features and services that allow you to evolve the security posture of your workload.",
        Title:
          "Evaluate and implement new security services and features regularly",
      },
      {
        ChoiceId: "sec_securely_operate_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "securely-operate",
    QuestionTitle: "How do you securely operate your workload?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_identities_enforce_mechanisms",
        Description:
          "Enforce minimum password length, and educate users to avoid common or re-used passwords. Enforce multi-factor authentication (MFA) with software or hardware mechanisms to provide an additional layer.",
        Title: "Use strong sign-in mechanisms",
      },
      {
        ChoiceId: "sec_identities_unique",
        Description:
          "Require identities to dynamically acquire temporary credentials. For workforce identities, use AWS Single Sign-On, or federation with IAM roles to access AWS accounts. For machine identities, require the use of IAM roles instead of long term access keys.",
        Title: "Use temporary credentials",
      },
      {
        ChoiceId: "sec_identities_secrets",
        Description:
          "For workforce and machine identities that require secrets such as passwords to third party applications, store them with automatic rotation using the latest industry standards in a specialized service.",
        Title: "Store and use secrets securely",
      },
      {
        ChoiceId: "sec_identities_identity_provider",
        Description:
          "For workforce identities, rely on an identity provider that enables you to manage identities in a centralized place. This enables you to create, manage, and revoke access from a single location making it easier to manage access. This reduces the requirement for multiple credentials and provides an opportunity to integrate with HR processes.",
        Title: "Rely on a centralized identity provider",
      },
      {
        ChoiceId: "sec_identities_audit",
        Description:
          "When you cannot rely on temporary credentials and require long term credentials, audit credentials to ensure that the defined controls (for example, MFA) are enforced, rotated regularly, and have appropriate access level.",
        Title: "Audit and rotate credentials periodically",
      },
      {
        ChoiceId: "sec_identities_groups_attributes",
        Description:
          "Place users with common security requirements in groups defined by your identity provider, and put mechanisms in place to ensure that user attributes that may be used for access control (e.g., department or location) are correct and updated. Use these groups and attributes, rather than individual users, to control access. This allows you to manage access centrally by changing a user’s group membership or attributes once, rather than updating many individual policies when a user’s access needs change.",
        Title: "Leverage user groups and attributes",
      },
      {
        ChoiceId: "sec_identities_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "identities",
    QuestionTitle: "How do you manage identities for people and machines?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_permissions_define",
        Description:
          "Each component or resource of your workload needs to be accessed by administrators, end users, or other components. Have a clear definition of who or what should have access to each component, choose the appropriate identity type and method of authentication and authorization.",
        Title: "Define access requirements",
      },
      {
        ChoiceId: "sec_permissions_least_privileges",
        Description:
          "Grant only the access that identities require by allowing access to specific actions on specific AWS resources under specific conditions. Rely on groups and identity attributes to dynamically set permissions at scale, rather than defining permissions for individual users. For example, you can allow a group of developers access to manage only resources for their project. This way, when a developer is removed from the group, access for the developer is revoked everywhere that group was used for access control, without requiring any changes to the access policies.",
        Title: "Grant least privilege access",
      },
      {
        ChoiceId: "sec_permissions_emergency_process",
        Description:
          "A process that allows emergency access to your workload in the unlikely event of an automated process or pipeline issue. This will help you rely on least privilege access, but ensure users can obtain the right level of access when they require it. For example, establish a process for administrators to verify and approve their request.",
        Title: "Establish emergency access process",
      },
      {
        ChoiceId: "sec_permissions_continuous_reduction",
        Description:
          "As teams and workloads determine what access they need, remove permissions they no longer use and establish review processes to achieve least privilege permissions. Continuously monitor and reduce unused identities and permissions.",
        Title: "Reduce permissions continuously",
      },
      {
        ChoiceId: "sec_permissions_define_guardrails",
        Description:
          "Establish common controls that restrict access to all identities in your organization. For example, you can restrict access to specific AWS Regions, or prevent your operators from deleting common resources, such as an IAM role used for your central security team.",
        Title: "Define permission guardrails for your organization",
      },
      {
        ChoiceId: "sec_permissions_lifecycle",
        Description:
          "Integrate access controls with operator and application life cycle and your centralized federation provider. For example, remove a user’s access when they leave the organization or change roles.",
        Title: "Manage access based on life cycle",
      },
      {
        ChoiceId: "sec_permissions_analyze_cross_account",
        Description:
          "Continuously monitor findings that highlight public and cross account access. Reduce public access and cross account access to only resources that require this type of access.",
        Title: "Analyze public and cross account access",
      },
      {
        ChoiceId: "sec_permissions_share_securely",
        Description:
          "Govern the consumption of shared resources across accounts or within your AWS Organization. Monitor shared resources and review shared resource access.",
        Title: "Share resources securely",
      },
      {
        ChoiceId: "sec_permissions_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "permissions",
    QuestionTitle: "How do you manage permissions for people and machines?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_detect_investigate_events_app_service_logging",
        Description:
          "Configure logging throughout the workload, including application logs, resource logs, and AWS service logs. For example, ensure that AWS CloudTrail, Amazon CloudWatch Logs, Amazon GuardDuty and AWS Security Hub are enabled for all accounts within your organization.",
        Title: "Configure service and application logging",
      },
      {
        ChoiceId: "sec_detect_investigate_events_analyze_all",
        Description:
          "All logs, metrics, and telemetry should be collected centrally, and automatically analyzed to detect anomalies and indicators of unauthorized activity. A dashboard can provide you easy to access insight into real-time health. For example, ensure that Amazon GuardDuty and Security Hub logs are sent to a central location for alerting and analysis.",
        Title: "Analyze logs, findings, and metrics centrally",
      },
      {
        ChoiceId: "sec_detect_investigate_events_auto_response",
        Description:
          "Using automation to investigate and remediate events reduces human effort and error, and enables you to scale investigation capabilities. Regular reviews will help you tune automation tools, and continuously iterate. For example, automate responses to Amazon GuardDuty events by automating the first investigation step, then iterate to gradually remove human effort.",
        Title: "Automate response to events",
      },
      {
        ChoiceId: "sec_detect_investigate_events_actionable_events",
        Description:
          "Create alerts that are sent to and can be actioned by your team. Ensure that alerts include relevant information for the team to take action. For example, ensure that Amazon GuardDuty and AWS Security Hub alerts are sent to the team to action, or sent to response automation tooling with the team remaining informed by messaging from the automation framework.",
        Title: "Implement actionable security events",
      },
      {
        ChoiceId: "sec_detect_investigate_events_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "detect-investigate-events",
    QuestionTitle: "How do you detect and investigate security events?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_network_protection_create_layers",
        Description:
          "Group components that share reachability requirements into layers. For example, a database cluster in a VPC with no need for internet access should be placed in subnets with no route to or from the internet. In a serverless workload operating without a VPC, similar layering and segmentation with microservices can achieve the same goal.",
        Title: "Create network layers",
      },
      {
        ChoiceId: "sec_network_protection_layered",
        Description:
          "Apply controls with a defense in depth approach for both inbound and outbound traffic. For example, for Amazon Virtual Private Cloud (VPC) this includes security groups, Network ACLs, and subnets. For AWS Lambda, consider running in your private VPC with VPC-based controls.",
        Title: "Control traffic at all layers",
      },
      {
        ChoiceId: "sec_network_protection_auto_protect",
        Description:
          "Automate protection mechanisms to provide a self-defending network based on threat intelligence and anomaly detection. For example, intrusion detection and prevention tools that can pro-actively adapt to current threats and reduce their impact.",
        Title: "Automate network protection",
      },
      {
        ChoiceId: "sec_network_protection_inspection",
        Description:
          "Inspect and filter your traffic at each layer. For example, use a web application firewall to help protect against inadvertent access at the application network layer. For Lambda functions, third-party tools can add application-layer firewalling to your runtime environment.",
        Title: "Implement inspection and protection",
      },
      {
        ChoiceId: "sec_network_protection_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "network-protection",
    QuestionTitle: "How do you protect your network resources?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_protect_compute_vulnerability_management",
        Description:
          "Frequently scan and patch for vulnerabilities in your code, dependencies, and in your infrastructure to help protect against new threats.",
        Title: "Perform vulnerability management",
      },
      {
        ChoiceId: "sec_protect_compute_reduce_surface",
        Description:
          "Reduce your attack surface by hardening operating systems, minimizing components, libraries, and externally consumable services in use.",
        Title: "Reduce attack surface",
      },
      {
        ChoiceId: "sec_protect_compute_implement_managed_services",
        Description:
          "Implement services that manage resources, such as Amazon RDS, AWS Lambda, and Amazon ECS, to reduce your security maintenance tasks as part of the shared responsibility model.",
        Title: "Implement managed services",
      },
      {
        ChoiceId: "sec_protect_compute_auto_protection",
        Description:
          "Automate your protective compute mechanisms including vulnerability management, reduction in attack surface, and management of resources.",
        Title: "Automate compute protection",
      },
      {
        ChoiceId: "sec_protect_compute_actions_distance",
        Description:
          "Removing the ability for interactive access reduces the risk of human error, and the potential for manual configuration or management. For example, use a change management workflow to deploy EC2 instances using infrastructure as code, then manage EC2 instances using tools instead of allowing direct access or a bastion host.",
        Title: "Enable people to perform actions at a distance",
      },
      {
        ChoiceId: "sec_protect_compute_validate_software_integrity",
        Description:
          "Implement mechanisms (for example, code signing) to validate that the software, code, and libraries used in the workload are from trusted sources and have not been tampered with.",
        Title: "Validate software integrity",
      },
      {
        ChoiceId: "sec_protect_compute_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-compute",
    QuestionTitle: "How do you protect your compute resources?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_data_classification_identify_data",
        Description:
          "This includes the type and classification of data, the associated business processes. data owner, applicable legal and compliance requirements, where it’s stored, and the resulting controls that are needed to be enforced. This may include classifications to indicate if the data is intended to be publicly available, if the data is internal use only such as customer personally identifiable information (PII), or if the data is for more restricted access such as intellectual property, legally privileged or marked sensititve, and more.",
        Title: "Identify the data within your workload",
      },
      {
        ChoiceId: "sec_data_classification_define_protection",
        Description:
          "Protect data according to its classification level. For example, secure data classified as public by using relevant recommendations while protecting sensitive data with additional controls.",
        Title: "Define data protection controls",
      },
      {
        ChoiceId: "sec_data_classification_auto_classification",
        Description:
          "Automate identification and classification of data to reduce the risk of human error from manual interactions.",
        Title: "Automate identification and classification",
      },
      {
        ChoiceId: "sec_data_classification_lifecycle_management",
        Description:
          "Your defined lifecycle strategy should be based on sensitivity level, as well as legal and organization requirements. Aspects including the duration you retain data for, data destruction, data access management, data transformation, and data sharing should be considered.",
        Title: "Define data lifecycle management",
      },
      {
        ChoiceId: "sec_data_classification_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "data-classification",
    QuestionTitle: "How do you classify your data?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_protect_data_rest_key_mgmt",
        Description:
          "Encryption keys must be stored securely, withstrict access control, for example, by using a key management service such as AWSKMS. Consider using different keys, and access control to the keys, combined with theAWS IAM and resource policies, to align with data classification levels andsegregation requirements.",
        Title: "Implement secure key management",
      },
      {
        ChoiceId: "sec_protect_data_rest_encrypt",
        Description:
          "Enforce your encryption requirements based on thelatest standards and recommendations to help protect your data at rest.",
        Title: "Enforce encryption at rest",
      },
      {
        ChoiceId: "sec_protect_data_rest_automate_protection",
        Description:
          "Use automated tools to validate and enforce data atrest protection continuously, for example, verify that there are only encryptedstorage resources.",
        Title: "Automate data at rest protection",
      },
      {
        ChoiceId: "sec_protect_data_rest_access_control",
        Description:
          "Enforce access control with least privileges andmechanisms, including backups, isolation, and versioning, to help protect your dataat rest. Prevent operators from granting public access to your data.",
        Title: "Enforce access control",
      },
      {
        ChoiceId: "sec_protect_data_rest_use_people_away",
        Description:
          "Keep all users away from directly accessingsensitive data and systems under normal operational circumstances. For example,provide a dashboard instead of direct access to a data store to run queries. WhereCI/CD pipelines are not used, determine which controls and processes are required toadequately provide a normally disabled break-glass access mechanism.",
        Title: "Use mechanisms to keep people away from data",
      },
      {
        ChoiceId: "sec_protect_data_rest_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-data-rest",
    QuestionTitle: "How do you protect your data at rest?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_protect_data_transit_key_cert_mgmt",
        Description:
          "Store encryption keys and certificates securely androtate them at appropriate time intervals while applying strict access control; forexample, by using a certificate management service, such as AWS Certificate Manager(ACM).",
        Title: "Implement secure key and certificatemanagement",
      },
      {
        ChoiceId: "sec_protect_data_transit_encrypt",
        Description:
          "Enforce your defined encryption requirements basedon appropriate standards and recommendations to help you meet your organizational,legal, and compliance requirements.",
        Title: "Enforce encryption in transit",
      },
      {
        ChoiceId: "sec_protect_data_transit_auto_unintended_access",
        Description:
          "Use tools such as GuardDuty to automatically detectattempts to move data outside of defined boundaries based on data classificationlevel, for example, to detect a trojan that is copying data to an unknown oruntrusted network using the DNS protocol.",
        Title: "Automate detection of unintended dataaccess",
      },
      {
        ChoiceId: "sec_protect_data_transit_authentication",
        Description:
          "Verify the identity of communications by usingprotocols that support authentication, such as Transport Layer Security (TLS) orIPsec.",
        Title: "Authenticate network communications",
      },
      {
        ChoiceId: "sec_protect_data_transit_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-data-transit",
    QuestionTitle: "How do you protect your data in transit?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_incident_response_identify_personnel",
        Description:
          "Identify internal and external personnel, resources, and legal obligations that would help your organization respond to an incident.",
        Title: "Identify key personnel and external resources",
      },
      {
        ChoiceId: "sec_incident_response_develop_management_plans",
        Description:
          "Create plans to help you respond to, communicate during, and recover from an incident. For example, you can start an incident response plan with the most likely scenarios for your workload and organization. Include how you would communicate and escalate both internally and externally.",
        Title: "Develop incident management plans",
      },
      {
        ChoiceId: "sec_incident_response_prepare_forensic",
        Description:
          "Identify and prepare forensic investigation capabilities that are suitable, including external specialists, tools, and automation.",
        Title: "Prepare forensic capabilities",
      },
      {
        ChoiceId: "sec_incident_response_auto_contain",
        Description:
          "Automate containment and recovery of an incident to reduce response times and organizational impact.",
        Title: "Automate containment capability",
      },
      {
        ChoiceId: "sec_incident_response_pre_provision_access",
        Description:
          "Ensure that incident responders have the correct access pre-provisioned into AWS to reduce the time for investigation through to recovery.",
        Title: "Pre-provision access",
      },
      {
        ChoiceId: "sec_incident_response_pre_deploy_tools",
        Description:
          "Ensure that security personnel have the right tools pre-deployed into AWS to reduce the time for investigation through to recovery.",
        Title: "Pre-deploy tools",
      },
      {
        ChoiceId: "sec_incident_response_run_game_days",
        Description:
          "Practice incident response game days (simulations) regularly, incorporate lessons learned into your incident management plans, and continuously improve.",
        Title: "Run game days",
      },
      {
        ChoiceId: "sec_incident_response_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "incident-response",
    QuestionTitle:
      "How do you anticipate, respond to, and recover from incidents?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
];

export const Security_Check_Q4_Answer_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: moment().subtract(1, "days"),
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-04-03 09:14:19",
    Description: "Test",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "yameen",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: moment().subtract(1, "days"),
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Security_Pillar_Q5 = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "sec_network_protection_layered",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_network_protection_inspection",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_network_protection_auto_protect",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sec_network_protection_create_layers",
        Description:
          "Group components that share sensitivity requirements into layers to minimize the potential scope of impact of unauthorized access. For example, a database cluster in a virtual private cloud (VPC) with no need for internet access should be placed in subnets with no route to or from the internet. Traffic should only flow from the adjacent next least sensitive resource. Consider a web application sitting behind a load balancer. Your database should not be accessible directly from the load balancer. Only the business logic or web server should have direct access to your database. ",
        Title: "Create network layers",
      },
      {
        ChoiceId: "sec_network_protection_layered",
        Description:
          "  When architecting your network topology, you should examine the connectivity requirements of each component. For example, if a component requires internet accessibility (inbound and outbound), connectivity to VPCs, edge services, and external data centers. ",
        Title: "Control traffic at all layers",
      },
      {
        ChoiceId: "sec_network_protection_inspection",
        Description:
          " Inspect and filter your traffic at each layer. You can inspect your VPC configurations for potential unintended access using VPC Network Access Analyzer. You can specify your network access requirements and identify potential network paths that do not meet them. For components transacting over HTTP-based protocols, a web application firewall can help protect from common attacks. AWS WAF is a web application firewall that lets you monitor and block HTTP(s) requests that match your configurable rules that are forwarded to an Amazon API Gateway API, Amazon CloudFront, or an Application Load Balancer. To get started with AWS WAF, you can use AWS Managed Rules in combination with your own, or use existing partner integrations. ",
        Title: "Implement inspection and protection",
      },
      {
        ChoiceId: "sec_network_protection_auto_protect",
        Description:
          " Automate protection mechanisms to provide a self-defending network based on threat intelligence and anomaly detection. For example, intrusion detection and prevention tools that can adapt to current threats and reduce their impact. A web application firewall is an example of where you can automate network protection, for example, by using the AWS WAF Security Automations solution to automatically block requests originating from IP addresses associated with known threat actors. ",
        Title: "Automate network protection",
      },
      {
        ChoiceId: "sec_network_protection_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.network-protection.helpful-resources.en.html",
    ImprovementPlanUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.network-protection.improvement-plan.en.html",
    IsApplicable: true,
    PillarId: "security",
    QuestionDescription:
      "Any workload that has some form of network connectivity, whether it’s the internet or a private network, requires multiple layers of defense to help protect from external and internal network-based threats.",
    QuestionId: "network-protection",
    QuestionTitle: "How do you protect your network resources?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "sec_network_protection_layered",
      "sec_network_protection_inspection",
      "sec_network_protection_auto_protect",
    ],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};
export const Security_Check_Q5_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 11,
  Passed: 29,
};

export const Security_Check_Q5_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: moment().subtract(1, "days"),
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-04-03 09:14:19",
    Description: "Test",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "yameen",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: moment().subtract(1, "days"),
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Security_Check_Q5_Answer_Summaries = [
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_securely_operate_multi_accounts",
        Description:
          "Organize workloads in separate accounts and group accounts based on function or a common set of controls rather than mirroring your company’s reporting structure. Start with security and infrastructure in mind to enable your organization to set common guardrails as your workloads grow.",
        Title: "Separate workloads using accounts",
      },
      {
        ChoiceId: "sec_securely_operate_aws_account",
        Description:
          "Secure access to your accounts, for example by enabling MFA and restrict use of the root user, and configure account contacts.",
        Title: "Secure AWS account",
      },
      {
        ChoiceId: "sec_securely_operate_control_objectives",
        Description:
          "Based on your compliance requirements and risks identified from your threat model, derive and validate the control objectives and controls that you need to apply to your workload. Ongoing validation of control objectives and controls help you measure the effectiveness of risk mitigation.",
        Title: "Identify and validate control objectives",
      },
      {
        ChoiceId: "sec_securely_operate_updated_threats",
        Description:
          "Recognize attack vectors by staying up to date with the latest security threats to help you define and implement appropriate controls.",
        Title: "Keep up to date with security threats",
      },
      {
        ChoiceId: "sec_securely_operate_updated_recommendations",
        Description:
          "Stay up to date with both AWS and industry security recommendations to evolve the security posture of your workload. ",
        Title: "Keep up to date with security recommendations",
      },
      {
        ChoiceId: "sec_securely_operate_test_validate_pipeline",
        Description:
          "Establish secure baselines and templates for security mechanisms that are tested and validated as part of your build, pipelines, and processes. Use tools and automation to test and validate all security controls continuously. For example, scan items such as machine images and infrastructure as code templates for security vulnerabilities, irregularities, and drift from an established baseline at each stage.",
        Title:
          "Automate testing and validation of security controls in pipelines",
      },
      {
        ChoiceId: "sec_securely_operate_threat_model",
        Description:
          "Use a threat model to identify and maintain an up-to-date register of potential threats. Prioritize your threats and adapt your security controls to prevent, detect, and respond. Revisit and maintain this in the context of the evolving security landscape.",
        Title: "Identify and prioritize risks using a threat model",
      },
      {
        ChoiceId: "sec_securely_operate_implement_services_features",
        Description:
          "AWS and APN Partners constantly release new features and services that allow you to evolve the security posture of your workload.",
        Title:
          "Evaluate and implement new security services and features regularly",
      },
      {
        ChoiceId: "sec_securely_operate_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "securely-operate",
    QuestionTitle: "How do you securely operate your workload?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_identities_enforce_mechanisms",
        Description:
          "Enforce minimum password length, and educate users to avoid common or re-used passwords. Enforce multi-factor authentication (MFA) with software or hardware mechanisms to provide an additional layer.",
        Title: "Use strong sign-in mechanisms",
      },
      {
        ChoiceId: "sec_identities_unique",
        Description:
          "Require identities to dynamically acquire temporary credentials. For workforce identities, use AWS Single Sign-On, or federation with IAM roles to access AWS accounts. For machine identities, require the use of IAM roles instead of long term access keys.",
        Title: "Use temporary credentials",
      },
      {
        ChoiceId: "sec_identities_secrets",
        Description:
          "For workforce and machine identities that require secrets such as passwords to third party applications, store them with automatic rotation using the latest industry standards in a specialized service.",
        Title: "Store and use secrets securely",
      },
      {
        ChoiceId: "sec_identities_identity_provider",
        Description:
          "For workforce identities, rely on an identity provider that enables you to manage identities in a centralized place. This enables you to create, manage, and revoke access from a single location making it easier to manage access. This reduces the requirement for multiple credentials and provides an opportunity to integrate with HR processes.",
        Title: "Rely on a centralized identity provider",
      },
      {
        ChoiceId: "sec_identities_audit",
        Description:
          "When you cannot rely on temporary credentials and require long term credentials, audit credentials to ensure that the defined controls (for example, MFA) are enforced, rotated regularly, and have appropriate access level.",
        Title: "Audit and rotate credentials periodically",
      },
      {
        ChoiceId: "sec_identities_groups_attributes",
        Description:
          "Place users with common security requirements in groups defined by your identity provider, and put mechanisms in place to ensure that user attributes that may be used for access control (e.g., department or location) are correct and updated. Use these groups and attributes, rather than individual users, to control access. This allows you to manage access centrally by changing a user’s group membership or attributes once, rather than updating many individual policies when a user’s access needs change.",
        Title: "Leverage user groups and attributes",
      },
      {
        ChoiceId: "sec_identities_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "identities",
    QuestionTitle: "How do you manage identities for people and machines?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_permissions_define",
        Description:
          "Each component or resource of your workload needs to be accessed by administrators, end users, or other components. Have a clear definition of who or what should have access to each component, choose the appropriate identity type and method of authentication and authorization.",
        Title: "Define access requirements",
      },
      {
        ChoiceId: "sec_permissions_least_privileges",
        Description:
          "Grant only the access that identities require by allowing access to specific actions on specific AWS resources under specific conditions. Rely on groups and identity attributes to dynamically set permissions at scale, rather than defining permissions for individual users. For example, you can allow a group of developers access to manage only resources for their project. This way, when a developer is removed from the group, access for the developer is revoked everywhere that group was used for access control, without requiring any changes to the access policies.",
        Title: "Grant least privilege access",
      },
      {
        ChoiceId: "sec_permissions_emergency_process",
        Description:
          "A process that allows emergency access to your workload in the unlikely event of an automated process or pipeline issue. This will help you rely on least privilege access, but ensure users can obtain the right level of access when they require it. For example, establish a process for administrators to verify and approve their request.",
        Title: "Establish emergency access process",
      },
      {
        ChoiceId: "sec_permissions_continuous_reduction",
        Description:
          "As teams and workloads determine what access they need, remove permissions they no longer use and establish review processes to achieve least privilege permissions. Continuously monitor and reduce unused identities and permissions.",
        Title: "Reduce permissions continuously",
      },
      {
        ChoiceId: "sec_permissions_define_guardrails",
        Description:
          "Establish common controls that restrict access to all identities in your organization. For example, you can restrict access to specific AWS Regions, or prevent your operators from deleting common resources, such as an IAM role used for your central security team.",
        Title: "Define permission guardrails for your organization",
      },
      {
        ChoiceId: "sec_permissions_lifecycle",
        Description:
          "Integrate access controls with operator and application life cycle and your centralized federation provider. For example, remove a user’s access when they leave the organization or change roles.",
        Title: "Manage access based on life cycle",
      },
      {
        ChoiceId: "sec_permissions_analyze_cross_account",
        Description:
          "Continuously monitor findings that highlight public and cross account access. Reduce public access and cross account access to only resources that require this type of access.",
        Title: "Analyze public and cross account access",
      },
      {
        ChoiceId: "sec_permissions_share_securely",
        Description:
          "Govern the consumption of shared resources across accounts or within your AWS Organization. Monitor shared resources and review shared resource access.",
        Title: "Share resources securely",
      },
      {
        ChoiceId: "sec_permissions_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "permissions",
    QuestionTitle: "How do you manage permissions for people and machines?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_detect_investigate_events_app_service_logging",
        Description:
          "Configure logging throughout the workload, including application logs, resource logs, and AWS service logs. For example, ensure that AWS CloudTrail, Amazon CloudWatch Logs, Amazon GuardDuty and AWS Security Hub are enabled for all accounts within your organization.",
        Title: "Configure service and application logging",
      },
      {
        ChoiceId: "sec_detect_investigate_events_analyze_all",
        Description:
          "All logs, metrics, and telemetry should be collected centrally, and automatically analyzed to detect anomalies and indicators of unauthorized activity. A dashboard can provide you easy to access insight into real-time health. For example, ensure that Amazon GuardDuty and Security Hub logs are sent to a central location for alerting and analysis.",
        Title: "Analyze logs, findings, and metrics centrally",
      },
      {
        ChoiceId: "sec_detect_investigate_events_auto_response",
        Description:
          "Using automation to investigate and remediate events reduces human effort and error, and enables you to scale investigation capabilities. Regular reviews will help you tune automation tools, and continuously iterate. For example, automate responses to Amazon GuardDuty events by automating the first investigation step, then iterate to gradually remove human effort.",
        Title: "Automate response to events",
      },
      {
        ChoiceId: "sec_detect_investigate_events_actionable_events",
        Description:
          "Create alerts that are sent to and can be actioned by your team. Ensure that alerts include relevant information for the team to take action. For example, ensure that Amazon GuardDuty and AWS Security Hub alerts are sent to the team to action, or sent to response automation tooling with the team remaining informed by messaging from the automation framework.",
        Title: "Implement actionable security events",
      },
      {
        ChoiceId: "sec_detect_investigate_events_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "detect-investigate-events",
    QuestionTitle: "How do you detect and investigate security events?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_network_protection_create_layers",
        Description:
          "Group components that share reachability requirements into layers. For example, a database cluster in a VPC with no need for internet access should be placed in subnets with no route to or from the internet. In a serverless workload operating without a VPC, similar layering and segmentation with microservices can achieve the same goal.",
        Title: "Create network layers",
      },
      {
        ChoiceId: "sec_network_protection_layered",
        Description:
          "Apply controls with a defense in depth approach for both inbound and outbound traffic. For example, for Amazon Virtual Private Cloud (VPC) this includes security groups, Network ACLs, and subnets. For AWS Lambda, consider running in your private VPC with VPC-based controls.",
        Title: "Control traffic at all layers",
      },
      {
        ChoiceId: "sec_network_protection_auto_protect",
        Description:
          "Automate protection mechanisms to provide a self-defending network based on threat intelligence and anomaly detection. For example, intrusion detection and prevention tools that can pro-actively adapt to current threats and reduce their impact.",
        Title: "Automate network protection",
      },
      {
        ChoiceId: "sec_network_protection_inspection",
        Description:
          "Inspect and filter your traffic at each layer. For example, use a web application firewall to help protect against inadvertent access at the application network layer. For Lambda functions, third-party tools can add application-layer firewalling to your runtime environment.",
        Title: "Implement inspection and protection",
      },
      {
        ChoiceId: "sec_network_protection_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "network-protection",
    QuestionTitle: "How do you protect your network resources?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_protect_compute_vulnerability_management",
        Description:
          "Frequently scan and patch for vulnerabilities in your code, dependencies, and in your infrastructure to help protect against new threats.",
        Title: "Perform vulnerability management",
      },
      {
        ChoiceId: "sec_protect_compute_reduce_surface",
        Description:
          "Reduce your attack surface by hardening operating systems, minimizing components, libraries, and externally consumable services in use.",
        Title: "Reduce attack surface",
      },
      {
        ChoiceId: "sec_protect_compute_implement_managed_services",
        Description:
          "Implement services that manage resources, such as Amazon RDS, AWS Lambda, and Amazon ECS, to reduce your security maintenance tasks as part of the shared responsibility model.",
        Title: "Implement managed services",
      },
      {
        ChoiceId: "sec_protect_compute_auto_protection",
        Description:
          "Automate your protective compute mechanisms including vulnerability management, reduction in attack surface, and management of resources.",
        Title: "Automate compute protection",
      },
      {
        ChoiceId: "sec_protect_compute_actions_distance",
        Description:
          "Removing the ability for interactive access reduces the risk of human error, and the potential for manual configuration or management. For example, use a change management workflow to deploy EC2 instances using infrastructure as code, then manage EC2 instances using tools instead of allowing direct access or a bastion host.",
        Title: "Enable people to perform actions at a distance",
      },
      {
        ChoiceId: "sec_protect_compute_validate_software_integrity",
        Description:
          "Implement mechanisms (for example, code signing) to validate that the software, code, and libraries used in the workload are from trusted sources and have not been tampered with.",
        Title: "Validate software integrity",
      },
      {
        ChoiceId: "sec_protect_compute_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-compute",
    QuestionTitle: "How do you protect your compute resources?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_data_classification_identify_data",
        Description:
          "This includes the type and classification of data, the associated business processes. data owner, applicable legal and compliance requirements, where it’s stored, and the resulting controls that are needed to be enforced. This may include classifications to indicate if the data is intended to be publicly available, if the data is internal use only such as customer personally identifiable information (PII), or if the data is for more restricted access such as intellectual property, legally privileged or marked sensititve, and more.",
        Title: "Identify the data within your workload",
      },
      {
        ChoiceId: "sec_data_classification_define_protection",
        Description:
          "Protect data according to its classification level. For example, secure data classified as public by using relevant recommendations while protecting sensitive data with additional controls.",
        Title: "Define data protection controls",
      },
      {
        ChoiceId: "sec_data_classification_auto_classification",
        Description:
          "Automate identification and classification of data to reduce the risk of human error from manual interactions.",
        Title: "Automate identification and classification",
      },
      {
        ChoiceId: "sec_data_classification_lifecycle_management",
        Description:
          "Your defined lifecycle strategy should be based on sensitivity level, as well as legal and organization requirements. Aspects including the duration you retain data for, data destruction, data access management, data transformation, and data sharing should be considered.",
        Title: "Define data lifecycle management",
      },
      {
        ChoiceId: "sec_data_classification_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "data-classification",
    QuestionTitle: "How do you classify your data?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_protect_data_rest_key_mgmt",
        Description:
          "Encryption keys must be stored securely, withstrict access control, for example, by using a key management service such as AWSKMS. Consider using different keys, and access control to the keys, combined with theAWS IAM and resource policies, to align with data classification levels andsegregation requirements.",
        Title: "Implement secure key management",
      },
      {
        ChoiceId: "sec_protect_data_rest_encrypt",
        Description:
          "Enforce your encryption requirements based on thelatest standards and recommendations to help protect your data at rest.",
        Title: "Enforce encryption at rest",
      },
      {
        ChoiceId: "sec_protect_data_rest_automate_protection",
        Description:
          "Use automated tools to validate and enforce data atrest protection continuously, for example, verify that there are only encryptedstorage resources.",
        Title: "Automate data at rest protection",
      },
      {
        ChoiceId: "sec_protect_data_rest_access_control",
        Description:
          "Enforce access control with least privileges andmechanisms, including backups, isolation, and versioning, to help protect your dataat rest. Prevent operators from granting public access to your data.",
        Title: "Enforce access control",
      },
      {
        ChoiceId: "sec_protect_data_rest_use_people_away",
        Description:
          "Keep all users away from directly accessingsensitive data and systems under normal operational circumstances. For example,provide a dashboard instead of direct access to a data store to run queries. WhereCI/CD pipelines are not used, determine which controls and processes are required toadequately provide a normally disabled break-glass access mechanism.",
        Title: "Use mechanisms to keep people away from data",
      },
      {
        ChoiceId: "sec_protect_data_rest_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-data-rest",
    QuestionTitle: "How do you protect your data at rest?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_protect_data_transit_key_cert_mgmt",
        Description:
          "Store encryption keys and certificates securely androtate them at appropriate time intervals while applying strict access control; forexample, by using a certificate management service, such as AWS Certificate Manager(ACM).",
        Title: "Implement secure key and certificatemanagement",
      },
      {
        ChoiceId: "sec_protect_data_transit_encrypt",
        Description:
          "Enforce your defined encryption requirements basedon appropriate standards and recommendations to help you meet your organizational,legal, and compliance requirements.",
        Title: "Enforce encryption in transit",
      },
      {
        ChoiceId: "sec_protect_data_transit_auto_unintended_access",
        Description:
          "Use tools such as GuardDuty to automatically detectattempts to move data outside of defined boundaries based on data classificationlevel, for example, to detect a trojan that is copying data to an unknown oruntrusted network using the DNS protocol.",
        Title: "Automate detection of unintended dataaccess",
      },
      {
        ChoiceId: "sec_protect_data_transit_authentication",
        Description:
          "Verify the identity of communications by usingprotocols that support authentication, such as Transport Layer Security (TLS) orIPsec.",
        Title: "Authenticate network communications",
      },
      {
        ChoiceId: "sec_protect_data_transit_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-data-transit",
    QuestionTitle: "How do you protect your data in transit?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_incident_response_identify_personnel",
        Description:
          "Identify internal and external personnel, resources, and legal obligations that would help your organization respond to an incident.",
        Title: "Identify key personnel and external resources",
      },
      {
        ChoiceId: "sec_incident_response_develop_management_plans",
        Description:
          "Create plans to help you respond to, communicate during, and recover from an incident. For example, you can start an incident response plan with the most likely scenarios for your workload and organization. Include how you would communicate and escalate both internally and externally.",
        Title: "Develop incident management plans",
      },
      {
        ChoiceId: "sec_incident_response_prepare_forensic",
        Description:
          "Identify and prepare forensic investigation capabilities that are suitable, including external specialists, tools, and automation.",
        Title: "Prepare forensic capabilities",
      },
      {
        ChoiceId: "sec_incident_response_auto_contain",
        Description:
          "Automate containment and recovery of an incident to reduce response times and organizational impact.",
        Title: "Automate containment capability",
      },
      {
        ChoiceId: "sec_incident_response_pre_provision_access",
        Description:
          "Ensure that incident responders have the correct access pre-provisioned into AWS to reduce the time for investigation through to recovery.",
        Title: "Pre-provision access",
      },
      {
        ChoiceId: "sec_incident_response_pre_deploy_tools",
        Description:
          "Ensure that security personnel have the right tools pre-deployed into AWS to reduce the time for investigation through to recovery.",
        Title: "Pre-deploy tools",
      },
      {
        ChoiceId: "sec_incident_response_run_game_days",
        Description:
          "Practice incident response game days (simulations) regularly, incorporate lessons learned into your incident management plans, and continuously improve.",
        Title: "Run game days",
      },
      {
        ChoiceId: "sec_incident_response_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "incident-response",
    QuestionTitle:
      "How do you anticipate, respond to, and recover from incidents?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
];

export const Security_Pillar_Q6 = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "sec_protect_compute_reduce_surface",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_protect_compute_implement_managed_services",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_protect_compute_actions_distance",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_protect_compute_auto_protection",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sec_protect_compute_vulnerability_management",
        Description:
          "Frequently scan and patch for vulnerabilities in your code, dependencies, and in your infrastructure to help protect against new threats.",
        Title: "Perform vulnerability management",
      },
      {
        ChoiceId: "sec_protect_compute_reduce_surface",
        Description:
          " Reduce your exposure to unintended access by hardening operating systems and minimizing the components, libraries, and externally consumable services in use. Start by reducing unused components, whether they are operating system packages or applications, for Amazon Elastic Compute Cloud (Amazon EC2)-based workloads, or external software modules in your code, for all workloads. You can find many hardening and security configuration guides for common operating systems and server software. For example, you can start with the Center for Internet Security and iterate.",
        Title: "Reduce attack surface",
      },
      {
        ChoiceId: "sec_protect_compute_actions_distance",
        Description:
          " Removing the ability for interactive access reduces the risk of human error, and the potential for manual configuration or management. For example, use a change management workflow to deploy Amazon Elastic Compute Cloud (Amazon EC2) instances using infrastructure-as-code, then manage Amazon EC2 instances using tools such as AWS Systems Manager instead of allowing direct access or through a bastion host. AWS Systems Manager can automate a variety of maintenance and deployment tasks, using features including automation workflows, documents (playbooks), and the run command. AWS CloudFormation stacks build from pipelines and can automate your infrastructure deployment and management tasks without using the AWS Management Console or APIs directly. ",
        Title: "Enable people to perform actions at a distance",
      },
      {
        ChoiceId: "sec_protect_compute_validate_software_integrity",
        Description:
          " Implement mechanisms (for example, code signing) to validate that the software, code and libraries used in the workload are from trusted sources and have not been tampered with. For example, you should verify the code signing certificate of binaries and scripts to confirm the author, and ensure it has not been tampered with since created by the author. AWS Signer can help ensure the trust and integrity of your code by centrally managing the code- signing lifecycle, including signing certification and public and private keys. You can learn how to use advanced patterns and best practices for code signing with AWS Lambda. Additionally, a checksum of software that you download, compared to that of the checksum from the provider, can help ensure it has not been tampered with. ",
        Title: "Validate software integrity",
      },
      {
        ChoiceId: "sec_protect_compute_implement_managed_services",
        Description:
          " Implement services that manage resources, such as Amazon Relational Database Service (Amazon RDS), AWS Lambda, and Amazon Elastic Container Service (Amazon ECS), to reduce your security maintenance tasks as part of the shared responsibility model. For example, Amazon RDS helps you set up, operate, and scale a relational database, automates administration tasks such as hardware provisioning, database setup, patching, and backups. This means you have more free time to focus on securing your application in other ways described in the AWS Well-Architected Framework. Lambda lets you run code without provisioning or managing servers, so you only need to focus on the connectivity, invocation, and security at the code level–not the infrastructure or operating system. ",
        Title: "Implement managed services",
      },
      {
        ChoiceId: "sec_protect_compute_auto_protection",
        Description:
          " Automate your protective compute mechanisms including vulnerability management, reduction in attack surface, and management of resources. The automation will help you invest time in securing other aspects of your workload, and reduce the risk of human error. ",
        Title: "Automate compute protection",
      },
      {
        ChoiceId: "sec_protect_compute_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.protect-compute.helpful-resources.en.html",
    ImprovementPlanUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.protect-compute.improvement-plan.en.html",
    IsApplicable: true,
    PillarId: "security",
    QuestionDescription:
      "Compute resources in your workload require multiple layers of defense to help protect from external and internal threats. Compute resources include EC2 instances, containers, AWS Lambda functions, database services, IoT devices, and more.",
    QuestionId: "protect-compute",
    QuestionTitle: "How do you protect your compute resources?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "sec_protect_compute_reduce_surface",
      "sec_protect_compute_implement_managed_services",
      "sec_protect_compute_actions_distance",
      "sec_protect_compute_auto_protection",
    ],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Security_Check_Q6_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 1,
  Failed: 19,
  Passed: 12,
};

export const Security_Check_Q6_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: moment().subtract(1, "days"),
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-04-03 09:14:19",
    Description: "Test",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "yameen",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: moment().subtract(1, "days"),
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Security_Check_Q6_Answer_Summaries = [
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_securely_operate_multi_accounts",
        Description:
          "Organize workloads in separate accounts and group accounts based on function or a common set of controls rather than mirroring your company’s reporting structure. Start with security and infrastructure in mind to enable your organization to set common guardrails as your workloads grow.",
        Title: "Separate workloads using accounts",
      },
      {
        ChoiceId: "sec_securely_operate_aws_account",
        Description:
          "Secure access to your accounts, for example by enabling MFA and restrict use of the root user, and configure account contacts.",
        Title: "Secure AWS account",
      },
      {
        ChoiceId: "sec_securely_operate_control_objectives",
        Description:
          "Based on your compliance requirements and risks identified from your threat model, derive and validate the control objectives and controls that you need to apply to your workload. Ongoing validation of control objectives and controls help you measure the effectiveness of risk mitigation.",
        Title: "Identify and validate control objectives",
      },
      {
        ChoiceId: "sec_securely_operate_updated_threats",
        Description:
          "Recognize attack vectors by staying up to date with the latest security threats to help you define and implement appropriate controls.",
        Title: "Keep up to date with security threats",
      },
      {
        ChoiceId: "sec_securely_operate_updated_recommendations",
        Description:
          "Stay up to date with both AWS and industry security recommendations to evolve the security posture of your workload. ",
        Title: "Keep up to date with security recommendations",
      },
      {
        ChoiceId: "sec_securely_operate_test_validate_pipeline",
        Description:
          "Establish secure baselines and templates for security mechanisms that are tested and validated as part of your build, pipelines, and processes. Use tools and automation to test and validate all security controls continuously. For example, scan items such as machine images and infrastructure as code templates for security vulnerabilities, irregularities, and drift from an established baseline at each stage.",
        Title:
          "Automate testing and validation of security controls in pipelines",
      },
      {
        ChoiceId: "sec_securely_operate_threat_model",
        Description:
          "Use a threat model to identify and maintain an up-to-date register of potential threats. Prioritize your threats and adapt your security controls to prevent, detect, and respond. Revisit and maintain this in the context of the evolving security landscape.",
        Title: "Identify and prioritize risks using a threat model",
      },
      {
        ChoiceId: "sec_securely_operate_implement_services_features",
        Description:
          "AWS and APN Partners constantly release new features and services that allow you to evolve the security posture of your workload.",
        Title:
          "Evaluate and implement new security services and features regularly",
      },
      {
        ChoiceId: "sec_securely_operate_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "securely-operate",
    QuestionTitle: "How do you securely operate your workload?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_identities_enforce_mechanisms",
        Description:
          "Enforce minimum password length, and educate users to avoid common or re-used passwords. Enforce multi-factor authentication (MFA) with software or hardware mechanisms to provide an additional layer.",
        Title: "Use strong sign-in mechanisms",
      },
      {
        ChoiceId: "sec_identities_unique",
        Description:
          "Require identities to dynamically acquire temporary credentials. For workforce identities, use AWS Single Sign-On, or federation with IAM roles to access AWS accounts. For machine identities, require the use of IAM roles instead of long term access keys.",
        Title: "Use temporary credentials",
      },
      {
        ChoiceId: "sec_identities_secrets",
        Description:
          "For workforce and machine identities that require secrets such as passwords to third party applications, store them with automatic rotation using the latest industry standards in a specialized service.",
        Title: "Store and use secrets securely",
      },
      {
        ChoiceId: "sec_identities_identity_provider",
        Description:
          "For workforce identities, rely on an identity provider that enables you to manage identities in a centralized place. This enables you to create, manage, and revoke access from a single location making it easier to manage access. This reduces the requirement for multiple credentials and provides an opportunity to integrate with HR processes.",
        Title: "Rely on a centralized identity provider",
      },
      {
        ChoiceId: "sec_identities_audit",
        Description:
          "When you cannot rely on temporary credentials and require long term credentials, audit credentials to ensure that the defined controls (for example, MFA) are enforced, rotated regularly, and have appropriate access level.",
        Title: "Audit and rotate credentials periodically",
      },
      {
        ChoiceId: "sec_identities_groups_attributes",
        Description:
          "Place users with common security requirements in groups defined by your identity provider, and put mechanisms in place to ensure that user attributes that may be used for access control (e.g., department or location) are correct and updated. Use these groups and attributes, rather than individual users, to control access. This allows you to manage access centrally by changing a user’s group membership or attributes once, rather than updating many individual policies when a user’s access needs change.",
        Title: "Leverage user groups and attributes",
      },
      {
        ChoiceId: "sec_identities_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "identities",
    QuestionTitle: "How do you manage identities for people and machines?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_permissions_define",
        Description:
          "Each component or resource of your workload needs to be accessed by administrators, end users, or other components. Have a clear definition of who or what should have access to each component, choose the appropriate identity type and method of authentication and authorization.",
        Title: "Define access requirements",
      },
      {
        ChoiceId: "sec_permissions_least_privileges",
        Description:
          "Grant only the access that identities require by allowing access to specific actions on specific AWS resources under specific conditions. Rely on groups and identity attributes to dynamically set permissions at scale, rather than defining permissions for individual users. For example, you can allow a group of developers access to manage only resources for their project. This way, when a developer is removed from the group, access for the developer is revoked everywhere that group was used for access control, without requiring any changes to the access policies.",
        Title: "Grant least privilege access",
      },
      {
        ChoiceId: "sec_permissions_emergency_process",
        Description:
          "A process that allows emergency access to your workload in the unlikely event of an automated process or pipeline issue. This will help you rely on least privilege access, but ensure users can obtain the right level of access when they require it. For example, establish a process for administrators to verify and approve their request.",
        Title: "Establish emergency access process",
      },
      {
        ChoiceId: "sec_permissions_continuous_reduction",
        Description:
          "As teams and workloads determine what access they need, remove permissions they no longer use and establish review processes to achieve least privilege permissions. Continuously monitor and reduce unused identities and permissions.",
        Title: "Reduce permissions continuously",
      },
      {
        ChoiceId: "sec_permissions_define_guardrails",
        Description:
          "Establish common controls that restrict access to all identities in your organization. For example, you can restrict access to specific AWS Regions, or prevent your operators from deleting common resources, such as an IAM role used for your central security team.",
        Title: "Define permission guardrails for your organization",
      },
      {
        ChoiceId: "sec_permissions_lifecycle",
        Description:
          "Integrate access controls with operator and application life cycle and your centralized federation provider. For example, remove a user’s access when they leave the organization or change roles.",
        Title: "Manage access based on life cycle",
      },
      {
        ChoiceId: "sec_permissions_analyze_cross_account",
        Description:
          "Continuously monitor findings that highlight public and cross account access. Reduce public access and cross account access to only resources that require this type of access.",
        Title: "Analyze public and cross account access",
      },
      {
        ChoiceId: "sec_permissions_share_securely",
        Description:
          "Govern the consumption of shared resources across accounts or within your AWS Organization. Monitor shared resources and review shared resource access.",
        Title: "Share resources securely",
      },
      {
        ChoiceId: "sec_permissions_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "permissions",
    QuestionTitle: "How do you manage permissions for people and machines?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_detect_investigate_events_app_service_logging",
        Description:
          "Configure logging throughout the workload, including application logs, resource logs, and AWS service logs. For example, ensure that AWS CloudTrail, Amazon CloudWatch Logs, Amazon GuardDuty and AWS Security Hub are enabled for all accounts within your organization.",
        Title: "Configure service and application logging",
      },
      {
        ChoiceId: "sec_detect_investigate_events_analyze_all",
        Description:
          "All logs, metrics, and telemetry should be collected centrally, and automatically analyzed to detect anomalies and indicators of unauthorized activity. A dashboard can provide you easy to access insight into real-time health. For example, ensure that Amazon GuardDuty and Security Hub logs are sent to a central location for alerting and analysis.",
        Title: "Analyze logs, findings, and metrics centrally",
      },
      {
        ChoiceId: "sec_detect_investigate_events_auto_response",
        Description:
          "Using automation to investigate and remediate events reduces human effort and error, and enables you to scale investigation capabilities. Regular reviews will help you tune automation tools, and continuously iterate. For example, automate responses to Amazon GuardDuty events by automating the first investigation step, then iterate to gradually remove human effort.",
        Title: "Automate response to events",
      },
      {
        ChoiceId: "sec_detect_investigate_events_actionable_events",
        Description:
          "Create alerts that are sent to and can be actioned by your team. Ensure that alerts include relevant information for the team to take action. For example, ensure that Amazon GuardDuty and AWS Security Hub alerts are sent to the team to action, or sent to response automation tooling with the team remaining informed by messaging from the automation framework.",
        Title: "Implement actionable security events",
      },
      {
        ChoiceId: "sec_detect_investigate_events_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "detect-investigate-events",
    QuestionTitle: "How do you detect and investigate security events?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_network_protection_create_layers",
        Description:
          "Group components that share reachability requirements into layers. For example, a database cluster in a VPC with no need for internet access should be placed in subnets with no route to or from the internet. In a serverless workload operating without a VPC, similar layering and segmentation with microservices can achieve the same goal.",
        Title: "Create network layers",
      },
      {
        ChoiceId: "sec_network_protection_layered",
        Description:
          "Apply controls with a defense in depth approach for both inbound and outbound traffic. For example, for Amazon Virtual Private Cloud (VPC) this includes security groups, Network ACLs, and subnets. For AWS Lambda, consider running in your private VPC with VPC-based controls.",
        Title: "Control traffic at all layers",
      },
      {
        ChoiceId: "sec_network_protection_auto_protect",
        Description:
          "Automate protection mechanisms to provide a self-defending network based on threat intelligence and anomaly detection. For example, intrusion detection and prevention tools that can pro-actively adapt to current threats and reduce their impact.",
        Title: "Automate network protection",
      },
      {
        ChoiceId: "sec_network_protection_inspection",
        Description:
          "Inspect and filter your traffic at each layer. For example, use a web application firewall to help protect against inadvertent access at the application network layer. For Lambda functions, third-party tools can add application-layer firewalling to your runtime environment.",
        Title: "Implement inspection and protection",
      },
      {
        ChoiceId: "sec_network_protection_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "network-protection",
    QuestionTitle: "How do you protect your network resources?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_protect_compute_vulnerability_management",
        Description:
          "Frequently scan and patch for vulnerabilities in your code, dependencies, and in your infrastructure to help protect against new threats.",
        Title: "Perform vulnerability management",
      },
      {
        ChoiceId: "sec_protect_compute_reduce_surface",
        Description:
          "Reduce your attack surface by hardening operating systems, minimizing components, libraries, and externally consumable services in use.",
        Title: "Reduce attack surface",
      },
      {
        ChoiceId: "sec_protect_compute_implement_managed_services",
        Description:
          "Implement services that manage resources, such as Amazon RDS, AWS Lambda, and Amazon ECS, to reduce your security maintenance tasks as part of the shared responsibility model.",
        Title: "Implement managed services",
      },
      {
        ChoiceId: "sec_protect_compute_auto_protection",
        Description:
          "Automate your protective compute mechanisms including vulnerability management, reduction in attack surface, and management of resources.",
        Title: "Automate compute protection",
      },
      {
        ChoiceId: "sec_protect_compute_actions_distance",
        Description:
          "Removing the ability for interactive access reduces the risk of human error, and the potential for manual configuration or management. For example, use a change management workflow to deploy EC2 instances using infrastructure as code, then manage EC2 instances using tools instead of allowing direct access or a bastion host.",
        Title: "Enable people to perform actions at a distance",
      },
      {
        ChoiceId: "sec_protect_compute_validate_software_integrity",
        Description:
          "Implement mechanisms (for example, code signing) to validate that the software, code, and libraries used in the workload are from trusted sources and have not been tampered with.",
        Title: "Validate software integrity",
      },
      {
        ChoiceId: "sec_protect_compute_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-compute",
    QuestionTitle: "How do you protect your compute resources?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_data_classification_identify_data",
        Description:
          "This includes the type and classification of data, the associated business processes. data owner, applicable legal and compliance requirements, where it’s stored, and the resulting controls that are needed to be enforced. This may include classifications to indicate if the data is intended to be publicly available, if the data is internal use only such as customer personally identifiable information (PII), or if the data is for more restricted access such as intellectual property, legally privileged or marked sensititve, and more.",
        Title: "Identify the data within your workload",
      },
      {
        ChoiceId: "sec_data_classification_define_protection",
        Description:
          "Protect data according to its classification level. For example, secure data classified as public by using relevant recommendations while protecting sensitive data with additional controls.",
        Title: "Define data protection controls",
      },
      {
        ChoiceId: "sec_data_classification_auto_classification",
        Description:
          "Automate identification and classification of data to reduce the risk of human error from manual interactions.",
        Title: "Automate identification and classification",
      },
      {
        ChoiceId: "sec_data_classification_lifecycle_management",
        Description:
          "Your defined lifecycle strategy should be based on sensitivity level, as well as legal and organization requirements. Aspects including the duration you retain data for, data destruction, data access management, data transformation, and data sharing should be considered.",
        Title: "Define data lifecycle management",
      },
      {
        ChoiceId: "sec_data_classification_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "data-classification",
    QuestionTitle: "How do you classify your data?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_protect_data_rest_key_mgmt",
        Description:
          "Encryption keys must be stored securely, withstrict access control, for example, by using a key management service such as AWSKMS. Consider using different keys, and access control to the keys, combined with theAWS IAM and resource policies, to align with data classification levels andsegregation requirements.",
        Title: "Implement secure key management",
      },
      {
        ChoiceId: "sec_protect_data_rest_encrypt",
        Description:
          "Enforce your encryption requirements based on thelatest standards and recommendations to help protect your data at rest.",
        Title: "Enforce encryption at rest",
      },
      {
        ChoiceId: "sec_protect_data_rest_automate_protection",
        Description:
          "Use automated tools to validate and enforce data atrest protection continuously, for example, verify that there are only encryptedstorage resources.",
        Title: "Automate data at rest protection",
      },
      {
        ChoiceId: "sec_protect_data_rest_access_control",
        Description:
          "Enforce access control with least privileges andmechanisms, including backups, isolation, and versioning, to help protect your dataat rest. Prevent operators from granting public access to your data.",
        Title: "Enforce access control",
      },
      {
        ChoiceId: "sec_protect_data_rest_use_people_away",
        Description:
          "Keep all users away from directly accessingsensitive data and systems under normal operational circumstances. For example,provide a dashboard instead of direct access to a data store to run queries. WhereCI/CD pipelines are not used, determine which controls and processes are required toadequately provide a normally disabled break-glass access mechanism.",
        Title: "Use mechanisms to keep people away from data",
      },
      {
        ChoiceId: "sec_protect_data_rest_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-data-rest",
    QuestionTitle: "How do you protect your data at rest?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_protect_data_transit_key_cert_mgmt",
        Description:
          "Store encryption keys and certificates securely androtate them at appropriate time intervals while applying strict access control; forexample, by using a certificate management service, such as AWS Certificate Manager(ACM).",
        Title: "Implement secure key and certificatemanagement",
      },
      {
        ChoiceId: "sec_protect_data_transit_encrypt",
        Description:
          "Enforce your defined encryption requirements basedon appropriate standards and recommendations to help you meet your organizational,legal, and compliance requirements.",
        Title: "Enforce encryption in transit",
      },
      {
        ChoiceId: "sec_protect_data_transit_auto_unintended_access",
        Description:
          "Use tools such as GuardDuty to automatically detectattempts to move data outside of defined boundaries based on data classificationlevel, for example, to detect a trojan that is copying data to an unknown oruntrusted network using the DNS protocol.",
        Title: "Automate detection of unintended dataaccess",
      },
      {
        ChoiceId: "sec_protect_data_transit_authentication",
        Description:
          "Verify the identity of communications by usingprotocols that support authentication, such as Transport Layer Security (TLS) orIPsec.",
        Title: "Authenticate network communications",
      },
      {
        ChoiceId: "sec_protect_data_transit_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-data-transit",
    QuestionTitle: "How do you protect your data in transit?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_incident_response_identify_personnel",
        Description:
          "Identify internal and external personnel, resources, and legal obligations that would help your organization respond to an incident.",
        Title: "Identify key personnel and external resources",
      },
      {
        ChoiceId: "sec_incident_response_develop_management_plans",
        Description:
          "Create plans to help you respond to, communicate during, and recover from an incident. For example, you can start an incident response plan with the most likely scenarios for your workload and organization. Include how you would communicate and escalate both internally and externally.",
        Title: "Develop incident management plans",
      },
      {
        ChoiceId: "sec_incident_response_prepare_forensic",
        Description:
          "Identify and prepare forensic investigation capabilities that are suitable, including external specialists, tools, and automation.",
        Title: "Prepare forensic capabilities",
      },
      {
        ChoiceId: "sec_incident_response_auto_contain",
        Description:
          "Automate containment and recovery of an incident to reduce response times and organizational impact.",
        Title: "Automate containment capability",
      },
      {
        ChoiceId: "sec_incident_response_pre_provision_access",
        Description:
          "Ensure that incident responders have the correct access pre-provisioned into AWS to reduce the time for investigation through to recovery.",
        Title: "Pre-provision access",
      },
      {
        ChoiceId: "sec_incident_response_pre_deploy_tools",
        Description:
          "Ensure that security personnel have the right tools pre-deployed into AWS to reduce the time for investigation through to recovery.",
        Title: "Pre-deploy tools",
      },
      {
        ChoiceId: "sec_incident_response_run_game_days",
        Description:
          "Practice incident response game days (simulations) regularly, incorporate lessons learned into your incident management plans, and continuously improve.",
        Title: "Run game days",
      },
      {
        ChoiceId: "sec_incident_response_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "incident-response",
    QuestionTitle:
      "How do you anticipate, respond to, and recover from incidents?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
];

export const Security_Pillar_Q7 = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "sec_data_classification_define_protection",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_data_classification_lifecycle_management",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sec_data_classification_identify_data",
        Description:
          "It’s critical to understand the type and classification of data your workload is processing, the associated business processes, where the data is stored, and who is the data owner. You should also have an understanding of the applicable legal and compliance requirements of your workload, and what data controls need to be enforced. Identifying data is the first step in the data classification journey. ",
        Title: "Identify the data within your workload",
      },
      {
        ChoiceId: "sec_data_classification_define_protection",
        Description:
          " Protect data according to its classification level. For example, secure data classified as public by using relevant recommendations while protecting sensitive data with additional controls. ",
        Title: "Define data protection controls",
      },
      {
        ChoiceId: "sec_data_classification_lifecycle_management",
        Description:
          " Your defined lifecycle strategy should be based on sensitivity level as well as legal and organization requirements. Aspects including the duration for which you retain data, data destruction processes, data access management, data transformation, and data sharing should be considered. When choosing a data classification methodology, balance usability versus access. You should also accommodate the multiple levels of access and nuances for implementing a secure, but still usable, approach for each level. Always use a defense in depth approach and reduce human access to data and mechanisms for transforming, deleting, or copying data. For example, require users to strongly authenticate to an application, and give the application, rather than the users, the requisite access permission to perform action at a distance. In addition, ensure that users come from a trusted network path and require access to the decryption keys. Use tools, such as dashboards and automated reporting, to give users information from the data rather than giving them direct access to the data. ",
        Title: "Define data lifecycle management",
      },
      {
        ChoiceId: "sec_data_classification_auto_classification",
        Description:
          " Automating the identification and classification of data can help you implement the correct controls. Using automation for this instead of direct access from a person reduces the risk of human error and exposure. You should evaluate using a tool, such as Amazon Macie, that uses machine learning to automatically discover, classify, and protect sensitive data in AWS. Amazon Macie recognizes sensitive data, such as personally identifiable information (PII) or intellectual property, and provides you with dashboards and alerts that give visibility into how this data is being accessed or moved. ",
        Title: "Automate identification and classification",
      },
      {
        ChoiceId: "sec_data_classification_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.data-classification.helpful-resources.en.html",
    ImprovementPlanUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.data-classification.improvement-plan.en.html",
    IsApplicable: true,
    PillarId: "security",
    QuestionDescription:
      "Classification provides a way to categorize data, based on criticality and sensitivity in order to help you determine appropriate protection and retention controls.",
    QuestionId: "data-classification",
    QuestionTitle: "How do you classify your data?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "sec_data_classification_define_protection",
      "sec_data_classification_lifecycle_management",
    ],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Security_Check_Q7_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 3,
  Passed: 5,
};

export const Security_Check_Q7_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: moment().subtract(1, "days"),
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-04-03 09:14:19",
    Description: "Test",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "yameen",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: moment().subtract(1, "days"),
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Security_Check_Q7_Answer_Summaries = [
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_securely_operate_multi_accounts",
        Description:
          "Organize workloads in separate accounts and group accounts based on function or a common set of controls rather than mirroring your company’s reporting structure. Start with security and infrastructure in mind to enable your organization to set common guardrails as your workloads grow.",
        Title: "Separate workloads using accounts",
      },
      {
        ChoiceId: "sec_securely_operate_aws_account",
        Description:
          "Secure access to your accounts, for example by enabling MFA and restrict use of the root user, and configure account contacts.",
        Title: "Secure AWS account",
      },
      {
        ChoiceId: "sec_securely_operate_control_objectives",
        Description:
          "Based on your compliance requirements and risks identified from your threat model, derive and validate the control objectives and controls that you need to apply to your workload. Ongoing validation of control objectives and controls help you measure the effectiveness of risk mitigation.",
        Title: "Identify and validate control objectives",
      },
      {
        ChoiceId: "sec_securely_operate_updated_threats",
        Description:
          "Recognize attack vectors by staying up to date with the latest security threats to help you define and implement appropriate controls.",
        Title: "Keep up to date with security threats",
      },
      {
        ChoiceId: "sec_securely_operate_updated_recommendations",
        Description:
          "Stay up to date with both AWS and industry security recommendations to evolve the security posture of your workload. ",
        Title: "Keep up to date with security recommendations",
      },
      {
        ChoiceId: "sec_securely_operate_test_validate_pipeline",
        Description:
          "Establish secure baselines and templates for security mechanisms that are tested and validated as part of your build, pipelines, and processes. Use tools and automation to test and validate all security controls continuously. For example, scan items such as machine images and infrastructure as code templates for security vulnerabilities, irregularities, and drift from an established baseline at each stage.",
        Title:
          "Automate testing and validation of security controls in pipelines",
      },
      {
        ChoiceId: "sec_securely_operate_threat_model",
        Description:
          "Use a threat model to identify and maintain an up-to-date register of potential threats. Prioritize your threats and adapt your security controls to prevent, detect, and respond. Revisit and maintain this in the context of the evolving security landscape.",
        Title: "Identify and prioritize risks using a threat model",
      },
      {
        ChoiceId: "sec_securely_operate_implement_services_features",
        Description:
          "AWS and APN Partners constantly release new features and services that allow you to evolve the security posture of your workload.",
        Title:
          "Evaluate and implement new security services and features regularly",
      },
      {
        ChoiceId: "sec_securely_operate_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "securely-operate",
    QuestionTitle: "How do you securely operate your workload?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_identities_enforce_mechanisms",
        Description:
          "Enforce minimum password length, and educate users to avoid common or re-used passwords. Enforce multi-factor authentication (MFA) with software or hardware mechanisms to provide an additional layer.",
        Title: "Use strong sign-in mechanisms",
      },
      {
        ChoiceId: "sec_identities_unique",
        Description:
          "Require identities to dynamically acquire temporary credentials. For workforce identities, use AWS Single Sign-On, or federation with IAM roles to access AWS accounts. For machine identities, require the use of IAM roles instead of long term access keys.",
        Title: "Use temporary credentials",
      },
      {
        ChoiceId: "sec_identities_secrets",
        Description:
          "For workforce and machine identities that require secrets such as passwords to third party applications, store them with automatic rotation using the latest industry standards in a specialized service.",
        Title: "Store and use secrets securely",
      },
      {
        ChoiceId: "sec_identities_identity_provider",
        Description:
          "For workforce identities, rely on an identity provider that enables you to manage identities in a centralized place. This enables you to create, manage, and revoke access from a single location making it easier to manage access. This reduces the requirement for multiple credentials and provides an opportunity to integrate with HR processes.",
        Title: "Rely on a centralized identity provider",
      },
      {
        ChoiceId: "sec_identities_audit",
        Description:
          "When you cannot rely on temporary credentials and require long term credentials, audit credentials to ensure that the defined controls (for example, MFA) are enforced, rotated regularly, and have appropriate access level.",
        Title: "Audit and rotate credentials periodically",
      },
      {
        ChoiceId: "sec_identities_groups_attributes",
        Description:
          "Place users with common security requirements in groups defined by your identity provider, and put mechanisms in place to ensure that user attributes that may be used for access control (e.g., department or location) are correct and updated. Use these groups and attributes, rather than individual users, to control access. This allows you to manage access centrally by changing a user’s group membership or attributes once, rather than updating many individual policies when a user’s access needs change.",
        Title: "Leverage user groups and attributes",
      },
      {
        ChoiceId: "sec_identities_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "identities",
    QuestionTitle: "How do you manage identities for people and machines?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_permissions_define",
        Description:
          "Each component or resource of your workload needs to be accessed by administrators, end users, or other components. Have a clear definition of who or what should have access to each component, choose the appropriate identity type and method of authentication and authorization.",
        Title: "Define access requirements",
      },
      {
        ChoiceId: "sec_permissions_least_privileges",
        Description:
          "Grant only the access that identities require by allowing access to specific actions on specific AWS resources under specific conditions. Rely on groups and identity attributes to dynamically set permissions at scale, rather than defining permissions for individual users. For example, you can allow a group of developers access to manage only resources for their project. This way, when a developer is removed from the group, access for the developer is revoked everywhere that group was used for access control, without requiring any changes to the access policies.",
        Title: "Grant least privilege access",
      },
      {
        ChoiceId: "sec_permissions_emergency_process",
        Description:
          "A process that allows emergency access to your workload in the unlikely event of an automated process or pipeline issue. This will help you rely on least privilege access, but ensure users can obtain the right level of access when they require it. For example, establish a process for administrators to verify and approve their request.",
        Title: "Establish emergency access process",
      },
      {
        ChoiceId: "sec_permissions_continuous_reduction",
        Description:
          "As teams and workloads determine what access they need, remove permissions they no longer use and establish review processes to achieve least privilege permissions. Continuously monitor and reduce unused identities and permissions.",
        Title: "Reduce permissions continuously",
      },
      {
        ChoiceId: "sec_permissions_define_guardrails",
        Description:
          "Establish common controls that restrict access to all identities in your organization. For example, you can restrict access to specific AWS Regions, or prevent your operators from deleting common resources, such as an IAM role used for your central security team.",
        Title: "Define permission guardrails for your organization",
      },
      {
        ChoiceId: "sec_permissions_lifecycle",
        Description:
          "Integrate access controls with operator and application life cycle and your centralized federation provider. For example, remove a user’s access when they leave the organization or change roles.",
        Title: "Manage access based on life cycle",
      },
      {
        ChoiceId: "sec_permissions_analyze_cross_account",
        Description:
          "Continuously monitor findings that highlight public and cross account access. Reduce public access and cross account access to only resources that require this type of access.",
        Title: "Analyze public and cross account access",
      },
      {
        ChoiceId: "sec_permissions_share_securely",
        Description:
          "Govern the consumption of shared resources across accounts or within your AWS Organization. Monitor shared resources and review shared resource access.",
        Title: "Share resources securely",
      },
      {
        ChoiceId: "sec_permissions_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "permissions",
    QuestionTitle: "How do you manage permissions for people and machines?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_detect_investigate_events_app_service_logging",
        Description:
          "Configure logging throughout the workload, including application logs, resource logs, and AWS service logs. For example, ensure that AWS CloudTrail, Amazon CloudWatch Logs, Amazon GuardDuty and AWS Security Hub are enabled for all accounts within your organization.",
        Title: "Configure service and application logging",
      },
      {
        ChoiceId: "sec_detect_investigate_events_analyze_all",
        Description:
          "All logs, metrics, and telemetry should be collected centrally, and automatically analyzed to detect anomalies and indicators of unauthorized activity. A dashboard can provide you easy to access insight into real-time health. For example, ensure that Amazon GuardDuty and Security Hub logs are sent to a central location for alerting and analysis.",
        Title: "Analyze logs, findings, and metrics centrally",
      },
      {
        ChoiceId: "sec_detect_investigate_events_auto_response",
        Description:
          "Using automation to investigate and remediate events reduces human effort and error, and enables you to scale investigation capabilities. Regular reviews will help you tune automation tools, and continuously iterate. For example, automate responses to Amazon GuardDuty events by automating the first investigation step, then iterate to gradually remove human effort.",
        Title: "Automate response to events",
      },
      {
        ChoiceId: "sec_detect_investigate_events_actionable_events",
        Description:
          "Create alerts that are sent to and can be actioned by your team. Ensure that alerts include relevant information for the team to take action. For example, ensure that Amazon GuardDuty and AWS Security Hub alerts are sent to the team to action, or sent to response automation tooling with the team remaining informed by messaging from the automation framework.",
        Title: "Implement actionable security events",
      },
      {
        ChoiceId: "sec_detect_investigate_events_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "detect-investigate-events",
    QuestionTitle: "How do you detect and investigate security events?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_network_protection_create_layers",
        Description:
          "Group components that share reachability requirements into layers. For example, a database cluster in a VPC with no need for internet access should be placed in subnets with no route to or from the internet. In a serverless workload operating without a VPC, similar layering and segmentation with microservices can achieve the same goal.",
        Title: "Create network layers",
      },
      {
        ChoiceId: "sec_network_protection_layered",
        Description:
          "Apply controls with a defense in depth approach for both inbound and outbound traffic. For example, for Amazon Virtual Private Cloud (VPC) this includes security groups, Network ACLs, and subnets. For AWS Lambda, consider running in your private VPC with VPC-based controls.",
        Title: "Control traffic at all layers",
      },
      {
        ChoiceId: "sec_network_protection_auto_protect",
        Description:
          "Automate protection mechanisms to provide a self-defending network based on threat intelligence and anomaly detection. For example, intrusion detection and prevention tools that can pro-actively adapt to current threats and reduce their impact.",
        Title: "Automate network protection",
      },
      {
        ChoiceId: "sec_network_protection_inspection",
        Description:
          "Inspect and filter your traffic at each layer. For example, use a web application firewall to help protect against inadvertent access at the application network layer. For Lambda functions, third-party tools can add application-layer firewalling to your runtime environment.",
        Title: "Implement inspection and protection",
      },
      {
        ChoiceId: "sec_network_protection_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "network-protection",
    QuestionTitle: "How do you protect your network resources?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_protect_compute_vulnerability_management",
        Description:
          "Frequently scan and patch for vulnerabilities in your code, dependencies, and in your infrastructure to help protect against new threats.",
        Title: "Perform vulnerability management",
      },
      {
        ChoiceId: "sec_protect_compute_reduce_surface",
        Description:
          "Reduce your attack surface by hardening operating systems, minimizing components, libraries, and externally consumable services in use.",
        Title: "Reduce attack surface",
      },
      {
        ChoiceId: "sec_protect_compute_implement_managed_services",
        Description:
          "Implement services that manage resources, such as Amazon RDS, AWS Lambda, and Amazon ECS, to reduce your security maintenance tasks as part of the shared responsibility model.",
        Title: "Implement managed services",
      },
      {
        ChoiceId: "sec_protect_compute_auto_protection",
        Description:
          "Automate your protective compute mechanisms including vulnerability management, reduction in attack surface, and management of resources.",
        Title: "Automate compute protection",
      },
      {
        ChoiceId: "sec_protect_compute_actions_distance",
        Description:
          "Removing the ability for interactive access reduces the risk of human error, and the potential for manual configuration or management. For example, use a change management workflow to deploy EC2 instances using infrastructure as code, then manage EC2 instances using tools instead of allowing direct access or a bastion host.",
        Title: "Enable people to perform actions at a distance",
      },
      {
        ChoiceId: "sec_protect_compute_validate_software_integrity",
        Description:
          "Implement mechanisms (for example, code signing) to validate that the software, code, and libraries used in the workload are from trusted sources and have not been tampered with.",
        Title: "Validate software integrity",
      },
      {
        ChoiceId: "sec_protect_compute_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-compute",
    QuestionTitle: "How do you protect your compute resources?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_data_classification_identify_data",
        Description:
          "This includes the type and classification of data, the associated business processes. data owner, applicable legal and compliance requirements, where it’s stored, and the resulting controls that are needed to be enforced. This may include classifications to indicate if the data is intended to be publicly available, if the data is internal use only such as customer personally identifiable information (PII), or if the data is for more restricted access such as intellectual property, legally privileged or marked sensititve, and more.",
        Title: "Identify the data within your workload",
      },
      {
        ChoiceId: "sec_data_classification_define_protection",
        Description:
          "Protect data according to its classification level. For example, secure data classified as public by using relevant recommendations while protecting sensitive data with additional controls.",
        Title: "Define data protection controls",
      },
      {
        ChoiceId: "sec_data_classification_auto_classification",
        Description:
          "Automate identification and classification of data to reduce the risk of human error from manual interactions.",
        Title: "Automate identification and classification",
      },
      {
        ChoiceId: "sec_data_classification_lifecycle_management",
        Description:
          "Your defined lifecycle strategy should be based on sensitivity level, as well as legal and organization requirements. Aspects including the duration you retain data for, data destruction, data access management, data transformation, and data sharing should be considered.",
        Title: "Define data lifecycle management",
      },
      {
        ChoiceId: "sec_data_classification_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "data-classification",
    QuestionTitle: "How do you classify your data?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_protect_data_rest_key_mgmt",
        Description:
          "Encryption keys must be stored securely, withstrict access control, for example, by using a key management service such as AWSKMS. Consider using different keys, and access control to the keys, combined with theAWS IAM and resource policies, to align with data classification levels andsegregation requirements.",
        Title: "Implement secure key management",
      },
      {
        ChoiceId: "sec_protect_data_rest_encrypt",
        Description:
          "Enforce your encryption requirements based on thelatest standards and recommendations to help protect your data at rest.",
        Title: "Enforce encryption at rest",
      },
      {
        ChoiceId: "sec_protect_data_rest_automate_protection",
        Description:
          "Use automated tools to validate and enforce data atrest protection continuously, for example, verify that there are only encryptedstorage resources.",
        Title: "Automate data at rest protection",
      },
      {
        ChoiceId: "sec_protect_data_rest_access_control",
        Description:
          "Enforce access control with least privileges andmechanisms, including backups, isolation, and versioning, to help protect your dataat rest. Prevent operators from granting public access to your data.",
        Title: "Enforce access control",
      },
      {
        ChoiceId: "sec_protect_data_rest_use_people_away",
        Description:
          "Keep all users away from directly accessingsensitive data and systems under normal operational circumstances. For example,provide a dashboard instead of direct access to a data store to run queries. WhereCI/CD pipelines are not used, determine which controls and processes are required toadequately provide a normally disabled break-glass access mechanism.",
        Title: "Use mechanisms to keep people away from data",
      },
      {
        ChoiceId: "sec_protect_data_rest_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-data-rest",
    QuestionTitle: "How do you protect your data at rest?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_protect_data_transit_key_cert_mgmt",
        Description:
          "Store encryption keys and certificates securely androtate them at appropriate time intervals while applying strict access control; forexample, by using a certificate management service, such as AWS Certificate Manager(ACM).",
        Title: "Implement secure key and certificatemanagement",
      },
      {
        ChoiceId: "sec_protect_data_transit_encrypt",
        Description:
          "Enforce your defined encryption requirements basedon appropriate standards and recommendations to help you meet your organizational,legal, and compliance requirements.",
        Title: "Enforce encryption in transit",
      },
      {
        ChoiceId: "sec_protect_data_transit_auto_unintended_access",
        Description:
          "Use tools such as GuardDuty to automatically detectattempts to move data outside of defined boundaries based on data classificationlevel, for example, to detect a trojan that is copying data to an unknown oruntrusted network using the DNS protocol.",
        Title: "Automate detection of unintended dataaccess",
      },
      {
        ChoiceId: "sec_protect_data_transit_authentication",
        Description:
          "Verify the identity of communications by usingprotocols that support authentication, such as Transport Layer Security (TLS) orIPsec.",
        Title: "Authenticate network communications",
      },
      {
        ChoiceId: "sec_protect_data_transit_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-data-transit",
    QuestionTitle: "How do you protect your data in transit?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_incident_response_identify_personnel",
        Description:
          "Identify internal and external personnel, resources, and legal obligations that would help your organization respond to an incident.",
        Title: "Identify key personnel and external resources",
      },
      {
        ChoiceId: "sec_incident_response_develop_management_plans",
        Description:
          "Create plans to help you respond to, communicate during, and recover from an incident. For example, you can start an incident response plan with the most likely scenarios for your workload and organization. Include how you would communicate and escalate both internally and externally.",
        Title: "Develop incident management plans",
      },
      {
        ChoiceId: "sec_incident_response_prepare_forensic",
        Description:
          "Identify and prepare forensic investigation capabilities that are suitable, including external specialists, tools, and automation.",
        Title: "Prepare forensic capabilities",
      },
      {
        ChoiceId: "sec_incident_response_auto_contain",
        Description:
          "Automate containment and recovery of an incident to reduce response times and organizational impact.",
        Title: "Automate containment capability",
      },
      {
        ChoiceId: "sec_incident_response_pre_provision_access",
        Description:
          "Ensure that incident responders have the correct access pre-provisioned into AWS to reduce the time for investigation through to recovery.",
        Title: "Pre-provision access",
      },
      {
        ChoiceId: "sec_incident_response_pre_deploy_tools",
        Description:
          "Ensure that security personnel have the right tools pre-deployed into AWS to reduce the time for investigation through to recovery.",
        Title: "Pre-deploy tools",
      },
      {
        ChoiceId: "sec_incident_response_run_game_days",
        Description:
          "Practice incident response game days (simulations) regularly, incorporate lessons learned into your incident management plans, and continuously improve.",
        Title: "Run game days",
      },
      {
        ChoiceId: "sec_incident_response_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "incident-response",
    QuestionTitle:
      "How do you anticipate, respond to, and recover from incidents?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
];

export const Security_Pillar_Q8 = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "sec_protect_data_rest_encrypt",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_protect_data_rest_access_control",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_protect_data_rest_use_people_away",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_protect_data_rest_automate_protection",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sec_protect_data_rest_key_mgmt",
        Description:
          " By defining an encryption approach that includes the storage, rotation, and access control of keys, you can help provide protection for your content against unauthorized users and against unnecessary exposure to authorized users. AWS Key Management Service (AWS KMS) helps you manage encryption keys and integrates with many AWS services. This service provides durable, secure, and redundant storage for your AWS KMS keys. You can define your key aliases as well as key-level policies. The policies help you define key administrators as well as key users. Additionally, AWS CloudHSM is a cloud-based hardware security module (HSM) that enables you to easily generate and use your own encryption keys in the AWS Cloud. It helps you meet corporate, contractual, and regulatory compliance requirements for data security by using FIPS 140-2 Level 3 validated HSMs. ",
        Title: "Implement secure key management",
      },
      {
        ChoiceId: "sec_protect_data_rest_encrypt",
        Description:
          " You should enforce the use of encryption for data at rest. Encryption maintains the confidentiality of sensitive data in the event of unauthorized access or accidental disclosure. ",
        Title: "Enforce encryption at rest",
      },
      {
        ChoiceId: "sec_protect_data_rest_access_control",
        Description:
          " To help protect your data at rest, enforce access control using mechanisms, such as isolation and versioning, and apply the principle of least privilege. Prevent the granting of public access to your data. ",
        Title: "Enforce access control",
      },
      {
        ChoiceId: "sec_protect_data_rest_use_people_away",
        Description:
          " Keep all users away from directly accessing sensitive data and systems under normal operational circumstances. For example, use a change management workflow to manage Amazon Elastic Compute Cloud (Amazon EC2) instances using tools instead of allowing direct access or a bastion host. This can be achieved using AWS Systems Manager Automation, which uses automation documents that contain steps you use to perform tasks. These documents can be stored in source control, be peer reviewed before running, and tested thoroughly to minimize risk compared to shell access. Business users could have a dashboard instead of direct access to a data store to run queries. Where CI/CD pipelines are not used, determine which controls and processes are required to adequately provide a normally disabled break-glass access mechanism. ",
        Title: "Use mechanisms to keep people away from data",
      },
      {
        ChoiceId: "sec_protect_data_rest_automate_protection",
        Description:
          " Use automated tools to validate and enforce data at rest controls continuously, for example, verify that there are only encrypted storage resources. You can automate validation that all EBS volumes are encrypted using AWS Config Rules. AWS Security Hub can also verify several different controls through automated checks against security standards. Additionally, your AWS Config Rules can automatically remediate noncompliant resources. ",
        Title: "Automate data at rest protection",
      },
      {
        ChoiceId: "sec_protect_data_rest_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.protect-data-rest.helpful-resources.en.html",
    ImprovementPlanUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.protect-data-rest.improvement-plan.en.html",
    IsApplicable: true,
    PillarId: "security",
    QuestionDescription:
      "Protect your data at rest by implementing multiple controls, to reduce the risk of unauthorized access or mishandling.",
    QuestionId: "protect-data-rest",
    QuestionTitle: "How do you protect your data at rest?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "sec_protect_data_rest_encrypt",
      "sec_protect_data_rest_access_control",
      "sec_protect_data_rest_use_people_away",
      "sec_protect_data_rest_automate_protection",
    ],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Security_Check_Q8_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 12,
  Passed: 24,
};

export const Security_Check_Q8_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: moment().subtract(1, "days"),
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-04-03 09:14:19",
    Description: "Test",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "yameen",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: moment().subtract(1, "days"),
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Security_Check_Q8_Answer_Summaries = [
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_securely_operate_multi_accounts",
        Description:
          "Organize workloads in separate accounts and group accounts based on function or a common set of controls rather than mirroring your company’s reporting structure. Start with security and infrastructure in mind to enable your organization to set common guardrails as your workloads grow.",
        Title: "Separate workloads using accounts",
      },
      {
        ChoiceId: "sec_securely_operate_aws_account",
        Description:
          "Secure access to your accounts, for example by enabling MFA and restrict use of the root user, and configure account contacts.",
        Title: "Secure AWS account",
      },
      {
        ChoiceId: "sec_securely_operate_control_objectives",
        Description:
          "Based on your compliance requirements and risks identified from your threat model, derive and validate the control objectives and controls that you need to apply to your workload. Ongoing validation of control objectives and controls help you measure the effectiveness of risk mitigation.",
        Title: "Identify and validate control objectives",
      },
      {
        ChoiceId: "sec_securely_operate_updated_threats",
        Description:
          "Recognize attack vectors by staying up to date with the latest security threats to help you define and implement appropriate controls.",
        Title: "Keep up to date with security threats",
      },
      {
        ChoiceId: "sec_securely_operate_updated_recommendations",
        Description:
          "Stay up to date with both AWS and industry security recommendations to evolve the security posture of your workload. ",
        Title: "Keep up to date with security recommendations",
      },
      {
        ChoiceId: "sec_securely_operate_test_validate_pipeline",
        Description:
          "Establish secure baselines and templates for security mechanisms that are tested and validated as part of your build, pipelines, and processes. Use tools and automation to test and validate all security controls continuously. For example, scan items such as machine images and infrastructure as code templates for security vulnerabilities, irregularities, and drift from an established baseline at each stage.",
        Title:
          "Automate testing and validation of security controls in pipelines",
      },
      {
        ChoiceId: "sec_securely_operate_threat_model",
        Description:
          "Use a threat model to identify and maintain an up-to-date register of potential threats. Prioritize your threats and adapt your security controls to prevent, detect, and respond. Revisit and maintain this in the context of the evolving security landscape.",
        Title: "Identify and prioritize risks using a threat model",
      },
      {
        ChoiceId: "sec_securely_operate_implement_services_features",
        Description:
          "AWS and APN Partners constantly release new features and services that allow you to evolve the security posture of your workload.",
        Title:
          "Evaluate and implement new security services and features regularly",
      },
      {
        ChoiceId: "sec_securely_operate_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "securely-operate",
    QuestionTitle: "How do you securely operate your workload?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_identities_enforce_mechanisms",
        Description:
          "Enforce minimum password length, and educate users to avoid common or re-used passwords. Enforce multi-factor authentication (MFA) with software or hardware mechanisms to provide an additional layer.",
        Title: "Use strong sign-in mechanisms",
      },
      {
        ChoiceId: "sec_identities_unique",
        Description:
          "Require identities to dynamically acquire temporary credentials. For workforce identities, use AWS Single Sign-On, or federation with IAM roles to access AWS accounts. For machine identities, require the use of IAM roles instead of long term access keys.",
        Title: "Use temporary credentials",
      },
      {
        ChoiceId: "sec_identities_secrets",
        Description:
          "For workforce and machine identities that require secrets such as passwords to third party applications, store them with automatic rotation using the latest industry standards in a specialized service.",
        Title: "Store and use secrets securely",
      },
      {
        ChoiceId: "sec_identities_identity_provider",
        Description:
          "For workforce identities, rely on an identity provider that enables you to manage identities in a centralized place. This enables you to create, manage, and revoke access from a single location making it easier to manage access. This reduces the requirement for multiple credentials and provides an opportunity to integrate with HR processes.",
        Title: "Rely on a centralized identity provider",
      },
      {
        ChoiceId: "sec_identities_audit",
        Description:
          "When you cannot rely on temporary credentials and require long term credentials, audit credentials to ensure that the defined controls (for example, MFA) are enforced, rotated regularly, and have appropriate access level.",
        Title: "Audit and rotate credentials periodically",
      },
      {
        ChoiceId: "sec_identities_groups_attributes",
        Description:
          "Place users with common security requirements in groups defined by your identity provider, and put mechanisms in place to ensure that user attributes that may be used for access control (e.g., department or location) are correct and updated. Use these groups and attributes, rather than individual users, to control access. This allows you to manage access centrally by changing a user’s group membership or attributes once, rather than updating many individual policies when a user’s access needs change.",
        Title: "Leverage user groups and attributes",
      },
      {
        ChoiceId: "sec_identities_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "identities",
    QuestionTitle: "How do you manage identities for people and machines?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_permissions_define",
        Description:
          "Each component or resource of your workload needs to be accessed by administrators, end users, or other components. Have a clear definition of who or what should have access to each component, choose the appropriate identity type and method of authentication and authorization.",
        Title: "Define access requirements",
      },
      {
        ChoiceId: "sec_permissions_least_privileges",
        Description:
          "Grant only the access that identities require by allowing access to specific actions on specific AWS resources under specific conditions. Rely on groups and identity attributes to dynamically set permissions at scale, rather than defining permissions for individual users. For example, you can allow a group of developers access to manage only resources for their project. This way, when a developer is removed from the group, access for the developer is revoked everywhere that group was used for access control, without requiring any changes to the access policies.",
        Title: "Grant least privilege access",
      },
      {
        ChoiceId: "sec_permissions_emergency_process",
        Description:
          "A process that allows emergency access to your workload in the unlikely event of an automated process or pipeline issue. This will help you rely on least privilege access, but ensure users can obtain the right level of access when they require it. For example, establish a process for administrators to verify and approve their request.",
        Title: "Establish emergency access process",
      },
      {
        ChoiceId: "sec_permissions_continuous_reduction",
        Description:
          "As teams and workloads determine what access they need, remove permissions they no longer use and establish review processes to achieve least privilege permissions. Continuously monitor and reduce unused identities and permissions.",
        Title: "Reduce permissions continuously",
      },
      {
        ChoiceId: "sec_permissions_define_guardrails",
        Description:
          "Establish common controls that restrict access to all identities in your organization. For example, you can restrict access to specific AWS Regions, or prevent your operators from deleting common resources, such as an IAM role used for your central security team.",
        Title: "Define permission guardrails for your organization",
      },
      {
        ChoiceId: "sec_permissions_lifecycle",
        Description:
          "Integrate access controls with operator and application life cycle and your centralized federation provider. For example, remove a user’s access when they leave the organization or change roles.",
        Title: "Manage access based on life cycle",
      },
      {
        ChoiceId: "sec_permissions_analyze_cross_account",
        Description:
          "Continuously monitor findings that highlight public and cross account access. Reduce public access and cross account access to only resources that require this type of access.",
        Title: "Analyze public and cross account access",
      },
      {
        ChoiceId: "sec_permissions_share_securely",
        Description:
          "Govern the consumption of shared resources across accounts or within your AWS Organization. Monitor shared resources and review shared resource access.",
        Title: "Share resources securely",
      },
      {
        ChoiceId: "sec_permissions_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "permissions",
    QuestionTitle: "How do you manage permissions for people and machines?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_detect_investigate_events_app_service_logging",
        Description:
          "Configure logging throughout the workload, including application logs, resource logs, and AWS service logs. For example, ensure that AWS CloudTrail, Amazon CloudWatch Logs, Amazon GuardDuty and AWS Security Hub are enabled for all accounts within your organization.",
        Title: "Configure service and application logging",
      },
      {
        ChoiceId: "sec_detect_investigate_events_analyze_all",
        Description:
          "All logs, metrics, and telemetry should be collected centrally, and automatically analyzed to detect anomalies and indicators of unauthorized activity. A dashboard can provide you easy to access insight into real-time health. For example, ensure that Amazon GuardDuty and Security Hub logs are sent to a central location for alerting and analysis.",
        Title: "Analyze logs, findings, and metrics centrally",
      },
      {
        ChoiceId: "sec_detect_investigate_events_auto_response",
        Description:
          "Using automation to investigate and remediate events reduces human effort and error, and enables you to scale investigation capabilities. Regular reviews will help you tune automation tools, and continuously iterate. For example, automate responses to Amazon GuardDuty events by automating the first investigation step, then iterate to gradually remove human effort.",
        Title: "Automate response to events",
      },
      {
        ChoiceId: "sec_detect_investigate_events_actionable_events",
        Description:
          "Create alerts that are sent to and can be actioned by your team. Ensure that alerts include relevant information for the team to take action. For example, ensure that Amazon GuardDuty and AWS Security Hub alerts are sent to the team to action, or sent to response automation tooling with the team remaining informed by messaging from the automation framework.",
        Title: "Implement actionable security events",
      },
      {
        ChoiceId: "sec_detect_investigate_events_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "detect-investigate-events",
    QuestionTitle: "How do you detect and investigate security events?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_network_protection_create_layers",
        Description:
          "Group components that share reachability requirements into layers. For example, a database cluster in a VPC with no need for internet access should be placed in subnets with no route to or from the internet. In a serverless workload operating without a VPC, similar layering and segmentation with microservices can achieve the same goal.",
        Title: "Create network layers",
      },
      {
        ChoiceId: "sec_network_protection_layered",
        Description:
          "Apply controls with a defense in depth approach for both inbound and outbound traffic. For example, for Amazon Virtual Private Cloud (VPC) this includes security groups, Network ACLs, and subnets. For AWS Lambda, consider running in your private VPC with VPC-based controls.",
        Title: "Control traffic at all layers",
      },
      {
        ChoiceId: "sec_network_protection_auto_protect",
        Description:
          "Automate protection mechanisms to provide a self-defending network based on threat intelligence and anomaly detection. For example, intrusion detection and prevention tools that can pro-actively adapt to current threats and reduce their impact.",
        Title: "Automate network protection",
      },
      {
        ChoiceId: "sec_network_protection_inspection",
        Description:
          "Inspect and filter your traffic at each layer. For example, use a web application firewall to help protect against inadvertent access at the application network layer. For Lambda functions, third-party tools can add application-layer firewalling to your runtime environment.",
        Title: "Implement inspection and protection",
      },
      {
        ChoiceId: "sec_network_protection_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "network-protection",
    QuestionTitle: "How do you protect your network resources?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_protect_compute_vulnerability_management",
        Description:
          "Frequently scan and patch for vulnerabilities in your code, dependencies, and in your infrastructure to help protect against new threats.",
        Title: "Perform vulnerability management",
      },
      {
        ChoiceId: "sec_protect_compute_reduce_surface",
        Description:
          "Reduce your attack surface by hardening operating systems, minimizing components, libraries, and externally consumable services in use.",
        Title: "Reduce attack surface",
      },
      {
        ChoiceId: "sec_protect_compute_implement_managed_services",
        Description:
          "Implement services that manage resources, such as Amazon RDS, AWS Lambda, and Amazon ECS, to reduce your security maintenance tasks as part of the shared responsibility model.",
        Title: "Implement managed services",
      },
      {
        ChoiceId: "sec_protect_compute_auto_protection",
        Description:
          "Automate your protective compute mechanisms including vulnerability management, reduction in attack surface, and management of resources.",
        Title: "Automate compute protection",
      },
      {
        ChoiceId: "sec_protect_compute_actions_distance",
        Description:
          "Removing the ability for interactive access reduces the risk of human error, and the potential for manual configuration or management. For example, use a change management workflow to deploy EC2 instances using infrastructure as code, then manage EC2 instances using tools instead of allowing direct access or a bastion host.",
        Title: "Enable people to perform actions at a distance",
      },
      {
        ChoiceId: "sec_protect_compute_validate_software_integrity",
        Description:
          "Implement mechanisms (for example, code signing) to validate that the software, code, and libraries used in the workload are from trusted sources and have not been tampered with.",
        Title: "Validate software integrity",
      },
      {
        ChoiceId: "sec_protect_compute_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-compute",
    QuestionTitle: "How do you protect your compute resources?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_data_classification_identify_data",
        Description:
          "This includes the type and classification of data, the associated business processes. data owner, applicable legal and compliance requirements, where it’s stored, and the resulting controls that are needed to be enforced. This may include classifications to indicate if the data is intended to be publicly available, if the data is internal use only such as customer personally identifiable information (PII), or if the data is for more restricted access such as intellectual property, legally privileged or marked sensititve, and more.",
        Title: "Identify the data within your workload",
      },
      {
        ChoiceId: "sec_data_classification_define_protection",
        Description:
          "Protect data according to its classification level. For example, secure data classified as public by using relevant recommendations while protecting sensitive data with additional controls.",
        Title: "Define data protection controls",
      },
      {
        ChoiceId: "sec_data_classification_auto_classification",
        Description:
          "Automate identification and classification of data to reduce the risk of human error from manual interactions.",
        Title: "Automate identification and classification",
      },
      {
        ChoiceId: "sec_data_classification_lifecycle_management",
        Description:
          "Your defined lifecycle strategy should be based on sensitivity level, as well as legal and organization requirements. Aspects including the duration you retain data for, data destruction, data access management, data transformation, and data sharing should be considered.",
        Title: "Define data lifecycle management",
      },
      {
        ChoiceId: "sec_data_classification_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "data-classification",
    QuestionTitle: "How do you classify your data?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_protect_data_rest_key_mgmt",
        Description:
          "Encryption keys must be stored securely, withstrict access control, for example, by using a key management service such as AWSKMS. Consider using different keys, and access control to the keys, combined with theAWS IAM and resource policies, to align with data classification levels andsegregation requirements.",
        Title: "Implement secure key management",
      },
      {
        ChoiceId: "sec_protect_data_rest_encrypt",
        Description:
          "Enforce your encryption requirements based on thelatest standards and recommendations to help protect your data at rest.",
        Title: "Enforce encryption at rest",
      },
      {
        ChoiceId: "sec_protect_data_rest_automate_protection",
        Description:
          "Use automated tools to validate and enforce data atrest protection continuously, for example, verify that there are only encryptedstorage resources.",
        Title: "Automate data at rest protection",
      },
      {
        ChoiceId: "sec_protect_data_rest_access_control",
        Description:
          "Enforce access control with least privileges andmechanisms, including backups, isolation, and versioning, to help protect your dataat rest. Prevent operators from granting public access to your data.",
        Title: "Enforce access control",
      },
      {
        ChoiceId: "sec_protect_data_rest_use_people_away",
        Description:
          "Keep all users away from directly accessingsensitive data and systems under normal operational circumstances. For example,provide a dashboard instead of direct access to a data store to run queries. WhereCI/CD pipelines are not used, determine which controls and processes are required toadequately provide a normally disabled break-glass access mechanism.",
        Title: "Use mechanisms to keep people away from data",
      },
      {
        ChoiceId: "sec_protect_data_rest_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-data-rest",
    QuestionTitle: "How do you protect your data at rest?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_protect_data_transit_key_cert_mgmt",
        Description:
          "Store encryption keys and certificates securely androtate them at appropriate time intervals while applying strict access control; forexample, by using a certificate management service, such as AWS Certificate Manager(ACM).",
        Title: "Implement secure key and certificatemanagement",
      },
      {
        ChoiceId: "sec_protect_data_transit_encrypt",
        Description:
          "Enforce your defined encryption requirements basedon appropriate standards and recommendations to help you meet your organizational,legal, and compliance requirements.",
        Title: "Enforce encryption in transit",
      },
      {
        ChoiceId: "sec_protect_data_transit_auto_unintended_access",
        Description:
          "Use tools such as GuardDuty to automatically detectattempts to move data outside of defined boundaries based on data classificationlevel, for example, to detect a trojan that is copying data to an unknown oruntrusted network using the DNS protocol.",
        Title: "Automate detection of unintended dataaccess",
      },
      {
        ChoiceId: "sec_protect_data_transit_authentication",
        Description:
          "Verify the identity of communications by usingprotocols that support authentication, such as Transport Layer Security (TLS) orIPsec.",
        Title: "Authenticate network communications",
      },
      {
        ChoiceId: "sec_protect_data_transit_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-data-transit",
    QuestionTitle: "How do you protect your data in transit?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_incident_response_identify_personnel",
        Description:
          "Identify internal and external personnel, resources, and legal obligations that would help your organization respond to an incident.",
        Title: "Identify key personnel and external resources",
      },
      {
        ChoiceId: "sec_incident_response_develop_management_plans",
        Description:
          "Create plans to help you respond to, communicate during, and recover from an incident. For example, you can start an incident response plan with the most likely scenarios for your workload and organization. Include how you would communicate and escalate both internally and externally.",
        Title: "Develop incident management plans",
      },
      {
        ChoiceId: "sec_incident_response_prepare_forensic",
        Description:
          "Identify and prepare forensic investigation capabilities that are suitable, including external specialists, tools, and automation.",
        Title: "Prepare forensic capabilities",
      },
      {
        ChoiceId: "sec_incident_response_auto_contain",
        Description:
          "Automate containment and recovery of an incident to reduce response times and organizational impact.",
        Title: "Automate containment capability",
      },
      {
        ChoiceId: "sec_incident_response_pre_provision_access",
        Description:
          "Ensure that incident responders have the correct access pre-provisioned into AWS to reduce the time for investigation through to recovery.",
        Title: "Pre-provision access",
      },
      {
        ChoiceId: "sec_incident_response_pre_deploy_tools",
        Description:
          "Ensure that security personnel have the right tools pre-deployed into AWS to reduce the time for investigation through to recovery.",
        Title: "Pre-deploy tools",
      },
      {
        ChoiceId: "sec_incident_response_run_game_days",
        Description:
          "Practice incident response game days (simulations) regularly, incorporate lessons learned into your incident management plans, and continuously improve.",
        Title: "Run game days",
      },
      {
        ChoiceId: "sec_incident_response_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "incident-response",
    QuestionTitle:
      "How do you anticipate, respond to, and recover from incidents?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
];

export const Security_Pillar_Q9 = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "sec_protect_data_transit_encrypt",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_protect_data_transit_authentication",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_protect_data_transit_auto_unintended_access",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sec_protect_data_transit_key_cert_mgmt",
        Description:
          " Store encryption keys and certificates securely and rotate them at appropriate time intervals with strict access control. The best way to accomplish this is to use a managed service, such as AWS Certificate Manager (ACM). It lets you easily provision, manage, and deploy public and private Transport Layer Security (TLS) certificates for use with AWS services and your internal connected resources. TLS certificates are used to secure network communications and establish the identity of websites over the internet as well as resources on private networks. ACM integrates with AWS resources, such as Elastic Load Balancers (ELBs), AWS distributions, and APIs on API Gateway, also handling automatic certificate renewals. If you use ACM to deploy a private root CA, both certificates and private keys can be provided by it for use in Amazon Elastic Compute Cloud (Amazon EC2) instances, containers, and so on. ",
        Title:
          "Implement secure key and certificate\n               management",
      },
      {
        ChoiceId: "sec_protect_data_transit_encrypt",
        Description:
          "Enforce your defined encryption requirements based on your organization’s policies, regulatory obligations and standards to help meet organizational, legal, and compliance requirements. Only use protocols with encryption when transmitting sensitive data outside of your virtual private cloud (VPC). Encryption helps maintain data confidentiality even when the data transits untrusted networks.",
        Title: "Enforce encryption in transit",
      },
      {
        ChoiceId: "sec_protect_data_transit_authentication",
        Description:
          " Verify the identity of communications by using protocols that support authentication, such as Transport Layer Security (TLS) or IPsec. ",
        Title: "Authenticate network communications",
      },
      {
        ChoiceId: "sec_protect_data_transit_auto_unintended_access",
        Description:
          " Use tools such as Amazon GuardDuty to automatically detect suspicious activity or attempts to move data outside of defined boundaries. For example, GuardDuty can detect Amazon Simple Storage Service (Amazon S3) read activity that is unusual with the Exfiltration:S3/AnomalousBehavior finding. In addition to GuardDuty, Amazon VPC Flow Logs, which capture network traffic information, can be used with Amazon EventBridge to trigger detection of abnormal connections–both successful and denied. Amazon S3 Access Analyzer can help assess what data is accessible to who in your Amazon S3 buckets. ",
        Title: "Automate detection of unintended data\n               access",
      },
      {
        ChoiceId: "sec_protect_data_transit_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.protect-data-transit.helpful-resources.en.html",
    ImprovementPlanUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.protect-data-transit.improvement-plan.en.html",
    IsApplicable: true,
    PillarId: "security",
    QuestionDescription:
      "Protect your data in transit by implementing multiple\n         controls to reduce the risk of unauthorized access or loss.",
    QuestionId: "protect-data-transit",
    QuestionTitle: "How do you protect your data in transit?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "sec_protect_data_transit_encrypt",
      "sec_protect_data_transit_authentication",
      "sec_protect_data_transit_auto_unintended_access",
    ],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Security_Check_Q9_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 4,
  Passed: 18,
};

export const Security_Check_Q9_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-05 06:33:57+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-04-03 09:14:19",
    Description: "Test",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "yameen",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-04-03 09:12:56",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Security_Check_Q9_Answer_Summaries = [
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_securely_operate_multi_accounts",
        Description:
          "Organize workloads in separate accounts and group accounts based on function or a common set of controls rather than mirroring your company’s reporting structure. Start with security and infrastructure in mind to enable your organization to set common guardrails as your workloads grow.",
        Title: "Separate workloads using accounts",
      },
      {
        ChoiceId: "sec_securely_operate_aws_account",
        Description:
          "Secure access to your accounts, for example by enabling MFA and restrict use of the root user, and configure account contacts.",
        Title: "Secure AWS account",
      },
      {
        ChoiceId: "sec_securely_operate_control_objectives",
        Description:
          "Based on your compliance requirements and risks identified from your threat model, derive and validate the control objectives and controls that you need to apply to your workload. Ongoing validation of control objectives and controls help you measure the effectiveness of risk mitigation.",
        Title: "Identify and validate control objectives",
      },
      {
        ChoiceId: "sec_securely_operate_updated_threats",
        Description:
          "Recognize attack vectors by staying up to date with the latest security threats to help you define and implement appropriate controls.",
        Title: "Keep up to date with security threats",
      },
      {
        ChoiceId: "sec_securely_operate_updated_recommendations",
        Description:
          "Stay up to date with both AWS and industry security recommendations to evolve the security posture of your workload. ",
        Title: "Keep up to date with security recommendations",
      },
      {
        ChoiceId: "sec_securely_operate_test_validate_pipeline",
        Description:
          "Establish secure baselines and templates for security mechanisms that are tested and validated as part of your build, pipelines, and processes. Use tools and automation to test and validate all security controls continuously. For example, scan items such as machine images and infrastructure as code templates for security vulnerabilities, irregularities, and drift from an established baseline at each stage.",
        Title:
          "Automate testing and validation of security controls in pipelines",
      },
      {
        ChoiceId: "sec_securely_operate_threat_model",
        Description:
          "Use a threat model to identify and maintain an up-to-date register of potential threats. Prioritize your threats and adapt your security controls to prevent, detect, and respond. Revisit and maintain this in the context of the evolving security landscape.",
        Title: "Identify and prioritize risks using a threat model",
      },
      {
        ChoiceId: "sec_securely_operate_implement_services_features",
        Description:
          "AWS and APN Partners constantly release new features and services that allow you to evolve the security posture of your workload.",
        Title:
          "Evaluate and implement new security services and features regularly",
      },
      {
        ChoiceId: "sec_securely_operate_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "securely-operate",
    QuestionTitle: "How do you securely operate your workload?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_identities_enforce_mechanisms",
        Description:
          "Enforce minimum password length, and educate users to avoid common or re-used passwords. Enforce multi-factor authentication (MFA) with software or hardware mechanisms to provide an additional layer.",
        Title: "Use strong sign-in mechanisms",
      },
      {
        ChoiceId: "sec_identities_unique",
        Description:
          "Require identities to dynamically acquire temporary credentials. For workforce identities, use AWS Single Sign-On, or federation with IAM roles to access AWS accounts. For machine identities, require the use of IAM roles instead of long term access keys.",
        Title: "Use temporary credentials",
      },
      {
        ChoiceId: "sec_identities_secrets",
        Description:
          "For workforce and machine identities that require secrets such as passwords to third party applications, store them with automatic rotation using the latest industry standards in a specialized service.",
        Title: "Store and use secrets securely",
      },
      {
        ChoiceId: "sec_identities_identity_provider",
        Description:
          "For workforce identities, rely on an identity provider that enables you to manage identities in a centralized place. This enables you to create, manage, and revoke access from a single location making it easier to manage access. This reduces the requirement for multiple credentials and provides an opportunity to integrate with HR processes.",
        Title: "Rely on a centralized identity provider",
      },
      {
        ChoiceId: "sec_identities_audit",
        Description:
          "When you cannot rely on temporary credentials and require long term credentials, audit credentials to ensure that the defined controls (for example, MFA) are enforced, rotated regularly, and have appropriate access level.",
        Title: "Audit and rotate credentials periodically",
      },
      {
        ChoiceId: "sec_identities_groups_attributes",
        Description:
          "Place users with common security requirements in groups defined by your identity provider, and put mechanisms in place to ensure that user attributes that may be used for access control (e.g., department or location) are correct and updated. Use these groups and attributes, rather than individual users, to control access. This allows you to manage access centrally by changing a user’s group membership or attributes once, rather than updating many individual policies when a user’s access needs change.",
        Title: "Leverage user groups and attributes",
      },
      {
        ChoiceId: "sec_identities_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "identities",
    QuestionTitle: "How do you manage identities for people and machines?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_permissions_define",
        Description:
          "Each component or resource of your workload needs to be accessed by administrators, end users, or other components. Have a clear definition of who or what should have access to each component, choose the appropriate identity type and method of authentication and authorization.",
        Title: "Define access requirements",
      },
      {
        ChoiceId: "sec_permissions_least_privileges",
        Description:
          "Grant only the access that identities require by allowing access to specific actions on specific AWS resources under specific conditions. Rely on groups and identity attributes to dynamically set permissions at scale, rather than defining permissions for individual users. For example, you can allow a group of developers access to manage only resources for their project. This way, when a developer is removed from the group, access for the developer is revoked everywhere that group was used for access control, without requiring any changes to the access policies.",
        Title: "Grant least privilege access",
      },
      {
        ChoiceId: "sec_permissions_emergency_process",
        Description:
          "A process that allows emergency access to your workload in the unlikely event of an automated process or pipeline issue. This will help you rely on least privilege access, but ensure users can obtain the right level of access when they require it. For example, establish a process for administrators to verify and approve their request.",
        Title: "Establish emergency access process",
      },
      {
        ChoiceId: "sec_permissions_continuous_reduction",
        Description:
          "As teams and workloads determine what access they need, remove permissions they no longer use and establish review processes to achieve least privilege permissions. Continuously monitor and reduce unused identities and permissions.",
        Title: "Reduce permissions continuously",
      },
      {
        ChoiceId: "sec_permissions_define_guardrails",
        Description:
          "Establish common controls that restrict access to all identities in your organization. For example, you can restrict access to specific AWS Regions, or prevent your operators from deleting common resources, such as an IAM role used for your central security team.",
        Title: "Define permission guardrails for your organization",
      },
      {
        ChoiceId: "sec_permissions_lifecycle",
        Description:
          "Integrate access controls with operator and application life cycle and your centralized federation provider. For example, remove a user’s access when they leave the organization or change roles.",
        Title: "Manage access based on life cycle",
      },
      {
        ChoiceId: "sec_permissions_analyze_cross_account",
        Description:
          "Continuously monitor findings that highlight public and cross account access. Reduce public access and cross account access to only resources that require this type of access.",
        Title: "Analyze public and cross account access",
      },
      {
        ChoiceId: "sec_permissions_share_securely",
        Description:
          "Govern the consumption of shared resources across accounts or within your AWS Organization. Monitor shared resources and review shared resource access.",
        Title: "Share resources securely",
      },
      {
        ChoiceId: "sec_permissions_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "permissions",
    QuestionTitle: "How do you manage permissions for people and machines?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_detect_investigate_events_app_service_logging",
        Description:
          "Configure logging throughout the workload, including application logs, resource logs, and AWS service logs. For example, ensure that AWS CloudTrail, Amazon CloudWatch Logs, Amazon GuardDuty and AWS Security Hub are enabled for all accounts within your organization.",
        Title: "Configure service and application logging",
      },
      {
        ChoiceId: "sec_detect_investigate_events_analyze_all",
        Description:
          "All logs, metrics, and telemetry should be collected centrally, and automatically analyzed to detect anomalies and indicators of unauthorized activity. A dashboard can provide you easy to access insight into real-time health. For example, ensure that Amazon GuardDuty and Security Hub logs are sent to a central location for alerting and analysis.",
        Title: "Analyze logs, findings, and metrics centrally",
      },
      {
        ChoiceId: "sec_detect_investigate_events_auto_response",
        Description:
          "Using automation to investigate and remediate events reduces human effort and error, and enables you to scale investigation capabilities. Regular reviews will help you tune automation tools, and continuously iterate. For example, automate responses to Amazon GuardDuty events by automating the first investigation step, then iterate to gradually remove human effort.",
        Title: "Automate response to events",
      },
      {
        ChoiceId: "sec_detect_investigate_events_actionable_events",
        Description:
          "Create alerts that are sent to and can be actioned by your team. Ensure that alerts include relevant information for the team to take action. For example, ensure that Amazon GuardDuty and AWS Security Hub alerts are sent to the team to action, or sent to response automation tooling with the team remaining informed by messaging from the automation framework.",
        Title: "Implement actionable security events",
      },
      {
        ChoiceId: "sec_detect_investigate_events_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "detect-investigate-events",
    QuestionTitle: "How do you detect and investigate security events?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_network_protection_create_layers",
        Description:
          "Group components that share reachability requirements into layers. For example, a database cluster in a VPC with no need for internet access should be placed in subnets with no route to or from the internet. In a serverless workload operating without a VPC, similar layering and segmentation with microservices can achieve the same goal.",
        Title: "Create network layers",
      },
      {
        ChoiceId: "sec_network_protection_layered",
        Description:
          "Apply controls with a defense in depth approach for both inbound and outbound traffic. For example, for Amazon Virtual Private Cloud (VPC) this includes security groups, Network ACLs, and subnets. For AWS Lambda, consider running in your private VPC with VPC-based controls.",
        Title: "Control traffic at all layers",
      },
      {
        ChoiceId: "sec_network_protection_auto_protect",
        Description:
          "Automate protection mechanisms to provide a self-defending network based on threat intelligence and anomaly detection. For example, intrusion detection and prevention tools that can pro-actively adapt to current threats and reduce their impact.",
        Title: "Automate network protection",
      },
      {
        ChoiceId: "sec_network_protection_inspection",
        Description:
          "Inspect and filter your traffic at each layer. For example, use a web application firewall to help protect against inadvertent access at the application network layer. For Lambda functions, third-party tools can add application-layer firewalling to your runtime environment.",
        Title: "Implement inspection and protection",
      },
      {
        ChoiceId: "sec_network_protection_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "network-protection",
    QuestionTitle: "How do you protect your network resources?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_protect_compute_vulnerability_management",
        Description:
          "Frequently scan and patch for vulnerabilities in your code, dependencies, and in your infrastructure to help protect against new threats.",
        Title: "Perform vulnerability management",
      },
      {
        ChoiceId: "sec_protect_compute_reduce_surface",
        Description:
          "Reduce your attack surface by hardening operating systems, minimizing components, libraries, and externally consumable services in use.",
        Title: "Reduce attack surface",
      },
      {
        ChoiceId: "sec_protect_compute_implement_managed_services",
        Description:
          "Implement services that manage resources, such as Amazon RDS, AWS Lambda, and Amazon ECS, to reduce your security maintenance tasks as part of the shared responsibility model.",
        Title: "Implement managed services",
      },
      {
        ChoiceId: "sec_protect_compute_auto_protection",
        Description:
          "Automate your protective compute mechanisms including vulnerability management, reduction in attack surface, and management of resources.",
        Title: "Automate compute protection",
      },
      {
        ChoiceId: "sec_protect_compute_actions_distance",
        Description:
          "Removing the ability for interactive access reduces the risk of human error, and the potential for manual configuration or management. For example, use a change management workflow to deploy EC2 instances using infrastructure as code, then manage EC2 instances using tools instead of allowing direct access or a bastion host.",
        Title: "Enable people to perform actions at a distance",
      },
      {
        ChoiceId: "sec_protect_compute_validate_software_integrity",
        Description:
          "Implement mechanisms (for example, code signing) to validate that the software, code, and libraries used in the workload are from trusted sources and have not been tampered with.",
        Title: "Validate software integrity",
      },
      {
        ChoiceId: "sec_protect_compute_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-compute",
    QuestionTitle: "How do you protect your compute resources?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_data_classification_identify_data",
        Description:
          "This includes the type and classification of data, the associated business processes. data owner, applicable legal and compliance requirements, where it’s stored, and the resulting controls that are needed to be enforced. This may include classifications to indicate if the data is intended to be publicly available, if the data is internal use only such as customer personally identifiable information (PII), or if the data is for more restricted access such as intellectual property, legally privileged or marked sensititve, and more.",
        Title: "Identify the data within your workload",
      },
      {
        ChoiceId: "sec_data_classification_define_protection",
        Description:
          "Protect data according to its classification level. For example, secure data classified as public by using relevant recommendations while protecting sensitive data with additional controls.",
        Title: "Define data protection controls",
      },
      {
        ChoiceId: "sec_data_classification_auto_classification",
        Description:
          "Automate identification and classification of data to reduce the risk of human error from manual interactions.",
        Title: "Automate identification and classification",
      },
      {
        ChoiceId: "sec_data_classification_lifecycle_management",
        Description:
          "Your defined lifecycle strategy should be based on sensitivity level, as well as legal and organization requirements. Aspects including the duration you retain data for, data destruction, data access management, data transformation, and data sharing should be considered.",
        Title: "Define data lifecycle management",
      },
      {
        ChoiceId: "sec_data_classification_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "data-classification",
    QuestionTitle: "How do you classify your data?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_protect_data_rest_key_mgmt",
        Description:
          "Encryption keys must be stored securely, withstrict access control, for example, by using a key management service such as AWSKMS. Consider using different keys, and access control to the keys, combined with theAWS IAM and resource policies, to align with data classification levels andsegregation requirements.",
        Title: "Implement secure key management",
      },
      {
        ChoiceId: "sec_protect_data_rest_encrypt",
        Description:
          "Enforce your encryption requirements based on thelatest standards and recommendations to help protect your data at rest.",
        Title: "Enforce encryption at rest",
      },
      {
        ChoiceId: "sec_protect_data_rest_automate_protection",
        Description:
          "Use automated tools to validate and enforce data atrest protection continuously, for example, verify that there are only encryptedstorage resources.",
        Title: "Automate data at rest protection",
      },
      {
        ChoiceId: "sec_protect_data_rest_access_control",
        Description:
          "Enforce access control with least privileges andmechanisms, including backups, isolation, and versioning, to help protect your dataat rest. Prevent operators from granting public access to your data.",
        Title: "Enforce access control",
      },
      {
        ChoiceId: "sec_protect_data_rest_use_people_away",
        Description:
          "Keep all users away from directly accessingsensitive data and systems under normal operational circumstances. For example,provide a dashboard instead of direct access to a data store to run queries. WhereCI/CD pipelines are not used, determine which controls and processes are required toadequately provide a normally disabled break-glass access mechanism.",
        Title: "Use mechanisms to keep people away from data",
      },
      {
        ChoiceId: "sec_protect_data_rest_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-data-rest",
    QuestionTitle: "How do you protect your data at rest?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_protect_data_transit_key_cert_mgmt",
        Description:
          "Store encryption keys and certificates securely androtate them at appropriate time intervals while applying strict access control; forexample, by using a certificate management service, such as AWS Certificate Manager(ACM).",
        Title: "Implement secure key and certificatemanagement",
      },
      {
        ChoiceId: "sec_protect_data_transit_encrypt",
        Description:
          "Enforce your defined encryption requirements basedon appropriate standards and recommendations to help you meet your organizational,legal, and compliance requirements.",
        Title: "Enforce encryption in transit",
      },
      {
        ChoiceId: "sec_protect_data_transit_auto_unintended_access",
        Description:
          "Use tools such as GuardDuty to automatically detectattempts to move data outside of defined boundaries based on data classificationlevel, for example, to detect a trojan that is copying data to an unknown oruntrusted network using the DNS protocol.",
        Title: "Automate detection of unintended dataaccess",
      },
      {
        ChoiceId: "sec_protect_data_transit_authentication",
        Description:
          "Verify the identity of communications by usingprotocols that support authentication, such as Transport Layer Security (TLS) orIPsec.",
        Title: "Authenticate network communications",
      },
      {
        ChoiceId: "sec_protect_data_transit_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-data-transit",
    QuestionTitle: "How do you protect your data in transit?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_incident_response_identify_personnel",
        Description:
          "Identify internal and external personnel, resources, and legal obligations that would help your organization respond to an incident.",
        Title: "Identify key personnel and external resources",
      },
      {
        ChoiceId: "sec_incident_response_develop_management_plans",
        Description:
          "Create plans to help you respond to, communicate during, and recover from an incident. For example, you can start an incident response plan with the most likely scenarios for your workload and organization. Include how you would communicate and escalate both internally and externally.",
        Title: "Develop incident management plans",
      },
      {
        ChoiceId: "sec_incident_response_prepare_forensic",
        Description:
          "Identify and prepare forensic investigation capabilities that are suitable, including external specialists, tools, and automation.",
        Title: "Prepare forensic capabilities",
      },
      {
        ChoiceId: "sec_incident_response_auto_contain",
        Description:
          "Automate containment and recovery of an incident to reduce response times and organizational impact.",
        Title: "Automate containment capability",
      },
      {
        ChoiceId: "sec_incident_response_pre_provision_access",
        Description:
          "Ensure that incident responders have the correct access pre-provisioned into AWS to reduce the time for investigation through to recovery.",
        Title: "Pre-provision access",
      },
      {
        ChoiceId: "sec_incident_response_pre_deploy_tools",
        Description:
          "Ensure that security personnel have the right tools pre-deployed into AWS to reduce the time for investigation through to recovery.",
        Title: "Pre-deploy tools",
      },
      {
        ChoiceId: "sec_incident_response_run_game_days",
        Description:
          "Practice incident response game days (simulations) regularly, incorporate lessons learned into your incident management plans, and continuously improve.",
        Title: "Run game days",
      },
      {
        ChoiceId: "sec_incident_response_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "incident-response",
    QuestionTitle:
      "How do you anticipate, respond to, and recover from incidents?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
];

export const Security_Pillar_Q10 = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "sec_incident_response_identify_personnel",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_incident_response_develop_management_plans",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_incident_response_pre_deploy_tools",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_incident_response_run_game_days",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_incident_response_prepare_forensic",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_incident_response_auto_contain",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_incident_response_pre_provision_access",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sec_incident_response_identify_personnel",
        Description:
          " Identify internal and external personnel, resources, and legal obligations that would help your organization respond to an incident. ",
        Title: "Identify key personnel and external resources",
      },
      {
        ChoiceId: "sec_incident_response_develop_management_plans",
        Description:
          " Create plans to help you respond to, communicate during, and recover from an incident. For example, you can start an incident response plan with the most likely scenarios for your workload and organization. Include how you would communicate and escalate both internally and externally. ",
        Title: "Develop incident management plans",
      },
      {
        ChoiceId: "sec_incident_response_pre_deploy_tools",
        Description:
          " Ensure that security personnel have the right tools pre-deployed into AWS to reduce the time for investigation through to recovery. ",
        Title: "Pre-deploy tools",
      },
      {
        ChoiceId: "sec_incident_response_run_game_days",
        Description:
          "Game days, also known as simulations or exercises, are internal events that provide a structured opportunity to practice your incident management plans and procedures during a realistic scenario. These events should exercise responders using the same tools and techniques that would be used in a real-world scenario - even mimicking real-world environments. Game days are fundamentally about being prepared and iteratively improving your response capabilities. Some of the reasons you might find value in performing game day activities include: ",
        Title: "Run game days",
      },
      {
        ChoiceId: "sec_incident_response_prepare_forensic",
        Description:
          " It’s important for your incident responders to understand when and how the forensic investigation fits into your response plan. Your organization should define what evidence is collected and what tools are used in the process. Identify and prepare forensic investigation capabilities that are suitable, including external specialists, tools, and automation. A key decision that you should make upfront is if you will collect data from a live system. Some data, such as the contents of volatile memory or active network connections, will be lost if the system is powered off or rebooted. ",
        Title: "Prepare forensic capabilities",
      },
      {
        ChoiceId: "sec_incident_response_auto_contain",
        Description:
          "Automate containment and recovery of an incident to reduce response times and organizational impact.",
        Title: "Automate containment capability",
      },
      {
        ChoiceId: "sec_incident_response_pre_provision_access",
        Description:
          "Verify that incident responders have the correct access pre-provisioned in AWS to reduce the time needed for investigation through to recovery.",
        Title: "Pre-provision access",
      },
      {
        ChoiceId: "sec_incident_response_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.incident-response.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "security",
    QuestionDescription:
      "Preparation is critical to timely and effective investigation, response to, and recovery from security incidents to help minimize disruption to your organization.",
    QuestionId: "incident-response",
    QuestionTitle:
      "How do you anticipate, respond to, and recover from incidents?",
    Reason: "NONE",
    Risk: "NONE",
    SelectedChoices: [
      "sec_incident_response_identify_personnel",
      "sec_incident_response_develop_management_plans",
      "sec_incident_response_pre_deploy_tools",
      "sec_incident_response_run_game_days",
      "sec_incident_response_prepare_forensic",
      "sec_incident_response_auto_contain",
      "sec_incident_response_pre_provision_access",
    ],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Security_Pillar_Q11 = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "sec_appsec_perform_regular_penetration_testing",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId:
          "sec_appsec_regularly_assess_security_properties_of_pipelines",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId:
          "sec_appsec_build_program_that_embeds_security_ownership_in_teams",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sec_appsec_train_for_application_security",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sec_appsec_perform_regular_penetration_testing",
        Description:
          "Perform regular penetration testing of your software. This mechanism helps identify potential software issues that cannot be detected by automated testing or a manual code review. It can also help you understand the efficacy of your detective controls. Penetration testing should try to determine if the software can be made to perform in unexpected ways, such as exposing data that should be protected, or granting broader permissions than expected.",
        Title: "Perform regular penetration testing",
      },
      {
        ChoiceId: "sec_appsec_deploy_software_programmatically",
        Description:
          "Perform software deployments programmatically where possible. This approach reduces the likelihood that a deployment fails or an unexpected issue is introduced due to human error.",
        Title: "Deploy software programmatically",
      },
      {
        ChoiceId:
          "sec_appsec_regularly_assess_security_properties_of_pipelines",
        Description:
          "Apply the principles of the Well-Architected Security Pillar to your pipelines, with particular attention to the separation of permissions. Regularly assess the security properties of your pipeline infrastructure. Effectively managing the security of the pipelines allows you to deliver the security of the software that passes through the pipelines. ",
        Title: "Regularly assess security properties of the pipelines",
      },
      {
        ChoiceId:
          "sec_appsec_build_program_that_embeds_security_ownership_in_teams",
        Description:
          "Build a program or mechanism that empowers builder teams to make security decisions about the software that they create. Your security team still needs to validate these decisions during a review, but embedding security ownership in builder teams allows for faster, more secure workloads to be built. This mechanism also promotes a culture of ownership that positively impacts the operation of the systems you build.",
        Title:
          "Build a program that embeds security ownership in workload teams",
      },
      {
        ChoiceId: "sec_appsec_train_for_application_security",
        Description:
          "Provide training to the builders in your organization on common practices for the secure development and operation of applications. Adopting security focused development practices helps reduce the likelihood of issues that are only detected at the security review stage. ",
        Title: "Train for application security",
      },
      {
        ChoiceId: "sec_appsec_automate_testing_throughout_lifecycle",
        Description:
          " Automate the testing for security properties throughout the development and release lifecycle. Automation makes it easier to consistently and repeatably identify potential issues in software prior to release, which reduces the risk of security issues in the software being provided. ",
        Title:
          "Automate testing throughout the development and release lifecycle",
      },
      {
        ChoiceId: "sec_appsec_manual_code_reviews",
        Description:
          "Perform a manual code review of the software that you produce. This process helps verify that the person who wrote the code is not the only one checking the code quality.",
        Title: "Manual code reviews",
      },
      {
        ChoiceId:
          "sec_appsec_centralize_services_for_packages_and_dependencies",
        Description:
          "Provide centralized services for builder teams to obtain software packages and other dependencies. This allows the validation of packages before they are included in the software that you write, and provides a source of data for the analysis of the software being used in your organization.",
        Title: "Centralize services for packages and dependencies",
      },
      {
        ChoiceId: "sec_application_security_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.application-security.helpful-resources.en.html",
    ImprovementPlanUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.application-security.improvement-plan.en.html",
    IsApplicable: true,
    PillarId: "security",
    QuestionDescription:
      "Training people, testing using automation, understanding dependencies, and validating the security properties of tools and applications help to reduce the likelihood of security issues in production workloads.",
    QuestionId: "application-security",
    QuestionTitle:
      "How do you incorporate and validate the security properties of applications throughout the design, development, and deployment lifecycle?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "sec_appsec_perform_regular_penetration_testing",
      "sec_appsec_regularly_assess_security_properties_of_pipelines",
      "sec_appsec_build_program_that_embeds_security_ownership_in_teams",
      "sec_appsec_train_for_application_security",
    ],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Security_Check_Q10_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Security_Check_Q10_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-05 06:33:57+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-04-03 09:14:19",
    Description: "Test",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "yameen",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-04-03 09:12:56",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Security_Check_Q10_Answer_Summaries = [
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_securely_operate_multi_accounts",
        Description:
          "Organize workloads in separate accounts and group accounts based on function or a common set of controls rather than mirroring your company’s reporting structure. Start with security and infrastructure in mind to enable your organization to set common guardrails as your workloads grow.",
        Title: "Separate workloads using accounts",
      },
      {
        ChoiceId: "sec_securely_operate_aws_account",
        Description:
          "Secure access to your accounts, for example by enabling MFA and restrict use of the root user, and configure account contacts.",
        Title: "Secure AWS account",
      },
      {
        ChoiceId: "sec_securely_operate_control_objectives",
        Description:
          "Based on your compliance requirements and risks identified from your threat model, derive and validate the control objectives and controls that you need to apply to your workload. Ongoing validation of control objectives and controls help you measure the effectiveness of risk mitigation.",
        Title: "Identify and validate control objectives",
      },
      {
        ChoiceId: "sec_securely_operate_updated_threats",
        Description:
          "Recognize attack vectors by staying up to date with the latest security threats to help you define and implement appropriate controls.",
        Title: "Keep up to date with security threats",
      },
      {
        ChoiceId: "sec_securely_operate_updated_recommendations",
        Description:
          "Stay up to date with both AWS and industry security recommendations to evolve the security posture of your workload. ",
        Title: "Keep up to date with security recommendations",
      },
      {
        ChoiceId: "sec_securely_operate_test_validate_pipeline",
        Description:
          "Establish secure baselines and templates for security mechanisms that are tested and validated as part of your build, pipelines, and processes. Use tools and automation to test and validate all security controls continuously. For example, scan items such as machine images and infrastructure as code templates for security vulnerabilities, irregularities, and drift from an established baseline at each stage.",
        Title:
          "Automate testing and validation of security controls in pipelines",
      },
      {
        ChoiceId: "sec_securely_operate_threat_model",
        Description:
          "Use a threat model to identify and maintain an up-to-date register of potential threats. Prioritize your threats and adapt your security controls to prevent, detect, and respond. Revisit and maintain this in the context of the evolving security landscape.",
        Title: "Identify and prioritize risks using a threat model",
      },
      {
        ChoiceId: "sec_securely_operate_implement_services_features",
        Description:
          "AWS and APN Partners constantly release new features and services that allow you to evolve the security posture of your workload.",
        Title:
          "Evaluate and implement new security services and features regularly",
      },
      {
        ChoiceId: "sec_securely_operate_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "securely-operate",
    QuestionTitle: "How do you securely operate your workload?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_identities_enforce_mechanisms",
        Description:
          "Enforce minimum password length, and educate users to avoid common or re-used passwords. Enforce multi-factor authentication (MFA) with software or hardware mechanisms to provide an additional layer.",
        Title: "Use strong sign-in mechanisms",
      },
      {
        ChoiceId: "sec_identities_unique",
        Description:
          "Require identities to dynamically acquire temporary credentials. For workforce identities, use AWS Single Sign-On, or federation with IAM roles to access AWS accounts. For machine identities, require the use of IAM roles instead of long term access keys.",
        Title: "Use temporary credentials",
      },
      {
        ChoiceId: "sec_identities_secrets",
        Description:
          "For workforce and machine identities that require secrets such as passwords to third party applications, store them with automatic rotation using the latest industry standards in a specialized service.",
        Title: "Store and use secrets securely",
      },
      {
        ChoiceId: "sec_identities_identity_provider",
        Description:
          "For workforce identities, rely on an identity provider that enables you to manage identities in a centralized place. This enables you to create, manage, and revoke access from a single location making it easier to manage access. This reduces the requirement for multiple credentials and provides an opportunity to integrate with HR processes.",
        Title: "Rely on a centralized identity provider",
      },
      {
        ChoiceId: "sec_identities_audit",
        Description:
          "When you cannot rely on temporary credentials and require long term credentials, audit credentials to ensure that the defined controls (for example, MFA) are enforced, rotated regularly, and have appropriate access level.",
        Title: "Audit and rotate credentials periodically",
      },
      {
        ChoiceId: "sec_identities_groups_attributes",
        Description:
          "Place users with common security requirements in groups defined by your identity provider, and put mechanisms in place to ensure that user attributes that may be used for access control (e.g., department or location) are correct and updated. Use these groups and attributes, rather than individual users, to control access. This allows you to manage access centrally by changing a user’s group membership or attributes once, rather than updating many individual policies when a user’s access needs change.",
        Title: "Leverage user groups and attributes",
      },
      {
        ChoiceId: "sec_identities_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "identities",
    QuestionTitle: "How do you manage identities for people and machines?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_permissions_define",
        Description:
          "Each component or resource of your workload needs to be accessed by administrators, end users, or other components. Have a clear definition of who or what should have access to each component, choose the appropriate identity type and method of authentication and authorization.",
        Title: "Define access requirements",
      },
      {
        ChoiceId: "sec_permissions_least_privileges",
        Description:
          "Grant only the access that identities require by allowing access to specific actions on specific AWS resources under specific conditions. Rely on groups and identity attributes to dynamically set permissions at scale, rather than defining permissions for individual users. For example, you can allow a group of developers access to manage only resources for their project. This way, when a developer is removed from the group, access for the developer is revoked everywhere that group was used for access control, without requiring any changes to the access policies.",
        Title: "Grant least privilege access",
      },
      {
        ChoiceId: "sec_permissions_emergency_process",
        Description:
          "A process that allows emergency access to your workload in the unlikely event of an automated process or pipeline issue. This will help you rely on least privilege access, but ensure users can obtain the right level of access when they require it. For example, establish a process for administrators to verify and approve their request.",
        Title: "Establish emergency access process",
      },
      {
        ChoiceId: "sec_permissions_continuous_reduction",
        Description:
          "As teams and workloads determine what access they need, remove permissions they no longer use and establish review processes to achieve least privilege permissions. Continuously monitor and reduce unused identities and permissions.",
        Title: "Reduce permissions continuously",
      },
      {
        ChoiceId: "sec_permissions_define_guardrails",
        Description:
          "Establish common controls that restrict access to all identities in your organization. For example, you can restrict access to specific AWS Regions, or prevent your operators from deleting common resources, such as an IAM role used for your central security team.",
        Title: "Define permission guardrails for your organization",
      },
      {
        ChoiceId: "sec_permissions_lifecycle",
        Description:
          "Integrate access controls with operator and application life cycle and your centralized federation provider. For example, remove a user’s access when they leave the organization or change roles.",
        Title: "Manage access based on life cycle",
      },
      {
        ChoiceId: "sec_permissions_analyze_cross_account",
        Description:
          "Continuously monitor findings that highlight public and cross account access. Reduce public access and cross account access to only resources that require this type of access.",
        Title: "Analyze public and cross account access",
      },
      {
        ChoiceId: "sec_permissions_share_securely",
        Description:
          "Govern the consumption of shared resources across accounts or within your AWS Organization. Monitor shared resources and review shared resource access.",
        Title: "Share resources securely",
      },
      {
        ChoiceId: "sec_permissions_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "permissions",
    QuestionTitle: "How do you manage permissions for people and machines?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_detect_investigate_events_app_service_logging",
        Description:
          "Configure logging throughout the workload, including application logs, resource logs, and AWS service logs. For example, ensure that AWS CloudTrail, Amazon CloudWatch Logs, Amazon GuardDuty and AWS Security Hub are enabled for all accounts within your organization.",
        Title: "Configure service and application logging",
      },
      {
        ChoiceId: "sec_detect_investigate_events_analyze_all",
        Description:
          "All logs, metrics, and telemetry should be collected centrally, and automatically analyzed to detect anomalies and indicators of unauthorized activity. A dashboard can provide you easy to access insight into real-time health. For example, ensure that Amazon GuardDuty and Security Hub logs are sent to a central location for alerting and analysis.",
        Title: "Analyze logs, findings, and metrics centrally",
      },
      {
        ChoiceId: "sec_detect_investigate_events_auto_response",
        Description:
          "Using automation to investigate and remediate events reduces human effort and error, and enables you to scale investigation capabilities. Regular reviews will help you tune automation tools, and continuously iterate. For example, automate responses to Amazon GuardDuty events by automating the first investigation step, then iterate to gradually remove human effort.",
        Title: "Automate response to events",
      },
      {
        ChoiceId: "sec_detect_investigate_events_actionable_events",
        Description:
          "Create alerts that are sent to and can be actioned by your team. Ensure that alerts include relevant information for the team to take action. For example, ensure that Amazon GuardDuty and AWS Security Hub alerts are sent to the team to action, or sent to response automation tooling with the team remaining informed by messaging from the automation framework.",
        Title: "Implement actionable security events",
      },
      {
        ChoiceId: "sec_detect_investigate_events_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "detect-investigate-events",
    QuestionTitle: "How do you detect and investigate security events?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_network_protection_create_layers",
        Description:
          "Group components that share reachability requirements into layers. For example, a database cluster in a VPC with no need for internet access should be placed in subnets with no route to or from the internet. In a serverless workload operating without a VPC, similar layering and segmentation with microservices can achieve the same goal.",
        Title: "Create network layers",
      },
      {
        ChoiceId: "sec_network_protection_layered",
        Description:
          "Apply controls with a defense in depth approach for both inbound and outbound traffic. For example, for Amazon Virtual Private Cloud (VPC) this includes security groups, Network ACLs, and subnets. For AWS Lambda, consider running in your private VPC with VPC-based controls.",
        Title: "Control traffic at all layers",
      },
      {
        ChoiceId: "sec_network_protection_auto_protect",
        Description:
          "Automate protection mechanisms to provide a self-defending network based on threat intelligence and anomaly detection. For example, intrusion detection and prevention tools that can pro-actively adapt to current threats and reduce their impact.",
        Title: "Automate network protection",
      },
      {
        ChoiceId: "sec_network_protection_inspection",
        Description:
          "Inspect and filter your traffic at each layer. For example, use a web application firewall to help protect against inadvertent access at the application network layer. For Lambda functions, third-party tools can add application-layer firewalling to your runtime environment.",
        Title: "Implement inspection and protection",
      },
      {
        ChoiceId: "sec_network_protection_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "network-protection",
    QuestionTitle: "How do you protect your network resources?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_protect_compute_vulnerability_management",
        Description:
          "Frequently scan and patch for vulnerabilities in your code, dependencies, and in your infrastructure to help protect against new threats.",
        Title: "Perform vulnerability management",
      },
      {
        ChoiceId: "sec_protect_compute_reduce_surface",
        Description:
          "Reduce your attack surface by hardening operating systems, minimizing components, libraries, and externally consumable services in use.",
        Title: "Reduce attack surface",
      },
      {
        ChoiceId: "sec_protect_compute_implement_managed_services",
        Description:
          "Implement services that manage resources, such as Amazon RDS, AWS Lambda, and Amazon ECS, to reduce your security maintenance tasks as part of the shared responsibility model.",
        Title: "Implement managed services",
      },
      {
        ChoiceId: "sec_protect_compute_auto_protection",
        Description:
          "Automate your protective compute mechanisms including vulnerability management, reduction in attack surface, and management of resources.",
        Title: "Automate compute protection",
      },
      {
        ChoiceId: "sec_protect_compute_actions_distance",
        Description:
          "Removing the ability for interactive access reduces the risk of human error, and the potential for manual configuration or management. For example, use a change management workflow to deploy EC2 instances using infrastructure as code, then manage EC2 instances using tools instead of allowing direct access or a bastion host.",
        Title: "Enable people to perform actions at a distance",
      },
      {
        ChoiceId: "sec_protect_compute_validate_software_integrity",
        Description:
          "Implement mechanisms (for example, code signing) to validate that the software, code, and libraries used in the workload are from trusted sources and have not been tampered with.",
        Title: "Validate software integrity",
      },
      {
        ChoiceId: "sec_protect_compute_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-compute",
    QuestionTitle: "How do you protect your compute resources?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_data_classification_identify_data",
        Description:
          "This includes the type and classification of data, the associated business processes. data owner, applicable legal and compliance requirements, where it’s stored, and the resulting controls that are needed to be enforced. This may include classifications to indicate if the data is intended to be publicly available, if the data is internal use only such as customer personally identifiable information (PII), or if the data is for more restricted access such as intellectual property, legally privileged or marked sensititve, and more.",
        Title: "Identify the data within your workload",
      },
      {
        ChoiceId: "sec_data_classification_define_protection",
        Description:
          "Protect data according to its classification level. For example, secure data classified as public by using relevant recommendations while protecting sensitive data with additional controls.",
        Title: "Define data protection controls",
      },
      {
        ChoiceId: "sec_data_classification_auto_classification",
        Description:
          "Automate identification and classification of data to reduce the risk of human error from manual interactions.",
        Title: "Automate identification and classification",
      },
      {
        ChoiceId: "sec_data_classification_lifecycle_management",
        Description:
          "Your defined lifecycle strategy should be based on sensitivity level, as well as legal and organization requirements. Aspects including the duration you retain data for, data destruction, data access management, data transformation, and data sharing should be considered.",
        Title: "Define data lifecycle management",
      },
      {
        ChoiceId: "sec_data_classification_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "data-classification",
    QuestionTitle: "How do you classify your data?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_protect_data_rest_key_mgmt",
        Description:
          "Encryption keys must be stored securely, withstrict access control, for example, by using a key management service such as AWSKMS. Consider using different keys, and access control to the keys, combined with theAWS IAM and resource policies, to align with data classification levels andsegregation requirements.",
        Title: "Implement secure key management",
      },
      {
        ChoiceId: "sec_protect_data_rest_encrypt",
        Description:
          "Enforce your encryption requirements based on thelatest standards and recommendations to help protect your data at rest.",
        Title: "Enforce encryption at rest",
      },
      {
        ChoiceId: "sec_protect_data_rest_automate_protection",
        Description:
          "Use automated tools to validate and enforce data atrest protection continuously, for example, verify that there are only encryptedstorage resources.",
        Title: "Automate data at rest protection",
      },
      {
        ChoiceId: "sec_protect_data_rest_access_control",
        Description:
          "Enforce access control with least privileges andmechanisms, including backups, isolation, and versioning, to help protect your dataat rest. Prevent operators from granting public access to your data.",
        Title: "Enforce access control",
      },
      {
        ChoiceId: "sec_protect_data_rest_use_people_away",
        Description:
          "Keep all users away from directly accessingsensitive data and systems under normal operational circumstances. For example,provide a dashboard instead of direct access to a data store to run queries. WhereCI/CD pipelines are not used, determine which controls and processes are required toadequately provide a normally disabled break-glass access mechanism.",
        Title: "Use mechanisms to keep people away from data",
      },
      {
        ChoiceId: "sec_protect_data_rest_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-data-rest",
    QuestionTitle: "How do you protect your data at rest?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_protect_data_transit_key_cert_mgmt",
        Description:
          "Store encryption keys and certificates securely androtate them at appropriate time intervals while applying strict access control; forexample, by using a certificate management service, such as AWS Certificate Manager(ACM).",
        Title: "Implement secure key and certificatemanagement",
      },
      {
        ChoiceId: "sec_protect_data_transit_encrypt",
        Description:
          "Enforce your defined encryption requirements basedon appropriate standards and recommendations to help you meet your organizational,legal, and compliance requirements.",
        Title: "Enforce encryption in transit",
      },
      {
        ChoiceId: "sec_protect_data_transit_auto_unintended_access",
        Description:
          "Use tools such as GuardDuty to automatically detectattempts to move data outside of defined boundaries based on data classificationlevel, for example, to detect a trojan that is copying data to an unknown oruntrusted network using the DNS protocol.",
        Title: "Automate detection of unintended dataaccess",
      },
      {
        ChoiceId: "sec_protect_data_transit_authentication",
        Description:
          "Verify the identity of communications by usingprotocols that support authentication, such as Transport Layer Security (TLS) orIPsec.",
        Title: "Authenticate network communications",
      },
      {
        ChoiceId: "sec_protect_data_transit_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "protect-data-transit",
    QuestionTitle: "How do you protect your data in transit?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "sec_incident_response_identify_personnel",
        Description:
          "Identify internal and external personnel, resources, and legal obligations that would help your organization respond to an incident.",
        Title: "Identify key personnel and external resources",
      },
      {
        ChoiceId: "sec_incident_response_develop_management_plans",
        Description:
          "Create plans to help you respond to, communicate during, and recover from an incident. For example, you can start an incident response plan with the most likely scenarios for your workload and organization. Include how you would communicate and escalate both internally and externally.",
        Title: "Develop incident management plans",
      },
      {
        ChoiceId: "sec_incident_response_prepare_forensic",
        Description:
          "Identify and prepare forensic investigation capabilities that are suitable, including external specialists, tools, and automation.",
        Title: "Prepare forensic capabilities",
      },
      {
        ChoiceId: "sec_incident_response_auto_contain",
        Description:
          "Automate containment and recovery of an incident to reduce response times and organizational impact.",
        Title: "Automate containment capability",
      },
      {
        ChoiceId: "sec_incident_response_pre_provision_access",
        Description:
          "Ensure that incident responders have the correct access pre-provisioned into AWS to reduce the time for investigation through to recovery.",
        Title: "Pre-provision access",
      },
      {
        ChoiceId: "sec_incident_response_pre_deploy_tools",
        Description:
          "Ensure that security personnel have the right tools pre-deployed into AWS to reduce the time for investigation through to recovery.",
        Title: "Pre-deploy tools",
      },
      {
        ChoiceId: "sec_incident_response_run_game_days",
        Description:
          "Practice incident response game days (simulations) regularly, incorporate lessons learned into your incident management plans, and continuously improve.",
        Title: "Run game days",
      },
      {
        ChoiceId: "sec_incident_response_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "security",
    QuestionId: "incident-response",
    QuestionTitle:
      "How do you anticipate, respond to, and recover from incidents?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
];

export const Performance_Efficiency_Q1 = [
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "perf_performing_architecture_evaluate_resources",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_performing_architecture_process",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_performing_architecture_cost",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_performing_architecture_use_policies",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "perf_performing_architecture_evaluate_resources",
        Description:
          "\n               Learn about and understand the wide range of services and resources available in the cloud. Identify the relevant services and configuration options for your workload, and understand how to achieve optimal performance. \n\t\t\t\t",
        Title: "Understand the available services and resources",
      },
      {
        ChoiceId: "perf_performing_architecture_process",
        Description:
          "\n               Use internal experience and knowledge of the cloud, or external resources such as published use cases, relevant documentation, or whitepapers to define a process to choose resources and services. You should define a process that encourages experimentation and benchmarking with the services that could be used in your workload. \n\t\t\t\t",
        Title: "Define a process for architectural choices",
      },
      {
        ChoiceId: "perf_performing_architecture_cost",
        Description:
          "\n               Workloads often have cost requirements for operation. Use internal cost controls to select resource types and sizes based on predicted resource need.",
        Title: "Factor cost requirements into decisions ",
      },
      {
        ChoiceId: "perf_performing_architecture_load_test",
        Description:
          "\n               Deploy your latest workload architecture on the cloud using different resource types and sizes. Monitor the deployment to capture performance metrics that identify bottlenecks or excess capacity. Use this performance information to design or improve your architecture and resource selection. \n\t\t\t\t",
        Title: "Load test your workload",
      },
      {
        ChoiceId: "perf_performing_architecture_use_policies",
        Description:
          "\n               Maximize performance and efficiency by evaluating internal policies and existing reference architectures and using your analysis to select services and configurations for your workload. \n\t\t\t\t",
        Title: "Use policies or reference architectures",
      },
      {
        ChoiceId: "perf_performing_architecture_external_guidance",
        Description:
          "\n               Use cloud company resources, such as solutions architects, professional services, or an appropriate partner to guide your decisions. These resources can help review and improve your architecture for optimal performance. \n\t\t\t\t",
        Title:
          "Use guidance from your cloud provider or an appropriate partner",
      },
      {
        ChoiceId: "perf_performing_architecture_benchmark",
        Description:
          "\n               Benchmark the performance of an existing workload to understand how it performs on the cloud. Use the data collected from benchmarks to drive architectural decisions. \n\t\t\t\t",
        Title: "Benchmark existing workloads",
      },
      {
        ChoiceId: "perf_performing_architecture_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "performance",
    QuestionId: "performing-architecture",
    QuestionTitle: "How do you select the best performing architecture?",
    Reason: "NONE",
    Risk: "MEDIUM",
    SelectedChoices: [
      "perf_performing_architecture_evaluate_resources",
      "perf_performing_architecture_process",
      "perf_performing_architecture_cost",
      "perf_performing_architecture_use_policies",
    ],
  },
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "perf_select_compute_collect_metrics",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_select_compute_right_sizing",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_select_compute_elasticity",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "perf_select_compute_evaluate_options",
        Description:
          " Understand how your workload can benefit from the use of different compute options, such as instances, containers and functions. ",
        Title: "Evaluate the available compute options",
      },
      {
        ChoiceId: "perf_select_compute_config_options",
        Description:
          " Each compute solution has options and configurations available to you to support your workload characteristics. Learn how various options complement your workload, and which configuration options are best for your application. Examples of these options include instance family, sizes, features (GPU, I/O), bursting, time-outs, function sizes, container instances, and concurrency. ",
        Title: "Understand the available compute configuration options",
      },
      {
        ChoiceId: "perf_select_compute_collect_metrics",
        Description:
          "To understand how your compute resources are performing, you must record and track the utilization of various systems. This data can be used to make more accurate determinations about resource requirements.  ",
        Title: "Collect compute-related metrics",
      },
      {
        ChoiceId: "perf_select_compute_use_metrics",
        Description:
          "Use a data-driven approach to continually evaluate and optimize the compute resources for your workload over time.",
        Title: "Continually evaluate compute needs based on metrics",
      },
      {
        ChoiceId: "perf_select_compute_right_sizing",
        Description:
          "Analyze the various performance characteristics of your workload and how these characteristics relate to memory, network, I/O, and CPU usage. Use this data to choose resources that best match your workload’s profile. For example, a memory-intensive workload like a database may benefit from a higher memory per core ratio. However, a compute intensive workload may need a higher core count and frequency, but can be satisfied with a lower amount of memory per core.",
        Title: "Determine the required configuration by right-sizing",
      },
      {
        ChoiceId: "perf_select_compute_elasticity",
        Description:
          "The cloud provides the flexibility to expand and reduce your resources dynamically through a variety of mechanisms to meet changes in demand. Combining this elasticity with compute-related metrics, a workload can automatically respond to changes to use the resources it needs and only the resources it needs.",
        Title: "Use the available elasticity of resources",
      },
      {
        ChoiceId: "perf_select_compute_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "performance",
    QuestionId: "select-compute",
    QuestionTitle: "How do you select your compute solution?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "perf_select_compute_collect_metrics",
      "perf_select_compute_right_sizing",
      "perf_select_compute_elasticity",
    ],
  },
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "perf_right_storage_solution_optimize_patterns",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_right_storage_solution_understand_char",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_right_storage_solution_evaluated_options",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "perf_right_storage_solution_understand_char",
        Description:
          " Identify and document the workload storage needs and define the storage characteristics of each location. Examples of storage characteristics include: shareable access, file size, growth rate, throughput, IOPS, latency, access patterns, and persistence of data. Use these characteristics to evaluate if block, file, object, or instance storage services are the most efficient solution for your storage needs. ",
        Title: "Understand storage characteristics and requirements",
      },
      {
        ChoiceId: "perf_right_storage_solution_optimize_patterns",
        Description:
          " Choose storage systems based on your workload's access patterns and configure them by determining how the workload accesses data. Increase storage efficiency by choosing object storage over block storage. Configure the storage options you choose to match your data access patterns. ",
        Title: "Make decisions based on access patterns and metrics",
      },
      {
        ChoiceId: "perf_right_storage_solution_evaluated_options",
        Description:
          " Evaluate the various characteristics and configuration options and how they relate to storage. Understand where and how to use provisioned IOPS, SSDs, magnetic storage, object storage, archival storage, or ephemeral storage to optimize storage space and performance for your workload. ",
        Title: "Evaluate available configuration options",
      },
      {
        ChoiceId: "perf_right_storage_solution_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "performance",
    QuestionId: "right-storage-solution",
    QuestionTitle: "How do you select your storage solution?",
    Reason: "NONE",
    Risk: "NONE",
    SelectedChoices: [
      "perf_right_storage_solution_optimize_patterns",
      "perf_right_storage_solution_understand_char",
      "perf_right_storage_solution_evaluated_options",
    ],
  },
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "perf_right_database_solution_evaluate_options",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_right_database_solution_collect_metrics",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_right_database_solution_access_patterns",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_right_database_solution_optimize_metrics",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "perf_right_database_solution_understand_char",
        Description:
          " Choose your data management solutions to optimally match the characteristics, access patterns, and requirements of your workload datasets. When selecting and implementing a data management solution, you must ensure that the querying, scaling, and storage characteristics support the workload data requirements. Learn how various database options match your data models, and which configuration options are best for your use-case.  ",
        Title: "Understand data characteristics",
      },
      {
        ChoiceId: "perf_right_database_solution_evaluate_options",
        Description:
          " Understand the available database options and how it can optimize your performance before you select your data management solution. Use load testing to identify database metrics that matter for your workload. While you explore the database options, take into consideration various aspects such as the parameter groups, storage options, memory, compute, read replica, eventual consistency, connection pooling, and caching options. Experiment with these various configuration options to improve the metrics. ",
        Title: "Evaluate the available options",
      },
      {
        ChoiceId: "perf_right_database_solution_collect_metrics",
        Description:
          " To understand how your data management systems are performing, it is important to track relevant metrics. These metrics will help you to optimize your data management resources, to ensure that your workload requirements are met, and that you have a clear overview on how the workload performs. Use tools, libraries, and systems that record performance measurements related to database performance. ",
        Title: "Collect and record database performance metrics",
      },
      {
        ChoiceId: "perf_right_database_solution_optimize_metrics",
        Description:
          " Use performance characteristics and access patterns that optimize how data is stored or queried to achieve the best possible performance. Measure how optimizations such as indexing, key distribution, data warehouse design, or caching strategies impact system performance or overall efficiency. ",
        Title: "Optimize data storage based on access patterns and metrics",
      },
      {
        ChoiceId: "perf_right_database_solution_access_patterns",
        Description:
          "Use the access patterns of the workload and requirements of the applications to decide on optimal data services and technologies to use. ",
        Title: "Choose data storage based on access patterns",
      },
      {
        ChoiceId: "perf_right_database_solution_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "performance",
    QuestionId: "right-database-solution",
    QuestionTitle: "How do you select your database solution?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "perf_right_database_solution_evaluate_options",
      "perf_right_database_solution_collect_metrics",
      "perf_right_database_solution_access_patterns",
      "perf_right_database_solution_optimize_metrics",
    ],
  },
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "perf_select_network_understand_impact",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_select_network_evaluate_features",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_select_network_hybrid",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_select_network_encryption_offload",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_select_network_protocols",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "perf_select_network_understand_impact",
        Description:
          " Analyze and understand how network-related decisions impact workload performance. The network is responsible for the connectivity between application components, cloud services, edge networks and on-premises data and therefor it can highly impact workload performance. In addition to workload performance, user experience is also impacted by network latency, bandwidth, protocols, location, network congestion, jitter, throughput, and routing rules. ",
        Title: "Understand how networking impacts performance",
      },
      {
        ChoiceId: "perf_select_network_evaluate_features",
        Description:
          "Evaluate networking features in the cloud that may increase performance. Measure the impact of these features through testing, metrics, and analysis. For example, take advantage of network-level features that are available to reduce latency, packet loss, or jitter. ",
        Title: "Evaluate available networking features",
      },
      {
        ChoiceId: "perf_select_network_hybrid",
        Description:
          " When a common network is required to connect on-premises and cloud resources in AWS, verify that you have adequate bandwidth to meet your performance requirements. Estimate the bandwidth and latency requirements for your hybrid workload. These numbers will drive the sizing requirements for your connectivity options. ",
        Title:
          "Choose appropriately sized dedicated connectivity or VPN for hybrid workloads",
      },
      {
        ChoiceId: "perf_select_network_encryption_offload",
        Description:
          "Use load balancers to achieve optimal performance efficiency of your target resources and improve the responsiveness of your system.",
        Title: "Leverage load-balancing and encryption offloading",
      },
      {
        ChoiceId: "perf_select_network_protocols",
        Description:
          "Assess the performance requirements for your workload, and choose the network protocols that optimize your workload’s overall performance.",
        Title: "Choose network protocols to improve performance",
      },
      {
        ChoiceId: "perf_select_network_location",
        Description:
          "Evaluate options for resource placement to reduce network latency and improve throughput, providing an optimal user experience by reducing page load and data transfer times.",
        Title: "Choose your workload’s location based on network requirements",
      },
      {
        ChoiceId: "perf_select_network_optimize",
        Description:
          "Improper network configuration often affects network performance, efficiency, and cost. In common network environments, in order to quickly complete the deployment in the early stage, the proper network configuration is not fully considered in terms of network performance. To optimize your network configuration, you must first have visibility and data about your network environment.",
        Title: "Optimize network configuration based on metrics",
      },
      {
        ChoiceId: "perf_select_network_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "performance",
    QuestionId: "select-network",
    QuestionTitle: "How do you configure your networking solution?",
    Reason: "NONE",
    Risk: "MEDIUM",
    SelectedChoices: [
      "perf_select_network_understand_impact",
      "perf_select_network_evaluate_features",
      "perf_select_network_hybrid",
      "perf_select_network_encryption_offload",
      "perf_select_network_protocols",
    ],
  },
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId:
          "perf_continue_having_appropriate_resource_type_keep_up_to_date",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_continue_having_appropriate_resource_type_evolve",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId:
          "perf_continue_having_appropriate_resource_type_define_process",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId:
          "perf_continue_having_appropriate_resource_type_keep_up_to_date",
        Description:
          "Evaluate ways to improve performance as new services, design patterns, and product offerings become available. Determine which of these could improve performance or increase the efficiency of the workload through evaluation, internal discussion, or external analysis.",
        Title: "Stay up-to-date on new resources and services",
      },
      {
        ChoiceId: "perf_continue_having_appropriate_resource_type_evolve",
        Description:
          " As an organization, use the information gathered through the evaluation process to actively drive adoption of new services or resources when they become available. ",
        Title: "Evolve workload performance over time",
      },
      {
        ChoiceId:
          "perf_continue_having_appropriate_resource_type_define_process",
        Description:
          " Define a process to evaluate new services, design patterns, resource types, and configurations as they become available. For example, run existing performance tests on new instance offerings to determine their potential to improve your workload. ",
        Title: "Define a process to improve workload performance",
      },
      {
        ChoiceId: "perf_continue_having_appropriate_resource_type_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "performance",
    QuestionId: "continue-having-appropriate-resource-type",
    QuestionTitle:
      "How do you evolve your workload to take advantage of new releases?",
    Reason: "NONE",
    Risk: "NONE",
    SelectedChoices: [
      "perf_continue_having_appropriate_resource_type_keep_up_to_date",
      "perf_continue_having_appropriate_resource_type_evolve",
      "perf_continue_having_appropriate_resource_type_define_process",
    ],
  },
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "perf_monitor_instances_post_launch_review_metrics",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_monitor_instances_post_launch_establish_kpi",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_monitor_instances_post_launch_generate_alarms",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_monitor_instances_post_launch_review_metrics_collected",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "perf_monitor_instances_post_launch_record_metrics",
        Description:
          " Use a monitoring and observability service to record performance-related metrics. Examples of metrics include record database transactions, slow queries, I/O latency, HTTP request throughput, service latency, or other key data. ",
        Title: "Record performance-related metrics",
      },
      {
        ChoiceId: "perf_monitor_instances_post_launch_review_metrics",
        Description:
          " In response to (or during) an event or incident, use monitoring dashboards or reports to understand and diagnose the impact. These views provide insight into which portions of the workload are not performing as expected. ",
        Title: "Analyze metrics when events or incidents occur",
      },
      {
        ChoiceId: "perf_monitor_instances_post_launch_establish_kpi",
        Description:
          " Identify the KPIs that quantitatively and qualitatively measures workload performance. KPIs help to measure the health of a workload as it relates to a business goal. KPIs allow business and engineering teams to align on the measurement of goals and strategies and how this combines to produce business outcomes. KPIs should be revisited when business goals, strategies, or end-user requirements change.   ",
        Title:
          "Establish key performance indicators (KPIs) to measure workload performance",
      },
      {
        ChoiceId: "perf_monitor_instances_post_launch_proactive",
        Description:
          " Use key performance indicators (KPIs), combined with monitoring and alerting systems, to proactively address performance-related issues. Use alarms to trigger automated actions to remediate issues where possible. Escalate the alarm to those able to respond if automated response is not possible. For example, you may have a system that can predict expected key performance indicators (KPI) values and alarm when they breach certain thresholds, or a tool that can automatically halt or roll back deployments if KPIs are outside of expected values. ",
        Title: "Monitor and alarm proactively",
      },
      {
        ChoiceId: "perf_monitor_instances_post_launch_generate_alarms",
        Description:
          " Using the performance-related key performance indicators (KPIs) that you defined, use a monitoring system that generates alarms automatically when these measurements are outside expected boundaries. ",
        Title: "Use monitoring to generate alarm-based notifications",
      },
      {
        ChoiceId: "perf_monitor_instances_post_launch_review_metrics_collected",
        Description:
          " As routine maintenance, or in response to events or incidents, review which metrics are collected. Use these reviews to identify which metrics were essential in addressing issues and which additional metrics, if they were being tracked, would help to identify, address, or prevent issues. ",
        Title: "Review metrics at regular intervals",
      },
      {
        ChoiceId: "perf_monitor_instances_post_launch_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "performance",
    QuestionId: "monitor-instances-post-launch",
    QuestionTitle:
      "How do you monitor your resources to ensure they are performing?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "perf_monitor_instances_post_launch_review_metrics",
      "perf_monitor_instances_post_launch_establish_kpi",
      "perf_monitor_instances_post_launch_generate_alarms",
      "perf_monitor_instances_post_launch_review_metrics_collected",
    ],
  },
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "perf_tradeoffs_performance_critical_areas",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_tradeoffs_performance_design_patterns",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_tradeoffs_performance_understand_impact",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_tradeoffs_performance_implement_strategy",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_tradeoffs_performance_measure",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "perf_tradeoffs_performance_critical_areas",
        Description:
          " Understand and identify areas where increasing the performance of your workload will have a positive impact on efficiency or customer experience. For example, a website that has a large amount of customer interaction can benefit from using edge services to move content delivery closer to customers. ",
        Title: "Understand the areas where performance is most critical",
      },
      {
        ChoiceId: "perf_tradeoffs_performance_design_patterns",
        Description:
          " Research and understand the various design patterns and services that help improve workload performance. As part of the analysis, identify what you could trade to achieve higher performance. For example, using a cache service can help to reduce the load placed on database systems. However, caching can introduce eventual consistency and requires engineering effort to implement within business requirements and customer expectations. ",
        Title: "Learn about design patterns and services",
      },
      {
        ChoiceId: "perf_tradeoffs_performance_understand_impact",
        Description:
          " When evaluating performance-related improvements, determine which choices will impact your customers and workload efficiency. For example, if using a key-value data store increases system performance, it is important to evaluate how the eventually consistent nature of it will impact customers. ",
        Title: "Identify how tradeoffs impact customers and efficiency",
      },
      {
        ChoiceId: "perf_tradeoffs_performance_implement_strategy",
        Description:
          " Where applicable, use multiple strategies to improve performance. For example, using strategies like caching data to prevent excessive network or database calls, using read-replicas for database engines to improve read rates, sharding or compressing data where possible to reduce data volumes, and buffering and streaming of results as they are available to avoid blocking. ",
        Title: "Use various performance-related strategies",
      },
      {
        ChoiceId: "perf_tradeoffs_performance_measure",
        Description:
          " As changes are made to improve performance, evaluate the collected metrics and data. Use this information to determine impact that the performance improvement had on the workload, the workload’s components, and your customers. This measurement helps you understand the improvements that result from the tradeoff, and helps you determine if any negative side-effects were introduced. ",
        Title: "Measure the impact of performance improvements",
      },
      {
        ChoiceId: "perf_tradeoffs_performance_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "performance",
    QuestionId: "tradeoffs-performance",
    QuestionTitle: "How do you use tradeoffs to improve performance?",
    Reason: "NONE",
    Risk: "NONE",
    SelectedChoices: [
      "perf_tradeoffs_performance_critical_areas",
      "perf_tradeoffs_performance_design_patterns",
      "perf_tradeoffs_performance_understand_impact",
      "perf_tradeoffs_performance_implement_strategy",
      "perf_tradeoffs_performance_measure",
    ],
  },
];

export const Performance_Efficiency_Check_Q1_ExecutionStatus = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "perf_performing_architecture_evaluate_resources",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_performing_architecture_process",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_performing_architecture_cost",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_performing_architecture_use_policies",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "perf_performing_architecture_evaluate_resources",
        Description:
          "\n               Learn about and understand the wide range of services and resources available in the cloud. Identify the relevant services and configuration options for your workload, and understand how to achieve optimal performance. \n\t\t\t\t",
        Title: "Understand the available services and resources",
      },
      {
        ChoiceId: "perf_performing_architecture_process",
        Description:
          "\n               Use internal experience and knowledge of the cloud, or external resources such as published use cases, relevant documentation, or whitepapers to define a process to choose resources and services. You should define a process that encourages experimentation and benchmarking with the services that could be used in your workload. \n\t\t\t\t",
        Title: "Define a process for architectural choices",
      },
      {
        ChoiceId: "perf_performing_architecture_cost",
        Description:
          "\n               Workloads often have cost requirements for operation. Use internal cost controls to select resource types and sizes based on predicted resource need.",
        Title: "Factor cost requirements into decisions ",
      },
      {
        ChoiceId: "perf_performing_architecture_load_test",
        Description:
          "\n               Deploy your latest workload architecture on the cloud using different resource types and sizes. Monitor the deployment to capture performance metrics that identify bottlenecks or excess capacity. Use this performance information to design or improve your architecture and resource selection. \n\t\t\t\t",
        Title: "Load test your workload",
      },
      {
        ChoiceId: "perf_performing_architecture_use_policies",
        Description:
          "\n               Maximize performance and efficiency by evaluating internal policies and existing reference architectures and using your analysis to select services and configurations for your workload. \n\t\t\t\t",
        Title: "Use policies or reference architectures",
      },
      {
        ChoiceId: "perf_performing_architecture_external_guidance",
        Description:
          "\n               Use cloud company resources, such as solutions architects, professional services, or an appropriate partner to guide your decisions. These resources can help review and improve your architecture for optimal performance. \n\t\t\t\t",
        Title:
          "Use guidance from your cloud provider or an appropriate partner",
      },
      {
        ChoiceId: "perf_performing_architecture_benchmark",
        Description:
          "\n               Benchmark the performance of an existing workload to understand how it performs on the cloud. Use the data collected from benchmarks to drive architectural decisions. \n\t\t\t\t",
        Title: "Benchmark existing workloads",
      },
      {
        ChoiceId: "perf_performing_architecture_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.performing-architecture.helpful-resources.en.html",
    ImprovementPlanUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.performing-architecture.improvement-plan.en.html",
    IsApplicable: true,
    PillarId: "performance",
    QuestionDescription:
      "\n         Often, multiple approaches are required for optimal performance across a workload. Well-architected systems use multiple solutions and features to improve performance.\n      ",
    QuestionId: "performing-architecture",
    QuestionTitle: "How do you select the best performing architecture?",
    Reason: "NONE",
    Risk: "MEDIUM",
    SelectedChoices: [
      "perf_performing_architecture_evaluate_resources",
      "perf_performing_architecture_process",
      "perf_performing_architecture_cost",
      "perf_performing_architecture_use_policies",
    ],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Performance_Efficiency_Q1_Summaries = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 2,
  Passed: 2,
};

export const Performance_Efficiency_Q1_Answer_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-05 06:47:12+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-04-03 09:14:19",
    Description: "Test",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "yameen",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-04-03 09:12:56",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Performance_Efficiency_Q2 = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "perf_select_compute_collect_metrics",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_select_compute_right_sizing",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_select_compute_elasticity",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "perf_select_compute_evaluate_options",
        Description:
          " Understand how your workload can benefit from the use of different compute options, such as instances, containers and functions. ",
        Title: "Evaluate the available compute options",
      },
      {
        ChoiceId: "perf_select_compute_config_options",
        Description:
          " Each compute solution has options and configurations available to you to support your workload characteristics. Learn how various options complement your workload, and which configuration options are best for your application. Examples of these options include instance family, sizes, features (GPU, I/O), bursting, time-outs, function sizes, container instances, and concurrency. ",
        Title: "Understand the available compute configuration options",
      },
      {
        ChoiceId: "perf_select_compute_collect_metrics",
        Description:
          "To understand how your compute resources are performing, you must record and track the utilization of various systems. This data can be used to make more accurate determinations about resource requirements.  ",
        Title: "Collect compute-related metrics",
      },
      {
        ChoiceId: "perf_select_compute_use_metrics",
        Description:
          "Use a data-driven approach to continually evaluate and optimize the compute resources for your workload over time.",
        Title: "Continually evaluate compute needs based on metrics",
      },
      {
        ChoiceId: "perf_select_compute_right_sizing",
        Description:
          "Analyze the various performance characteristics of your workload and how these characteristics relate to memory, network, I/O, and CPU usage. Use this data to choose resources that best match your workload’s profile. For example, a memory-intensive workload like a database may benefit from a higher memory per core ratio. However, a compute intensive workload may need a higher core count and frequency, but can be satisfied with a lower amount of memory per core.",
        Title: "Determine the required configuration by right-sizing",
      },
      {
        ChoiceId: "perf_select_compute_elasticity",
        Description:
          "The cloud provides the flexibility to expand and reduce your resources dynamically through a variety of mechanisms to meet changes in demand. Combining this elasticity with compute-related metrics, a workload can automatically respond to changes to use the resources it needs and only the resources it needs.",
        Title: "Use the available elasticity of resources",
      },
      {
        ChoiceId: "perf_select_compute_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.select-compute.helpful-resources.en.html",
    ImprovementPlanUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.select-compute.improvement-plan.en.html",
    IsApplicable: true,
    PillarId: "performance",
    QuestionDescription:
      "The optimal compute solution for a workload varies based on application design, usage patterns, and configuration settings. Architectures can use different compute solutions for various components and enable different features to improve performance. Selecting the wrong compute solution for an architecture can lead to lower performance efficiency.",
    QuestionId: "select-compute",
    QuestionTitle: "How do you select your compute solution?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "perf_select_compute_collect_metrics",
      "perf_select_compute_right_sizing",
      "perf_select_compute_elasticity",
    ],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Performance_Efficiency_Check_Q2_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Performance_Efficiency_Q2_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-05 06:47:12+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-04-03 09:14:19",
    Description: "Test",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "yameen",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-04-03 09:12:56",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Performance_Efficiency_Q3 = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "perf_right_storage_solution_optimize_patterns",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_right_storage_solution_understand_char",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_right_storage_solution_evaluated_options",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "perf_right_storage_solution_understand_char",
        Description:
          " Identify and document the workload storage needs and define the storage characteristics of each location. Examples of storage characteristics include: shareable access, file size, growth rate, throughput, IOPS, latency, access patterns, and persistence of data. Use these characteristics to evaluate if block, file, object, or instance storage services are the most efficient solution for your storage needs. ",
        Title: "Understand storage characteristics and requirements",
      },
      {
        ChoiceId: "perf_right_storage_solution_optimize_patterns",
        Description:
          " Choose storage systems based on your workload's access patterns and configure them by determining how the workload accesses data. Increase storage efficiency by choosing object storage over block storage. Configure the storage options you choose to match your data access patterns. ",
        Title: "Make decisions based on access patterns and metrics",
      },
      {
        ChoiceId: "perf_right_storage_solution_evaluated_options",
        Description:
          " Evaluate the various characteristics and configuration options and how they relate to storage. Understand where and how to use provisioned IOPS, SSDs, magnetic storage, object storage, archival storage, or ephemeral storage to optimize storage space and performance for your workload. ",
        Title: "Evaluate available configuration options",
      },
      {
        ChoiceId: "perf_right_storage_solution_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.right-storage-solution.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "performance",
    QuestionDescription:
      "\n        The optimal storage solution for a system varies based on the kind of access method (block, file, or object), patterns of access (random or sequential), required throughput, frequency of access (online, offline, archival), frequency of update (WORM, dynamic), and availability and durability constraints. Well-architected systems use multiple storage solutions and enable different features to improve performance and use resources efficiently.\n      ",
    QuestionId: "right-storage-solution",
    QuestionTitle: "How do you select your storage solution?",
    Reason: "NONE",
    Risk: "NONE",
    SelectedChoices: [
      "perf_right_storage_solution_optimize_patterns",
      "perf_right_storage_solution_understand_char",
      "perf_right_storage_solution_evaluated_options",
    ],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Performance_Efficiency_Check_Q3_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Performance_Efficiency_Q3_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-05 07:07:19+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-04-03 09:14:19",
    Description: "Test",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "yameen",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-04-03 09:12:56",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Performance_Efficiency_Q4 = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-05 07:23:28+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-04-03 09:14:19",
    Description: "Test",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "yameen",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-04-03 09:12:56",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Performance_Efficiency_Q4_Summaries = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "perf_right_database_solution_evaluate_options",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_right_database_solution_collect_metrics",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_right_database_solution_access_patterns",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_right_database_solution_optimize_metrics",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "perf_right_database_solution_understand_char",
        Description:
          " Choose your data management solutions to optimally match the characteristics, access patterns, and requirements of your workload datasets. When selecting and implementing a data management solution, you must ensure that the querying, scaling, and storage characteristics support the workload data requirements. Learn how various database options match your data models, and which configuration options are best for your use-case.  ",
        Title: "Understand data characteristics",
      },
      {
        ChoiceId: "perf_right_database_solution_evaluate_options",
        Description:
          " Understand the available database options and how it can optimize your performance before you select your data management solution. Use load testing to identify database metrics that matter for your workload. While you explore the database options, take into consideration various aspects such as the parameter groups, storage options, memory, compute, read replica, eventual consistency, connection pooling, and caching options. Experiment with these various configuration options to improve the metrics. ",
        Title: "Evaluate the available options",
      },
      {
        ChoiceId: "perf_right_database_solution_collect_metrics",
        Description:
          " To understand how your data management systems are performing, it is important to track relevant metrics. These metrics will help you to optimize your data management resources, to ensure that your workload requirements are met, and that you have a clear overview on how the workload performs. Use tools, libraries, and systems that record performance measurements related to database performance. ",
        Title: "Collect and record database performance metrics",
      },
      {
        ChoiceId: "perf_right_database_solution_optimize_metrics",
        Description:
          " Use performance characteristics and access patterns that optimize how data is stored or queried to achieve the best possible performance. Measure how optimizations such as indexing, key distribution, data warehouse design, or caching strategies impact system performance or overall efficiency. ",
        Title: "Optimize data storage based on access patterns and metrics",
      },
      {
        ChoiceId: "perf_right_database_solution_access_patterns",
        Description:
          "Use the access patterns of the workload and requirements of the applications to decide on optimal data services and technologies to use. ",
        Title: "Choose data storage based on access patterns",
      },
      {
        ChoiceId: "perf_right_database_solution_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.right-database-solution.helpful-resources.en.html",
    ImprovementPlanUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.right-database-solution.improvement-plan.en.html",
    IsApplicable: true,
    PillarId: "performance",
    QuestionDescription:
      "\n        The optimal database solution for a system varies based on requirements for availability, consistency, partition tolerance, latency, durability, scalability, and query capability. Many systems use different database solutions for various subsystems and enable different features to improve performance. Selecting the wrong database solution and features for a system can lead to lower performance efficiency.\n      ",
    QuestionId: "right-database-solution",
    QuestionTitle: "How do you select your database solution?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "perf_right_database_solution_evaluate_options",
      "perf_right_database_solution_collect_metrics",
      "perf_right_database_solution_access_patterns",
      "perf_right_database_solution_optimize_metrics",
    ],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Performance_Efficiency_Q4_Answer_Summaries = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Performance_Efficiency_Q5 = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "perf_select_network_understand_impact",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_select_network_evaluate_features",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_select_network_hybrid",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_select_network_encryption_offload",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_select_network_protocols",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "perf_select_network_understand_impact",
        Description:
          " Analyze and understand how network-related decisions impact workload performance. The network is responsible for the connectivity between application components, cloud services, edge networks and on-premises data and therefor it can highly impact workload performance. In addition to workload performance, user experience is also impacted by network latency, bandwidth, protocols, location, network congestion, jitter, throughput, and routing rules. ",
        Title: "Understand how networking impacts performance",
      },
      {
        ChoiceId: "perf_select_network_evaluate_features",
        Description:
          "Evaluate networking features in the cloud that may increase performance. Measure the impact of these features through testing, metrics, and analysis. For example, take advantage of network-level features that are available to reduce latency, packet loss, or jitter. ",
        Title: "Evaluate available networking features",
      },
      {
        ChoiceId: "perf_select_network_hybrid",
        Description:
          " When a common network is required to connect on-premises and cloud resources in AWS, verify that you have adequate bandwidth to meet your performance requirements. Estimate the bandwidth and latency requirements for your hybrid workload. These numbers will drive the sizing requirements for your connectivity options. ",
        Title:
          "Choose appropriately sized dedicated connectivity or VPN for hybrid workloads",
      },
      {
        ChoiceId: "perf_select_network_encryption_offload",
        Description:
          "Use load balancers to achieve optimal performance efficiency of your target resources and improve the responsiveness of your system.",
        Title: "Leverage load-balancing and encryption offloading",
      },
      {
        ChoiceId: "perf_select_network_protocols",
        Description:
          "Assess the performance requirements for your workload, and choose the network protocols that optimize your workload’s overall performance.",
        Title: "Choose network protocols to improve performance",
      },
      {
        ChoiceId: "perf_select_network_location",
        Description:
          "Evaluate options for resource placement to reduce network latency and improve throughput, providing an optimal user experience by reducing page load and data transfer times.",
        Title: "Choose your workload’s location based on network requirements",
      },
      {
        ChoiceId: "perf_select_network_optimize",
        Description:
          "Improper network configuration often affects network performance, efficiency, and cost. In common network environments, in order to quickly complete the deployment in the early stage, the proper network configuration is not fully considered in terms of network performance. To optimize your network configuration, you must first have visibility and data about your network environment.",
        Title: "Optimize network configuration based on metrics",
      },
      {
        ChoiceId: "perf_select_network_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.select-network.helpful-resources.en.html",
    ImprovementPlanUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.select-network.improvement-plan.en.html",
    IsApplicable: true,
    PillarId: "performance",
    QuestionDescription:
      "\n        The optimal network solution for a workload varies based on latency, throughput requirements, jitter, and bandwidth. Physical constraints, such as user or on-premises resources, determine location options. These constraints can be offset with edge locations or resource placement.\n      ",
    QuestionId: "select-network",
    QuestionTitle: "How do you configure your networking solution?",
    Reason: "NONE",
    Risk: "MEDIUM",
    SelectedChoices: [
      "perf_select_network_understand_impact",
      "perf_select_network_evaluate_features",
      "perf_select_network_hybrid",
      "perf_select_network_encryption_offload",
      "perf_select_network_protocols",
    ],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Performance_Efficiency_Check_Q5_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Performance_Efficiency_Q5_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-05 07:37:18+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-04-03 09:14:19",
    Description: "Test",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "yameen",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-04-03 09:12:56",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Performance_Efficiency_Q6 = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId:
          "perf_continue_having_appropriate_resource_type_define_process",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_continue_having_appropriate_resource_type_evolve",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId:
          "perf_continue_having_appropriate_resource_type_keep_up_to_date",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId:
          "perf_continue_having_appropriate_resource_type_keep_up_to_date",
        Description:
          "\n              Evaluate ways to improve performance as new services, design patterns, and product offerings become available. Determine which of these could improve performance or increase the efficiency of the workload through ad-hoc evaluation, internal discussion, or external analysis.\n            ",
        Title: "Stay up-to-date on new resources and services",
      },
      {
        ChoiceId:
          "perf_continue_having_appropriate_resource_type_define_process",
        Description:
          "\n              Define a process to evaluate new services, design patterns, resource types, and configurations as they become available. For example, run existing performance tests on new instance offerings to determine their potential to improve your workload.\n\t\t\t\t\t",
        Title: "Define a process to improve workload performance",
      },
      {
        ChoiceId: "perf_continue_having_appropriate_resource_type_evolve",
        Description:
          "\n              As an organization, use the information gathered through the evaluation process to actively drive adoption of new services or resources when they become available.\n\t\t\t\t",
        Title: "Evolve workload performance over time",
      },
      {
        ChoiceId: "perf_continue_having_appropriate_resource_type_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/wellarchitected/2022-03-31T08-00-00/TypeII/en/wellarchitected/wellarchitected.continue-having-appropriate-resource-type.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "performance",
    QuestionDescription:
      "\n        When architecting workloads, there are finite options that you can choose from. However, over time, new technologies and approaches become available that could improve the performance of your workload.\n      ",
    QuestionId: "continue-having-appropriate-resource-type",
    QuestionTitle:
      "How do you evolve your workload to take advantage of new releases?",
    Reason: "NONE",
    Risk: "NONE",
    SelectedChoices: [
      "perf_continue_having_appropriate_resource_type_define_process",
      "perf_continue_having_appropriate_resource_type_evolve",
      "perf_continue_having_appropriate_resource_type_keep_up_to_date",
    ],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Performance_Efficiency_Check_Q6_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 4,
};

export const Performance_Efficiency_Q6_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-05 07:37:18+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-04-03 09:14:19",
    Description: "Test",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "yameen",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-04-03 09:12:56",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Performance_Efficiency_Q7 = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "perf_monitor_instances_post_launch_review_metrics",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_monitor_instances_post_launch_establish_kpi",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_monitor_instances_post_launch_generate_alarms",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_monitor_instances_post_launch_review_metrics_collected",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "perf_monitor_instances_post_launch_record_metrics",
        Description:
          " Use a monitoring and observability service to record performance-related metrics. Examples of metrics include record database transactions, slow queries, I/O latency, HTTP request throughput, service latency, or other key data. ",
        Title: "Record performance-related metrics",
      },
      {
        ChoiceId: "perf_monitor_instances_post_launch_review_metrics",
        Description:
          " In response to (or during) an event or incident, use monitoring dashboards or reports to understand and diagnose the impact. These views provide insight into which portions of the workload are not performing as expected. ",
        Title: "Analyze metrics when events or incidents occur",
      },
      {
        ChoiceId: "perf_monitor_instances_post_launch_establish_kpi",
        Description:
          " Identify the KPIs that quantitatively and qualitatively measures workload performance. KPIs help to measure the health of a workload as it relates to a business goal. KPIs allow business and engineering teams to align on the measurement of goals and strategies and how this combines to produce business outcomes. KPIs should be revisited when business goals, strategies, or end-user requirements change.   ",
        Title:
          "Establish key performance indicators (KPIs) to measure workload performance",
      },
      {
        ChoiceId: "perf_monitor_instances_post_launch_proactive",
        Description:
          " Use key performance indicators (KPIs), combined with monitoring and alerting systems, to proactively address performance-related issues. Use alarms to trigger automated actions to remediate issues where possible. Escalate the alarm to those able to respond if automated response is not possible. For example, you may have a system that can predict expected key performance indicators (KPI) values and alarm when they breach certain thresholds, or a tool that can automatically halt or roll back deployments if KPIs are outside of expected values. ",
        Title: "Monitor and alarm proactively",
      },
      {
        ChoiceId: "perf_monitor_instances_post_launch_generate_alarms",
        Description:
          " Using the performance-related key performance indicators (KPIs) that you defined, use a monitoring system that generates alarms automatically when these measurements are outside expected boundaries. ",
        Title: "Use monitoring to generate alarm-based notifications",
      },
      {
        ChoiceId: "perf_monitor_instances_post_launch_review_metrics_collected",
        Description:
          " As routine maintenance, or in response to events or incidents, review which metrics are collected. Use these reviews to identify which metrics were essential in addressing issues and which additional metrics, if they were being tracked, would help to identify, address, or prevent issues. ",
        Title: "Review metrics at regular intervals",
      },
      {
        ChoiceId: "perf_monitor_instances_post_launch_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.monitor-instances-post-launch.helpful-resources.en.html",
    ImprovementPlanUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.monitor-instances-post-launch.improvement-plan.en.html",
    IsApplicable: true,
    PillarId: "performance",
    QuestionDescription:
      "\n        System performance can degrade over time. Monitor system performance to identify degradation and remediate internal or external factors, such as the operating system or application load.\n      ",
    QuestionId: "monitor-instances-post-launch",
    QuestionTitle:
      "How do you monitor your resources to ensure they are performing?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "perf_monitor_instances_post_launch_review_metrics",
      "perf_monitor_instances_post_launch_establish_kpi",
      "perf_monitor_instances_post_launch_generate_alarms",
      "perf_monitor_instances_post_launch_review_metrics_collected",
    ],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Performance_Efficiency_Check_Q7_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 15,
  Passed: 14,
};

export const Performance_Efficiency_Q7_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-05 07:53:43+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-04-03 09:14:19",
    Description: "Test",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "yameen",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-04-03 09:12:56",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Performance_Efficiency_Q8 = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "perf_tradeoffs_performance_critical_areas",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_tradeoffs_performance_design_patterns",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_tradeoffs_performance_understand_impact",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_tradeoffs_performance_implement_strategy",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "perf_tradeoffs_performance_measure",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "perf_tradeoffs_performance_critical_areas",
        Description:
          " Understand and identify areas where increasing the performance of your workload will have a positive impact on efficiency or customer experience. For example, a website that has a large amount of customer interaction can benefit from using edge services to move content delivery closer to customers. ",
        Title: "Understand the areas where performance is most critical",
      },
      {
        ChoiceId: "perf_tradeoffs_performance_design_patterns",
        Description:
          " Research and understand the various design patterns and services that help improve workload performance. As part of the analysis, identify what you could trade to achieve higher performance. For example, using a cache service can help to reduce the load placed on database systems. However, caching can introduce eventual consistency and requires engineering effort to implement within business requirements and customer expectations. ",
        Title: "Learn about design patterns and services",
      },
      {
        ChoiceId: "perf_tradeoffs_performance_understand_impact",
        Description:
          " When evaluating performance-related improvements, determine which choices will impact your customers and workload efficiency. For example, if using a key-value data store increases system performance, it is important to evaluate how the eventually consistent nature of it will impact customers. ",
        Title: "Identify how tradeoffs impact customers and efficiency",
      },
      {
        ChoiceId: "perf_tradeoffs_performance_implement_strategy",
        Description:
          " Where applicable, use multiple strategies to improve performance. For example, using strategies like caching data to prevent excessive network or database calls, using read-replicas for database engines to improve read rates, sharding or compressing data where possible to reduce data volumes, and buffering and streaming of results as they are available to avoid blocking. ",
        Title: "Use various performance-related strategies",
      },
      {
        ChoiceId: "perf_tradeoffs_performance_measure",
        Description:
          " As changes are made to improve performance, evaluate the collected metrics and data. Use this information to determine impact that the performance improvement had on the workload, the workload’s components, and your customers. This measurement helps you understand the improvements that result from the tradeoff, and helps you determine if any negative side-effects were introduced. ",
        Title: "Measure the impact of performance improvements",
      },
      {
        ChoiceId: "perf_tradeoffs_performance_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.tradeoffs-performance.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "performance",
    QuestionDescription:
      "\n        When architecting solutions, determining tradeoffs enables you to select an optimal approach. Often you can improve performance by trading consistency, durability, and space for time and latency.\n      ",
    QuestionId: "tradeoffs-performance",
    QuestionTitle: "How do you use tradeoffs to improve performance?",
    Reason: "NONE",
    Risk: "NONE",
    SelectedChoices: [
      "perf_tradeoffs_performance_critical_areas",
      "perf_tradeoffs_performance_design_patterns",
      "perf_tradeoffs_performance_understand_impact",
      "perf_tradeoffs_performance_implement_strategy",
      "perf_tradeoffs_performance_measure",
    ],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Performance_Efficiency_Check_Q8_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Performance_Efficiency_Q8_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-05 07:58:50+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-04-03 09:14:19",
    Description: "Test",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "yameen",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-04-03 09:12:56",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Sustainability_Q1 = [
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "sus_sus_region_a2",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sus_sus_region_a2",
        Description:
          "Choose a Region for your workload based on both your business requirements and sustainability goals to optimize its KPIs, including performance, cost, and carbon footprint.",
        Title:
          "Choose Region based on both business requirements and sustainability goals",
      },
      {
        ChoiceId: "sus_sus_region_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "sustainability",
    QuestionId: "sus_region",
    QuestionTitle: "How do you select Regions for your workload?",
    Reason: "NONE",
    Risk: "NONE",
    SelectedChoices: ["sus_sus_region_a2"],
  },
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "sus_sus_user_a2",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_user_a3",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_user_a4",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_user_a5",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sus_sus_user_a3",
        Description:
          " Review and optimize workload service-level agreements (SLA) based on your sustainability goals to minimize the resources required to support your workload while continuing to meet business needs. ",
        Title: "Align SLAs with sustainability goals",
      },
      {
        ChoiceId: "sus_sus_user_a4",
        Description:
          "Decommission unused assets in your workload to reduce the number of cloud resources required to support your demand and minimize waste.",
        Title: "Stop the creation and maintenance of unused assets",
      },
      {
        ChoiceId: "sus_sus_user_a6",
        Description:
          "Optimize resources provided to team members to minimize the environmental sustainability impact while supporting their needs. ",
        Title: "Optimize team member resources for activities performed",
      },
      {
        ChoiceId: "sus_sus_user_a7",
        Description:
          "Buffering and throttling flatten the demand curve and reduce the provisioned capacity required for your workload. ",
        Title: "Implement buffering or throttling to flatten the demand curve",
      },
      {
        ChoiceId: "sus_sus_user_a2",
        Description:
          "Use elasticity of the cloud and scale your infrastructure dynamically to match supply of cloud resources to demand and avoid overprovisioned capacity in your workload.",
        Title: "Scale workload infrastructure dynamically",
      },
      {
        ChoiceId: "sus_sus_user_a5",
        Description:
          "Select cloud location and services for your workload that reduce the distance network traffic must travel and decrease the total network resources required to support your workload.",
        Title:
          "Optimize geographic placement of workloads based on their networking requirements",
      },
      {
        ChoiceId: "sus_sus_user_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "sustainability",
    QuestionId: "sus_user",
    QuestionTitle: " How do you align cloud resources to your demand?",
    Reason: "NONE",
    Risk: "NONE",
    SelectedChoices: [
      "sus_sus_user_a2",
      "sus_sus_user_a3",
      "sus_sus_user_a4",
      "sus_sus_user_a5",
    ],
  },
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "sus_sus_software_a3",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_software_a4",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_software_a5",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_software_a6",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sus_sus_software_a2",
        Description:
          "Use efficient software and architecture patterns such as queue-driven to maintain consistent high utilization of deployed resources.",
        Title:
          "Optimize software and architecture for asynchronous and scheduled jobs",
      },
      {
        ChoiceId: "sus_sus_software_a3",
        Description:
          "Remove components that are unused and no longer required, and refactor components with little utilization to minimize waste in your workload.",
        Title: "Remove or refactor workload components with low or no use",
      },
      {
        ChoiceId: "sus_sus_software_a4",
        Description:
          "Optimize your code that runs within different components of your architecture to minimize resource usage while maximizing performance.",
        Title: "Optimize areas of code that consume the most time or resources",
      },
      {
        ChoiceId: "sus_sus_software_a5",
        Description:
          "Understand the devices and equipment used in your architecture and use strategies to reduce their usage. This can minimize the overall environmental impact of your cloud workload. ",
        Title: "Optimize impact on devices and equipment",
      },
      {
        ChoiceId: "sus_sus_software_a6",
        Description:
          "Understand how data is used within your workload, consumed by your users, transferred, and stored. Use software patterns and architectures that best support data access and storage to minimize the compute, networking, and storage resources required to support the workload.",
        Title:
          "Use software patterns and architectures that best support data access and storage patterns",
      },
      {
        ChoiceId: "sus_sus_software_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "sustainability",
    QuestionId: "sus_software",
    QuestionTitle:
      "How do you take advantage of software and architecture patterns to support your sustainability goals?",
    Reason: "NONE",
    Risk: "MEDIUM",
    SelectedChoices: [
      "sus_sus_software_a3",
      "sus_sus_software_a4",
      "sus_sus_software_a5",
      "sus_sus_software_a6",
    ],
  },
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "sus_sus_data_a2",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_data_a3",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_data_a6",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_data_a4",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_data_a5",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sus_sus_data_a3",
        Description:
          " Use storage technologies that best support how your data is accessed and stored to minimize the resources provisioned while supporting your workload. ",
        Title: "Use technologies that support data access and storage patterns",
      },
      {
        ChoiceId: "sus_sus_data_a2",
        Description:
          "Classify data to understand its criticality to business outcomes and choose the right energy-efficient storage tier to store the data.",
        Title: "Implement a data classification policy",
      },
      {
        ChoiceId: "sus_sus_data_a4",
        Description:
          "Manage the lifecycle of all of your data and automatically enforce deletion to minimize the total storage required for your workload.",
        Title: "Use policies to manage the lifecycle of your datasets",
      },
      {
        ChoiceId: "sus_sus_data_a5",
        Description:
          "Use elasticity and automation to expand block storage or file system as data grows to minimize the total provisioned storage.",
        Title:
          "Use elasticity and automation to expand block storage or file system",
      },
      {
        ChoiceId: "sus_sus_data_a6",
        Description:
          "Remove unneeded or redundant data to minimize the storage resources required to store your datasets. ",
        Title: "Remove unneeded or redundant data",
      },
      {
        ChoiceId: "sus_sus_data_a7",
        Description:
          "Adopt shared file systems or storage to avoid data duplication and enable more efficient infrastructure for your workload. ",
        Title: "Use shared file systems or storage to access common data",
      },
      {
        ChoiceId: "sus_sus_data_a8",
        Description:
          "Use shared file systems or object storage to access common data and minimize the total networking resources required to support data movement for your workload.",
        Title: "Minimize data movement across networks",
      },
      {
        ChoiceId: "sus_sus_data_a9",
        Description:
          "Avoid backing up data that has no business value to minimize storage resources requirements for your workload. ",
        Title: "Back up data only when difficult to recreate",
      },
      {
        ChoiceId: "sus_sus_data_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "sustainability",
    QuestionId: "sus_data",
    QuestionTitle:
      "How do you take advantage of data management policies and patterns to support your sustainability goals?",
    Reason: "NONE",
    Risk: "MEDIUM",
    SelectedChoices: [
      "sus_sus_data_a2",
      "sus_sus_data_a3",
      "sus_sus_data_a6",
      "sus_sus_data_a4",
      "sus_sus_data_a5",
    ],
  },
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "sus_sus_hardware_a3",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_hardware_a4",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_hardware_a5",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sus_sus_hardware_a2",
        Description:
          "Use the minimum amount of hardware for your workload to efficiently meet your business needs.",
        Title: "Use the minimum amount of hardware to meet your needs",
      },
      {
        ChoiceId: "sus_sus_hardware_a3",
        Description:
          "Continually monitor and use new instance types to take advantage of energy efficiency improvements.",
        Title: "Use instance types with the least impact",
      },
      {
        ChoiceId: "sus_sus_hardware_a4",
        Description:
          "Use managed services to operate more efficiently in the cloud.",
        Title: "Use managed services",
      },
      {
        ChoiceId: "sus_sus_hardware_a5",
        Description:
          "Optimize your use of accelerated computing instances to reduce the physical infrastructure demands of your workload.",
        Title: "Optimize your use of hardware-based compute accelerators",
      },
      {
        ChoiceId: "sus_sus_hardware_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "sustainability",
    QuestionId: "sus_hardware",
    QuestionTitle:
      "How do you select and use cloud hardware and services in your architecture to support your sustainability goals?",
    Reason: "NONE",
    Risk: "MEDIUM",
    SelectedChoices: [
      "sus_sus_hardware_a3",
      "sus_sus_hardware_a4",
      "sus_sus_hardware_a5",
    ],
  },
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "sus_sus_dev_a3",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_dev_a2",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_dev_a4",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sus_sus_dev_a3",
        Description:
          "Keep your workload up-to-date to adopt efficient features, remove issues, and improve the overall efficiency of your workload. ",
        Title: "Keep your workload up-to-date",
      },
      {
        ChoiceId: "sus_sus_dev_a4",
        Description:
          "Increase the utilization of resources to develop, test, and build your workloads.",
        Title: "Increase utilization of build environments",
      },
      {
        ChoiceId: "sus_sus_dev_a5",
        Description:
          "Use managed device farms to efficiently test a new feature on a representative set of hardware.",
        Title: "Use managed device farms for testing",
      },
      {
        ChoiceId: "sus_sus_dev_a2",
        Description:
          "Adopt methods and processes to validate potential improvements, minimize testing costs, and deliver small improvements.",
        Title:
          "Adopt methods that can rapidly introduce sustainability improvements",
      },
      {
        ChoiceId: "sus_sus_dev_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "sustainability",
    QuestionId: "sus_dev",
    QuestionTitle:
      "How do your organizational processes support your sustainability goals?",
    Reason: "NONE",
    Risk: "NONE",
    SelectedChoices: ["sus_sus_dev_a3", "sus_sus_dev_a2", "sus_sus_dev_a4"],
  },
];

export const Sustainability_Check_Q1_ExecutionStatus = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-05 08:04:18+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-04-03 09:14:19",
    Description: "Test",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "yameen",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-04-03 09:12:56",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Sustainability_Q1_Summaries = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "sus_sus_region_a2",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sus_sus_region_a2",
        Description:
          "Choose a Region for your workload based on both your business requirements and sustainability goals to optimize its KPIs, including performance, cost, and carbon footprint.",
        Title:
          "Choose Region based on both business requirements and sustainability goals",
      },
      {
        ChoiceId: "sus_sus_region_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.sus_region.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "sustainability",
    QuestionDescription:
      "The choice of Region for your workload significantly affects its KPIs, including performance, cost, and carbon footprint. To effectively improve these KPIs, you should choose Regions for your workloads based on both business requirements and sustainability goals.",
    QuestionId: "sus_region",
    QuestionTitle: "How do you select Regions for your workload?",
    Reason: "NONE",
    Risk: "NONE",
    SelectedChoices: ["sus_sus_region_a2"],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};
export const Sustainability_Q1_Answer_Summaries = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Sustainability_Q2 = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "sus_sus_user_a2",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_user_a3",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_user_a4",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_user_a5",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sus_sus_user_a3",
        Description:
          " Review and optimize workload service-level agreements (SLA) based on your sustainability goals to minimize the resources required to support your workload while continuing to meet business needs. ",
        Title: "Align SLAs with sustainability goals",
      },
      {
        ChoiceId: "sus_sus_user_a4",
        Description:
          "Decommission unused assets in your workload to reduce the number of cloud resources required to support your demand and minimize waste.",
        Title: "Stop the creation and maintenance of unused assets",
      },
      {
        ChoiceId: "sus_sus_user_a6",
        Description:
          "Optimize resources provided to team members to minimize the environmental sustainability impact while supporting their needs. ",
        Title: "Optimize team member resources for activities performed",
      },
      {
        ChoiceId: "sus_sus_user_a7",
        Description:
          "Buffering and throttling flatten the demand curve and reduce the provisioned capacity required for your workload. ",
        Title: "Implement buffering or throttling to flatten the demand curve",
      },
      {
        ChoiceId: "sus_sus_user_a2",
        Description:
          "Use elasticity of the cloud and scale your infrastructure dynamically to match supply of cloud resources to demand and avoid overprovisioned capacity in your workload.",
        Title: "Scale workload infrastructure dynamically",
      },
      {
        ChoiceId: "sus_sus_user_a5",
        Description:
          "Select cloud location and services for your workload that reduce the distance network traffic must travel and decrease the total network resources required to support your workload.",
        Title:
          "Optimize geographic placement of workloads based on their networking requirements",
      },
      {
        ChoiceId: "sus_sus_user_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.sus_user.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "sustainability",
    QuestionDescription:
      "The way users and applications consume your workloads and other resources can help you identify improvements to meet sustainability goals. Scale infrastructure to continually match demand and verify that you use only the minimum resources required to support your users. Align service levels to customer needs. Position resources to limit the network required for users and applications to consume them. Remove unused assets. Provide your team members with devices that support their needs and minimize their sustainability impact.",
    QuestionId: "sus_user",
    QuestionTitle: " How do you align cloud resources to your demand?",
    Reason: "NONE",
    Risk: "NONE",
    SelectedChoices: [
      "sus_sus_user_a2",
      "sus_sus_user_a3",
      "sus_sus_user_a4",
      "sus_sus_user_a5",
    ],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Sustainability_Check_Q2_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 8,
  Passed: 5,
};

export const Sustainability_Q2_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-05 08:04:18+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-04-03 09:14:19",
    Description: "Test",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "yameen",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-04-03 09:12:56",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Sustainability_Q3 = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "sus_sus_software_a3",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_software_a4",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_software_a5",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_software_a6",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sus_sus_software_a2",
        Description:
          "Use efficient software designs and architectures to minimize the average resources required per unit of work. Implement mechanisms that result in even utilization of components to reduce resources that are idle between tasks and minimize the impact of load spikes.",
        Title:
          "Optimize software and architecture for asynchronous and scheduled jobs",
      },
      {
        ChoiceId: "sus_sus_software_a3",
        Description:
          "Monitor workload activity to identify changes in utilization of individual components over time. Remove components that are unused and no longer required, and refactor components with little utilization, to limit wasted resources.",
        Title: "Remove or refactor workload components with low or no use",
      },
      {
        ChoiceId: "sus_sus_software_a4",
        Description:
          "Monitor workload activity to identify application components that consume the most resources. Optimize the code that runs within these components to minimize resource usage while maximizing performance.",
        Title: "Optimize areas of code that consume the most time or resources",
      },
      {
        ChoiceId: "sus_sus_software_a5",
        Description:
          "Understand the devices and equipment your customers use to consume your services, their expected lifecycle, and the financial and sustainability impact of replacing those components. Implement software patterns and architectures to minimize the need for customers to replace devices and upgrade equipment. For example, implement new features using code that is backward compatible with older hardware and operating system versions, or manage the size of payloads so they don’t exceed the storage capacity of the target device.",
        Title: "Optimize impact on customer devices and equipment",
      },
      {
        ChoiceId: "sus_sus_software_a6",
        Description:
          "Understand how data is used within your workload, consumed by your users, transferred, and stored. Select technologies to minimize data processing and storage requirements.",
        Title:
          "Use software patterns and architectures that best support data access and storage patterns",
      },
      {
        ChoiceId: "sus_sus_software_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/wellarchitected/2022-03-31T08-00-00/TypeII/en/wellarchitected/wellarchitected.sus_software.helpful-resources.en.html",
    ImprovementPlanUrl:
      "https://wa.aws.amazon.com/wellarchitected/2022-03-31T08-00-00/TypeII/en/wellarchitected/wellarchitected.sus_software.improvement-plan.en.html",
    IsApplicable: true,
    PillarId: "sustainability",
    QuestionDescription:
      "Implement patterns for performing load smoothing and maintaining consistent high utilization of deployed resources to minimize the resources consumed. Components might become idle from lack of use because of changes in user behavior over time. Revise patterns and architecture to consolidate under-utilized components to increase overall utilization. Retire components that are no longer required. Understand the performance of your workload components, and optimize the components that consume the most resources. Be aware of the devices your customers use to access your services, and implement patterns to minimize the need for device upgrades.",
    QuestionId: "sus_software",
    QuestionTitle:
      "How do you take advantage of software and architecture patterns to support your sustainability goals?",
    Reason: "NONE",
    Risk: "MEDIUM",
    SelectedChoices: [
      "sus_sus_software_a3",
      "sus_sus_software_a4",
      "sus_sus_software_a5",
      "sus_sus_software_a6",
    ],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Sustainability_Check_Q3_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 1,
  Passed: 1,
};

export const Sustainability_Q3_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-05 08:20:43+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-04-03 09:14:19",
    Description: "Test",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "yameen",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-04-03 09:12:56",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Sustainability_Q4 = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "sus_sus_data_a2",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_data_a3",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_data_a4",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_data_a5",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_data_a6",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sus_sus_data_a2",
        Description:
          "Classify data to understand its significance to business outcomes. Use this information to determine when you can move data to more energy-efficient storage or safely delete it.",
        Title: "Implement a data classification policy",
      },
      {
        ChoiceId: "sus_sus_data_a3",
        Description:
          "Use storage that best supports how your data is accessed and stored to minimize the resources provisioned while supporting your workload. For example, solid state devices (SSDs) are more energy intensive than magnetic drives and should be used only for active data use cases. Use energy-efficient, archival-class storage for infrequently accessed data.",
        Title: "Use technologies that support data access and storage patterns",
      },
      {
        ChoiceId: "sus_sus_data_a4",
        Description:
          "Manage the lifecycle of all your data and automatically enforce deletion timelines to minimize the total storage requirements of your workload.",
        Title: "Use lifecycle policies to delete unnecessary data",
      },
      {
        ChoiceId: "sus_sus_data_a5",
        Description:
          "To minimize total provisioned storage, create block storage with size allocations that are appropriate for the workload. Use elastic volumes to expand storage as data grows without having to resize storage attached to compute resources. Regularly review elastic volumes and shrink over-provisioned volumes to fit the current data size.",
        Title: "Minimize over-provisioning in block storage",
      },
      {
        ChoiceId: "sus_sus_data_a6",
        Description:
          "Duplicate data only when necessary to minimize total storage consumed. Use backup technologies that deduplicate data at the file and block level. Limit the use of Redundant Array of Independent Drives (RAID) configurations except where required to meet SLAs.",
        Title: "Remove unneeded or redundant data",
      },
      {
        ChoiceId: "sus_sus_data_a7",
        Description:
          "Adopt shared storage and single sources of truth to avoid data duplication and reduce the total storage requirements of your workload. Fetch data from shared storage only as needed. Detach unused volumes to free resources.",
        Title:
          "Use shared file systems or object storage to access common data",
      },
      {
        ChoiceId: "sus_sus_data_a8",
        Description:
          "Use shared storage and access data from regional data stores to minimize the total networking resources required to support data movement for your workload.",
        Title: "Minimize data movement across networks",
      },
      {
        ChoiceId: "sus_sus_data_a9",
        Description:
          "To minimize storage consumption, only back up data that has business value or is required to satisfy compliance requirements. Examine backup policies and exclude ephemeral storage that doesn’t provide value in a recovery scenario.",
        Title: "Back up data only when difficult to recreate",
      },
      {
        ChoiceId: "sus_sus_data_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/wellarchitected/2022-03-31T08-00-00/TypeII/en/wellarchitected/wellarchitected.sus_data.helpful-resources.en.html",
    ImprovementPlanUrl:
      "https://wa.aws.amazon.com/wellarchitected/2022-03-31T08-00-00/TypeII/en/wellarchitected/wellarchitected.sus_data.improvement-plan.en.html",
    IsApplicable: true,
    PillarId: "sustainability",
    QuestionDescription:
      "Implement data management practices to reduce the provisioned storage required to support your workload, and the resources required to use it. Understand your data, and use storage technologies and configurations that best support the business value of the data and how it’s used. Lifecycle data to more efficient, less performant storage when requirements decrease, and delete data that’s no longer required.",
    QuestionId: "sus_data",
    QuestionTitle:
      " How do you take advantage of data management policies and patterns to support your sustainability goals?",
    Reason: "NONE",
    Risk: "MEDIUM",
    SelectedChoices: [
      "sus_sus_data_a2",
      "sus_sus_data_a3",
      "sus_sus_data_a4",
      "sus_sus_data_a5",
      "sus_sus_data_a6",
    ],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Sustainability_Check_Q4_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 1,
  Passed: 0,
};

export const Sustainability_Q4_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-05 08:23:59+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-04-03 09:14:19",
    Description: "Test",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "yameen",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-04-03 09:12:56",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Sustainability_Q5 = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "sus_sus_hardware_a3",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_hardware_a4",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_hardware_a5",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sus_sus_hardware_a2",
        Description:
          "Using the capabilities of the cloud, you can make frequent changes to your workload implementations. Update deployed components as your needs change.",
        Title: "Use the minimum amount of hardware to meet your needs",
      },
      {
        ChoiceId: "sus_sus_hardware_a3",
        Description:
          "Continually monitor the release of new instance types and take advantage of energy efficiency improvements, including those instance types designed to support specific workloads such as machine learning training and inference, and video transcoding.",
        Title: "Use instance types with the least impact",
      },
      {
        ChoiceId: "sus_sus_hardware_a4",
        Description:
          "Managed services shift responsibility for maintaining high average utilization, and sustainability optimization of the deployed hardware, to AWS. Use managed services to distribute the sustainability impact of the service across all organizations of the service, reducing your individual contribution.",
        Title: "Use managed services",
      },
      {
        ChoiceId: "sus_sus_hardware_a5",
        Description:
          "Graphics processing units (GPUs) can be a source of high-power consumption, and many GPU workloads are highly variable, such as rendering, transcoding, and machine learning training and modeling. Only run GPUs instances for the time needed, and decommission them with automation when not required to minimize resources consumed.",
        Title: "Optimize your use of GPUs",
      },
      {
        ChoiceId: "sus_sus_hardware_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/wellarchitected/2022-03-31T08-00-00/TypeII/en/wellarchitected/wellarchitected.sus_hardware.helpful-resources.en.html",
    ImprovementPlanUrl:
      "https://wa.aws.amazon.com/wellarchitected/2022-03-31T08-00-00/TypeII/en/wellarchitected/wellarchitected.sus_hardware.improvement-plan.en.html",
    IsApplicable: true,
    PillarId: "sustainability",
    QuestionDescription:
      "Look for opportunities to reduce workload sustainability impacts by making changes to your hardware management practices. Minimize the amount of hardware needed to provision and deploy, and select the most efficient hardware for your individual workload.",
    QuestionId: "sus_hardware",
    QuestionTitle:
      "How do you select and use cloud hardware and services in your architecture to support your sustainability goals?",
    Reason: "NONE",
    Risk: "MEDIUM",
    SelectedChoices: [
      "sus_sus_hardware_a3",
      "sus_sus_hardware_a4",
      "sus_sus_hardware_a5",
    ],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Sustainability_Check_Q5_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Sustainability_Q5_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-05 08:29:31+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-04-03 09:14:19",
    Description: "Test",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "yameen",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-04-03 09:12:56",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Sustainability_Q6 = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "sus_sus_dev_a3",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_dev_a2",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "sus_sus_dev_a4",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "sus_sus_dev_a3",
        Description:
          "Keep your workload up-to-date to adopt efficient features, remove issues, and improve the overall efficiency of your workload. ",
        Title: "Keep your workload up-to-date",
      },
      {
        ChoiceId: "sus_sus_dev_a4",
        Description:
          "Increase the utilization of resources to develop, test, and build your workloads.",
        Title: "Increase utilization of build environments",
      },
      {
        ChoiceId: "sus_sus_dev_a5",
        Description:
          "Use managed device farms to efficiently test a new feature on a representative set of hardware.",
        Title: "Use managed device farms for testing",
      },
      {
        ChoiceId: "sus_sus_dev_a2",
        Description:
          "Adopt methods and processes to validate potential improvements, minimize testing costs, and deliver small improvements.",
        Title:
          "Adopt methods that can rapidly introduce sustainability improvements",
      },
      {
        ChoiceId: "sus_sus_dev_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.sus_dev.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "sustainability",
    QuestionDescription:
      "Look for opportunities to reduce your sustainability impact by making changes to your development, test, and deployment practices",
    QuestionId: "sus_dev",
    QuestionTitle:
      "How do your organizational processes support your sustainability goals?",
    Reason: "NONE",
    Risk: "NONE",
    SelectedChoices: ["sus_sus_dev_a3", "sus_sus_dev_a2", "sus_sus_dev_a4"],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Sustainability_Check_Q6_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Sustainability_Q6_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-05 08:33:27+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-04-03 09:14:19",
    Description: "Test",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "yameen",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-04-03 09:12:56",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Save_Milestone_Data = {
  Limit: 10,
  MilestonesList: [
    {
      CreatedAt: "2023-04-06 04:05:48",
      CreatedBy: "87491b95-c69e-4145-b43d-7790bcf74a6c",
      FindingStatus: "COMPLETED",
      MilestoneId: "0edb97b9-3999-4424-8b04-f0b329dde0e7",
      MilestoneName: "test",
      MilestoneNumber: 1,
      MilestoneSummary: {
        AnsweredQuestions: 0,
        CheckSummary: {
          CheckExecutionStatus: "COMPLETED",
          Error: 29,
          Failed: 256,
          LastRun: "2023-04-05 06:50:44",
          Passed: 155,
        },
        RiskCounts: {
          HIGH: 0,
          MEDIUM: 0,
          NONE: 0,
          NOT_APPLICABLE: 0,
          UNANSWERED: 58,
        },
        TotalQuestions: 58,
      },
      WorkloadId: "7f8638d12c1a86640275f3754b9b8dc6",
    },
  ],
  PageNumber: 1,
  TotalRecords: 1,
};

export const Reliability_Q1 = [
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "rel_manage_service_limits_aware_quotas_and_constraints",
        Description:
          "You are aware of your default quotas and quota increase requests for your workload architecture. You additionally know which resource constraints, such as disk or network, are potentially impactful.",
        Title: "Aware of service quotas and constraints",
      },
      {
        ChoiceId: "rel_manage_service_limits_limits_considered",
        Description:
          "If you are using multiple AWS accounts or AWS Regions, ensure that you request the appropriate quotas in all environments in which your production workloads run.",
        Title: "Manage service quotas across accounts and regions",
      },
      {
        ChoiceId: "rel_manage_service_limits_aware_fixed_limits",
        Description:
          "Be aware of unchangeable service quotas and physical resources, and architect to prevent these from impacting reliability.",
        Title:
          "Accommodate fixed service quotas and constraints through architecture",
      },
      {
        ChoiceId: "rel_manage_service_limits_monitor_manage_limits",
        Description:
          "Evaluate your potential usage and increase your quotas appropriately allowing for planned growth in usage.",
        Title: "Monitor and manage quotas",
      },
      {
        ChoiceId: "rel_manage_service_limits_automated_monitor_limits",
        Description:
          "Implement tools to alert you when thresholds are being approached. By using AWS Service Quotas APIs, you can automate quota increase requests.",
        Title: "Automate quota management",
      },
      {
        ChoiceId: "rel_manage_service_limits_suff_buffer_limits",
        Description:
          "When a resource fails, it may still be counted against quotas until its successfully terminated. Ensure that your quotas cover the overlap of all failed resources with replacements before the failed resources are terminated. You should consider an Availability Zone failure when calculating this gap.",
        Title:
          "Ensure that a sufficient gap exists between the current quotas and the maximum usage to accommodate failover",
      },
      {
        ChoiceId: "rel_manage_service_limits_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "reliability",
    QuestionId: "manage-service-limits",
    QuestionTitle: "How do you manage service quotas and constraints?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "rel_planning_network_topology_ha_conn_users",
        Description:
          "These endpoints and the routing to them must be highly available. To achieve this, use highly available DNS, content delivery networks (CDNs), API Gateway, load balancing, or reverse proxies.",
        Title:
          "Use highly available network connectivity for your workload public endpoints",
      },
      {
        ChoiceId: "rel_planning_network_topology_ha_conn_private_networks",
        Description:
          "Use multiple AWS Direct Connect (DX) connections or VPN tunnels between separately deployed private networks. Use multiple DX locations for high availability. If using multiple AWS Regions, ensure redundancy in at least two of them. You might want to evaluate AWS Marketplace appliances that terminate VPNs. If you use AWS Marketplace appliances, deploy redundant instances for high availability in different Availability Zones.",
        Title:
          "Provision redundant connectivity between private networks in the cloud and on-premises environments",
      },
      {
        ChoiceId: "rel_planning_network_topology_ip_subnet_allocation",
        Description:
          "Amazon VPC IP address ranges must be large enough to accommodate workload requirements, including factoring in future expansion and allocation of IP addresses to subnets across Availability Zones. This includes load balancers, EC2 instances, and container-based applications.",
        Title:
          "Ensure IP subnet allocation accounts for expansion and availability",
      },
      {
        ChoiceId: "rel_planning_network_topology_prefer_hub_and_spoke",
        Description:
          "If more than two network address spaces (for example, VPCs and on-premises networks) are connected via VPC peering, AWS Direct Connect, or VPN, then use a hub-and-spoke model, like that provided by AWS Transit Gateway.",
        Title: "Prefer hub-and-spoke topologies over many-to-many mesh",
      },
      {
        ChoiceId: "rel_planning_network_topology_non_overlap_ip",
        Description:
          "The IP address ranges of each of your VPCs must not overlap when peered or connected via VPN. You must similarly avoid IP address conflicts between a VPC and on-premises environments or with other cloud providers that you use. You must also have a way to allocate private IP address ranges when needed.",
        Title:
          "Enforce non-overlapping private IP address ranges in all private address spaces where they are connected",
      },
      {
        ChoiceId: "rel_planning_network_topology_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "reliability",
    QuestionId: "planning-network-topology",
    QuestionTitle: "How do you plan your network topology?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "rel_service_architecture_monolith_soa_microservice",
        Description:
          "\n               Monolithic architecture should be avoided. Instead, you should choose between SOA and microservices. When making each choice, balance the benefits against the complexities—what is right for a new product racing to first launch is different than what a workload built to scale from the start needs. The benefits of using smaller segments include greater agility, organizational flexibility, and scalability. Complexities include possible increased latency, more complex debugging, and increased operational burden\n            ",
        Title: "Choose how to segment your workload",
      },
      {
        ChoiceId: "rel_service_architecture_business_domains",
        Description:
          "\n               SOA builds services with well-delineated functions defined by business needs. Microservices use domain models and bounded context to limit this further so that each service does just one thing.  Focusing on specific functionality enables you to differentiate the reliability requirements of different services, and target investments more specifically.  A concise business problem and having a small team associated with each service also enables easier organizational scaling.\n            ",
        Title:
          "Build services focused on specific business domains and functionality",
      },
      {
        ChoiceId: "rel_service_architecture_api_contracts",
        Description:
          "\n               Service contracts are documented agreements between teams on service integration and include a machine-readable API definition, rate limits, and performance expectations. A versioning strategy allows clients to continue using the existing API and migrate their applications to the newer API when they are ready. Deployment can happen anytime, as long as the contract is not violated. The service provider team can use the technology stack of their choice to satisfy the API contract. Similarly, the service consumer can use their own technology.",
        Title: "Provide service contracts per API",
      },
      {
        ChoiceId: "rel_service_architecture_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "reliability",
    QuestionId: "service-architecture",
    QuestionTitle: "How do you design your workload service architecture?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "rel_prevent_interaction_failure_identify",
        Description:
          "\n               Hard real-time distributed systems require responses to be given synchronously and rapidly, while soft real-time systems have a more generous time window of minutes or more for response. Offline systems handle responses through batch or asynchronous processing. Hard real-time distributed systems have the most stringent reliability requirements.\n            ",
        Title: "Identify which kind of distributed system is required",
      },
      {
        ChoiceId: "rel_prevent_interaction_failure_loosely_coupled_system",
        Description:
          "\n               Dependencies such as queuing systems, streaming systems, workflows, and load balancers are loosely coupled. Loose coupling helps isolate behavior of a component from other components that depend on it, increasing resiliency and agility\n            ",
        Title: "Implement loosely coupled dependencies",
      },
      {
        ChoiceId: "rel_prevent_interaction_failure_constant_work",
        Description:
          "\n               Systems can fail when there are large, rapid changes in load. For example, if your workload is doing a health check that monitors the health of thousands of servers, it should send the same size payload (a full snapshot of the current state) each time. Whether no servers are failing, or all of them, the health check system is doing constant work with no large, rapid changes.\n            ",
        Title: "Do constant work",
      },
      {
        ChoiceId: "rel_prevent_interaction_failure_idempotent",
        Description:
          "\n               An idempotent service promises that each request is completed exactly once, such that making multiple identical requests has the same effect as making a single request. An idempotent service makes it easier for a client to implement retries without fear that a request will be erroneously processed multiple times. To do this, clients can issue API requests with an idempotency token—the same token is used whenever the request is repeated. An idempotent service API uses the token to return a response identical to the response that was returned the first time that the request was completed.\n            ",
        Title: "Make all responses idempotent",
      },
      {
        ChoiceId: "rel_prevent_interaction_failure_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "reliability",
    QuestionId: "prevent-interaction-failure",
    QuestionTitle:
      "How do you design interactions in a distributed system to prevent failures?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "rel_mitigate_interaction_failure_graceful_degradation",
        Description:
          "\n                    When a component's dependencies are unhealthy, the component itself can still function, although in a degraded manner. For example, when a dependency call fails, failover to a predetermined static response.\n                ",
        Title:
          "Implement graceful degradation to transform applicable hard dependencies into soft dependencies",
      },
      {
        ChoiceId: "rel_mitigate_interaction_failure_throttle_requests",
        Description:
          "\n                    This is a mitigation pattern to respond to an unexpected increase in demand. Some requests are honored but those over a defined limit are rejected and return a message indicating they have been throttled. The expectation on clients is that they will back off and abandon the request or try again at a slower rate.\n                ",
        Title: "Throttle requests",
      },
      {
        ChoiceId: "rel_mitigate_interaction_failure_limit_retries",
        Description:
          "\n                    Use exponential backoff to retry after progressively longer intervals. Introduce jitter to randomize those retry intervals, and limit the maximum number of retries. \n                ",
        Title: "Control and limit retry calls",
      },
      {
        ChoiceId: "rel_mitigate_interaction_failure_fail_fast",
        Description:
          "\n                    If the workload is unable to respond successfully to a request, then fail fast. This allows the releasing of resources associated with a request, and permits the service to recover if it’s running out of resources.  If the workload is able to respond successfully but the rate of requests is too high, then use a queue to buffer requests instead. However, do not allow long queues that can result in serving stale requests that the client has already given up on.\n                ",
        Title: "Fail fast and limit queues",
      },
      {
        ChoiceId: "rel_mitigate_interaction_failure_client_timeouts",
        Description:
          "\n                    Set timeouts appropriately, verify them systematically, and do not rely on default values as they are generally set too high\n                ",
        Title: "Set client timeouts",
      },
      {
        ChoiceId: "rel_mitigate_interaction_failure_stateless",
        Description:
          "\n                    Services should either not require state, or should offload state such that between different client requests, there is no dependence on locally stored data on disk or in memory. This enables servers to be replaced at will without causing an availability impact. Amazon ElastiCache or Amazon DynamoDB are good destinations for offloaded state.\n                ",
        Title: "Make services stateless where possible",
      },
      {
        ChoiceId: "rel_mitigate_interaction_failure_emergency_levers",
        Description:
          "\n                    These are rapid processes that may mitigate availability impact on your workload. They can be operated in the absence of a root cause. An ideal emergency lever reduces the cognitive burden on the resolvers to zero by providing fully deterministic activation and deactivation criteria. Example levers include blocking all robot traffic or serving a static response. Levers are often manual, but they can also be automated.\n                ",
        Title: "Implement emergency levers",
      },
      {
        ChoiceId: "rel_mitigate_interaction_failure_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "reliability",
    QuestionId: "mitigate-interaction-failure",
    QuestionTitle:
      "How do you design interactions in a distributed system to mitigate or withstand failures?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "rel_monitor_aws_resources_monitor_resources",
        Description:
          "Monitor the components of the workload with Amazon CloudWatch or third-party tools. Monitor AWS services with Personal Health Dashboard",
        Title: "Monitor all components for the workload (Generation)",
      },
      {
        ChoiceId: "rel_monitor_aws_resources_notification_aggregation",
        Description:
          "Store log data and apply filters where necessary to calculate metrics, such as counts of a specific log event, or latency calculated from log event timestamps",
        Title: "Define and calculate metrics (Aggregation)",
      },
      {
        ChoiceId: "rel_monitor_aws_resources_notification_monitor",
        Description:
          "Organizations that need to know, receive notifications when significant events occur",
        Title: "Send notifications (Real-time processing and alarming)",
      },
      {
        ChoiceId: "rel_monitor_aws_resources_automate_response_monitor",
        Description:
          "Use automation to take action when an event is detected, for example, to replace failed components",
        Title: "Automate responses (Real-time processing and alarming)",
      },
      {
        ChoiceId: "rel_monitor_aws_resources_storage_analytics",
        Description:
          "Collect log files and metrics histories and analyze these for broader trends and workload insights",
        Title: "Analytics",
      },
      {
        ChoiceId: "rel_monitor_aws_resources_review_monitoring",
        Description:
          "Frequently review how workload monitoring is implemented and update it based on significant events and changes",
        Title: "Conduct reviews regularly",
      },
      {
        ChoiceId: "rel_monitor_aws_resources_end_to_end",
        Description:
          "Use AWS X-Ray or third-party tools so that developers can more easily analyze and debug distributed systems to understand how their applications and its underlying services are performing",
        Title: "Monitor end-to-end tracing of requests through your system",
      },
      {
        ChoiceId: "rel_monitor_aws_resources_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "reliability",
    QuestionId: "monitor-aws-resources",
    QuestionTitle: "How do you monitor workload resources?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "rel_adapt_to_changes_autoscale_adapt",
        Description:
          "When replacing impaired resources or scaling your workload, automate the process by using managed AWS services, such as Amazon S3 and AWS Auto Scaling. You can also use third-party tools and AWS SDKs to automate scaling. ",
        Title: "Use automation when obtaining or scaling resources",
      },
      {
        ChoiceId: "rel_adapt_to_changes_reactive_adapt_auto",
        Description:
          "Scale resources reactively when necessary if availability is impacted, to restore workload availability.",
        Title: "Obtain resources upon detection of impairment to a workload",
      },
      {
        ChoiceId: "rel_adapt_to_changes_proactive_adapt_auto",
        Description:
          "Scale resources proactively to meet demand and avoid availability impact.",
        Title:
          "Obtain resources upon detection that more resources are needed for a workload",
      },
      {
        ChoiceId: "rel_adapt_to_changes_load_tested_adapt",
        Description:
          "Adopt a load testing methodology to measure if scaling activity meets workload requirements.",
        Title: "Load test your workload",
      },
      {
        ChoiceId: "rel_adapt_to_changes_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "reliability",
    QuestionId: "adapt-to-changes",
    QuestionTitle:
      "How do you design your workload to adapt to changes in demand?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "rel_tracking_change_management_planned_changemgmt",
        Description:
          "Runbooks are the predefined steps used to achieve specific outcomes. Use runbooks to perform standard activities, whether done manually or automatically. Examples include deploying a workload, patching it, or making DNS modifications.",
        Title: "Use runbooks for standard activities such as deployment",
      },
      {
        ChoiceId: "rel_tracking_change_management_functional_testing",
        Description:
          "Functional tests are run as part of automated deployment. If success criteria are not met, the pipeline is halted or rolled back.",
        Title: "Integrate functional testing as part of your deployment",
      },
      {
        ChoiceId: "rel_tracking_change_management_resiliency_testing",
        Description:
          "Resiliency tests (as part of chaos engineering) are run as part of the automated deployment pipeline in a pre-prod environment.",
        Title: "Integrate resiliency testing as part of your deployment",
      },
      {
        ChoiceId: "rel_tracking_change_management_immutable_infrastructure",
        Description:
          "This is a model that mandates that no updates, security patches, or configuration changes happen in-place on production workloads. When a change is needed, the architecture is built onto new infrastructure and deployed into production.",
        Title: "Deploy using immutable infrastructure",
      },
      {
        ChoiceId: "rel_tracking_change_management_automated_changemgmt",
        Description:
          "Deployments and patching are automated to eliminate negative impact.",
        Title: "Deploy changes with automation",
      },
      {
        ChoiceId: "rel_tracking_change_management_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "reliability",
    QuestionId: "tracking-change-management",
    QuestionTitle: "How do you implement change?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "rel_backing_up_data_identified_backups_data",
        Description:
          "Amazon S3 can be used as a backup destination for multiple data sources. AWS services such as Amazon EBS, Amazon RDS, and Amazon DynamoDB have built in capabilities to create backups. Third-party backup software can also be used. Alternatively, if the data can be reproduced from other sources to meet RPO, you might not require a backup",
        Title:
          "Identify and back up all data that needs to be backed up, or reproduce the data from sources",
      },
      {
        ChoiceId: "rel_backing_up_data_secured_backups_data",
        Description:
          "Detect access using authentication and authorization, such as AWS IAM, and detect data integrity compromise by using encryption.",
        Title: "Secure and encrypt backups",
      },
      {
        ChoiceId: "rel_backing_up_data_automated_backups_data",
        Description:
          "Configure backups to be taken automatically based on a periodic schedule, or by changes in the dataset. RDS instances, EBS volumes, DynamoDB tables, and S3 objects can all be configured for automatic backup. AWS Marketplace solutions or third-party solutions can also be used.",
        Title: "Perform data backup automatically",
      },
      {
        ChoiceId: "rel_backing_up_data_periodic_recovery_testing_data",
        Description:
          "Validate that your backup process implementation meets your recovery time objectives (RTO) and recovery point objectives (RPO) by performing a recovery test.",
        Title:
          "Perform periodic recovery of the data to verify backup integrity and processes",
      },
      {
        ChoiceId: "rel_backing_up_data_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "reliability",
    QuestionId: "backing-up-data",
    QuestionTitle: "How do you back up data?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "rel_fault_isolation_multiaz_region_system",
        Description:
          "\n               Distribute workload data and resources across multiple Availability Zones or, where necessary, across AWS Regions. These locations can be as diverse as required.\n            ",
        Title: "Deploy the workload to multiple locations",
      },
      {
        ChoiceId: "rel_fault_isolation_select_location",
        Description:
          "\n               Always use multiple AZs where possible within an AWS Region. For workloads that require more resiliency, also use a multi-Region strategy, such as active-passive or active-active.\n            ",
        Title:
          "Select the appropriate locations for your multi-location deployment",
      },
      {
        ChoiceId: "rel_fault_isolation_single_az_system",
        Description:
          "\n               If components of the workload can only run in a single Availability Zone or on-premises data center, you must implement the capability to do a complete rebuild of the workload within your defined recovery objectives.\n            ",
        Title:
          "Automate recovery for components constrained to a single location",
      },
      {
        ChoiceId: "rel_fault_isolation_use_bulkhead",
        Description:
          "\n               Like the bulkheads on a ship, this pattern ensures that a failure is contained to a small subset of requests or users so that the number of impaired requests is limited, and most can continue without error. Bulkheads for data are often called partitions, while bulkheads for services are known as cells.\n            ",
        Title: "Use bulkhead architectures to limit scope of impact",
      },
      {
        ChoiceId: "rel_fault_isolation_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "reliability",
    QuestionId: "fault-isolation",
    QuestionTitle: "How do you use fault isolation to protect your workload?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "rel_withstand_component_failures_monitoring_health",
        Description:
          "Continuously monitor the health of your workload so that you and your automated systems are aware of degradation or complete failure as soon as they occur. Monitor for key performance indicators (KPIs) based on business value.",
        Title: "Monitor all components of the workload to detect failures",
      },
      {
        ChoiceId: "rel_withstand_component_failures_failover2good",
        Description:
          "Ensure that if a resource failure occurs, that healthy resources can continue to serve requests. For location failures (such as Availability Zone or AWS Region) ensure you have systems in place to fail over to healthy resources in unimpaired locations.",
        Title: "Fail over to healthy resources",
      },
      {
        ChoiceId: "rel_withstand_component_failures_auto_healing_system",
        Description:
          "Upon detection of a failure, use automated capabilities to perform actions to remediate.",
        Title: "Automate healing on all layers",
      },
      {
        ChoiceId: "rel_withstand_component_failures_avoid_control_plane",
        Description:
          "\n               The control plane is used to configure resources, and the data plane delivers services. Data planes typically have higher availability design goals than control planes and are usually less complex. When implementing recovery or mitigation responses to potentially resiliency-impacting events, using control plane operations can lower the overall resiliency of your architecture.  For example, you can rely on the Amazon Route 53 data plane to reliably route DNS queries based on health checks, but updating Route 53 routing policies uses the control plane, so do not rely on it for recovery.\n            ",
        Title:
          "Rely on the data plane and not the control plane during recovery",
      },
      {
        ChoiceId: "rel_withstand_component_failures_static_stability",
        Description:
          "Bimodal behavior is when your workload exhibits different behavior under normal and failure modes, for example, relying on launching new instances if an Availability Zone fails. You should instead build workloads that are statically stable and operate in only one mode. In this case, provision enough instances in each Availability Zone to handle the workload load if one AZ were removed and then use Elastic Load Balancing or Amazon Route 53 health checks to shift load away from the impaired instances.",
        Title: "Use static stability to prevent bimodal behavior",
      },
      {
        ChoiceId: "rel_withstand_component_failures_notifications_sent_system",
        Description:
          "Notifications are sent upon the detection of significant events, even if the issue caused by the event was automatically resolved.",
        Title: "Send notifications when events impact availability",
      },
      {
        ChoiceId: "rel_withstand_component_failures_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "reliability",
    QuestionId: "withstand-component-failures",
    QuestionTitle:
      "How do you design your workload to withstand component failures?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "rel_testing_resiliency_playbook_resiliency",
        Description:
          "Enable consistent and prompt responses to failure\n               scenarios that are not well understood, by documenting the investigation process in\n               playbooks. Playbooks are the predefined steps performed to identify the factors\n               contributing to a failure scenario. The results from any process step are used to\n               determine the next steps to take until the issue is identified or\n               escalated.",
        Title: "Use playbooks to investigate failures",
      },
      {
        ChoiceId: "rel_testing_resiliency_rca_resiliency",
        Description:
          "Review customer-impacting events, and identify the\n               contributing factors and preventative action items. Use this information to develop\n               mitigations to limit or prevent recurrence. Develop procedures for prompt and\n               effective responses. Communicate contributing factors and corrective actions as\n               appropriate, tailored to target audiences. Have a method to communicate these causes\n               to others as needed.",
        Title: "Perform post-incident analysis",
      },
      {
        ChoiceId: "rel_testing_resiliency_test_functional",
        Description:
          "These include unit tests and integration tests that validate required functionality.",
        Title: "Test functional requirements",
      },
      {
        ChoiceId: "rel_testing_resiliency_test_non_functional",
        Description:
          "This includes load testing to validate that the workload meets scaling and performance requirements.",
        Title: "Test scaling and performance requirements",
      },
      {
        ChoiceId: "rel_testing_resiliency_failure_injection_resiliency",
        Description:
          "Run tests that inject failures regularly into pre-production and production environments. Hypothesize how your workload will react to the failure, then compare your hypothesis to the testing results and iterate if they do not match. Ensure that production testing does not impact users.",
        Title: "Test resiliency using chaos engineering",
      },
      {
        ChoiceId: "rel_testing_resiliency_game_days_resiliency",
        Description:
          "\n               Use game days to regularly exercise your procedures for responding to events and failures as close to production as possible (including in production environments) with the people who will be involved in actual failure scenarios. Game days enforce measures to ensure that production events do not impact users.\n            ",
        Title: "Conduct game days regularly",
      },
      {
        ChoiceId: "rel_testing_resiliency_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "reliability",
    QuestionId: "testing-resiliency",
    QuestionTitle: "How do you test reliability?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "rel_planning_for_recovery_objective_defined_recovery",
        Description:
          "The workload has a recovery time objective (RTO) and recovery point objective (RPO).",
        Title: "Define recovery objectives for downtime and data loss",
      },
      {
        ChoiceId: "rel_planning_for_recovery_disaster_recovery",
        Description:
          "\n               A disaster recovery (DR) strategy has been defined to meet your workload objectives. Choose a strategy such as: backup and restore; standby (active/passive); or active/active.\n            ",
        Title:
          "Use defined recovery strategies to meet the recovery objectives",
      },
      {
        ChoiceId: "rel_planning_for_recovery_dr_tested",
        Description:
          "Regularly test failover to DR to ensure that RTO and RPO are met.",
        Title:
          "Test disaster recovery implementation to validate the implementation",
      },
      {
        ChoiceId: "rel_planning_for_recovery_config_drift",
        Description:
          "Ensure that the infrastructure, data, and configuration are as needed at the DR site or Region.  For example, check that AMIs and service quotas are up to date.",
        Title: "Manage configuration drift at the DR site or Region",
      },
      {
        ChoiceId: "rel_planning_for_recovery_auto_recovery",
        Description:
          "Use AWS or third-party tools to automate system recovery and route traffic to the DR site or Region.",
        Title: "Automate recovery",
      },
      {
        ChoiceId: "rel_planning_for_recovery_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "reliability",
    QuestionId: "planning-for-recovery",
    QuestionTitle: "How do you plan for disaster recovery (DR)?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
];

export const Reliability_Check_Q1_ExecutionStatus = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 05:44:37+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Reliability_Q1_Summaries = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "rel_manage_service_limits_aware_quotas_and_constraints",
        Description:
          "You are aware of your default quotas and quota increase requests for your workload architecture. You additionally know which resource constraints, such as disk or network, are potentially impactful.",
        Title: "Aware of service quotas and constraints",
      },
      {
        ChoiceId: "rel_manage_service_limits_limits_considered",
        Description:
          "If you are using multiple AWS accounts or AWS Regions, ensure that you request the appropriate quotas in all environments in which your production workloads run.",
        Title: "Manage service quotas across accounts and regions",
      },
      {
        ChoiceId: "rel_manage_service_limits_aware_fixed_limits",
        Description:
          "Be aware of unchangeable service quotas and physical resources, and architect to prevent these from impacting reliability.",
        Title:
          "Accommodate fixed service quotas and constraints through architecture",
      },
      {
        ChoiceId: "rel_manage_service_limits_monitor_manage_limits",
        Description:
          "Evaluate your potential usage and increase your quotas appropriately allowing for planned growth in usage.",
        Title: "Monitor and manage quotas",
      },
      {
        ChoiceId: "rel_manage_service_limits_automated_monitor_limits",
        Description:
          "Implement tools to alert you when thresholds are being approached. By using AWS Service Quotas APIs, you can automate quota increase requests.",
        Title: "Automate quota management",
      },
      {
        ChoiceId: "rel_manage_service_limits_suff_buffer_limits",
        Description:
          "When a resource fails, it may still be counted against quotas until its successfully terminated. Ensure that your quotas cover the overlap of all failed resources with replacements before the failed resources are terminated. You should consider an Availability Zone failure when calculating this gap.",
        Title:
          "Ensure that a sufficient gap exists between the current quotas and the maximum usage to accommodate failover",
      },
      {
        ChoiceId: "rel_manage_service_limits_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.manage-service-limits.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "reliability",
    QuestionDescription:
      "For cloud-based workload architectures, there are service quotas (which are also referred to as service limits). These quotas exist to prevent accidentally provisioning more resources than you need and to limit request rates on API operations so as to protect services from abuse. There are also resource constraints, for example, the rate that you can push bits down a fiber-optic cable, or the amount of storage on a physical disk.\n      ",
    QuestionId: "manage-service-limits",
    QuestionTitle: "How do you manage service quotas and constraints?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Reliability_Q1_Answer_Summaries = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Reliability_Q2 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "rel_planning_network_topology_ha_conn_users",
        Description:
          "These endpoints and the routing to them must be highly available. To achieve this, use highly available DNS, content delivery networks (CDNs), API Gateway, load balancing, or reverse proxies.",
        Title:
          "Use highly available network connectivity for your workload public endpoints",
      },
      {
        ChoiceId: "rel_planning_network_topology_ha_conn_private_networks",
        Description:
          "Use multiple AWS Direct Connect (DX) connections or VPN tunnels between separately deployed private networks. Use multiple DX locations for high availability. If using multiple AWS Regions, ensure redundancy in at least two of them. You might want to evaluate AWS Marketplace appliances that terminate VPNs. If you use AWS Marketplace appliances, deploy redundant instances for high availability in different Availability Zones.",
        Title:
          "Provision redundant connectivity between private networks in the cloud and on-premises environments",
      },
      {
        ChoiceId: "rel_planning_network_topology_ip_subnet_allocation",
        Description:
          "Amazon VPC IP address ranges must be large enough to accommodate workload requirements, including factoring in future expansion and allocation of IP addresses to subnets across Availability Zones. This includes load balancers, EC2 instances, and container-based applications.",
        Title:
          "Ensure IP subnet allocation accounts for expansion and availability",
      },
      {
        ChoiceId: "rel_planning_network_topology_prefer_hub_and_spoke",
        Description:
          "If more than two network address spaces (for example, VPCs and on-premises networks) are connected via VPC peering, AWS Direct Connect, or VPN, then use a hub-and-spoke model, like that provided by AWS Transit Gateway.",
        Title: "Prefer hub-and-spoke topologies over many-to-many mesh",
      },
      {
        ChoiceId: "rel_planning_network_topology_non_overlap_ip",
        Description:
          "The IP address ranges of each of your VPCs must not overlap when peered or connected via VPN. You must similarly avoid IP address conflicts between a VPC and on-premises environments or with other cloud providers that you use. You must also have a way to allocate private IP address ranges when needed.",
        Title:
          "Enforce non-overlapping private IP address ranges in all private address spaces where they are connected",
      },
      {
        ChoiceId: "rel_planning_network_topology_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.planning-network-topology.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "reliability",
    QuestionDescription:
      "Workloads often exist in multiple environments. These include multiple cloud environments (both publicly accessible and private) and possibly your existing data center infrastructure. Plans must include network considerations such as intra- and inter-system connectivity, public IP address management, private IP address management, and domain name resolution.",
    QuestionId: "planning-network-topology",
    QuestionTitle: "How do you plan your network topology?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Reliability_Check_Q2_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 1,
};

export const Reliability_Q2_Answer_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 12:55:18+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Reliability_Q3 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "rel_service_architecture_monolith_soa_microservice",
        Description:
          "Monolithic architecture should be avoided. Instead, you should choose between SOA and microservices. When making each choice, balance the benefits against the complexities—what is right for a new product racing to first launch is different than what a workload built to scale from the start needs. The benefits of using smaller segments include greater agility, organizational flexibility, and scalability. Complexities include possible increased latency, more complex debugging, and increased operational burden\n            ",
        Title: "Choose how to segment your workload",
      },
      {
        ChoiceId: "rel_service_architecture_business_domains",
        Description:
          "SOA builds services with well-delineated functions defined by business needs. Microservices use domain models and bounded context to limit this further so that each service does just one thing.  Focusing on specific functionality enables you to differentiate the reliability requirements of different services, and target investments more specifically.  A concise business problem and having a small team associated with each service also enables easier organizational scaling.\n            ",
        Title:
          "Build services focused on specific business domains and functionality",
      },
      {
        ChoiceId: "rel_service_architecture_api_contracts",
        Description:
          "Service contracts are documented agreements between teams on service integration and include a machine-readable API definition, rate limits, and performance expectations. A versioning strategy allows clients to continue using the existing API and migrate their applications to the newer API when they are ready. Deployment can happen anytime, as long as the contract is not violated. The service provider team can use the technology stack of their choice to satisfy the API contract. Similarly, the service consumer can use their own technology.",
        Title: "Provide service contracts per API",
      },
      {
        ChoiceId: "rel_service_architecture_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.service-architecture.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "reliability",
    QuestionDescription:
      "Build highly scalable and reliable workloads using a service-oriented architecture (SOA) or a microservices architecture. Service-oriented architecture (SOA) is the practice of making software components reusable via service interfaces. Microservices architecture goes further to make components smaller and simpler.",
    QuestionId: "service-architecture",
    QuestionTitle: "How do you design your workload service architecture?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Reliability_Check_Q3_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 1,
};

export const Reliability_Q3_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 13:03:19+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Reliability_Q4 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "rel_prevent_interaction_failure_identify",
        Description:
          "Hard real-time distributed systems require responses to be given synchronously and rapidly, while soft real-time systems have a more generous time window of minutes or more for response. Offline systems handle responses through batch or asynchronous processing. Hard real-time distributed systems have the most stringent reliability requirements.\n            ",
        Title: "Identify which kind of distributed system is required",
      },
      {
        ChoiceId: "rel_prevent_interaction_failure_loosely_coupled_system",
        Description:
          "Dependencies such as queuing systems, streaming systems, workflows, and load balancers are loosely coupled. Loose coupling helps isolate behavior of a component from other components that depend on it, increasing resiliency and agility\n            ",
        Title: "Implement loosely coupled dependencies",
      },
      {
        ChoiceId: "rel_prevent_interaction_failure_constant_work",
        Description:
          "Systems can fail when there are large, rapid changes in load. For example, if your workload is doing a health check that monitors the health of thousands of servers, it should send the same size payload (a full snapshot of the current state) each time. Whether no servers are failing, or all of them, the health check system is doing constant work with no large, rapid changes.\n            ",
        Title: "Do constant work",
      },
      {
        ChoiceId: "rel_prevent_interaction_failure_idempotent",
        Description:
          "An idempotent service promises that each request is completed exactly once, such that making multiple identical requests has the same effect as making a single request. An idempotent service makes it easier for a client to implement retries without fear that a request will be erroneously processed multiple times. To do this, clients can issue API requests with an idempotency token—the same token is used whenever the request is repeated. An idempotent service API uses the token to return a response identical to the response that was returned the first time that the request was completed.\n            ",
        Title: "Make all responses idempotent",
      },
      {
        ChoiceId: "rel_prevent_interaction_failure_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.prevent-interaction-failure.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "reliability",
    QuestionDescription:
      "Distributed systems rely on communications networks to interconnect components, such as servers or services. Your workload must operate reliably despite data loss or latency in these networks. Components of the distributed system must operate in a way that does not negatively impact other components or the workload. These best practices prevent failures and improve mean time between failures (MTBF).",
    QuestionId: "prevent-interaction-failure",
    QuestionTitle:
      "How do you design interactions in a distributed system to prevent failures?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Reliability_Check_Q4_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Reliability_Q4_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 13:03:19+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Reliability_Q5 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "rel_mitigate_interaction_failure_graceful_degradation",
        Description:
          "     When a component's dependencies are unhealthy, the component itself can still function, although in a degraded manner. For example, when a dependency call fails, failover to a predetermined static response. ",
        Title:
          "Implement graceful degradation to transform applicable hard dependencies into soft dependencies",
      },
      {
        ChoiceId: "rel_mitigate_interaction_failure_throttle_requests",
        Description:
          "     This is a mitigation pattern to respond to an unexpected increase in demand. Some requests are honored but those over a defined limit are rejected and return a message indicating they have been throttled. The expectation on clients is that they will back off and abandon the request or try again at a slower rate. ",
        Title: "Throttle requests",
      },
      {
        ChoiceId: "rel_mitigate_interaction_failure_limit_retries",
        Description:
          "     Use exponential backoff to retry after progressively longer intervals. Introduce jitter to randomize those retry intervals, and limit the maximum number of retries.  ",
        Title: "Control and limit retry calls",
      },
      {
        ChoiceId: "rel_mitigate_interaction_failure_fail_fast",
        Description:
          "     If the workload is unable to respond successfully to a request, then fail fast. This allows the releasing of resources associated with a request, and permits the service to recover if it’s running out of resources.  If the workload is able to respond successfully but the rate of requests is too high, then use a queue to buffer requests instead. However, do not allow long queues that can result in serving stale requests that the client has already given up on. ",
        Title: "Fail fast and limit queues",
      },
      {
        ChoiceId: "rel_mitigate_interaction_failure_client_timeouts",
        Description:
          "     Set timeouts appropriately, verify them systematically, and do not rely on default values as they are generally set too high ",
        Title: "Set client timeouts",
      },
      {
        ChoiceId: "rel_mitigate_interaction_failure_stateless",
        Description:
          "     Services should either not require state, or should offload state such that between different client requests, there is no dependence on locally stored data on disk or in memory. This enables servers to be replaced at will without causing an availability impact. Amazon ElastiCache or Amazon DynamoDB are good destinations for offloaded state. ",
        Title: "Make services stateless where possible",
      },
      {
        ChoiceId: "rel_mitigate_interaction_failure_emergency_levers",
        Description:
          "     These are rapid processes that may mitigate availability impact on your workload. They can be operated in the absence of a root cause. An ideal emergency lever reduces the cognitive burden on the resolvers to zero by providing fully deterministic activation and deactivation criteria. Example levers include blocking all robot traffic or serving a static response. Levers are often manual, but they can also be automated. ",
        Title: "Implement emergency levers",
      },
      {
        ChoiceId: "rel_mitigate_interaction_failure_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.mitigate-interaction-failure.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "reliability",
    QuestionDescription:
      "Distributed systems rely on communications networks to interconnect components (such as servers or services). Your workload must operate reliably despite data loss or latency over these networks. Components of the distributed system must operate in a way that does not negatively impact other components or the workload. These best practices enable workloads to withstand stresses or failures, more quickly recover from them, and mitigate the impact of such impairments.  The result is improved mean time to recovery (MTTR).",
    QuestionId: "mitigate-interaction-failure",
    QuestionTitle:
      "How do you design interactions in a distributed system to mitigate or withstand failures?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Reliability_Check_Q5_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 1,
  Passed: 2,
};

export const Reliability_Q5_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 16:11:55+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Reliability_Q6 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "rel_monitor_aws_resources_monitor_resources",
        Description:
          "Monitor the components of the workload with Amazon CloudWatch or third-party tools. Monitor AWS services with Personal Health Dashboard",
        Title: "Monitor all components for the workload (Generation)",
      },
      {
        ChoiceId: "rel_monitor_aws_resources_notification_aggregation",
        Description:
          "Store log data and apply filters where necessary to calculate metrics, such as counts of a specific log event, or latency calculated from log event timestamps",
        Title: "Define and calculate metrics (Aggregation)",
      },
      {
        ChoiceId: "rel_monitor_aws_resources_notification_monitor",
        Description:
          "Organizations that need to know, receive notifications when significant events occur",
        Title: "Send notifications (Real-time processing and alarming)",
      },
      {
        ChoiceId: "rel_monitor_aws_resources_automate_response_monitor",
        Description:
          "Use automation to take action when an event is detected, for example, to replace failed components",
        Title: "Automate responses (Real-time processing and alarming)",
      },
      {
        ChoiceId: "rel_monitor_aws_resources_storage_analytics",
        Description:
          "Collect log files and metrics histories and analyze these for broader trends and workload insights",
        Title: "Analytics",
      },
      {
        ChoiceId: "rel_monitor_aws_resources_review_monitoring",
        Description:
          "Frequently review how workload monitoring is implemented and update it based on significant events and changes",
        Title: "Conduct reviews regularly",
      },
      {
        ChoiceId: "rel_monitor_aws_resources_end_to_end",
        Description:
          "Use AWS X-Ray or third-party tools so that developers can more easily analyze and debug distributed systems to understand how their applications and its underlying services are performing",
        Title: "Monitor end-to-end tracing of requests through your system",
      },
      {
        ChoiceId: "rel_monitor_aws_resources_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.monitor-aws-resources.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "reliability",
    QuestionDescription:
      "Logs and metrics are powerful tools to gain insight into the health of your workload. You can configure your workload to monitor logs and metrics and send notifications when thresholds are crossed or significant events occur. Monitoring enables your workload to recognize when low-performance thresholds are crossed or failures occur, so it can recover automatically in response.",
    QuestionId: "monitor-aws-resources",
    QuestionTitle: "How do you monitor workload resources?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Reliability_Check_Q6_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 30,
  Passed: 15,
};

export const Reliability_Q6_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 16:14:28+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Reliability_Q7 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "rel_adapt_to_changes_autoscale_adapt",
        Description:
          "When replacing impaired resources or scaling your workload, automate the process by using managed AWS services, such as Amazon S3 and AWS Auto Scaling. You can also use third-party tools and AWS SDKs to automate scaling. ",
        Title: "Use automation when obtaining or scaling resources",
      },
      {
        ChoiceId: "rel_adapt_to_changes_reactive_adapt_auto",
        Description:
          "Scale resources reactively when necessary if availability is impacted, to restore workload availability.",
        Title: "Obtain resources upon detection of impairment to a workload",
      },
      {
        ChoiceId: "rel_adapt_to_changes_proactive_adapt_auto",
        Description:
          "Scale resources proactively to meet demand and avoid availability impact.",
        Title:
          "Obtain resources upon detection that more resources are needed for a workload",
      },
      {
        ChoiceId: "rel_adapt_to_changes_load_tested_adapt",
        Description:
          "Adopt a load testing methodology to measure if scaling activity meets workload requirements.",
        Title: "Load test your workload",
      },
      {
        ChoiceId: "rel_adapt_to_changes_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.adapt-to-changes.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "reliability",
    QuestionDescription:
      "A scalable workload provides elasticity to add or remove resources automatically so that they closely match the current demand at any given point in time.",
    QuestionId: "adapt-to-changes",
    QuestionTitle:
      "How do you design your workload to adapt to changes in demand?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Reliability_Check_Q7_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Reliability_Q7_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 16:14:28+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Reliability_Q8 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "rel_tracking_change_management_planned_changemgmt",
        Description:
          "Runbooks are the predefined steps used to achieve specific outcomes. Use runbooks to perform standard activities, whether done manually or automatically. Examples include deploying a workload, patching it, or making DNS modifications.",
        Title: "Use runbooks for standard activities such as deployment",
      },
      {
        ChoiceId: "rel_tracking_change_management_functional_testing",
        Description:
          "Functional tests are run as part of automated deployment. If success criteria are not met, the pipeline is halted or rolled back.",
        Title: "Integrate functional testing as part of your deployment",
      },
      {
        ChoiceId: "rel_tracking_change_management_resiliency_testing",
        Description:
          "Resiliency tests (as part of chaos engineering) are run as part of the automated deployment pipeline in a pre-prod environment.",
        Title: "Integrate resiliency testing as part of your deployment",
      },
      {
        ChoiceId: "rel_tracking_change_management_immutable_infrastructure",
        Description:
          "This is a model that mandates that no updates, security patches, or configuration changes happen in-place on production workloads. When a change is needed, the architecture is built onto new infrastructure and deployed into production.",
        Title: "Deploy using immutable infrastructure",
      },
      {
        ChoiceId: "rel_tracking_change_management_automated_changemgmt",
        Description:
          "Deployments and patching are automated to eliminate negative impact.",
        Title: "Deploy changes with automation",
      },
      {
        ChoiceId: "rel_tracking_change_management_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.tracking-change-management.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "reliability",
    QuestionDescription:
      "Controlled changes are necessary to deploy new functionality, and to ensure that the workloads and the operating environment are running known software and can be patched or replaced in a predictable manner. If these changes are uncontrolled, then it makes it difficult to predict the effect of these changes, or to address issues that arise because of them.\n      ",
    QuestionId: "tracking-change-management",
    QuestionTitle: "How do you implement change?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Reliability_Check_Q8_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Reliability_Q8_Answer_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 16:23:06+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Reliability_Q9 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "rel_backing_up_data_identified_backups_data",
        Description:
          "Amazon S3 can be used as a backup destination for multiple data sources. AWS services such as Amazon EBS, Amazon RDS, and Amazon DynamoDB have built in capabilities to create backups. Third-party backup software can also be used. Alternatively, if the data can be reproduced from other sources to meet RPO, you might not require a backup",
        Title:
          "Identify and back up all data that needs to be backed up, or reproduce the data from sources",
      },
      {
        ChoiceId: "rel_backing_up_data_secured_backups_data",
        Description:
          "Detect access using authentication and authorization, such as AWS IAM, and detect data integrity compromise by using encryption.",
        Title: "Secure and encrypt backups",
      },
      {
        ChoiceId: "rel_backing_up_data_automated_backups_data",
        Description:
          "Configure backups to be taken automatically based on a periodic schedule, or by changes in the dataset. RDS instances, EBS volumes, DynamoDB tables, and S3 objects can all be configured for automatic backup. AWS Marketplace solutions or third-party solutions can also be used.",
        Title: "Perform data backup automatically",
      },
      {
        ChoiceId: "rel_backing_up_data_periodic_recovery_testing_data",
        Description:
          "Validate that your backup process implementation meets your recovery time objectives (RTO) and recovery point objectives (RPO) by performing a recovery test.",
        Title:
          "Perform periodic recovery of the data to verify backup integrity and processes",
      },
      {
        ChoiceId: "rel_backing_up_data_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.backing-up-data.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "reliability",
    QuestionDescription:
      "Back up data, applications, and configuration to meet your requirements for recovery time objectives (RTO) and recovery point objectives (RPO).",
    QuestionId: "backing-up-data",
    QuestionTitle: "How do you back up data?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Reliability_Check_Q9_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 7,
  Passed: 3,
};

export const Reliability_Q9_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 16:31:58+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Reliability_Q10 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "rel_fault_isolation_multiaz_region_system",
        Description:
          "Distribute workload data and resources across multiple Availability Zones or, where necessary, across AWS Regions. These locations can be as diverse as required.\n            ",
        Title: "Deploy the workload to multiple locations",
      },
      {
        ChoiceId: "rel_fault_isolation_select_location",
        Description:
          "Always use multiple AZs where possible within an AWS Region. For workloads that require more resiliency, also use a multi-Region strategy, such as active-passive or active-active.\n            ",
        Title:
          "Select the appropriate locations for your multi-location deployment",
      },
      {
        ChoiceId: "rel_fault_isolation_single_az_system",
        Description:
          "If components of the workload can only run in a single Availability Zone or on-premises data center, you must implement the capability to do a complete rebuild of the workload within your defined recovery objectives.\n            ",
        Title:
          "Automate recovery for components constrained to a single location",
      },
      {
        ChoiceId: "rel_fault_isolation_use_bulkhead",
        Description:
          "Like the bulkheads on a ship, this pattern ensures that a failure is contained to a small subset of requests or users so that the number of impaired requests is limited, and most can continue without error. Bulkheads for data are often called partitions, while bulkheads for services are known as cells.\n            ",
        Title: "Use bulkhead architectures to limit scope of impact",
      },
      {
        ChoiceId: "rel_fault_isolation_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.fault-isolation.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "reliability",
    QuestionDescription:
      "Fault isolated boundaries limit the effect of a failure within a workload to a limited number of components. Components outside of the boundary are unaffected by the failure. Using multiple fault isolated boundaries, you can limit the impact on your workload.",
    QuestionId: "fault-isolation",
    QuestionTitle: "How do you use fault isolation to protect your workload?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Reliability_Check_Q10_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 1,
};

export const Reliability_Q10_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 16:36:05+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Reliability_Q11 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "rel_withstand_component_failures_monitoring_health",
        Description:
          "Continuously monitor the health of your workload so that you and your automated systems are aware of degradation or complete failure as soon as they occur. Monitor for key performance indicators (KPIs) based on business value.",
        Title: "Monitor all components of the workload to detect failures",
      },
      {
        ChoiceId: "rel_withstand_component_failures_failover2good",
        Description:
          "Ensure that if a resource failure occurs, that healthy resources can continue to serve requests. For location failures (such as Availability Zone or AWS Region) ensure you have systems in place to fail over to healthy resources in unimpaired locations.",
        Title: "Fail over to healthy resources",
      },
      {
        ChoiceId: "rel_withstand_component_failures_auto_healing_system",
        Description:
          "Upon detection of a failure, use automated capabilities to perform actions to remediate.",
        Title: "Automate healing on all layers",
      },
      {
        ChoiceId: "rel_withstand_component_failures_avoid_control_plane",
        Description:
          "The control plane is used to configure resources, and the data plane delivers services. Data planes typically have higher availability design goals than control planes and are usually less complex. When implementing recovery or mitigation responses to potentially resiliency-impacting events, using control plane operations can lower the overall resiliency of your architecture.  For example, you can rely on the Amazon Route 53 data plane to reliably route DNS queries based on health checks, but updating Route 53 routing policies uses the control plane, so do not rely on it for recovery.\n            ",
        Title:
          "Rely on the data plane and not the control plane during recovery",
      },
      {
        ChoiceId: "rel_withstand_component_failures_static_stability",
        Description:
          "Bimodal behavior is when your workload exhibits different behavior under normal and failure modes, for example, relying on launching new instances if an Availability Zone fails. You should instead build workloads that are statically stable and operate in only one mode. In this case, provision enough instances in each Availability Zone to handle the workload load if one AZ were removed and then use Elastic Load Balancing or Amazon Route 53 health checks to shift load away from the impaired instances.",
        Title: "Use static stability to prevent bimodal behavior",
      },
      {
        ChoiceId: "rel_withstand_component_failures_notifications_sent_system",
        Description:
          "Notifications are sent upon the detection of significant events, even if the issue caused by the event was automatically resolved.",
        Title: "Send notifications when events impact availability",
      },
      {
        ChoiceId: "rel_withstand_component_failures_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.withstand-component-failures.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "reliability",
    QuestionDescription:
      "Workloads with a requirement for high availability and low mean time to recovery (MTTR) must be architected for resiliency.",
    QuestionId: "withstand-component-failures",
    QuestionTitle:
      "How do you design your workload to withstand component failures?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Reliability_Check_Q11_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 4,
  Passed: 4,
};

export const Reliability_Q11_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 16:39:53+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Reliability_Q12 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "rel_testing_resiliency_playbook_resiliency",
        Description:
          "Enable consistent and prompt responses to failurescenarios that are not well understood, by documenting the investigation process inplaybooks. Playbooks are the predefined steps performed to identify the factorscontributing to a failure scenario. The results from any process step are used todetermine the next steps to take until the issue is identified orescalated.",
        Title: "Use playbooks to investigate failures",
      },
      {
        ChoiceId: "rel_testing_resiliency_rca_resiliency",
        Description:
          "Review customer-impacting events, and identify thecontributing factors and preventative action items. Use this information to developmitigations to limit or prevent recurrence. Develop procedures for prompt andeffective responses. Communicate contributing factors and corrective actions asappropriate, tailored to target audiences. Have a method to communicate these causesto others as needed.",
        Title: "Perform post-incident analysis",
      },
      {
        ChoiceId: "rel_testing_resiliency_test_functional",
        Description:
          "These include unit tests and integration tests that validate required functionality.",
        Title: "Test functional requirements",
      },
      {
        ChoiceId: "rel_testing_resiliency_test_non_functional",
        Description:
          "This includes load testing to validate that the workload meets scaling and performance requirements.",
        Title: "Test scaling and performance requirements",
      },
      {
        ChoiceId: "rel_testing_resiliency_failure_injection_resiliency",
        Description:
          "Run tests that inject failures regularly into pre-production and production environments. Hypothesize how your workload will react to the failure, then compare your hypothesis to the testing results and iterate if they do not match. Ensure that production testing does not impact users.",
        Title: "Test resiliency using chaos engineering",
      },
      {
        ChoiceId: "rel_testing_resiliency_game_days_resiliency",
        Description:
          "Use game days to regularly exercise your procedures for responding to events and failures as close to production as possible (including in production environments) with the people who will be involved in actual failure scenarios. Game days enforce measures to ensure that production events do not impact users.\n            ",
        Title: "Conduct game days regularly",
      },
      {
        ChoiceId: "rel_testing_resiliency_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.testing-resiliency.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "reliability",
    QuestionDescription:
      "After you have designed your workload to be resilient to\n         the stresses of production, testing is the only way to ensure that it will operate as\n         designed, and deliver the resiliency you expect.",
    QuestionId: "testing-resiliency",
    QuestionTitle: "How do you test reliability?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Reliability_Check_Q12_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Reliability_Q12_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 16:44:28+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Reliability_Q13 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "rel_planning_for_recovery_objective_defined_recovery",
        Description:
          "The workload has a recovery time objective (RTO) and recovery point objective (RPO).",
        Title: "Define recovery objectives for downtime and data loss",
      },
      {
        ChoiceId: "rel_planning_for_recovery_disaster_recovery",
        Description:
          "A disaster recovery (DR) strategy has been defined to meet your workload objectives. Choose a strategy such as: backup and restore; standby (active/passive); or active/active.\n            ",
        Title:
          "Use defined recovery strategies to meet the recovery objectives",
      },
      {
        ChoiceId: "rel_planning_for_recovery_dr_tested",
        Description:
          "Regularly test failover to DR to ensure that RTO and RPO are met.",
        Title:
          "Test disaster recovery implementation to validate the implementation",
      },
      {
        ChoiceId: "rel_planning_for_recovery_config_drift",
        Description:
          "Ensure that the infrastructure, data, and configuration are as needed at the DR site or Region.  For example, check that AMIs and service quotas are up to date.",
        Title: "Manage configuration drift at the DR site or Region",
      },
      {
        ChoiceId: "rel_planning_for_recovery_auto_recovery",
        Description:
          "Use AWS or third-party tools to automate system recovery and route traffic to the DR site or Region.",
        Title: "Automate recovery",
      },
      {
        ChoiceId: "rel_planning_for_recovery_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.planning-for-recovery.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "reliability",
    QuestionDescription:
      "\n         Having backups and redundant workload components in place is the start of your DR strategy. RTO and RPO are your objectives for restoration of your workload. Set these based on business needs. Implement a strategy to meet these objectives, considering locations and function of workload resources and data. The probability of disruption and cost of recovery are also key factors that help to inform the business value of providing disaster recovery for a workload.\n      ",
    QuestionId: "planning-for-recovery",
    QuestionTitle: "How do you plan for disaster recovery (DR)?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Reliability_Check_Q13_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Reliability_Q13_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 16:48:28+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Cost_Optimization_Q1 = [
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "cost_cloud_financial_management_function",
        Description:
          " Create a team (Cloud Business Office or Cloud Center of Excellence) that is responsible for \n               establishing and maintaining cost awareness across your organization. The team requires people from finance, technology, and \n               business roles across the organization. \n            ",
        Title: "Establish a cost optimization function",
      },
      {
        ChoiceId: "cost_cloud_financial_management_partnership",
        Description:
          "Involve finance and technology teams in cost\n                    and usage discussions at all stages of your cloud journey. Teams regularly meet and discuss topics such\n                    as organizational goals and targets, current state of cost and usage, and financial and accounting\n                    practices.\n                ",
        Title: "Establish a partnership between finance and technology",
      },
      {
        ChoiceId: "cost_cloud_financial_management_budget_forecast",
        Description:
          "Adjust existing organizational budgeting and forecasting processes to be compatible \n               with the highly variable nature of cloud costs and usage. Processes must be dynamic using trend-based or business \n               driver-based algorithms, or a combination of both. ",
        Title: "Establish cloud budgets and forecasts",
      },
      {
        ChoiceId: "cost_cloud_financial_management_cost_awareness",
        Description:
          "Implement cost awareness into new or\n                    existing processes that impact usage, and leverage existing processes for cost awareness. Implement\n                    cost awareness into employee training.\n                ",
        Title: "Implement cost awareness in your organizational processes",
      },
      {
        ChoiceId: "cost_cloud_financial_management_usage_report",
        Description:
          "Configure AWS Budgets and AWS Cost Anomaly Detection to provide notifications \n               on cost and usage against targets. Have regular meetings to analyze your workload's cost efficiency and to promote \n               cost-aware culture.",
        Title: "Report and notify on cost optimization",
      },
      {
        ChoiceId: "cost_cloud_financial_management_culture",
        Description:
          " Implement changes or programs across your organization to create a cost-aware culture. \n               It is recommended to start small, then as your capabilities increase and your organization’s use of the cloud increases, \n               implement large and wide ranging programs. \n            ",
        Title: "Create a cost-aware culture",
      },
      {
        ChoiceId: "cost_cloud_financial_management_proactive_process",
        Description:
          "Implement tooling and dashboards to monitor cost proactively for the workload. \n               Regularly review the costs with configured tools or out of the box tools, do not just look at costs and categories \n               when you receive notifications. Monitoring and analyzing costs proactively helps to identify positive trends and \n               allows you to promote them throughout your organization.",
        Title: "Monitor cost proactively",
      },
      {
        ChoiceId: "cost_cloud_financial_management_scheduled",
        Description:
          "Consult regularly with experts or APN Partners to consider\n                    which services and features provide lower cost. Review AWS blogs and other information sources.\n                ",
        Title: "Keep up to date with new service releases",
      },
      {
        ChoiceId: "cost_cloud_financial_management_quantify_value",
        Description:
          "Quantifying business value from cost optimization allows you to understand the \n               entire set of benefits to your organization. Because cost optimization is a necessary investment, quantifying business \n               value allows you to explain the return on investment to stakeholders. Quantifying business value can help you gain \n               more buy-in from stakeholders on future cost optimization investments, and provides a framework to measure the \n               outcomes for your organization’s cost optimization activities. ",
        Title: "Quantify business value from cost optimization",
      },
      {
        ChoiceId: "cost_cloud_financial_management_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "costOptimization",
    QuestionId: "cloud-financial-management",
    QuestionTitle: "How do you implement cloud financial management?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "cost_govern_usage_policies",
        Description:
          "Develop policies that define how resources\n               are managed by your organization. Policies should cover cost aspects of resources and workloads,\n               including creation, modification, and decommission over the resource lifetime.\n\t\t\t   ",
        Title: "Develop policies based on your organization requirements",
      },
      {
        ChoiceId: "cost_govern_usage_goal_target",
        Description:
          "Implement both cost and usage goals and targets for your workload. \n               Goals provide direction to your organization on expected outcomes, and targets provide specific \n               measurable outcomes to be achieved for your workloads.\n            ",
        Title: "Implement goals and targets",
      },
      {
        ChoiceId: "cost_govern_usage_account_structure",
        Description:
          "Implement a structure of accounts that maps to your organization. This assists in allocating and\n\t\t\t\tmanaging costs throughout your organization.",
        Title: "Implement an account structure",
      },
      {
        ChoiceId: "cost_govern_usage_track_lifecycle",
        Description:
          "Track, measure, and audit the lifecycle of projects, teams, and environments to\n               avoid using and paying for unnecessary resources.",
        Title: "Track project lifecycle",
      },
      {
        ChoiceId: "cost_govern_usage_groups_roles",
        Description:
          "Implement groups and roles that align to your policies and control who\n               can create, modify, or decommission instances and resources in each group. For example, implement\n               development, test, and production groups. This applies to AWS services and third-party solutions.",
        Title: "Implement groups and roles",
      },
      {
        ChoiceId: "cost_govern_usage_controls",
        Description:
          "Implement controls based on organization policies and defined groups and\n               roles. These certify that costs are only incurred as defined by organization requirements such as control \n               access to regions or resource types.\n            ",
        Title: "Implement cost controls",
      },
      {
        ChoiceId: "cost_govern_usage_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "costOptimization",
    QuestionId: "govern-usage",
    QuestionTitle: "How do you govern usage?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "cost_monitor_usage_detailed_source",
        Description:
          "Configure the AWS Cost and Usage Report, and Cost Explorer\n               hourly granularity, to provide detailed cost and usage information. Configure your workload to have log\n               entries for every delivered business outcome.",
        Title: "Configure detailed information sources",
      },
      {
        ChoiceId: "cost_monitor_usage_define_attribution",
        Description:
          "Identify organization categories that could be used to allocate cost\n               within your organization.",
        Title: "Identify cost attribution categories",
      },
      {
        ChoiceId: "cost_monitor_usage_define_kpi",
        Description:
          "Establish the organization metrics that are required for this workload.\n               Example metrics of a workload are customer reports produced or web pages served to customers.",
        Title: "Establish organization metrics",
      },
      {
        ChoiceId: "cost_monitor_usage_config_tools",
        Description:
          "Configure cost management tools in line with your organization policies to \n               manage and optimize cloud spend. This includes services, tools, and resources to organize and track cost and \n               usage data, enhance control through consolidated billing and access permission, improve planning through \n               budgeting and forecasts, receive notifications or alerts, and further lower cost with resources and pricing \n               optimizations. \n            ",
        Title: "Configure billing and cost management tools",
      },
      {
        ChoiceId: "cost_monitor_usage_allocate_outcome",
        Description:
          "Allocate the workload's costs by metrics or business\n               outcomes to measure workload cost efficiency. Implement a process to analyze the AWS Cost and Usage\n               Report with Amazon Athena, which can provide insight and charge back capability.",
        Title: "Allocate costs based on workload metrics",
      },
      {
        ChoiceId: "cost_monitor_usage_org_information",
        Description:
          "Define a tagging schema based on your organization, workload attributes, \n               and cost allocation categories so that you can filter and search for resources or monitor cost and usage \n               in cost management tools. Implement consistent tagging across all resources where possible by purpose, \n               team, environment, or other criteria relevant to your business. \n            ",
        Title: "Add organization information to cost and usage",
      },
      {
        ChoiceId: "cost_monitor_usage_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "costOptimization",
    QuestionId: "monitor-usage",
    QuestionTitle: "How do you monitor usage and cost?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "cost_decomissioning_resources_track",
        Description:
          "Define and implement a method to track resources and their\n               associations with systems over their life time. You can use tagging to identify the workload or function\n               of the resource.",
        Title: "Track resources over their life time",
      },
      {
        ChoiceId: "cost_decomissioning_resources_implement_process",
        Description:
          "Implement a process to identify and decommission unused\n               resources.",
        Title: "Implement a decommissioning process",
      },
      {
        ChoiceId: "cost_decomissioning_resources_decomm_automated",
        Description:
          "Design your workload to gracefully handle resource\n               termination as you identify and decommission non-critical resources, resources that are not required, or\n               resources with low utilization.",
        Title: "Decommission resources automatically",
      },
      {
        ChoiceId: "cost_decomissioning_resources_decommission",
        Description:
          "Decommission resources triggered by events such as periodic audits or\n               changes in usage. Decommissioning is typically performed periodically, and can be manual or automated.",
        Title: "Decommission resources",
      },
      {
        ChoiceId: "cost_decomissioning_resources_data_retention",
        Description:
          "Define data retention policies on supported resources to handle object \n               deletion per your organizations’ requirements. Identify and delete unnecessary or orphaned resources and \n               objects that are no longer required. ",
        Title: "Enforce data retention policies",
      },
      {
        ChoiceId: "cost_decomissioning_resources_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "costOptimization",
    QuestionId: "decomissioning-resources",
    QuestionTitle: "How do you decommission resources?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "cost_select_service_thorough_analysis",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "cost_select_service_licensing",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "cost_select_service_select_for_cost",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "cost_select_service_requirements",
        Description:
          "Work with team members to define the balance between\n               cost optimization and other pillars, such as performance and reliability, for this workload.",
        Title: "Identify organization requirements for cost",
      },
      {
        ChoiceId: "cost_select_service_analyze_all",
        Description:
          " Verify every workload component is analyzed, regardless of current \n               size or current costs. The review effort should reflect the potential benefit, such as current and \n               projected costs. ",
        Title: "Analyze all components of this workload",
      },
      {
        ChoiceId: "cost_select_service_thorough_analysis",
        Description:
          " Look at overall cost to the organization of each component. Calculate \n               the total cost of ownership by factoring in cost of operations and management, especially when using managed \n               services by cloud provider. The review effort should reflect potential benefit (for example, time spent \n               analyzing is proportional to component cost). ",
        Title: "Perform a thorough analysis of each component",
      },
      {
        ChoiceId: "cost_select_service_licensing",
        Description:
          "Open source software will eliminate software licensing\n               costs, which can contribute significant costs to workloads. Where licensed software is required, avoid\n               licenses bound to arbitrary attributes such as CPUs, look for licenses that are bound to output or\n               outcomes. The cost of these licenses scales more closely to the benefit they provide.\n            ",
        Title: "Select software with cost effective licensing",
      },
      {
        ChoiceId: "cost_select_service_select_for_cost",
        Description:
          "Factor in cost when selecting all components for your workload. \n               This includes using application level and managed services or serverless, containers, or event-driven \n               architecture to reduce overall cost. Minimize license costs by using open-source software, \n               software that does not have license fees, or alternatives to reduce the cost.",
        Title:
          "Select components of this workload to optimize cost in line with organization priorities",
      },
      {
        ChoiceId: "cost_select_service_analyze_over_time",
        Description:
          "Workloads can change over time. Some services or\n               features are more cost effective at different usage levels. By performing the analysis on each\n               component over time and at projected usage, you ensure the workload remains cost-effective over its\n               lifetime.",
        Title: "Perform cost analysis for different usage over time",
      },
      {
        ChoiceId: "cost_select_service_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "costOptimization",
    QuestionId: "select-service",
    QuestionTitle: "How do you evaluate cost when you select services?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "cost_select_service_thorough_analysis",
      "cost_select_service_licensing",
      "cost_select_service_select_for_cost",
    ],
  },
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "cost_type_size_number_resources_data",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "cost_type_size_number_resources_metrics",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "cost_type_size_number_resources_cost_modeling",
        Description:
          "Identify organization requirements (such as business needs and existing \n               commitments) and perform cost modeling (overall costs) of the workload and each of its components. Perform \n               benchmark activities for the workload under different predicted loads and compare the costs. The modeling \n               effort should reflect the potential benefit. For example, time spent is proportional to component cost.",
        Title: "Perform cost modeling",
      },
      {
        ChoiceId: "cost_type_size_number_resources_data",
        Description:
          "Select resource size or type based on data about the workload and resource \n               characteristics. For example, compute, memory, throughput, or write intensive. This selection is typically \n               made using a previous (on-premises) version of the workload, using documentation, or using other sources of \n               information about the workload.",
        Title: "Select resource type, size, and number based on data",
      },
      {
        ChoiceId: "cost_type_size_number_resources_metrics",
        Description:
          "Use metrics from the currently running workload to select the right size \n               and type to optimize for cost. Appropriately provision throughput, sizing, and storage for compute, storage, \n               data, and networking services. This can be done with a feedback loop such as automatic scaling or by custom \n               code in the workload.",
        Title:
          "Select resource type, size, and number automatically based on metrics",
      },
      {
        ChoiceId: "cost_type_size_number_resources_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "costOptimization",
    QuestionId: "type-size-number-resources",
    QuestionTitle:
      "How do you meet cost targets when you select resource type, size and number?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "cost_type_size_number_resources_data",
      "cost_type_size_number_resources_metrics",
    ],
  },
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "cost_pricing_model_region_cost",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "cost_pricing_model_third_party",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "cost_pricing_model_implement_models",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "cost_pricing_model_analysis",
        Description:
          "Analyze each component of the workload. Determine if the component and \n               resources will be running for extended periods (for commitment discounts) or dynamic and short-running \n               (for spot or on-demand). Perform an analysis on the workload using the recommendations in cost management \n               tools and apply business rules to those recommendations to achieve high returns.",
        Title: "Perform pricing model analysis",
      },
      {
        ChoiceId: "cost_pricing_model_implement_models",
        Description:
          " Permanently running resources should utilize reserved capacity such as \n               Savings Plans or Reserved Instances. Short-term capacity is configured to use Spot Instances, or Spot Fleet. \n               On-Demand Instances are only used for short-term workloads that cannot be interrupted and do not run long \n               enough for reserved capacity, between 25% to 75% of the period, depending on the resource type. ",
        Title: "Implement pricing models for all components of this workload",
      },
      {
        ChoiceId: "cost_pricing_model_master_analysis",
        Description:
          "Check billing and cost management tools and see recommended discounts \n               with commitments and reservations to perform regular analysis at the management account level.",
        Title: "Perform pricing model analysis at the master account level",
      },
      {
        ChoiceId: "cost_pricing_model_region_cost",
        Description:
          "Resource pricing may be different in each Region. Identify regional \n               cost differences and only deploy in Regions with higher costs to meet latency and data sovereignty \n               requirements. Factoring in Region cost helps you pay the lowest overall price for this workload.",
        Title: "Implement Regions based on cost",
      },
      {
        ChoiceId: "cost_pricing_model_third_party",
        Description:
          " Cost efficient agreements and terms ensure the cost of these \n               services scales with the benefits they provide. Select agreements and pricing that scale when they \n               provide additional benefits to your organization. ",
        Title: "Select third party agreements with cost efficient terms",
      },
      {
        ChoiceId: "cost_pricing_model_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "costOptimization",
    QuestionId: "pricing-model",
    QuestionTitle: "How do you use pricing models to reduce cost?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "cost_pricing_model_region_cost",
      "cost_pricing_model_third_party",
      "cost_pricing_model_implement_models",
    ],
  },
  {
    ChoiceAnswerSummaries: [
      {
        ChoiceId: "cost_data_transfer_modeling",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "cost_data_transfer_optimized_components",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "cost_data_transfer_modeling",
        Description:
          "Gather organization requirements and perform data transfer modeling\n               of the workload and each of its components. This identifies the lowest cost point for its current data\n               transfer requirements.",
        Title: "Perform data transfer modeling",
      },
      {
        ChoiceId: "cost_data_transfer_optimized_components",
        Description:
          " All components are selected, and architecture is designed to reduce \n               data transfer costs. This includes using components such as wide-area-network (WAN) optimization and \n               Multi-Availability Zone (AZ) configurations ",
        Title: "Select components to optimize data transfer cost",
      },
      {
        ChoiceId: "cost_data_transfer_implement_services",
        Description:
          " Implement services to reduce data transfer. For example, using a content \n               delivery network (CDN) such as Amazon CloudFront to deliver content to end users, caching layers using \n               Amazon ElastiCache, or using AWS Direct Connect instead of VPN for connectivity to AWS. ",
        Title: "Implement services to reduce data transfer costs",
      },
      {
        ChoiceId: "cost_data_transfer_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "costOptimization",
    QuestionId: "data-transfer",
    QuestionTitle: "How do you plan for data transfer charges?",
    Reason: "NONE",
    Risk: "MEDIUM",
    SelectedChoices: [
      "cost_data_transfer_modeling",
      "cost_data_transfer_optimized_components",
    ],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "cost_manage_demand_resources_cost_analysis",
        Description:
          "Analyze the demand of the workload over time. Verify that\n               the analysis covers seasonal trends and accurately represents operating conditions over the full\n               workload lifetime. Analysis effort should reflect potential benefit, for example, time spent is\n               proportional to the workload cost.",
        Title: "Perform an analysis on the workload demand",
      },
      {
        ChoiceId: "cost_manage_demand_resources_dynamic",
        Description:
          "Resources are provisioned in a planned manner. This can be demand-\n               based, such as through automatic scaling, or time-based, where demand is predictable and resources\n               are provided based on time. These methods result in the least amount of over or under-provisioning.",
        Title: "Supply resources dynamically",
      },
      {
        ChoiceId: "cost_manage_demand_resources_buffer_throttle",
        Description:
          "Buffering and throttling modify the demand on\n               your workload, smoothing out any peaks. Implement throttling when your clients perform retries.\n               Implement buffering to store the request and defer processing until a later time. Verify that your throttles\n               and buffers are designed so clients receive a response in the required time.\n            ",
        Title: "Implement a buffer or throttle to manage demand",
      },
      {
        ChoiceId: "cost_manage_demand_resources_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "costOptimization",
    QuestionId: "manage-demand-resources",
    QuestionTitle: "How do you manage demand, and supply resources?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "cost_evaluate_new_services_review_process",
        Description:
          " Develop a process that defines the criteria and process for workload \n               review. The review effort should reflect potential benefit. For example, core workloads or workloads with \n               a value of over ten percent of the bill are reviewed quarterly or every six months, while workloads below \n               ten percent are reviewed annually. ",
        Title: "Develop a workload review process",
      },
      {
        ChoiceId: "cost_evaluate_new_services_review_workload",
        Description:
          "Existing workloads are regularly reviewed based on each defined process to \n               find out if new services can be adopted, existing services can be replaced, or workloads can be re-architected.",
        Title: "Review and analyze this workload regularly",
      },
      {
        ChoiceId: "cost_evaluate_new_services_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "costOptimization",
    QuestionId: "evaluate-new-services",
    QuestionTitle: "How do you evaluate new services?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "cost_evaluate_cost_effort_automations_operations",
        Description:
          " Develop a process that defines the criteria and process for workload \n               review. The review effort should reflect potential benefit. For example, core workloads or workloads with \n               a value of over ten percent of the bill are reviewed quarterly or every six months, while workloads below \n               ten percent are reviewed annually. ",
        Title: "Perform automations for operations",
      },
      {
        ChoiceId: "cost_evaluate_cost_effort_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "costOptimization",
    QuestionId: "evaluate-cost-effort",
    QuestionTitle: "How do you evaluate the cost of effort?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
];

export const Cost_Optimization_Q1_ExecutionStatus = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 17:06:11+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Cost_Optimization_Q1_Summaries = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "cost_cloud_financial_management_function",
        Description:
          "Create a team that is responsible for establishing and\n                 maintaining cost awareness across your organization. The team requires people from finance,\n                 technology, and business roles across the organization.\n\t\t      ",
        Title: "Establish a cost optimization function",
      },
      {
        ChoiceId: "cost_cloud_financial_management_partnership",
        Description:
          "Involve finance and technology teams in cost\n                    and usage discussions at all stages of your cloud journey. Teams regularly meet and discuss topics such\n                    as organizational goals and targets, current state of cost and usage, and financial and accounting\n                    practices.\n                ",
        Title: "Establish a partnership between finance and technology",
      },
      {
        ChoiceId: "cost_cloud_financial_management_budget_forecast",
        Description:
          "Adjust existing organizational budgeting and forecasting\n                    processes to be compatible with the highly variable nature of cloud costs and usage. Processes must be\n                    dynamic using trend based or business driver-based algorithms, or a combination.\n                ",
        Title: "Establish cloud budgets and forecasts",
      },
      {
        ChoiceId: "cost_cloud_financial_management_cost_awareness",
        Description:
          "Implement cost awareness into new or\n                    existing processes that impact usage, and leverage existing processes for cost awareness. Implement\n                    cost awareness into employee training.\n                ",
        Title: "Implement cost awareness in your organizational processes",
      },
      {
        ChoiceId: "cost_cloud_financial_management_usage_report",
        Description:
          "Configure AWS Budgets to provide notifications on cost and\n                    usage against targets. Have regular meetings to analyze this workload's cost efficiency and to promote\n                    cost aware culture.",
        Title: "Report and notify on cost optimization",
      },
      {
        ChoiceId: "cost_cloud_financial_management_proactive_process",
        Description:
          "Implement tooling and dashboards to monitor cost proactively for the\n                    workload. Do not just look at costs and categories when you receive notifications. This helps to identify\n                    positive trends and promote them throughout your organization.",
        Title: "Monitor cost proactively",
      },
      {
        ChoiceId: "cost_cloud_financial_management_scheduled",
        Description:
          "Consult regularly with experts or APN Partners to consider\n                    which services and features provide lower cost. Review AWS blogs and other information sources.\n                ",
        Title: "Keep up to date with new service releases",
      },
      {
        ChoiceId: "cost_cloud_financial_management_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/wellarchitected/2022-03-31T08-00-00/TypeII/en/wellarchitected/wellarchitected.cloud-financial-management.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "costOptimization",
    QuestionDescription:
      "Implementing Cloud Financial Management enables organizations to realize business value and financial\n            success as they optimize their cost and usage and scale on AWS.",
    QuestionId: "cloud-financial-management",
    QuestionTitle: "How do you implement cloud financial management?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Cost_Optimization_Q1_Answer_Summaries = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Cost_Optimization_Q2 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "cost_govern_usage_policies",
        Description:
          "Develop policies that define how resources\n               are managed by your organization. Policies should cover cost aspects of resources and workloads,\n               including creation, modification and decommission over the resource lifetime.\n\t\t\t   ",
        Title: "Develop policies based on your organization requirements",
      },
      {
        ChoiceId: "cost_govern_usage_goal_target",
        Description:
          "Implement both cost and usage goals for your workload. Goals provide\n               direction to your organization on cost and usage, and targets provide measurable outcomes for your\n               workloads.\n            ",
        Title: "Implement goals and targets",
      },
      {
        ChoiceId: "cost_govern_usage_account_structure",
        Description:
          "Implement a structure of accounts that maps to your organization. This assists in allocating and\n\t\t\t\tmanaging costs throughout your organization.",
        Title: "Implement an account structure",
      },
      {
        ChoiceId: "cost_govern_usage_groups_roles",
        Description:
          "Implement groups and roles that align to your policies and control who\n               can create, modify, or decommission instances and resources in each group. For example, implement\n               development, test, and production groups. This applies to AWS services and third-party solutions.",
        Title: "Implement groups and roles",
      },
      {
        ChoiceId: "cost_govern_usage_controls",
        Description:
          "Implement controls based on organization policies and defined groups and\n               roles. These ensure that costs are only incurred as defined by organization requirements: for example,\n               control access to regions or resource types with IAM policies.",
        Title: "Implement cost controls",
      },
      {
        ChoiceId: "cost_govern_usage_track_lifecycle",
        Description:
          "Track, measure, and audit the lifecycle of projects, teams, and environments to\n               avoid using and paying for unnecessary resources.",
        Title: "Track project lifecycle",
      },
      {
        ChoiceId: "cost_govern_usage_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/wellarchitected/2022-03-31T08-00-00/TypeII/en/wellarchitected/wellarchitected.govern-usage.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "costOptimization",
    QuestionDescription:
      "Establish policies and mechanisms to ensure that appropriate costs are incurred\n\t\t\twhile objectives are achieved. By employing a checks-and-balances approach, you can innovate without overspending. ",
    QuestionId: "govern-usage",
    QuestionTitle: "How do you govern usage?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Cost_Optimization_Q2_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Cost_Optimization_Q2_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 17:06:11+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Cost_Optimization_Q3 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "cost_monitor_usage_detailed_source",
        Description:
          "Configure the AWS Cost and Usage Report, and Cost Explorer\n               hourly granularity, to provide detailed cost and usage information. Configure your workload to have log\n               entries for every delivered business outcome.",
        Title: "Configure detailed information sources",
      },
      {
        ChoiceId: "cost_monitor_usage_define_attribution",
        Description:
          "Identify organization categories that could be used to allocate cost\n               within your organization.",
        Title: "Identify cost attribution categories",
      },
      {
        ChoiceId: "cost_monitor_usage_define_kpi",
        Description:
          "Establish the organization metrics that are required for this workload.\n               Example metrics of a workload are customer reports produced or web pages served to customers.",
        Title: "Establish organization metrics",
      },
      {
        ChoiceId: "cost_monitor_usage_config_tools",
        Description:
          "Configure AWS Cost Explorer and AWS Budgets inline\n               with your organization policies.",
        Title: "Configure billing and cost management tools",
      },
      {
        ChoiceId: "cost_monitor_usage_org_information",
        Description:
          "Define a tagging schema based on organization, and\n               workload attributes, and cost allocation categories. Implement tagging across all resources. Use Cost\n               Categories to group costs and usage according to organization attributes.",
        Title: "Add organization information to cost and usage",
      },
      {
        ChoiceId: "cost_monitor_usage_allocate_outcome",
        Description:
          "Allocate the workload's costs by metrics or business\n               outcomes to measure workload cost efficiency. Implement a process to analyze the AWS Cost and Usage\n               Report with Amazon Athena, which can provide insight and charge back capability.",
        Title: "Allocate costs based on workload metrics",
      },
      {
        ChoiceId: "cost_monitor_usage_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/wellarchitected/2022-03-31T08-00-00/TypeII/en/wellarchitected/wellarchitected.monitor-usage.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "costOptimization",
    QuestionDescription:
      "Establish policies and procedures to monitor and appropriately allocate your\n\t\t\tcosts. This allows you to measure and improve the cost efficiency of this workload.",
    QuestionId: "monitor-usage",
    QuestionTitle: "How do you monitor usage and cost?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Cost_Optimization_Q3_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Cost_Optimization_Q3_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 17:28:43+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Cost_Optimization_Q4 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "cost_decomissioning_resources_track",
        Description:
          "Define and implement a method to track resources and their\n               associations with systems over their life time. You can use tagging to identify the workload or function\n               of the resource.",
        Title: "Track resources over their life time",
      },
      {
        ChoiceId: "cost_decomissioning_resources_implement_process",
        Description:
          "Implement a process to identify and decommission unused\n               resources.",
        Title: "Implement a decommissioning process",
      },
      {
        ChoiceId: "cost_decomissioning_resources_decomm_automated",
        Description:
          "Design your workload to gracefully handle resource\n               termination as you identify and decommission non-critical resources, resources that are not required, or\n               resources with low utilization.",
        Title: "Decommission resources automatically",
      },
      {
        ChoiceId: "cost_decomissioning_resources_decommission",
        Description:
          "Decommission resources triggered by events such as periodic audits or\n               changes in usage. Decommissioning is typically performed periodically, and can be manual or automated.",
        Title: "Decommission resources",
      },
      {
        ChoiceId: "cost_decomissioning_resources_data_retention",
        Description:
          "Define data retention policies on supported resources to handle object \n               deletion per your organizations’ requirements. Identify and delete unnecessary or orphaned resources and \n               objects that are no longer required. ",
        Title: "Enforce data retention policies",
      },
      {
        ChoiceId: "cost_decomissioning_resources_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.decomissioning-resources.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "costOptimization",
    QuestionDescription:
      "Implement change control and resource management from project inception to\n\t\t\tend-of-life. This ensures you shut down or terminate unused resources to reduce waste.",
    QuestionId: "decomissioning-resources",
    QuestionTitle: "How do you decommission resources?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Cost_Optimization_Q4_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 1,
  Failed: 8,
  Passed: 9,
};

export const Cost_Optimization_Q4_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 17:33:31+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Cost_Optimization_Q5 = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "cost_select_service_select_for_cost",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "cost_select_service_licensing",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "cost_select_service_thorough_analysis",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "cost_select_service_requirements",
        Description:
          "Work with team members to define the balance between\n               cost optimization and other pillars, such as performance and reliability, for this workload.",
        Title: "Identify organization requirements for cost",
      },
      {
        ChoiceId: "cost_select_service_analyze_all",
        Description:
          "Ensure every workload component is analyzed, regardless of\n               current size or current costs. Review effort should reflect potential benefit, such as current and\n               projected costs.",
        Title: "Analyze all components of this workload",
      },
      {
        ChoiceId: "cost_select_service_thorough_analysis",
        Description:
          "Look at overall cost to the organization of each\n               component. Look at total cost of ownership by factoring in cost of operations and management,\n               especially when using managed services. Review effort should reflect potential benefit: for example,\n               time spent analyzing is proportional to component cost.\n\t\t\t\t",
        Title: "Perform a thorough analysis of each component",
      },
      {
        ChoiceId: "cost_select_service_licensing",
        Description:
          "Open source software will eliminate software licensing\n               costs, which can contribute significant costs to workloads. Where licensed software is required, avoid\n               licenses bound to arbitrary attributes such as CPUs, look for licenses that are bound to output or\n               outcomes. The cost of these licenses scales more closely to the benefit they provide.\n            ",
        Title: "Select software with cost effective licensing",
      },
      {
        ChoiceId: "cost_select_service_select_for_cost",
        Description:
          "Factor in cost\n               when selecting all components. This includes using application level and managed services, such as\n               Amazon RDS, Amazon DynamoDB, Amazon SNS, and Amazon SES to reduce overall organization cost.\n               Use serverless and containers for compute, such as AWS Lambda, Amazon S3 for static websites, and\n               Amazon ECS. Minimize license costs by using open source software, or software that does not have\n               license fees: for example, Amazon Linux for compute workloads or migrate databases to Amazon\n               Aurora.",
        Title:
          "Select components of this workload to optimize cost in line with organization priorities",
      },
      {
        ChoiceId: "cost_select_service_analyze_over_time",
        Description:
          "Workloads can change over time. Some services or\n               features are more cost effective at different usage levels. By performing the analysis on each\n               component over time and at projected usage, you ensure the workload remains cost effective over its\n               lifetime..",
        Title: "Perform cost analysis for different usage over time",
      },
      {
        ChoiceId: "cost_select_service_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/wellarchitected/2022-03-31T08-00-00/TypeII/en/wellarchitected/wellarchitected.select-service.helpful-resources.en.html",
    ImprovementPlanUrl:
      "https://wa.aws.amazon.com/wellarchitected/2022-03-31T08-00-00/TypeII/en/wellarchitected/wellarchitected.select-service.improvement-plan.en.html",
    IsApplicable: true,
    PillarId: "costOptimization",
    QuestionDescription:
      "Amazon EC2, Amazon EBS, and Amazon S3 are building-block AWS services. Managed\n\t\t\tservices, such as Amazon RDS and Amazon DynamoDB, are higher level, or application level, AWS services. By\n\t\t\tselecting the appropriate building blocks and managed services, you can optimize this \n\t\t\tworkload for cost. For example, using managed services, you can reduce or remove\n\t\t\tmuch of your administrative and operational overhead, freeing you to work on\n\t\t\tapplications and business-related activities.",
    QuestionId: "select-service",
    QuestionTitle: "How do you evaluate cost when you select services?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "cost_select_service_select_for_cost",
      "cost_select_service_licensing",
      "cost_select_service_thorough_analysis",
    ],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Cost_Optimization_Q5_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 1,
};

export const Cost_Optimization_Q5_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 17:37:15+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Cost_Optimization_Q6 = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "cost_type_size_number_resources_data",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "cost_type_size_number_resources_metrics",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "cost_type_size_number_resources_cost_modeling",
        Description:
          "Identify organization requirements and perform cost modeling of the workload\n               and each of its components. Perform benchmark activities for the workload under different predicted\n               loads and compare the costs. The modeling effort should reflect potential benefit: for example, time\n               spent is proportional to component cost.\n\t\t\t\t",
        Title: "Perform cost modeling",
      },
      {
        ChoiceId: "cost_type_size_number_resources_data",
        Description:
          "Select resource size or type based on data about the\n               workload and resource characteristics: for example, compute, memory, throughput, or write intensive.\n               This selection is typically made using a previous version of the workload (such as an on-premises\n               version), using documentation, or using other sources of information about the workload.",
        Title: "Select resource type, size, and number based on data",
      },
      {
        ChoiceId: "cost_type_size_number_resources_metrics",
        Description:
          "Use metrics from the currently running\n               workload to select the right size and type to optimize for cost. Appropriately provision throughput,\n               sizing, and storage for services such as Amazon EC2, Amazon DynamoDB, Amazon EBS (PIOPS), Amazon\n               RDS, Amazon EMR, and networking. This can be done with a feedback loop such as automatic scaling or\n               by custom code in the workload.",
        Title:
          "Select resource type, size, and number automatically based on metrics",
      },
      {
        ChoiceId: "cost_type_size_number_resources_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/wellarchitected/2022-03-31T08-00-00/TypeII/en/wellarchitected/wellarchitected.type-size-number-resources.helpful-resources.en.html",
    ImprovementPlanUrl:
      "https://wa.aws.amazon.com/wellarchitected/2022-03-31T08-00-00/TypeII/en/wellarchitected/wellarchitected.type-size-number-resources.improvement-plan.en.html",
    IsApplicable: true,
    PillarId: "costOptimization",
    QuestionDescription:
      "Ensure that you choose the appropriate resource size and number of resources for the task at hand. You\n         minimize waste by selecting the most cost effective type, size, and number.",
    QuestionId: "type-size-number-resources",
    QuestionTitle:
      "How do you meet cost targets when you select resource type, size and number?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "cost_type_size_number_resources_data",
      "cost_type_size_number_resources_metrics",
    ],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Cost_Optimization_Q6_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Cost_Optimization_Q6_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 17:42:56+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Cost_Optimization_Q7 = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "cost_pricing_model_region_cost",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "cost_pricing_model_third_party",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "cost_pricing_model_implement_models",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "cost_pricing_model_analysis",
        Description:
          "Analyze each component of the workload. Determine if the component and \n               resources will be running for extended periods (for commitment discounts) or dynamic and short-running \n               (for spot or on-demand). Perform an analysis on the workload using the recommendations in cost management \n               tools and apply business rules to those recommendations to achieve high returns.",
        Title: "Perform pricing model analysis",
      },
      {
        ChoiceId: "cost_pricing_model_implement_models",
        Description:
          " Permanently running resources should utilize reserved capacity such as \n               Savings Plans or Reserved Instances. Short-term capacity is configured to use Spot Instances, or Spot Fleet. \n               On-Demand Instances are only used for short-term workloads that cannot be interrupted and do not run long \n               enough for reserved capacity, between 25% to 75% of the period, depending on the resource type. ",
        Title: "Implement pricing models for all components of this workload",
      },
      {
        ChoiceId: "cost_pricing_model_master_analysis",
        Description:
          "Check billing and cost management tools and see recommended discounts \n               with commitments and reservations to perform regular analysis at the management account level.",
        Title: "Perform pricing model analysis at the master account level",
      },
      {
        ChoiceId: "cost_pricing_model_region_cost",
        Description:
          "Resource pricing may be different in each Region. Identify regional \n               cost differences and only deploy in Regions with higher costs to meet latency and data sovereignty \n               requirements. Factoring in Region cost helps you pay the lowest overall price for this workload.",
        Title: "Implement Regions based on cost",
      },
      {
        ChoiceId: "cost_pricing_model_third_party",
        Description:
          " Cost efficient agreements and terms ensure the cost of these \n               services scales with the benefits they provide. Select agreements and pricing that scale when they \n               provide additional benefits to your organization. ",
        Title: "Select third party agreements with cost efficient terms",
      },
      {
        ChoiceId: "cost_pricing_model_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.pricing-model.helpful-resources.en.html",
    ImprovementPlanUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.pricing-model.improvement-plan.en.html",
    IsApplicable: true,
    PillarId: "costOptimization",
    QuestionDescription:
      "Use the pricing model that is most appropriate for your resources to minimize\n\t\t\texpense.",
    QuestionId: "pricing-model",
    QuestionTitle: "How do you use pricing models to reduce cost?",
    Reason: "NONE",
    Risk: "HIGH",
    SelectedChoices: [
      "cost_pricing_model_region_cost",
      "cost_pricing_model_third_party",
      "cost_pricing_model_implement_models",
    ],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Cost_Optimization_Q7_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Cost_Optimization_Q7_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 17:47:18+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Cost_Optimization_Q8 = {
  Answer: {
    ChoiceAnswers: [
      {
        ChoiceId: "cost_data_transfer_modeling",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
      {
        ChoiceId: "cost_data_transfer_optimized_components",
        Notes: "",
        Reason: "",
        Status: "SELECTED",
      },
    ],
    Choices: [
      {
        ChoiceId: "cost_data_transfer_modeling",
        Description:
          "Gather organization requirements and perform data transfer modeling\n               of the workload and each of its components. This identifies the lowest cost point for its current data\n               transfer requirements.",
        Title: "Perform data transfer modeling",
      },
      {
        ChoiceId: "cost_data_transfer_optimized_components",
        Description:
          "All components are selected, and architecture is\n               designed to reduce data transfer costs. This includes using components such as WAN optimization and\n               Multi-AZ configurations",
        Title: "Select components to optimize data transfer cost",
      },
      {
        ChoiceId: "cost_data_transfer_implement_services",
        Description:
          "Implement services to reduce data transfer: for\n               example, using a CDN such as Amazon CloudFront to deliver content to end users, caching layers using\n               Amazon ElastiCache, or using AWS Direct Connect instead of VPN for connectivity to AWS.",
        Title: "Implement services to reduce data transfer costs",
      },
      {
        ChoiceId: "cost_data_transfer_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/wellarchitected/2022-03-31T08-00-00/TypeII/en/wellarchitected/wellarchitected.data-transfer.helpful-resources.en.html",
    ImprovementPlanUrl:
      "https://wa.aws.amazon.com/wellarchitected/2022-03-31T08-00-00/TypeII/en/wellarchitected/wellarchitected.data-transfer.improvement-plan.en.html",
    IsApplicable: true,
    PillarId: "costOptimization",
    QuestionDescription:
      "Ensure that you plan and monitor data transfer charges so that you can make architectural\n\t\t\tdecisions to minimize costs. A small yet effective architectural change can\n\t\t\tdrastically reduce your operational costs over time. ",
    QuestionId: "data-transfer",
    QuestionTitle: "How do you plan for data transfer charges?",
    Reason: "NONE",
    Risk: "MEDIUM",
    SelectedChoices: [
      "cost_data_transfer_modeling",
      "cost_data_transfer_optimized_components",
    ],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Cost_Optimization_Q8_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Cost_Optimization_Q8_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 17:59:30+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Cost_Optimization_Q9 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "cost_manage_demand_resources_cost_analysis",
        Description:
          "Analyze the demand of the workload over time. Ensurethe analysis covers seasonal trends and accurately represents operating conditions over the fullworkload lifetime. Analysis effort should reflect potential benefit: for example, time spent isproportional to the workload cost.",
        Title: "Perform an analysis on the workload demand",
      },
      {
        ChoiceId: "cost_manage_demand_resources_buffer_throttle",
        Description:
          "Buffering and throttling modify the demand onyour workload, smoothing out any peaks. Implement throttling when your clients perform retries.Implement buffering to store the request and defer processing until a later time. Ensure your throttlesand buffers are designed so clients receive a response in the required time.\n            ",
        Title: "Implement a buffer or throttle to manage demand",
      },
      {
        ChoiceId: "cost_manage_demand_resources_dynamic",
        Description:
          "Resources are provisioned in a planned manner. This can be demand-based, such as through automatic scaling, or time-based, where demand is predictable and resourcesare provided based on time. These methods result in the least amount of over or under provisioning.",
        Title: "Supply resources dynamically",
      },
      {
        ChoiceId: "cost_manage_demand_resources_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.manage-demand-resources.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "costOptimization",
    QuestionDescription:
      "For a workload that has balanced spend and performance, ensure that\n\t\t\teverything you pay for is used and avoid significantly underutilizing instances. A\n\t\t\tskewed utilization metric in either direction has an adverse impact on your\n\t\t\torganization, in either operational costs (degraded performance due to over-utilization), or\n\t\t\twasted AWS expenditures (due to over-provisioning).",
    QuestionId: "manage-demand-resources",
    QuestionTitle: "How do you manage demand, and supply resources?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Cost_Optimization_Q9_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 2,
  Passed: 1,
};

export const Cost_Optimization_Q9_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 17:59:30+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Cost_Optimization_Q10 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "cost_evaluate_new_services_review_process",
        Description:
          "Develop a process that defines the criteria and process forworkload review. The review effort should reflect potential benefit: for example, core workloads orworkloads with a value of over 10% of the bill are reviewed quarterly, while workloads below 10% arereviewed annually.",
        Title: "Develop a workload review process",
      },
      {
        ChoiceId: "cost_evaluate_new_services_review_workload",
        Description:
          "Existing workloads are regularly reviewed as per definedprocesses.",
        Title: "Review and analyze this workload regularly",
      },
      {
        ChoiceId: "cost_evaluate_new_services_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.evaluate-new-services.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "costOptimization",
    QuestionDescription:
      "As AWS releases new services and features, it's a best practice to review your\n\t\t\texisting architectural decisions to ensure they continue to be the most cost\n\t\t\teffective.",
    QuestionId: "evaluate-new-services",
    QuestionTitle: "How do you evaluate new services?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Cost_Optimization_Q11 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "cost_evaluate_cost_effort_automations_operations",
        Description:
          " Develop a process that defines the criteria and process for workload \n               review. The review effort should reflect potential benefit. For example, core workloads or workloads with \n               a value of over ten percent of the bill are reviewed quarterly or every six months, while workloads below \n               ten percent are reviewed annually. ",
        Title: "Perform automations for operations",
      },
      {
        ChoiceId: "cost_evaluate_cost_effort_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.evaluate-cost-effort.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "costOptimization",
    QuestionDescription:
      "As AWS releases new services and features, it's a best practice to evaluate the cost of effort\n      to implement new services.",
    QuestionId: "evaluate-cost-effort",
    QuestionTitle: "How do you evaluate the cost of effort?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};
export const Cost_Optimization_Q11_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};
export const Cost_Optimization_Q10_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Cost_Optimization_Q10_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 18:09:39+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Operational_Excellence_Q1 = [
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_priorities_ext_cust_needs",
        Description:
          "\n               Involve key stakeholders, including business, development, and operations teams, to determine where to focus efforts on external customer needs.\n               This will ensure that you have a thorough understanding of the operations support that is required to achieve your desired business outcomes.\n            ",
        Title: "Evaluate external customer needs",
      },
      {
        ChoiceId: "ops_priorities_int_cust_needs",
        Description:
          "\n               Involve key stakeholders, including business, development, and operations teams, when determining where to focus efforts on internal customer needs.\n               This will ensure that you have a thorough understanding of the operations support that is required to achieve business outcomes.\n            ",
        Title: "Evaluate internal customer needs",
      },
      {
        ChoiceId: "ops_priorities_governance_reqs",
        Description:
          "\n               Ensure that you are aware of guidelines or obligations defined by your organization that may mandate or emphasize specific focus. Evaluate internal factors, such as organization policy, standards, and requirements. Validate that you have mechanisms to identify changes to governance. If no governance requirements are identified, ensure that you have applied due diligence to this determination.\n            ",
        Title: "Evaluate governance requirements",
      },
      {
        ChoiceId: "ops_priorities_compliance_reqs",
        Description:
          "\n               Evaluate external factors, such as regulatory compliance requirements and industry standards, \n               to ensure that you are aware of guidelines or obligations that may mandate or emphasize specific focus.\n               If no compliance requirements are identified, ensure that you apply due diligence to this determination.\n            ",
        Title: "Evaluate compliance requirements",
      },
      {
        ChoiceId: "ops_priorities_eval_threat_landscape",
        Description:
          "\n               Evaluate threats to the business (for example, competition, business risk and liabilities, operational risks, and information security threats) and maintain current information in a risk registry. Include the impact of risks when determining where to focus efforts.\n            ",
        Title: "Evaluate threat landscape",
      },
      {
        ChoiceId: "ops_priorities_eval_tradeoffs",
        Description:
          "\n               Evaluate the impact of tradeoffs between competing interests or alternative approaches, to help make informed decisions when determining where to focus efforts or choosing a course of action. For example, accelerating speed to market for new features may be emphasized over cost optimization, or you may choose a relational database for non-relational data to simplify the effort to migrate a system, rather than migrating to a database optimized for your data type and updating your application.\n            ",
        Title: "Evaluate tradeoffs",
      },
      {
        ChoiceId: "ops_priorities_manage_risk_benefit",
        Description:
          "\n               Manage benefits and risks to make informed decisions when determining where to focus efforts. For example, it may be beneficial to deploy a workload with unresolved issues so that significant new features can be made available to customers. It may be possible to mitigate associated risks, or it may become unacceptable to allow a risk to remain, in which case you will take action to address the risk.\n            ",
        Title: "Manage benefits and risks",
      },
      {
        ChoiceId: "ops_priorities_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "priorities",
    QuestionTitle: "How do you determine what your priorities are?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_ops_model_def_resource_owners",
        Description:
          "\n               Understand who has ownership of each application, workload, platform, and infrastructure component, what business value is provided by that component, and why that ownership exists. Understanding the business value of these individual components and how they support business outcomes informs the processes and procedures applied against them.\n            ",
        Title: "Resources have identified owners",
      },
      {
        ChoiceId: "ops_ops_model_def_proc_owners",
        Description:
          "\n               Understand who has ownership of the definition of individual processes and procedures, why those specific process and procedures are used, and why that ownership exists. Understanding the reasons that specific processes and procedures are used enables identification of improvement opportunities. \n            ",
        Title: "Processes and procedures have identified owners",
      },
      {
        ChoiceId: "ops_ops_model_def_activity_owners",
        Description:
          "\n               Understand who has responsibility to perform specific activities on defined workloads and why that responsibility exists. Understanding who has responsibility to perform activities informs who will conduct the activity, validate the result, and provide feedback to the owner of the activity.\n            ",
        Title:
          "Operations activities have identified owners responsible for their performance",
      },
      {
        ChoiceId: "ops_ops_model_know_my_job",
        Description:
          "\n               Understanding the responsibilities of your role and how you contribute to business outcomes informs the prioritization of your tasks and why your role is important. This enables team members to recognize needs and respond appropriately.\n            ",
        Title: "Team members know what they are responsible for",
      },
      {
        ChoiceId: "ops_ops_model_find_owner",
        Description:
          "\n               Where no individual or team is identified, there are defined escalation paths to someone with the authority to assign ownership or plan for that need to be addressed.\n            ",
        Title: "Mechanisms exist to identify responsibility and ownership",
      },
      {
        ChoiceId: "ops_ops_model_req_add_chg_exception",
        Description:
          "\n               You are able to make requests to owners of processes, procedures, and resources. Make informed decisions to approve requests where viable and determined to be appropriate after an evaluation of benefits and risks.\n            ",
        Title: "Mechanisms exist to request additions, changes, and exceptions",
      },
      {
        ChoiceId: "ops_ops_model_def_neg_team_agreements",
        Description:
          "\n               There are defined or negotiated agreements between teams describing how they work with and support each other (for example, response times, service level objectives, or service level agreements). Understanding the impact of the teams’ work on business outcomes, and the outcomes of other teams and organizations, informs the prioritization of their tasks and enables them to respond appropriately.\n            ",
        Title: "Responsibilities between teams are predefined or negotiated",
      },
      {
        ChoiceId: "ops_ops_model_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "ops-model",
    QuestionTitle:
      "How do you structure your organization to support your business outcomes?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_org_culture_executive_sponsor",
        Description:
          "\n               Senior leadership clearly sets expectations for the organization and evaluates success. Senior leadership is the sponsor, advocate, and driver for the adoption of best practices and evolution of the organization\n            ",
        Title: "Executive Sponsorship",
      },
      {
        ChoiceId: "ops_org_culture_team_emp_take_action",
        Description:
          "\n               The workload owner has defined guidance and scope empowering team members to respond when outcomes are at risk. Escalation mechanisms are used to get direction when events are outside of the defined scope.\n            ",
        Title:
          "Team members are empowered to take action when outcomes are at risk",
      },
      {
        ChoiceId: "ops_org_culture_team_enc_escalation",
        Description:
          "\n               Team members have mechanisms and are encouraged to escalate concerns to decision makers and stakeholders if they believe outcomes are at risk. Escalation should be performed early and often so that risks can be identified, and prevented from causing incidents.\n            ",
        Title: "Escalation is encouraged",
      },
      {
        ChoiceId: "ops_org_culture_effective_comms",
        Description:
          "\n               Mechanisms exist and are used to provide timely notice to team members of known risks and planned events. Necessary context, details, and time (when possible) are provided to support determining if action is necessary, what action is required, and to take action in a timely manner. For example, providing notice of software vulnerabilities so that patching can be expedited, or providing notice of planned sales promotions so that a change freeze can be implemented to avoid the risk of service disruption.\n            ",
        Title: "Communications are timely, clear, and actionable",
      },
      {
        ChoiceId: "ops_org_culture_team_enc_experiment",
        Description:
          "\n               Experimentation accelerates learning and keeps team members interested and engaged. An undesired result is a successful experiment that has identified a path that will not lead to success. Team members are not punished for successful experiments with undesired results. Experimentation is required for innovation to happen and turn ideas into outcomes.\n            ",
        Title: "Experimentation is encouraged",
      },
      {
        ChoiceId: "ops_org_culture_team_enc_learn",
        Description:
          "\n               Teams must grow their skill sets to adopt new technologies, and to support changes in demand and responsibilities in support of your workloads. Growth of skills in new technologies is frequently a source of team member satisfaction and supports innovation. Support your team members’ pursuit and maintenance of industry certifications that validate and acknowledge their growing skills. Cross train to promote knowledge transfer and reduce the risk of significant impact when you lose skilled and experienced team members with institutional knowledge. Provide dedicated structured time for learning.\n            ",
        Title:
          "Team members are enabled and encouraged to maintain and grow their skill sets",
      },
      {
        ChoiceId: "ops_org_culture_team_res_appro",
        Description:
          "\n               Maintain team member capacity, and provide tools and resources, to support your workload needs. Overtasking team members increases the risk of incidents resulting from human error. Investments in tools and resources (for example, providing automation for frequently executed activities) can scale the effectiveness of your team, enabling them to support additional activities.\n            ",
        Title: "Resource teams appropriately",
      },
      {
        ChoiceId: "ops_org_culture_diverse_inc_access",
        Description:
          "\n               Leverage cross-organizational diversity to seek multiple unique perspectives. Use this perspective to increase innovation, challenge your assumptions, and reduce the risk of confirmation bias. Grow inclusion, diversity, and accessibility within your teams to gain beneficial perspectives.\n            ",
        Title:
          "Diverse opinions are encouraged and sought within and across teams",
      },
      {
        ChoiceId: "ops_org_culture_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "org-culture",
    QuestionTitle:
      "How does your organizational culture support your business outcomes?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_telemetry_application_telemetry",
        Description:
          "\n               Instrument your application code to emit information about its internal state, status, and achievement of business outcomes. For example, queue depth, error messages, and response times. Use this information to determine when a response is required.\n            ",
        Title: "Implement application telemetry",
      },
      {
        ChoiceId: "ops_telemetry_workload_telemetry",
        Description:
          "\n               Design and configure your workload to emit information about its internal state and current status. For example, API call volume, HTTP status codes, and scaling events. Use this information to help determine when a response is required.\n            ",
        Title: "Implement and configure workload telemetry",
      },
      {
        ChoiceId: "ops_telemetry_customer_telemetry",
        Description:
          "\n               Instrument your application code to emit information about user activity, for example, click streams, or started, abandoned, and completed transactions. Use this information to help understand how the application is used, patterns of usage, and to determine when a response is required.\n            ",
        Title: "Implement user activity telemetry",
      },
      {
        ChoiceId: "ops_telemetry_dependency_telemetry",
        Description:
          "\n               Design and configure your workload to emit information about the status (for example, reachability or response time) of resources it depends on. Examples of external dependencies can include, external databases, DNS, and network connectivity. Use this information to determine when a response is required.\n            ",
        Title: "Implement dependency telemetry",
      },
      {
        ChoiceId: "ops_telemetry_dist_trace",
        Description:
          "\n               Implement your application code and configure your workload components to emit information about the flow of transactions across the workload. Use this information to determine when a response is required and to assist you in identifying the factors contributing to an issue.\n            ",
        Title: "Implement transaction traceability",
      },
      {
        ChoiceId: "ops_telemetry_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "telemetry",
    QuestionTitle:
      "How do you design your workload so that you can understand its state?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_dev_integ_version_control",
        Description:
          "\n               Use version control to enable tracking of changes and releases.\n            ",
        Title: "Use version control",
      },
      {
        ChoiceId: "ops_dev_integ_test_val_chg",
        Description:
          "\n               Test and validate changes to help limit and detect errors.\n               Automate testing to reduce errors caused by manual processes, and reduce the level of effort to test.\n            ",
        Title: "Test and validate changes",
      },
      {
        ChoiceId: "ops_dev_integ_conf_mgmt_sys",
        Description:
          "\n               Use configuration management systems to make and track configuration changes. \n               These systems reduce errors caused by manual processes and reduce the level of effort to deploy changes. \n            ",
        Title: "Use configuration management systems",
      },
      {
        ChoiceId: "ops_dev_integ_build_mgmt_sys",
        Description:
          "\n               Use build and deployment management systems.\n               These systems reduce errors caused by manual processes and reduce the level of effort to deploy changes. \n            ",
        Title: "Use build and deployment management systems",
      },
      {
        ChoiceId: "ops_dev_integ_patch_mgmt",
        Description:
          "\n               Perform patch management to gain features, address issues, and remain compliant with governance. \n               Automate patch management to reduce errors caused by manual processes, and reduce the level of effort to patch.\n            ",
        Title: "Perform patch management",
      },
      {
        ChoiceId: "ops_dev_integ_share_design_stds",
        Description:
          "\n               Share best practices across teams \n               to increase awareness \n               and maximize the benefits of development efforts.\n            ",
        Title: "Share design standards",
      },
      {
        ChoiceId: "ops_dev_integ_code_quality",
        Description:
          "\n               Implement practices \n               to improve code quality \n               and minimize defects. \n               For example, test-driven development, code reviews, and standards adoption.\n            ",
        Title: "Implement practices to improve code quality",
      },
      {
        ChoiceId: "ops_dev_integ_multi_env",
        Description:
          "\n               Use multiple environments to experiment, develop, and test your workload. Use increasing levels of controls as environments approach production to gain confidence your workload will operate as intended when deployed.\n            ",
        Title: "Use multiple environments",
      },
      {
        ChoiceId: "ops_dev_integ_freq_sm_rev_chg",
        Description:
          "\n               Frequent, small, and reversible changes reduce the scope and impact of a change.\n               This eases troubleshooting, enables faster remediation, and provides the option to roll back a change.\n            ",
        Title: "Make frequent, small, reversible changes",
      },
      {
        ChoiceId: "ops_dev_integ_auto_integ_deploy",
        Description:
          "\n               Automate build, deployment, and testing of the workload. \n               This reduces errors caused by manual processes and reduces the effort to deploy changes.\n            ",
        Title: "Fully automate integration and deployment",
      },
      {
        ChoiceId: "ops_dev_integ_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "dev-integ",
    QuestionTitle:
      "How do you reduce defects, ease remediation, and improve flow into production?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_mit_deploy_risks_plan_for_unsucessful_changes",
        Description:
          "\n               Plan to revert to a known good state, \n               or remediate in the production environment \n               if a change does not have the desired outcome.\n               This preparation reduces recovery time through faster responses.\n            ",
        Title: "Plan for unsuccessful changes",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_test_val_chg",
        Description:
          "\n               Test changes and validate the results at all lifecycle stages to confirm new features and minimize the risk and impact of failed deployments.\n            ",
        Title: "Test and validate changes",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_deploy_mgmt_sys",
        Description:
          "\n               Use deployment management systems \n               to track and implement change. \n               This reduces errors cause by manual processes and reduces the effort to deploy changes.\n            ",
        Title: "Use deployment management systems",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_test_limited_deploy",
        Description:
          "\n               Test with limited deployments alongside existing systems \n               to confirm desired outcomes prior to full scale deployment.\n               For example, use deployment canary testing or one-box deployments.\n            ",
        Title: "Test using limited deployments",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_deploy_to_parallel_env",
        Description:
          "\n               Implement changes onto parallel environments, and then transition over to the new environment. Maintain the prior environment until there is confirmation of successful deployment. Doing so minimizes recovery time by enabling rollback to the previous environment.\n            ",
        Title: "Deploy using parallel environments",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_freq_sm_rev_chg",
        Description:
          "\n               Use frequent, small, and reversible changes to reduce the scope of a change.\n               This results in easier troubleshooting and faster remediation with the option to roll back a change.\n            ",
        Title: "Deploy frequent, small, reversible changes",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_auto_integ_deploy",
        Description:
          "\n               Automate build, deployment, and testing of the workload. \n               This reduces errors cause by manual processes and reduces the effort to deploy changes.\n            ",
        Title: "Fully automate integration and deployment",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_auto_testing_and_rollback",
        Description:
          "\n               Automate testing of deployed environments to confirm desired outcomes.\n               Automate rollback to previous known good state when outcomes are not achieved to minimize recovery time and reduce errors caused by manual processes.\n            ",
        Title: "Automate testing and rollback",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "mit-deploy-risks",
    QuestionTitle: "How do you mitigate deployment risks?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_ready_to_support_personnel_capability",
        Description:
          "\n               Have a mechanism to validate that you have the appropriate number of trained personnel to provide support for operational needs. Train personnel and adjust personnel capacity as necessary to maintain effective support.\n            ",
        Title: "Ensure personnel capability",
      },
      {
        ChoiceId: "ops_ready_to_support_const_orr",
        Description:
          "\n               Ensure you have a consistent review of your readiness to operate a workload. Reviews must include, at a minimum, the operational readiness of the teams and the workload, and security requirements. Implement review activities in code and trigger automated review in response to events where appropriate, to ensure consistency, speed of execution, and reduce errors caused by manual processes.\n            ",
        Title: "Ensure consistent review of operational readiness",
      },
      {
        ChoiceId: "ops_ready_to_support_use_runbooks",
        Description:
          "\n               Runbooks are documented procedures to achieve specific outcomes. \n               Enable consistent and prompt responses to well-understood events by documenting procedures in runbooks. \n               Implement runbooks as code and trigger the execution of runbooks in response to events where appropriate,\n               to ensure consistency, speed responses, and reduce errors caused by manual processes.\n            ",
        Title: "Use runbooks to perform procedures",
      },
      {
        ChoiceId: "ops_ready_to_support_use_playbooks",
        Description:
          "\n               Enable consistent and prompt responses to issues that are not well understood, by documenting the investigation process in playbooks. Playbooks are the predefined steps performed to identify the factors contributing to a failure scenario. The results from any process step are used to determine the next steps to take until the issue is identified or escalated.\n            ",
        Title: "Use playbooks to investigate issues",
      },
      {
        ChoiceId: "ops_ready_to_support_informed_deploy_decisions",
        Description:
          "\n               Evaluate the capabilities of the team to support the workload and the workload's compliance with governance.\n               Evaluate these against the benefits of deployment when determining whether to transition a system or change into production.\n               Understand the benefits and risks to make informed decisions.\n            ",
        Title: "Make informed decisions to deploy systems and changes",
      },
      {
        ChoiceId: "ops_ready_to_support_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "ready-to-support",
    QuestionTitle: "How do you know that you are ready to support a workload?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_workload_health_define_workload_kpis",
        Description:
          "\n               Identify key performance indicators (KPIs) based on desired business outcomes (for example, order rate, customer retention rate, and profit versus operating expense) and customer outcomes (for example, customer satisfaction). Evaluate KPIs to determine workload success.\n            ",
        Title: "Identify key performance indicators",
      },
      {
        ChoiceId: "ops_workload_health_design_workload_metrics",
        Description:
          "\n               Define workload metrics to measure the achievement of KPIs (for example, abandoned shopping carts, orders placed, cost, price, and allocated workload expense). Define workload metrics to measure the health of the workload (for example, interface response time, error rate, requests made, requests completed, and utilization). Evaluate metrics to determine if the workload is achieving desired outcomes, and to understand the health of the workload.\n            ",
        Title: "Define workload metrics",
      },
      {
        ChoiceId: "ops_workload_health_collect_analyze_workload_metrics",
        Description:
          "\n               Perform regular proactive reviews of metrics\n               to identify trends and determine where appropriate responses are needed.\n            ",
        Title: "Collect and analyze workload metrics",
      },
      {
        ChoiceId: "ops_workload_health_workload_metric_baselines",
        Description:
          "\n               Establish baselines for metrics to provide expected values as the basis for comparison and identification of under and over performing components. Identify thresholds for improvement, investigation, and intervention.\n            ",
        Title: "Establish workload metrics baselines",
      },
      {
        ChoiceId: "ops_workload_health_learn_workload_usage_patterns",
        Description:
          "\n               Establish patterns of workload activity to identify anomalous behavior so that you can respond appropriately if required.\n            ",
        Title: "Learn expected patterns of activity for workload",
      },
      {
        ChoiceId: "ops_workload_health_workload_outcome_alerts",
        Description:
          "\n               Raise an alert when workload outcomes are at risk so that you can respond appropriately if necessary.\n            ",
        Title: "Alert when workload outcomes are at risk",
      },
      {
        ChoiceId: "ops_workload_health_workload_anomaly_alerts",
        Description:
          "\n               Raise an alert when workload anomalies are detected so that you can respond appropriately if necessary.\n            ",
        Title: "Alert when workload anomalies are detected",
      },
      {
        ChoiceId: "ops_workload_health_biz_level_view_workload",
        Description:
          "\n               Create a business-level view of your workload operations\n               to help you determine if you are satisfying needs and \n               to identify areas that need improvement to reach business goals.\n               Validate the effectiveness of KPIs and metrics \n               and revise them if necessary.\n            ",
        Title:
          "\n               Validate the achievement of outcomes and the effectiveness of KPIs and metrics\n            ",
      },
      {
        ChoiceId: "ops_workload_health_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "workload-health",
    QuestionTitle: "How do you understand the health of your workload?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_operations_health_define_ops_kpis",
        Description:
          "\n               Identify key performance indicators (KPIs) based on desired business (for example, new features delivered) and customer outcomes (for example, customer support cases). Evaluate KPIs to determine operations success.\n            ",
        Title: "Identify key performance indicators",
      },
      {
        ChoiceId: "ops_operations_health_design_ops_metrics",
        Description:
          "\n               Define operations metrics to measure the achievement of KPIs (for example, successful deployments, and failed deployments). Define operations metrics to measure the health of operations activities (for example, mean time to detect an incident (MTTD), and mean time to recovery (MTTR) from an incident). Evaluate metrics to determine if operations are achieving desired outcomes, and to understand the health of your operations activities.\n            ",
        Title: "Define operations metrics",
      },
      {
        ChoiceId: "ops_operations_health_collect_analyze_ops_metrics",
        Description:
          "\n               Perform regular, proactive reviews of metrics to identify trends and determine where appropriate responses are needed.\n            ",
        Title: "Collect and analyze operations metrics",
      },
      {
        ChoiceId: "ops_operations_health_ops_metric_baselines",
        Description:
          "\n               Establish baselines for metrics to provide expected values as the basis for comparison and identification of under and over performing operations activities.\n            ",
        Title: "Establish operations metrics baselines",
      },
      {
        ChoiceId: "ops_operations_health_learn_ops_usage_patterns",
        Description:
          "\n               Establish patterns of operations activities to identify anomalous activity so that you can respond appropriately if necessary.\n            ",
        Title: "Learn the expected patterns of activity for operations",
      },
      {
        ChoiceId: "ops_operations_health_ops_outcome_alerts",
        Description:
          "\n               Raise an alert when operations outcomes are at risk so that you can respond appropriately if necessary.\n            ",
        Title: "Alert when operations outcomes are at risk",
      },
      {
        ChoiceId: "ops_operations_health_ops_anomaly_alerts",
        Description:
          "\n               Raise an alert when operations anomalies are detected so that you can respond appropriately if necessary.\n            ",
        Title: "Alert when operations anomalies are detected",
      },
      {
        ChoiceId: "ops_operations_health_biz_level_view_ops",
        Description:
          "\n               Create a business-level view of your operations activities\n               to help you determine if you are satisfying needs and \n               to identify areas that need improvement to reach business goals.\n               Validate the effectiveness of KPIs and metrics \n               and revise them if necessary.\n            ",
        Title:
          "\n               Validate the achievement of outcomes and the effectiveness of KPIs and metrics\n            ",
      },
      {
        ChoiceId: "ops_operations_health_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "operations-health",
    QuestionTitle: "How do you understand the health of your operations?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_event_response_event_incident_problem_process",
        Description:
          "\n               Have processes to address observed events, events that require intervention (incidents), \n               and events that require intervention and either recur or cannot currently be resolved (problems). \n               Use these processes to mitigate the impact of these events on the business and your customers \n               by ensuring timely and appropriate responses.\n            ",
        Title: "Use processes for event, incident, and problem management",
      },
      {
        ChoiceId: "ops_event_response_process_per_alert",
        Description:
          "\n               Have a well-defined response (runbook or playbook), \n               with a specifically identified owner, \n               for any event for which you raise an alert.\n               This ensures effective and prompt responses to operations events \n               and prevents actionable events from being obscured by less valuable notifications.\n            ",
        Title: "Have a process per alert",
      },
      {
        ChoiceId: "ops_event_response_prioritize_events",
        Description:
          "\n               Ensure that when multiple events require intervention, \n               those that are most significant to the business are addressed first.\n               For example, impacts can include loss of life or injury, financial loss, or damage to reputation or trust.\n            ",
        Title: "Prioritize operational events based on business impact",
      },
      {
        ChoiceId: "ops_event_response_define_escalation_paths",
        Description:
          "\n               Define escalation paths in your runbooks and playbooks, \n               including what triggers escalation, and\n               procedures for escalation. \n               Specifically identify owners for each action \n               to ensure effective and prompt responses to operations events.\n            ",
        Title: "Define escalation paths",
      },
      {
        ChoiceId: "ops_event_response_push_notify",
        Description:
          "\n               Communicate directly with your users (for example, with email or SMS) when the services they use are impacted, and again when the services return to normal operating conditions, to enable users to take appropriate action.\n            ",
        Title: "Enable push notifications",
      },
      {
        ChoiceId: "ops_event_response_dashboards",
        Description:
          "\n               Provide dashboards tailored to their target audiences (for example, internal technical teams, leadership, and customers)\n               to communicate the current operating status of the business and provide metrics of interest. \n            ",
        Title: "Communicate status through dashboards",
      },
      {
        ChoiceId: "ops_event_response_auto_event_response",
        Description:
          "\n               Automate responses to events to reduce errors caused by manual processes, and to ensure prompt and consistent responses. \n            ",
        Title: "Automate responses to events",
      },
      {
        ChoiceId: "ops_event_response_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "event-response",
    QuestionTitle: "How do you manage workload and operations events?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_evolve_ops_process_cont_imp",
        Description:
          "\n               Regularly evaluate and prioritize opportunities for improvement\n               to focus efforts where they can provide the greatest benefits.\n            ",
        Title: "Have a process for continuous improvement",
      },
      {
        ChoiceId: "ops_evolve_ops_perform_rca_process",
        Description:
          "\n               Review customer-impacting events, and identify the contributing factors\n               and preventative actions. Use this information to develop mitigations to limit or prevent recurrence. Develop procedures for prompt and effective responses. Communicate contributing factors and corrective actions as appropriate, tailored to target audiences.\n            ",
        Title: "Perform post-incident analysis",
      },
      {
        ChoiceId: "ops_evolve_ops_feedback_loops",
        Description:
          "\n               Include feedback loops in your procedures and workloads\n               to help you identify issues and areas that need improvement.\n            ",
        Title: "Implement feedback loops",
      },
      {
        ChoiceId: "ops_evolve_ops_knowledge_management",
        Description:
          "\n               Mechanisms exist for your team members to discover the information that they are looking for in a timely manner, access it, and identify that it’s current and complete. Mechanisms are present to identify needed content, content in need of refresh, and content that should be archived so that it’s no longer referenced.\n            ",
        Title: "Perform Knowledge Management",
      },
      {
        ChoiceId: "ops_evolve_ops_drivers_for_imp",
        Description:
          "\n               Identify drivers for improvement \n               to help you evaluate and prioritize opportunities.\n            ",
        Title: "Define drivers for improvement",
      },
      {
        ChoiceId: "ops_evolve_ops_validate_insights",
        Description:
          "\n               Review your analysis results and responses with cross-functional teams and business owners. \n               Use these reviews to establish common understanding, identify additional impacts, and determine courses of action. \n               Adjust responses as appropriate.\n            ",
        Title: "Validate insights",
      },
      {
        ChoiceId: "ops_evolve_ops_metrics_review",
        Description:
          "\n               Regularly perform retrospective analysis of operations metrics with cross-team participants from different areas of the business. \n               Use these reviews to identify opportunities for improvement, potential courses of action, and to share lessons learned.\n            ",
        Title: "Perform operations metrics reviews",
      },
      {
        ChoiceId: "ops_evolve_ops_share_lessons_learned",
        Description:
          "\n               Document and share lessons learned from the execution of operations activities \n               so that you can use them internally and across teams.\n            ",
        Title: "Document and share lessons learned",
      },
      {
        ChoiceId: "ops_evolve_ops_allocate_time_for_imp",
        Description:
          "\n               Dedicate time and resources within your processes \n               to make continuous incremental improvements possible.\n            ",
        Title: "Allocate time to make improvements",
      },
      {
        ChoiceId: "ops_evolve_ops_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "evolve-ops",
    QuestionTitle: "How do you evolve operations?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
];

export const Operational_Excellence_Q1_ExecutionStatus = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "ops_priorities_ext_cust_needs",
        Description:
          "Involve key stakeholders, including business, development, and operations teams, to determine where to focus efforts on external customer needs.This will ensure that you have a thorough understanding of the operations support that is required to achieve your desired business outcomes.\n            ",
        Title: "Evaluate external customer needs",
      },
      {
        ChoiceId: "ops_priorities_int_cust_needs",
        Description:
          "Involve key stakeholders, including business, development, and operations teams, when determining where to focus efforts on internal customer needs.This will ensure that you have a thorough understanding of the operations support that is required to achieve business outcomes.\n            ",
        Title: "Evaluate internal customer needs",
      },
      {
        ChoiceId: "ops_priorities_governance_reqs",
        Description:
          "Ensure that you are aware of guidelines or obligations defined by your organization that may mandate or emphasize specific focus. Evaluate internal factors, such as organization policy, standards, and requirements. Validate that you have mechanisms to identify changes to governance. If no governance requirements are identified, ensure that you have applied due diligence to this determination.\n            ",
        Title: "Evaluate governance requirements",
      },
      {
        ChoiceId: "ops_priorities_compliance_reqs",
        Description:
          "Evaluate external factors, such as regulatory compliance requirements and industry standards, to ensure that you are aware of guidelines or obligations that may mandate or emphasize specific focus.If no compliance requirements are identified, ensure that you apply due diligence to this determination.\n            ",
        Title: "Evaluate compliance requirements",
      },
      {
        ChoiceId: "ops_priorities_eval_threat_landscape",
        Description:
          "Evaluate threats to the business (for example, competition, business risk and liabilities, operational risks, and information security threats) and maintain current information in a risk registry. Include the impact of risks when determining where to focus efforts.\n            ",
        Title: "Evaluate threat landscape",
      },
      {
        ChoiceId: "ops_priorities_eval_tradeoffs",
        Description:
          "Evaluate the impact of tradeoffs between competing interests or alternative approaches, to help make informed decisions when determining where to focus efforts or choosing a course of action. For example, accelerating speed to market for new features may be emphasized over cost optimization, or you may choose a relational database for non-relational data to simplify the effort to migrate a system, rather than migrating to a database optimized for your data type and updating your application.\n            ",
        Title: "Evaluate tradeoffs",
      },
      {
        ChoiceId: "ops_priorities_manage_risk_benefit",
        Description:
          "Manage benefits and risks to make informed decisions when determining where to focus efforts. For example, it may be beneficial to deploy a workload with unresolved issues so that significant new features can be made available to customers. It may be possible to mitigate associated risks, or it may become unacceptable to allow a risk to remain, in which case you will take action to address the risk.\n            ",
        Title: "Manage benefits and risks",
      },
      {
        ChoiceId: "ops_priorities_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.priorities.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionDescription:
      "\n         Everyone needs to understand their part in enabling business success. \n         Have shared goals in order to set priorities for resources. \n         This will maximize the benefits of your efforts.\n      ",
    QuestionId: "priorities",
    QuestionTitle: "How do you determine what your priorities are?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Operational_Excellence_Q1_Summaries = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Operational_Excellence_Q1_Answer_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 18:20:32+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Operational_Excellence_Q2 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "ops_ops_model_def_resource_owners",
        Description:
          "Understand who has ownership of each application, workload, platform, and infrastructure component, what business value is provided by that component, and why that ownership exists. Understanding the business value of these individual components and how they support business outcomes informs the processes and procedures applied against them.\n            ",
        Title: "Resources have identified owners",
      },
      {
        ChoiceId: "ops_ops_model_def_proc_owners",
        Description:
          "Understand who has ownership of the definition of individual processes and procedures, why those specific process and procedures are used, and why that ownership exists. Understanding the reasons that specific processes and procedures are used enables identification of improvement opportunities. \n            ",
        Title: "Processes and procedures have identified owners",
      },
      {
        ChoiceId: "ops_ops_model_def_activity_owners",
        Description:
          "Understand who has responsibility to perform specific activities on defined workloads and why that responsibility exists. Understanding who has responsibility to perform activities informs who will conduct the activity, validate the result, and provide feedback to the owner of the activity.\n            ",
        Title:
          "Operations activities have identified owners responsible for their performance",
      },
      {
        ChoiceId: "ops_ops_model_know_my_job",
        Description:
          "Understanding the responsibilities of your role and how you contribute to business outcomes informs the prioritization of your tasks and why your role is important. This enables team members to recognize needs and respond appropriately.\n            ",
        Title: "Team members know what they are responsible for",
      },
      {
        ChoiceId: "ops_ops_model_find_owner",
        Description:
          "Where no individual or team is identified, there are defined escalation paths to someone with the authority to assign ownership or plan for that need to be addressed.\n            ",
        Title: "Mechanisms exist to identify responsibility and ownership",
      },
      {
        ChoiceId: "ops_ops_model_req_add_chg_exception",
        Description:
          "You are able to make requests to owners of processes, procedures, and resources. Make informed decisions to approve requests where viable and determined to be appropriate after an evaluation of benefits and risks.\n            ",
        Title: "Mechanisms exist to request additions, changes, and exceptions",
      },
      {
        ChoiceId: "ops_ops_model_def_neg_team_agreements",
        Description:
          "There are defined or negotiated agreements between teams describing how they work with and support each other (for example, response times, service level objectives, or service level agreements). Understanding the impact of the teams’ work on business outcomes, and the outcomes of other teams and organizations, informs the prioritization of their tasks and enables them to respond appropriately.\n            ",
        Title: "Responsibilities between teams are predefined or negotiated",
      },
      {
        ChoiceId: "ops_ops_model_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.ops-model.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionDescription:
      "\n         Your teams must understand their part in achieving business outcomes. Teams need to understand their roles in the success of other teams, the role of other teams in their success, and have shared goals. Understanding responsibility, ownership, how decisions are made, and who has authority to make decisions will help focus efforts and maximize the benefits from your teams. \n      ",
    QuestionId: "ops-model",
    QuestionTitle:
      "How do you structure your organization to support your business outcomes?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Operational_Excellence_Q2_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Operational_Excellence_Q2_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 18:27:49+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Operational_Excellence_Q3_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Operational_Excellence_Q3 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "ops_org_culture_executive_sponsor",
        Description:
          "Senior leadership clearly sets expectations for the organization and evaluates success. Senior leadership is the sponsor, advocate, and driver for the adoption of best practices and evolution of the organization\n            ",
        Title: "Executive Sponsorship",
      },
      {
        ChoiceId: "ops_org_culture_team_emp_take_action",
        Description:
          "The workload owner has defined guidance and scope empowering team members to respond when outcomes are at risk. Escalation mechanisms are used to get direction when events are outside of the defined scope.\n            ",
        Title:
          "Team members are empowered to take action when outcomes are at risk",
      },
      {
        ChoiceId: "ops_org_culture_team_enc_escalation",
        Description:
          "Team members have mechanisms and are encouraged to escalate concerns to decision makers and stakeholders if they believe outcomes are at risk. Escalation should be performed early and often so that risks can be identified, and prevented from causing incidents.\n            ",
        Title: "Escalation is encouraged",
      },
      {
        ChoiceId: "ops_org_culture_effective_comms",
        Description:
          "Mechanisms exist and are used to provide timely notice to team members of known risks and planned events. Necessary context, details, and time (when possible) are provided to support determining if action is necessary, what action is required, and to take action in a timely manner. For example, providing notice of software vulnerabilities so that patching can be expedited, or providing notice of planned sales promotions so that a change freeze can be implemented to avoid the risk of service disruption.\n            ",
        Title: "Communications are timely, clear, and actionable",
      },
      {
        ChoiceId: "ops_org_culture_team_enc_experiment",
        Description:
          "Experimentation accelerates learning and keeps team members interested and engaged. An undesired result is a successful experiment that has identified a path that will not lead to success. Team members are not punished for successful experiments with undesired results. Experimentation is required for innovation to happen and turn ideas into outcomes.\n            ",
        Title: "Experimentation is encouraged",
      },
      {
        ChoiceId: "ops_org_culture_team_enc_learn",
        Description:
          "Teams must grow their skill sets to adopt new technologies, and to support changes in demand and responsibilities in support of your workloads. Growth of skills in new technologies is frequently a source of team member satisfaction and supports innovation. Support your team members’ pursuit and maintenance of industry certifications that validate and acknowledge their growing skills. Cross train to promote knowledge transfer and reduce the risk of significant impact when you lose skilled and experienced team members with institutional knowledge. Provide dedicated structured time for learning.\n            ",
        Title:
          "Team members are enabled and encouraged to maintain and grow their skill sets",
      },
      {
        ChoiceId: "ops_org_culture_team_res_appro",
        Description:
          "Maintain team member capacity, and provide tools and resources, to support your workload needs. Overtasking team members increases the risk of incidents resulting from human error. Investments in tools and resources (for example, providing automation for frequently executed activities) can scale the effectiveness of your team, enabling them to support additional activities.\n            ",
        Title: "Resource teams appropriately",
      },
      {
        ChoiceId: "ops_org_culture_diverse_inc_access",
        Description:
          "Leverage cross-organizational diversity to seek multiple unique perspectives. Use this perspective to increase innovation, challenge your assumptions, and reduce the risk of confirmation bias. Grow inclusion, diversity, and accessibility within your teams to gain beneficial perspectives.\n            ",
        Title:
          "Diverse opinions are encouraged and sought within and across teams",
      },
      {
        ChoiceId: "ops_org_culture_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.org-culture.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionDescription:
      "\n         Provide support for your team members so that they can be more effective in taking action and supporting your business outcome.\n      ",
    QuestionId: "org-culture",
    QuestionTitle:
      "How does your organizational culture support your business outcomes?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Operational_Excellence_Q3_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 18:30:44+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Operational_Excellence_Q4 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "ops_telemetry_application_telemetry",
        Description:
          "Instrument your application code to emit information about its internal state, status, and achievement of business outcomes. For example, queue depth, error messages, and response times. Use this information to determine when a response is required.\n            ",
        Title: "Implement application telemetry",
      },
      {
        ChoiceId: "ops_telemetry_workload_telemetry",
        Description:
          "Design and configure your workload to emit information about its internal state and current status. For example, API call volume, HTTP status codes, and scaling events. Use this information to help determine when a response is required.\n            ",
        Title: "Implement and configure workload telemetry",
      },
      {
        ChoiceId: "ops_telemetry_customer_telemetry",
        Description:
          "Instrument your application code to emit information about user activity, for example, click streams, or started, abandoned, and completed transactions. Use this information to help understand how the application is used, patterns of usage, and to determine when a response is required.\n            ",
        Title: "Implement user activity telemetry",
      },
      {
        ChoiceId: "ops_telemetry_dependency_telemetry",
        Description:
          "Design and configure your workload to emit information about the status (for example, reachability or response time) of resources it depends on. Examples of external dependencies can include, external databases, DNS, and network connectivity. Use this information to determine when a response is required.\n            ",
        Title: "Implement dependency telemetry",
      },
      {
        ChoiceId: "ops_telemetry_dist_trace",
        Description:
          "Implement your application code and configure your workload components to emit information about the flow of transactions across the workload. Use this information to determine when a response is required and to assist you in identifying the factors contributing to an issue.\n            ",
        Title: "Implement transaction traceability",
      },
      {
        ChoiceId: "ops_telemetry_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.telemetry.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionDescription:
      "\n         Design your workload so that it provides the information necessary across all components \n         (for example, metrics, logs, and traces) for you to understand its internal state.\n         This enables you to provide effective responses when appropriate.\n      ",
    QuestionId: "telemetry",
    QuestionTitle:
      "How do you design your workload so that you can understand its state?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Operational_Excellence_Q4_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 6,
  Passed: 14,
};

export const Operational_Excellence_Q4_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 18:35:35+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Operational_Excellence_Q5 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "ops_dev_integ_version_control",
        Description:
          "Use version control to enable tracking of changes and releases.\n            ",
        Title: "Use version control",
      },
      {
        ChoiceId: "ops_dev_integ_test_val_chg",
        Description:
          "Test and validate changes to help limit and detect errors.Automate testing to reduce errors caused by manual processes, and reduce the level of effort to test.\n            ",
        Title: "Test and validate changes",
      },
      {
        ChoiceId: "ops_dev_integ_conf_mgmt_sys",
        Description:
          "Use configuration management systems to make and track configuration changes. These systems reduce errors caused by manual processes and reduce the level of effort to deploy changes. \n            ",
        Title: "Use configuration management systems",
      },
      {
        ChoiceId: "ops_dev_integ_build_mgmt_sys",
        Description:
          "Use build and deployment management systems.These systems reduce errors caused by manual processes and reduce the level of effort to deploy changes. \n            ",
        Title: "Use build and deployment management systems",
      },
      {
        ChoiceId: "ops_dev_integ_patch_mgmt",
        Description:
          "Perform patch management to gain features, address issues, and remain compliant with governance. Automate patch management to reduce errors caused by manual processes, and reduce the level of effort to patch.\n            ",
        Title: "Perform patch management",
      },
      {
        ChoiceId: "ops_dev_integ_share_design_stds",
        Description:
          "Share best practices across teams to increase awareness and maximize the benefits of development efforts.\n            ",
        Title: "Share design standards",
      },
      {
        ChoiceId: "ops_dev_integ_code_quality",
        Description:
          "Implement practices to improve code quality and minimize defects. For example, test-driven development, code reviews, and standards adoption.\n            ",
        Title: "Implement practices to improve code quality",
      },
      {
        ChoiceId: "ops_dev_integ_multi_env",
        Description:
          "Use multiple environments to experiment, develop, and test your workload. Use increasing levels of controls as environments approach production to gain confidence your workload will operate as intended when deployed.\n            ",
        Title: "Use multiple environments",
      },
      {
        ChoiceId: "ops_dev_integ_freq_sm_rev_chg",
        Description:
          "Frequent, small, and reversible changes reduce the scope and impact of a change.This eases troubleshooting, enables faster remediation, and provides the option to roll back a change.\n            ",
        Title: "Make frequent, small, reversible changes",
      },
      {
        ChoiceId: "ops_dev_integ_auto_integ_deploy",
        Description:
          "Automate build, deployment, and testing of the workload. This reduces errors caused by manual processes and reduces the effort to deploy changes.\n            ",
        Title: "Fully automate integration and deployment",
      },
      {
        ChoiceId: "ops_dev_integ_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.dev-integ.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionDescription:
      "\n         Adopt approaches that improve flow of changes into production, that enable refactoring, fast feedback on quality, and bug fixing.\n         These accelerate beneficial changes entering production, limit issues deployed,\n         and enable rapid identification and remediation of issues introduced through deployment activities.\n      ",
    QuestionId: "dev-integ",
    QuestionTitle:
      "How do you reduce defects, ease remediation, and improve flow into production?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Operational_Excellence_Q5_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 1,
  Passed: 2,
};

export const Operational_Excellence_Q5_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 18:37:31+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Operational_Excellence_Q6_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Operational_Excellence_Q6 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "ops_mit_deploy_risks_plan_for_unsucessful_changes",
        Description:
          "Plan to revert to a known good state, or remediate in the production environment if a change does not have the desired outcome.This preparation reduces recovery time through faster responses.\n            ",
        Title: "Plan for unsuccessful changes",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_test_val_chg",
        Description:
          "Test changes and validate the results at all lifecycle stages to confirm new features and minimize the risk and impact of failed deployments.\n            ",
        Title: "Test and validate changes",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_deploy_mgmt_sys",
        Description:
          "Use deployment management systems to track and implement change. This reduces errors cause by manual processes and reduces the effort to deploy changes.\n            ",
        Title: "Use deployment management systems",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_test_limited_deploy",
        Description:
          "Test with limited deployments alongside existing systems to confirm desired outcomes prior to full scale deployment.For example, use deployment canary testing or one-box deployments.\n            ",
        Title: "Test using limited deployments",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_deploy_to_parallel_env",
        Description:
          "Implement changes onto parallel environments, and then transition over to the new environment. Maintain the prior environment until there is confirmation of successful deployment. Doing so minimizes recovery time by enabling rollback to the previous environment.\n            ",
        Title: "Deploy using parallel environments",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_freq_sm_rev_chg",
        Description:
          "Use frequent, small, and reversible changes to reduce the scope of a change.This results in easier troubleshooting and faster remediation with the option to roll back a change.\n            ",
        Title: "Deploy frequent, small, reversible changes",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_auto_integ_deploy",
        Description:
          "Automate build, deployment, and testing of the workload. This reduces errors cause by manual processes and reduces the effort to deploy changes.\n            ",
        Title: "Fully automate integration and deployment",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_auto_testing_and_rollback",
        Description:
          "Automate testing of deployed environments to confirm desired outcomes.Automate rollback to previous known good state when outcomes are not achieved to minimize recovery time and reduce errors caused by manual processes.\n            ",
        Title: "Automate testing and rollback",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.mit-deploy-risks.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionDescription:
      "\n         Adopt approaches that provide fast feedback on quality and \n         enable rapid recovery from changes that do not have desired outcomes.\n         Using these practices mitigates the impact of issues introduced through the deployment of changes.\n      ",
    QuestionId: "mit-deploy-risks",
    QuestionTitle: "How do you mitigate deployment risks?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Operational_Excellence_Q6_Answer_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 18:41:04+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Operational_Excellence_Q7 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "ops_ready_to_support_personnel_capability",
        Description:
          "Have a mechanism to validate that you have the appropriate number of trained personnel to provide support for operational needs. Train personnel and adjust personnel capacity as necessary to maintain effective support.\n            ",
        Title: "Ensure personnel capability",
      },
      {
        ChoiceId: "ops_ready_to_support_const_orr",
        Description:
          "Ensure you have a consistent review of your readiness to operate a workload. Reviews must include, at a minimum, the operational readiness of the teams and the workload, and security requirements. Implement review activities in code and trigger automated review in response to events where appropriate, to ensure consistency, speed of execution, and reduce errors caused by manual processes.\n            ",
        Title: "Ensure consistent review of operational readiness",
      },
      {
        ChoiceId: "ops_ready_to_support_use_runbooks",
        Description:
          "Runbooks are documented procedures to achieve specific outcomes. Enable consistent and prompt responses to well-understood events by documenting procedures in runbooks. Implement runbooks as code and trigger the execution of runbooks in response to events where appropriate,to ensure consistency, speed responses, and reduce errors caused by manual processes.\n            ",
        Title: "Use runbooks to perform procedures",
      },
      {
        ChoiceId: "ops_ready_to_support_use_playbooks",
        Description:
          "Enable consistent and prompt responses to issues that are not well understood, by documenting the investigation process in playbooks. Playbooks are the predefined steps performed to identify the factors contributing to a failure scenario. The results from any process step are used to determine the next steps to take until the issue is identified or escalated.\n            ",
        Title: "Use playbooks to investigate issues",
      },
      {
        ChoiceId: "ops_ready_to_support_informed_deploy_decisions",
        Description:
          "Evaluate the capabilities of the team to support the workload and the workload's compliance with governance.Evaluate these against the benefits of deployment when determining whether to transition a system or change into production.Understand the benefits and risks to make informed decisions.\n            ",
        Title: "Make informed decisions to deploy systems and changes",
      },
      {
        ChoiceId: "ops_ready_to_support_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.ready-to-support.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionDescription:
      "\n         Evaluate the operational readiness of your workload, processes and procedures, and personnel \n         to understand the operational risks related to your workload.\n      ",
    QuestionId: "ready-to-support",
    QuestionTitle: "How do you know that you are ready to support a workload?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Operational_Excellence_Q7_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Operational_Excellence_Q7_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 18:45:03+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Operational_Excellence_Q8 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "ops_workload_health_define_workload_kpis",
        Description:
          "Identify key performance indicators (KPIs) based on desired business outcomes (for example, order rate, customer retention rate, and profit versus operating expense) and customer outcomes (for example, customer satisfaction). Evaluate KPIs to determine workload success.\n            ",
        Title: "Identify key performance indicators",
      },
      {
        ChoiceId: "ops_workload_health_design_workload_metrics",
        Description:
          "Define workload metrics to measure the achievement of KPIs (for example, abandoned shopping carts, orders placed, cost, price, and allocated workload expense). Define workload metrics to measure the health of the workload (for example, interface response time, error rate, requests made, requests completed, and utilization). Evaluate metrics to determine if the workload is achieving desired outcomes, and to understand the health of the workload.\n            ",
        Title: "Define workload metrics",
      },
      {
        ChoiceId: "ops_workload_health_collect_analyze_workload_metrics",
        Description:
          "Perform regular proactive reviews of metricsto identify trends and determine where appropriate responses are needed.\n            ",
        Title: "Collect and analyze workload metrics",
      },
      {
        ChoiceId: "ops_workload_health_workload_metric_baselines",
        Description:
          "Establish baselines for metrics to provide expected values as the basis for comparison and identification of under and over performing components. Identify thresholds for improvement, investigation, and intervention.\n            ",
        Title: "Establish workload metrics baselines",
      },
      {
        ChoiceId: "ops_workload_health_learn_workload_usage_patterns",
        Description:
          "Establish patterns of workload activity to identify anomalous behavior so that you can respond appropriately if required.\n            ",
        Title: "Learn expected patterns of activity for workload",
      },
      {
        ChoiceId: "ops_workload_health_workload_outcome_alerts",
        Description:
          "Raise an alert when workload outcomes are at risk so that you can respond appropriately if necessary.\n            ",
        Title: "Alert when workload outcomes are at risk",
      },
      {
        ChoiceId: "ops_workload_health_workload_anomaly_alerts",
        Description:
          "Raise an alert when workload anomalies are detected so that you can respond appropriately if necessary.\n            ",
        Title: "Alert when workload anomalies are detected",
      },
      {
        ChoiceId: "ops_workload_health_biz_level_view_workload",
        Description:
          "Create a business-level view of your workload operationsto help you determine if you are satisfying needs and to identify areas that need improvement to reach business goals.Validate the effectiveness of KPIs and metrics and revise them if necessary.\n            ",
        Title:
          "Validate the achievement of outcomes and the effectiveness of KPIs and metrics\n            ",
      },
      {
        ChoiceId: "ops_workload_health_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.workload-health.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionDescription:
      "\n         Define, capture, and analyze workload metrics to gain visibility to workload events so that you can take appropriate action.\n      ",
    QuestionId: "workload-health",
    QuestionTitle: "How do you understand the health of your workload?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Operational_Excellence_Q8_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 4,
  Passed: 2,
};

export const Operational_Excellence_Q8_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 18:48:59+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Operational_Excellence_Q9 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "ops_operations_health_define_ops_kpis",
        Description:
          "Identify key performance indicators (KPIs) based on desired business (for example, new features delivered) and customer outcomes (for example, customer support cases). Evaluate KPIs to determine operations success.\n            ",
        Title: "Identify key performance indicators",
      },
      {
        ChoiceId: "ops_operations_health_design_ops_metrics",
        Description:
          "Define operations metrics to measure the achievement of KPIs (for example, successful deployments, and failed deployments). Define operations metrics to measure the health of operations activities (for example, mean time to detect an incident (MTTD), and mean time to recovery (MTTR) from an incident). Evaluate metrics to determine if operations are achieving desired outcomes, and to understand the health of your operations activities.\n            ",
        Title: "Define operations metrics",
      },
      {
        ChoiceId: "ops_operations_health_collect_analyze_ops_metrics",
        Description:
          "Perform regular, proactive reviews of metrics to identify trends and determine where appropriate responses are needed.\n            ",
        Title: "Collect and analyze operations metrics",
      },
      {
        ChoiceId: "ops_operations_health_ops_metric_baselines",
        Description:
          "Establish baselines for metrics to provide expected values as the basis for comparison and identification of under and over performing operations activities.\n            ",
        Title: "Establish operations metrics baselines",
      },
      {
        ChoiceId: "ops_operations_health_learn_ops_usage_patterns",
        Description:
          "Establish patterns of operations activities to identify anomalous activity so that you can respond appropriately if necessary.\n            ",
        Title: "Learn the expected patterns of activity for operations",
      },
      {
        ChoiceId: "ops_operations_health_ops_outcome_alerts",
        Description:
          "Raise an alert when operations outcomes are at risk so that you can respond appropriately if necessary.\n            ",
        Title: "Alert when operations outcomes are at risk",
      },
      {
        ChoiceId: "ops_operations_health_ops_anomaly_alerts",
        Description:
          "Raise an alert when operations anomalies are detected so that you can respond appropriately if necessary.\n            ",
        Title: "Alert when operations anomalies are detected",
      },
      {
        ChoiceId: "ops_operations_health_biz_level_view_ops",
        Description:
          "Create a business-level view of your operations activitiesto help you determine if you are satisfying needs and to identify areas that need improvement to reach business goals.Validate the effectiveness of KPIs and metrics and revise them if necessary.\n            ",
        Title:
          "Validate the achievement of outcomes and the effectiveness of KPIs and metrics\n            ",
      },
      {
        ChoiceId: "ops_operations_health_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.operations-health.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionDescription:
      "\n         Define, capture, and analyze operations metrics to gain visibility to operations events so that you can take appropriate action.\n      ",
    QuestionId: "operations-health",
    QuestionTitle: "How do you understand the health of your operations?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Operational_Excellence_Q9_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Operational_Excellence_Q9_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 18:48:59+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Operational_Excellence_Q10 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "ops_event_response_event_incident_problem_process",
        Description:
          "Have processes to address observed events, events that require intervention (incidents), and events that require intervention and either recur or cannot currently be resolved (problems). Use these processes to mitigate the impact of these events on the business and your customers by ensuring timely and appropriate responses.\n            ",
        Title: "Use processes for event, incident, and problem management",
      },
      {
        ChoiceId: "ops_event_response_process_per_alert",
        Description:
          "Have a well-defined response (runbook or playbook), with a specifically identified owner, for any event for which you raise an alert.This ensures effective and prompt responses to operations events and prevents actionable events from being obscured by less valuable notifications.\n            ",
        Title: "Have a process per alert",
      },
      {
        ChoiceId: "ops_event_response_prioritize_events",
        Description:
          "Ensure that when multiple events require intervention, those that are most significant to the business are addressed first.For example, impacts can include loss of life or injury, financial loss, or damage to reputation or trust.\n            ",
        Title: "Prioritize operational events based on business impact",
      },
      {
        ChoiceId: "ops_event_response_define_escalation_paths",
        Description:
          "Define escalation paths in your runbooks and playbooks, including what triggers escalation, andprocedures for escalation. Specifically identify owners for each action to ensure effective and prompt responses to operations events.\n            ",
        Title: "Define escalation paths",
      },
      {
        ChoiceId: "ops_event_response_push_notify",
        Description:
          "Communicate directly with your users (for example, with email or SMS) when the services they use are impacted, and again when the services return to normal operating conditions, to enable users to take appropriate action.\n            ",
        Title: "Enable push notifications",
      },
      {
        ChoiceId: "ops_event_response_dashboards",
        Description:
          "Provide dashboards tailored to their target audiences (for example, internal technical teams, leadership, and customers)to communicate the current operating status of the business and provide metrics of interest. \n            ",
        Title: "Communicate status through dashboards",
      },
      {
        ChoiceId: "ops_event_response_auto_event_response",
        Description:
          "Automate responses to events to reduce errors caused by manual processes, and to ensure prompt and consistent responses. \n            ",
        Title: "Automate responses to events",
      },
      {
        ChoiceId: "ops_event_response_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.event-response.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionDescription:
      " Prepare and validate procedures for responding to events \n         to minimize their disruption to your workload.\n      ",
    QuestionId: "event-response",
    QuestionTitle: "How do you manage workload and operations events?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Operational_Excellence_Q10_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 2,
  Passed: 0,
};

export const Operational_Excellence_Q10_Summaries = [
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_priorities_ext_cust_needs",
        Description:
          "Involve key stakeholders, including business, development, and operations teams, to determine where to focus efforts on external customer needs.This will ensure that you have a thorough understanding of the operations support that is required to achieve your desired business outcomes.\n            ",
        Title: "Evaluate external customer needs",
      },
      {
        ChoiceId: "ops_priorities_int_cust_needs",
        Description:
          "Involve key stakeholders, including business, development, and operations teams, when determining where to focus efforts on internal customer needs.This will ensure that you have a thorough understanding of the operations support that is required to achieve business outcomes.\n            ",
        Title: "Evaluate internal customer needs",
      },
      {
        ChoiceId: "ops_priorities_governance_reqs",
        Description:
          "Ensure that you are aware of guidelines or obligations defined by your organization that may mandate or emphasize specific focus. Evaluate internal factors, such as organization policy, standards, and requirements. Validate that you have mechanisms to identify changes to governance. If no governance requirements are identified, ensure that you have applied due diligence to this determination.\n            ",
        Title: "Evaluate governance requirements",
      },
      {
        ChoiceId: "ops_priorities_compliance_reqs",
        Description:
          "Evaluate external factors, such as regulatory compliance requirements and industry standards, to ensure that you are aware of guidelines or obligations that may mandate or emphasize specific focus.If no compliance requirements are identified, ensure that you apply due diligence to this determination.\n            ",
        Title: "Evaluate compliance requirements",
      },
      {
        ChoiceId: "ops_priorities_eval_threat_landscape",
        Description:
          "Evaluate threats to the business (for example, competition, business risk and liabilities, operational risks, and information security threats) and maintain current information in a risk registry. Include the impact of risks when determining where to focus efforts.\n            ",
        Title: "Evaluate threat landscape",
      },
      {
        ChoiceId: "ops_priorities_eval_tradeoffs",
        Description:
          "Evaluate the impact of tradeoffs between competing interests or alternative approaches, to help make informed decisions when determining where to focus efforts or choosing a course of action. For example, accelerating speed to market for new features may be emphasized over cost optimization, or you may choose a relational database for non-relational data to simplify the effort to migrate a system, rather than migrating to a database optimized for your data type and updating your application.\n            ",
        Title: "Evaluate tradeoffs",
      },
      {
        ChoiceId: "ops_priorities_manage_risk_benefit",
        Description:
          "Manage benefits and risks to make informed decisions when determining where to focus efforts. For example, it may be beneficial to deploy a workload with unresolved issues so that significant new features can be made available to customers. It may be possible to mitigate associated risks, or it may become unacceptable to allow a risk to remain, in which case you will take action to address the risk.\n            ",
        Title: "Manage benefits and risks",
      },
      {
        ChoiceId: "ops_priorities_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "priorities",
    QuestionTitle: "How do you determine what your priorities are?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_ops_model_def_resource_owners",
        Description:
          "Understand who has ownership of each application, workload, platform, and infrastructure component, what business value is provided by that component, and why that ownership exists. Understanding the business value of these individual components and how they support business outcomes informs the processes and procedures applied against them.\n            ",
        Title: "Resources have identified owners",
      },
      {
        ChoiceId: "ops_ops_model_def_proc_owners",
        Description:
          "Understand who has ownership of the definition of individual processes and procedures, why those specific process and procedures are used, and why that ownership exists. Understanding the reasons that specific processes and procedures are used enables identification of improvement opportunities. \n            ",
        Title: "Processes and procedures have identified owners",
      },
      {
        ChoiceId: "ops_ops_model_def_activity_owners",
        Description:
          "Understand who has responsibility to perform specific activities on defined workloads and why that responsibility exists. Understanding who has responsibility to perform activities informs who will conduct the activity, validate the result, and provide feedback to the owner of the activity.\n            ",
        Title:
          "Operations activities have identified owners responsible for their performance",
      },
      {
        ChoiceId: "ops_ops_model_know_my_job",
        Description:
          "Understanding the responsibilities of your role and how you contribute to business outcomes informs the prioritization of your tasks and why your role is important. This enables team members to recognize needs and respond appropriately.\n            ",
        Title: "Team members know what they are responsible for",
      },
      {
        ChoiceId: "ops_ops_model_find_owner",
        Description:
          "Where no individual or team is identified, there are defined escalation paths to someone with the authority to assign ownership or plan for that need to be addressed.\n            ",
        Title: "Mechanisms exist to identify responsibility and ownership",
      },
      {
        ChoiceId: "ops_ops_model_req_add_chg_exception",
        Description:
          "You are able to make requests to owners of processes, procedures, and resources. Make informed decisions to approve requests where viable and determined to be appropriate after an evaluation of benefits and risks.\n            ",
        Title: "Mechanisms exist to request additions, changes, and exceptions",
      },
      {
        ChoiceId: "ops_ops_model_def_neg_team_agreements",
        Description:
          "There are defined or negotiated agreements between teams describing how they work with and support each other (for example, response times, service level objectives, or service level agreements). Understanding the impact of the teams’ work on business outcomes, and the outcomes of other teams and organizations, informs the prioritization of their tasks and enables them to respond appropriately.\n            ",
        Title: "Responsibilities between teams are predefined or negotiated",
      },
      {
        ChoiceId: "ops_ops_model_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "ops-model",
    QuestionTitle:
      "How do you structure your organization to support your business outcomes?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_org_culture_executive_sponsor",
        Description:
          "Senior leadership clearly sets expectations for the organization and evaluates success. Senior leadership is the sponsor, advocate, and driver for the adoption of best practices and evolution of the organization\n            ",
        Title: "Executive Sponsorship",
      },
      {
        ChoiceId: "ops_org_culture_team_emp_take_action",
        Description:
          "The workload owner has defined guidance and scope empowering team members to respond when outcomes are at risk. Escalation mechanisms are used to get direction when events are outside of the defined scope.\n            ",
        Title:
          "Team members are empowered to take action when outcomes are at risk",
      },
      {
        ChoiceId: "ops_org_culture_team_enc_escalation",
        Description:
          "Team members have mechanisms and are encouraged to escalate concerns to decision makers and stakeholders if they believe outcomes are at risk. Escalation should be performed early and often so that risks can be identified, and prevented from causing incidents.\n            ",
        Title: "Escalation is encouraged",
      },
      {
        ChoiceId: "ops_org_culture_effective_comms",
        Description:
          "Mechanisms exist and are used to provide timely notice to team members of known risks and planned events. Necessary context, details, and time (when possible) are provided to support determining if action is necessary, what action is required, and to take action in a timely manner. For example, providing notice of software vulnerabilities so that patching can be expedited, or providing notice of planned sales promotions so that a change freeze can be implemented to avoid the risk of service disruption.\n            ",
        Title: "Communications are timely, clear, and actionable",
      },
      {
        ChoiceId: "ops_org_culture_team_enc_experiment",
        Description:
          "Experimentation accelerates learning and keeps team members interested and engaged. An undesired result is a successful experiment that has identified a path that will not lead to success. Team members are not punished for successful experiments with undesired results. Experimentation is required for innovation to happen and turn ideas into outcomes.\n            ",
        Title: "Experimentation is encouraged",
      },
      {
        ChoiceId: "ops_org_culture_team_enc_learn",
        Description:
          "Teams must grow their skill sets to adopt new technologies, and to support changes in demand and responsibilities in support of your workloads. Growth of skills in new technologies is frequently a source of team member satisfaction and supports innovation. Support your team members’ pursuit and maintenance of industry certifications that validate and acknowledge their growing skills. Cross train to promote knowledge transfer and reduce the risk of significant impact when you lose skilled and experienced team members with institutional knowledge. Provide dedicated structured time for learning.\n            ",
        Title:
          "Team members are enabled and encouraged to maintain and grow their skill sets",
      },
      {
        ChoiceId: "ops_org_culture_team_res_appro",
        Description:
          "Maintain team member capacity, and provide tools and resources, to support your workload needs. Overtasking team members increases the risk of incidents resulting from human error. Investments in tools and resources (for example, providing automation for frequently executed activities) can scale the effectiveness of your team, enabling them to support additional activities.\n            ",
        Title: "Resource teams appropriately",
      },
      {
        ChoiceId: "ops_org_culture_diverse_inc_access",
        Description:
          "Leverage cross-organizational diversity to seek multiple unique perspectives. Use this perspective to increase innovation, challenge your assumptions, and reduce the risk of confirmation bias. Grow inclusion, diversity, and accessibility within your teams to gain beneficial perspectives.\n            ",
        Title:
          "Diverse opinions are encouraged and sought within and across teams",
      },
      {
        ChoiceId: "ops_org_culture_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "org-culture",
    QuestionTitle:
      "How does your organizational culture support your business outcomes?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_telemetry_application_telemetry",
        Description:
          "Instrument your application code to emit information about its internal state, status, and achievement of business outcomes. For example, queue depth, error messages, and response times. Use this information to determine when a response is required.\n            ",
        Title: "Implement application telemetry",
      },
      {
        ChoiceId: "ops_telemetry_workload_telemetry",
        Description:
          "Design and configure your workload to emit information about its internal state and current status. For example, API call volume, HTTP status codes, and scaling events. Use this information to help determine when a response is required.\n            ",
        Title: "Implement and configure workload telemetry",
      },
      {
        ChoiceId: "ops_telemetry_customer_telemetry",
        Description:
          "Instrument your application code to emit information about user activity, for example, click streams, or started, abandoned, and completed transactions. Use this information to help understand how the application is used, patterns of usage, and to determine when a response is required.\n            ",
        Title: "Implement user activity telemetry",
      },
      {
        ChoiceId: "ops_telemetry_dependency_telemetry",
        Description:
          "Design and configure your workload to emit information about the status (for example, reachability or response time) of resources it depends on. Examples of external dependencies can include, external databases, DNS, and network connectivity. Use this information to determine when a response is required.\n            ",
        Title: "Implement dependency telemetry",
      },
      {
        ChoiceId: "ops_telemetry_dist_trace",
        Description:
          "Implement your application code and configure your workload components to emit information about the flow of transactions across the workload. Use this information to determine when a response is required and to assist you in identifying the factors contributing to an issue.\n            ",
        Title: "Implement transaction traceability",
      },
      {
        ChoiceId: "ops_telemetry_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "telemetry",
    QuestionTitle:
      "How do you design your workload so that you can understand its state?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_dev_integ_version_control",
        Description:
          "Use version control to enable tracking of changes and releases.\n            ",
        Title: "Use version control",
      },
      {
        ChoiceId: "ops_dev_integ_test_val_chg",
        Description:
          "Test and validate changes to help limit and detect errors.Automate testing to reduce errors caused by manual processes, and reduce the level of effort to test.\n            ",
        Title: "Test and validate changes",
      },
      {
        ChoiceId: "ops_dev_integ_conf_mgmt_sys",
        Description:
          "Use configuration management systems to make and track configuration changes. These systems reduce errors caused by manual processes and reduce the level of effort to deploy changes. \n            ",
        Title: "Use configuration management systems",
      },
      {
        ChoiceId: "ops_dev_integ_build_mgmt_sys",
        Description:
          "Use build and deployment management systems.These systems reduce errors caused by manual processes and reduce the level of effort to deploy changes. \n            ",
        Title: "Use build and deployment management systems",
      },
      {
        ChoiceId: "ops_dev_integ_patch_mgmt",
        Description:
          "Perform patch management to gain features, address issues, and remain compliant with governance. Automate patch management to reduce errors caused by manual processes, and reduce the level of effort to patch.\n            ",
        Title: "Perform patch management",
      },
      {
        ChoiceId: "ops_dev_integ_share_design_stds",
        Description:
          "Share best practices across teams to increase awareness and maximize the benefits of development efforts.\n            ",
        Title: "Share design standards",
      },
      {
        ChoiceId: "ops_dev_integ_code_quality",
        Description:
          "Implement practices to improve code quality and minimize defects. For example, test-driven development, code reviews, and standards adoption.\n            ",
        Title: "Implement practices to improve code quality",
      },
      {
        ChoiceId: "ops_dev_integ_multi_env",
        Description:
          "Use multiple environments to experiment, develop, and test your workload. Use increasing levels of controls as environments approach production to gain confidence your workload will operate as intended when deployed.\n            ",
        Title: "Use multiple environments",
      },
      {
        ChoiceId: "ops_dev_integ_freq_sm_rev_chg",
        Description:
          "Frequent, small, and reversible changes reduce the scope and impact of a change.This eases troubleshooting, enables faster remediation, and provides the option to roll back a change.\n            ",
        Title: "Make frequent, small, reversible changes",
      },
      {
        ChoiceId: "ops_dev_integ_auto_integ_deploy",
        Description:
          "Automate build, deployment, and testing of the workload. This reduces errors caused by manual processes and reduces the effort to deploy changes.\n            ",
        Title: "Fully automate integration and deployment",
      },
      {
        ChoiceId: "ops_dev_integ_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "dev-integ",
    QuestionTitle:
      "How do you reduce defects, ease remediation, and improve flow into production?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_mit_deploy_risks_plan_for_unsucessful_changes",
        Description:
          "Plan to revert to a known good state, or remediate in the production environment if a change does not have the desired outcome.This preparation reduces recovery time through faster responses.\n            ",
        Title: "Plan for unsuccessful changes",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_test_val_chg",
        Description:
          "Test changes and validate the results at all lifecycle stages to confirm new features and minimize the risk and impact of failed deployments.\n            ",
        Title: "Test and validate changes",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_deploy_mgmt_sys",
        Description:
          "Use deployment management systems to track and implement change. This reduces errors cause by manual processes and reduces the effort to deploy changes.\n            ",
        Title: "Use deployment management systems",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_test_limited_deploy",
        Description:
          "Test with limited deployments alongside existing systems to confirm desired outcomes prior to full scale deployment.For example, use deployment canary testing or one-box deployments.\n            ",
        Title: "Test using limited deployments",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_deploy_to_parallel_env",
        Description:
          "Implement changes onto parallel environments, and then transition over to the new environment. Maintain the prior environment until there is confirmation of successful deployment. Doing so minimizes recovery time by enabling rollback to the previous environment.\n            ",
        Title: "Deploy using parallel environments",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_freq_sm_rev_chg",
        Description:
          "Use frequent, small, and reversible changes to reduce the scope of a change.This results in easier troubleshooting and faster remediation with the option to roll back a change.\n            ",
        Title: "Deploy frequent, small, reversible changes",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_auto_integ_deploy",
        Description:
          "Automate build, deployment, and testing of the workload. This reduces errors cause by manual processes and reduces the effort to deploy changes.\n            ",
        Title: "Fully automate integration and deployment",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_auto_testing_and_rollback",
        Description:
          "Automate testing of deployed environments to confirm desired outcomes.Automate rollback to previous known good state when outcomes are not achieved to minimize recovery time and reduce errors caused by manual processes.\n            ",
        Title: "Automate testing and rollback",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "mit-deploy-risks",
    QuestionTitle: "How do you mitigate deployment risks?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_ready_to_support_personnel_capability",
        Description:
          "Have a mechanism to validate that you have the appropriate number of trained personnel to provide support for operational needs. Train personnel and adjust personnel capacity as necessary to maintain effective support.\n            ",
        Title: "Ensure personnel capability",
      },
      {
        ChoiceId: "ops_ready_to_support_const_orr",
        Description:
          "Ensure you have a consistent review of your readiness to operate a workload. Reviews must include, at a minimum, the operational readiness of the teams and the workload, and security requirements. Implement review activities in code and trigger automated review in response to events where appropriate, to ensure consistency, speed of execution, and reduce errors caused by manual processes.\n            ",
        Title: "Ensure consistent review of operational readiness",
      },
      {
        ChoiceId: "ops_ready_to_support_use_runbooks",
        Description:
          "Runbooks are documented procedures to achieve specific outcomes. Enable consistent and prompt responses to well-understood events by documenting procedures in runbooks. Implement runbooks as code and trigger the execution of runbooks in response to events where appropriate,to ensure consistency, speed responses, and reduce errors caused by manual processes.\n            ",
        Title: "Use runbooks to perform procedures",
      },
      {
        ChoiceId: "ops_ready_to_support_use_playbooks",
        Description:
          "Enable consistent and prompt responses to issues that are not well understood, by documenting the investigation process in playbooks. Playbooks are the predefined steps performed to identify the factors contributing to a failure scenario. The results from any process step are used to determine the next steps to take until the issue is identified or escalated.\n            ",
        Title: "Use playbooks to investigate issues",
      },
      {
        ChoiceId: "ops_ready_to_support_informed_deploy_decisions",
        Description:
          "Evaluate the capabilities of the team to support the workload and the workload's compliance with governance.Evaluate these against the benefits of deployment when determining whether to transition a system or change into production.Understand the benefits and risks to make informed decisions.\n            ",
        Title: "Make informed decisions to deploy systems and changes",
      },
      {
        ChoiceId: "ops_ready_to_support_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "ready-to-support",
    QuestionTitle: "How do you know that you are ready to support a workload?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_workload_health_define_workload_kpis",
        Description:
          "Identify key performance indicators (KPIs) based on desired business outcomes (for example, order rate, customer retention rate, and profit versus operating expense) and customer outcomes (for example, customer satisfaction). Evaluate KPIs to determine workload success.\n            ",
        Title: "Identify key performance indicators",
      },
      {
        ChoiceId: "ops_workload_health_design_workload_metrics",
        Description:
          "Define workload metrics to measure the achievement of KPIs (for example, abandoned shopping carts, orders placed, cost, price, and allocated workload expense). Define workload metrics to measure the health of the workload (for example, interface response time, error rate, requests made, requests completed, and utilization). Evaluate metrics to determine if the workload is achieving desired outcomes, and to understand the health of the workload.\n            ",
        Title: "Define workload metrics",
      },
      {
        ChoiceId: "ops_workload_health_collect_analyze_workload_metrics",
        Description:
          "Perform regular proactive reviews of metricsto identify trends and determine where appropriate responses are needed.\n            ",
        Title: "Collect and analyze workload metrics",
      },
      {
        ChoiceId: "ops_workload_health_workload_metric_baselines",
        Description:
          "Establish baselines for metrics to provide expected values as the basis for comparison and identification of under and over performing components. Identify thresholds for improvement, investigation, and intervention.\n            ",
        Title: "Establish workload metrics baselines",
      },
      {
        ChoiceId: "ops_workload_health_learn_workload_usage_patterns",
        Description:
          "Establish patterns of workload activity to identify anomalous behavior so that you can respond appropriately if required.\n            ",
        Title: "Learn expected patterns of activity for workload",
      },
      {
        ChoiceId: "ops_workload_health_workload_outcome_alerts",
        Description:
          "Raise an alert when workload outcomes are at risk so that you can respond appropriately if necessary.\n            ",
        Title: "Alert when workload outcomes are at risk",
      },
      {
        ChoiceId: "ops_workload_health_workload_anomaly_alerts",
        Description:
          "Raise an alert when workload anomalies are detected so that you can respond appropriately if necessary.\n            ",
        Title: "Alert when workload anomalies are detected",
      },
      {
        ChoiceId: "ops_workload_health_biz_level_view_workload",
        Description:
          "Create a business-level view of your workload operationsto help you determine if you are satisfying needs and to identify areas that need improvement to reach business goals.Validate the effectiveness of KPIs and metrics and revise them if necessary.\n            ",
        Title:
          "Validate the achievement of outcomes and the effectiveness of KPIs and metrics\n            ",
      },
      {
        ChoiceId: "ops_workload_health_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "workload-health",
    QuestionTitle: "How do you understand the health of your workload?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_operations_health_define_ops_kpis",
        Description:
          "Identify key performance indicators (KPIs) based on desired business (for example, new features delivered) and customer outcomes (for example, customer support cases). Evaluate KPIs to determine operations success.\n            ",
        Title: "Identify key performance indicators",
      },
      {
        ChoiceId: "ops_operations_health_design_ops_metrics",
        Description:
          "Define operations metrics to measure the achievement of KPIs (for example, successful deployments, and failed deployments). Define operations metrics to measure the health of operations activities (for example, mean time to detect an incident (MTTD), and mean time to recovery (MTTR) from an incident). Evaluate metrics to determine if operations are achieving desired outcomes, and to understand the health of your operations activities.\n            ",
        Title: "Define operations metrics",
      },
      {
        ChoiceId: "ops_operations_health_collect_analyze_ops_metrics",
        Description:
          "Perform regular, proactive reviews of metrics to identify trends and determine where appropriate responses are needed.\n            ",
        Title: "Collect and analyze operations metrics",
      },
      {
        ChoiceId: "ops_operations_health_ops_metric_baselines",
        Description:
          "Establish baselines for metrics to provide expected values as the basis for comparison and identification of under and over performing operations activities.\n            ",
        Title: "Establish operations metrics baselines",
      },
      {
        ChoiceId: "ops_operations_health_learn_ops_usage_patterns",
        Description:
          "Establish patterns of operations activities to identify anomalous activity so that you can respond appropriately if necessary.\n            ",
        Title: "Learn the expected patterns of activity for operations",
      },
      {
        ChoiceId: "ops_operations_health_ops_outcome_alerts",
        Description:
          "Raise an alert when operations outcomes are at risk so that you can respond appropriately if necessary.\n            ",
        Title: "Alert when operations outcomes are at risk",
      },
      {
        ChoiceId: "ops_operations_health_ops_anomaly_alerts",
        Description:
          "Raise an alert when operations anomalies are detected so that you can respond appropriately if necessary.\n            ",
        Title: "Alert when operations anomalies are detected",
      },
      {
        ChoiceId: "ops_operations_health_biz_level_view_ops",
        Description:
          "Create a business-level view of your operations activitiesto help you determine if you are satisfying needs and to identify areas that need improvement to reach business goals.Validate the effectiveness of KPIs and metrics and revise them if necessary.\n            ",
        Title:
          "Validate the achievement of outcomes and the effectiveness of KPIs and metrics\n            ",
      },
      {
        ChoiceId: "ops_operations_health_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "operations-health",
    QuestionTitle: "How do you understand the health of your operations?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_event_response_event_incident_problem_process",
        Description:
          "Have processes to address observed events, events that require intervention (incidents), and events that require intervention and either recur or cannot currently be resolved (problems). Use these processes to mitigate the impact of these events on the business and your customers by ensuring timely and appropriate responses.\n            ",
        Title: "Use processes for event, incident, and problem management",
      },
      {
        ChoiceId: "ops_event_response_process_per_alert",
        Description:
          "Have a well-defined response (runbook or playbook), with a specifically identified owner, for any event for which you raise an alert.This ensures effective and prompt responses to operations events and prevents actionable events from being obscured by less valuable notifications.\n            ",
        Title: "Have a process per alert",
      },
      {
        ChoiceId: "ops_event_response_prioritize_events",
        Description:
          "Ensure that when multiple events require intervention, those that are most significant to the business are addressed first.For example, impacts can include loss of life or injury, financial loss, or damage to reputation or trust.\n            ",
        Title: "Prioritize operational events based on business impact",
      },
      {
        ChoiceId: "ops_event_response_define_escalation_paths",
        Description:
          "Define escalation paths in your runbooks and playbooks, including what triggers escalation, andprocedures for escalation. Specifically identify owners for each action to ensure effective and prompt responses to operations events.\n            ",
        Title: "Define escalation paths",
      },
      {
        ChoiceId: "ops_event_response_push_notify",
        Description:
          "Communicate directly with your users (for example, with email or SMS) when the services they use are impacted, and again when the services return to normal operating conditions, to enable users to take appropriate action.\n            ",
        Title: "Enable push notifications",
      },
      {
        ChoiceId: "ops_event_response_dashboards",
        Description:
          "Provide dashboards tailored to their target audiences (for example, internal technical teams, leadership, and customers)to communicate the current operating status of the business and provide metrics of interest. \n            ",
        Title: "Communicate status through dashboards",
      },
      {
        ChoiceId: "ops_event_response_auto_event_response",
        Description:
          "Automate responses to events to reduce errors caused by manual processes, and to ensure prompt and consistent responses. \n            ",
        Title: "Automate responses to events",
      },
      {
        ChoiceId: "ops_event_response_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "event-response",
    QuestionTitle: "How do you manage workload and operations events?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_evolve_ops_process_cont_imp",
        Description:
          "Regularly evaluate and prioritize opportunities for improvementto focus efforts where they can provide the greatest benefits.\n            ",
        Title: "Have a process for continuous improvement",
      },
      {
        ChoiceId: "ops_evolve_ops_perform_rca_process",
        Description:
          "Review customer-impacting events, and identify the contributing factorsand preventative actions. Use this information to develop mitigations to limit or prevent recurrence. Develop procedures for prompt and effective responses. Communicate contributing factors and corrective actions as appropriate, tailored to target audiences.\n            ",
        Title: "Perform post-incident analysis",
      },
      {
        ChoiceId: "ops_evolve_ops_feedback_loops",
        Description:
          "Include feedback loops in your procedures and workloadsto help you identify issues and areas that need improvement.\n            ",
        Title: "Implement feedback loops",
      },
      {
        ChoiceId: "ops_evolve_ops_knowledge_management",
        Description:
          "Mechanisms exist for your team members to discover the information that they are looking for in a timely manner, access it, and identify that it’s current and complete. Mechanisms are present to identify needed content, content in need of refresh, and content that should be archived so that it’s no longer referenced.\n            ",
        Title: "Perform Knowledge Management",
      },
      {
        ChoiceId: "ops_evolve_ops_drivers_for_imp",
        Description:
          "Identify drivers for improvement to help you evaluate and prioritize opportunities.\n            ",
        Title: "Define drivers for improvement",
      },
      {
        ChoiceId: "ops_evolve_ops_validate_insights",
        Description:
          "Review your analysis results and responses with cross-functional teams and business owners. Use these reviews to establish common understanding, identify additional impacts, and determine courses of action. Adjust responses as appropriate.\n            ",
        Title: "Validate insights",
      },
      {
        ChoiceId: "ops_evolve_ops_metrics_review",
        Description:
          "Regularly perform retrospective analysis of operations metrics with cross-team participants from different areas of the business. Use these reviews to identify opportunities for improvement, potential courses of action, and to share lessons learned.\n            ",
        Title: "Perform operations metrics reviews",
      },
      {
        ChoiceId: "ops_evolve_ops_share_lessons_learned",
        Description:
          "Document and share lessons learned from the execution of operations activities so that you can use them internally and across teams.\n            ",
        Title: "Document and share lessons learned",
      },
      {
        ChoiceId: "ops_evolve_ops_allocate_time_for_imp",
        Description:
          "Dedicate time and resources within your processes to make continuous incremental improvements possible.\n            ",
        Title: "Allocate time to make improvements",
      },
      {
        ChoiceId: "ops_evolve_ops_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "evolve-ops",
    QuestionTitle: "How do you evolve operations?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
];

export const Operational_Excellence_Q10_Answer_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 18:56:33+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Operational_Excellence_Q11 = {
  Answer: {
    ChoiceAnswers: [],
    Choices: [
      {
        ChoiceId: "ops_evolve_ops_process_cont_imp",
        Description:
          "Regularly evaluate and prioritize opportunities for improvementto focus efforts where they can provide the greatest benefits.\n            ",
        Title: "Have a process for continuous improvement",
      },
      {
        ChoiceId: "ops_evolve_ops_perform_rca_process",
        Description:
          "Review customer-impacting events, and identify the contributing factorsand preventative actions. Use this information to develop mitigations to limit or prevent recurrence. Develop procedures for prompt and effective responses. Communicate contributing factors and corrective actions as appropriate, tailored to target audiences.\n            ",
        Title: "Perform post-incident analysis",
      },
      {
        ChoiceId: "ops_evolve_ops_feedback_loops",
        Description:
          "Include feedback loops in your procedures and workloadsto help you identify issues and areas that need improvement.\n            ",
        Title: "Implement feedback loops",
      },
      {
        ChoiceId: "ops_evolve_ops_knowledge_management",
        Description:
          "Mechanisms exist for your team members to discover the information that they are looking for in a timely manner, access it, and identify that it’s current and complete. Mechanisms are present to identify needed content, content in need of refresh, and content that should be archived so that it’s no longer referenced.\n            ",
        Title: "Perform Knowledge Management",
      },
      {
        ChoiceId: "ops_evolve_ops_drivers_for_imp",
        Description:
          "Identify drivers for improvement to help you evaluate and prioritize opportunities.\n            ",
        Title: "Define drivers for improvement",
      },
      {
        ChoiceId: "ops_evolve_ops_validate_insights",
        Description:
          "Review your analysis results and responses with cross-functional teams and business owners. Use these reviews to establish common understanding, identify additional impacts, and determine courses of action. Adjust responses as appropriate.\n            ",
        Title: "Validate insights",
      },
      {
        ChoiceId: "ops_evolve_ops_metrics_review",
        Description:
          "Regularly perform retrospective analysis of operations metrics with cross-team participants from different areas of the business. Use these reviews to identify opportunities for improvement, potential courses of action, and to share lessons learned.\n            ",
        Title: "Perform operations metrics reviews",
      },
      {
        ChoiceId: "ops_evolve_ops_share_lessons_learned",
        Description:
          "Document and share lessons learned from the execution of operations activities so that you can use them internally and across teams.\n            ",
        Title: "Document and share lessons learned",
      },
      {
        ChoiceId: "ops_evolve_ops_allocate_time_for_imp",
        Description:
          "Dedicate time and resources within your processes to make continuous incremental improvements possible.\n            ",
        Title: "Allocate time to make improvements",
      },
      {
        ChoiceId: "ops_evolve_ops_no",
        Description: "",
        Title: "None of these",
      },
    ],
    HelpfulResourceUrl:
      "https://wa.aws.amazon.com/TypeII/en/wellarchitected/wellarchitected.evolve-ops.helpful-resources.en.html",
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionDescription:
      "\n         Dedicate time and resources for continuous incremental improvement to evolve the effectiveness and efficiency of your operations.\n      ",
    QuestionId: "evolve-ops",
    QuestionTitle: "How do you evolve operations?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
};

export const Operational_Excellence_Q11_ExecutionStatus = {
  CheckExecutionStatus: "COMPLETED",
  Error: 0,
  Failed: 0,
  Passed: 0,
};

export const Operational_Excellence_Q11_Summaries = {
  LensAlias: "wellarchitected",
  LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
  LensName: "AWS Well-Architected Framework",
  LensStatus: "CURRENT",
  LensVersion: "2022-03-31",
  PillarReviewSummaries: [
    {
      PillarId: "security",
      PillarName: "Security",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "performance",
      PillarName: "Performance Efficiency",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 8,
      },
    },
    {
      PillarId: "reliability",
      PillarName: "Reliability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 13,
      },
    },
    {
      PillarId: "costOptimization",
      PillarName: "Cost Optimization",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 10,
      },
    },
    {
      PillarId: "sustainability",
      PillarName: "Sustainability",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 6,
      },
    },
    {
      PillarId: "operationalExcellence",
      PillarName: "Operational Excellence",
      RiskCounts: {
        HIGH: 0,
        MEDIUM: 0,
        NONE: 0,
        NOT_APPLICABLE: 0,
        UNANSWERED: 11,
      },
    },
  ],
  RiskCounts: {
    HIGH: 0,
    MEDIUM: 0,
    NONE: 0,
    NOT_APPLICABLE: 0,
    UNANSWERED: 58,
  },
  UpdatedAt: "2023-04-06 18:59:58+00:00",
  WorkloadSummary: {
    AnsweredQuestions: 0,
    CreatedAt: "2023-03-28 12:46:23",
    Description: "Well architected review for HumanTech Production Workload",
    DiagramURL: null,
    Environment: "PREPRODUCTION",
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: null,
    IndustryType: null,
    Lenses: "AWS Well-Architected Framework",
    Owner: "Vignesh",
    RegionCode: "us-east-1",
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: [
      {
        AccountNumber: "897930493710",
        Regions: ["us-east-1", "us-east-2"],
      },
    ],
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: "2023-03-28 12:17:32",
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
    WorkloadName: "HumanTech Production Workload",
  },
};

export const Operational_Excellence_Q11_Answer_Summaries = [
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_priorities_ext_cust_needs",
        Description:
          "Involve key stakeholders, including business, development, and operations teams, to determine where to focus efforts on external customer needs.This will ensure that you have a thorough understanding of the operations support that is required to achieve your desired business outcomes.\n            ",
        Title: "Evaluate external customer needs",
      },
      {
        ChoiceId: "ops_priorities_int_cust_needs",
        Description:
          "Involve key stakeholders, including business, development, and operations teams, when determining where to focus efforts on internal customer needs.This will ensure that you have a thorough understanding of the operations support that is required to achieve business outcomes.\n            ",
        Title: "Evaluate internal customer needs",
      },
      {
        ChoiceId: "ops_priorities_governance_reqs",
        Description:
          "Ensure that you are aware of guidelines or obligations defined by your organization that may mandate or emphasize specific focus. Evaluate internal factors, such as organization policy, standards, and requirements. Validate that you have mechanisms to identify changes to governance. If no governance requirements are identified, ensure that you have applied due diligence to this determination.\n            ",
        Title: "Evaluate governance requirements",
      },
      {
        ChoiceId: "ops_priorities_compliance_reqs",
        Description:
          "Evaluate external factors, such as regulatory compliance requirements and industry standards, to ensure that you are aware of guidelines or obligations that may mandate or emphasize specific focus.If no compliance requirements are identified, ensure that you apply due diligence to this determination.\n            ",
        Title: "Evaluate compliance requirements",
      },
      {
        ChoiceId: "ops_priorities_eval_threat_landscape",
        Description:
          "Evaluate threats to the business (for example, competition, business risk and liabilities, operational risks, and information security threats) and maintain current information in a risk registry. Include the impact of risks when determining where to focus efforts.\n            ",
        Title: "Evaluate threat landscape",
      },
      {
        ChoiceId: "ops_priorities_eval_tradeoffs",
        Description:
          "Evaluate the impact of tradeoffs between competing interests or alternative approaches, to help make informed decisions when determining where to focus efforts or choosing a course of action. For example, accelerating speed to market for new features may be emphasized over cost optimization, or you may choose a relational database for non-relational data to simplify the effort to migrate a system, rather than migrating to a database optimized for your data type and updating your application.\n            ",
        Title: "Evaluate tradeoffs",
      },
      {
        ChoiceId: "ops_priorities_manage_risk_benefit",
        Description:
          "Manage benefits and risks to make informed decisions when determining where to focus efforts. For example, it may be beneficial to deploy a workload with unresolved issues so that significant new features can be made available to customers. It may be possible to mitigate associated risks, or it may become unacceptable to allow a risk to remain, in which case you will take action to address the risk.\n            ",
        Title: "Manage benefits and risks",
      },
      {
        ChoiceId: "ops_priorities_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "priorities",
    QuestionTitle: "How do you determine what your priorities are?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_ops_model_def_resource_owners",
        Description:
          "Understand who has ownership of each application, workload, platform, and infrastructure component, what business value is provided by that component, and why that ownership exists. Understanding the business value of these individual components and how they support business outcomes informs the processes and procedures applied against them.\n            ",
        Title: "Resources have identified owners",
      },
      {
        ChoiceId: "ops_ops_model_def_proc_owners",
        Description:
          "Understand who has ownership of the definition of individual processes and procedures, why those specific process and procedures are used, and why that ownership exists. Understanding the reasons that specific processes and procedures are used enables identification of improvement opportunities. \n            ",
        Title: "Processes and procedures have identified owners",
      },
      {
        ChoiceId: "ops_ops_model_def_activity_owners",
        Description:
          "Understand who has responsibility to perform specific activities on defined workloads and why that responsibility exists. Understanding who has responsibility to perform activities informs who will conduct the activity, validate the result, and provide feedback to the owner of the activity.\n            ",
        Title:
          "Operations activities have identified owners responsible for their performance",
      },
      {
        ChoiceId: "ops_ops_model_know_my_job",
        Description:
          "Understanding the responsibilities of your role and how you contribute to business outcomes informs the prioritization of your tasks and why your role is important. This enables team members to recognize needs and respond appropriately.\n            ",
        Title: "Team members know what they are responsible for",
      },
      {
        ChoiceId: "ops_ops_model_find_owner",
        Description:
          "Where no individual or team is identified, there are defined escalation paths to someone with the authority to assign ownership or plan for that need to be addressed.\n            ",
        Title: "Mechanisms exist to identify responsibility and ownership",
      },
      {
        ChoiceId: "ops_ops_model_req_add_chg_exception",
        Description:
          "You are able to make requests to owners of processes, procedures, and resources. Make informed decisions to approve requests where viable and determined to be appropriate after an evaluation of benefits and risks.\n            ",
        Title: "Mechanisms exist to request additions, changes, and exceptions",
      },
      {
        ChoiceId: "ops_ops_model_def_neg_team_agreements",
        Description:
          "There are defined or negotiated agreements between teams describing how they work with and support each other (for example, response times, service level objectives, or service level agreements). Understanding the impact of the teams’ work on business outcomes, and the outcomes of other teams and organizations, informs the prioritization of their tasks and enables them to respond appropriately.\n            ",
        Title: "Responsibilities between teams are predefined or negotiated",
      },
      {
        ChoiceId: "ops_ops_model_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "ops-model",
    QuestionTitle:
      "How do you structure your organization to support your business outcomes?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_org_culture_executive_sponsor",
        Description:
          "Senior leadership clearly sets expectations for the organization and evaluates success. Senior leadership is the sponsor, advocate, and driver for the adoption of best practices and evolution of the organization\n            ",
        Title: "Executive Sponsorship",
      },
      {
        ChoiceId: "ops_org_culture_team_emp_take_action",
        Description:
          "The workload owner has defined guidance and scope empowering team members to respond when outcomes are at risk. Escalation mechanisms are used to get direction when events are outside of the defined scope.\n            ",
        Title:
          "Team members are empowered to take action when outcomes are at risk",
      },
      {
        ChoiceId: "ops_org_culture_team_enc_escalation",
        Description:
          "Team members have mechanisms and are encouraged to escalate concerns to decision makers and stakeholders if they believe outcomes are at risk. Escalation should be performed early and often so that risks can be identified, and prevented from causing incidents.\n            ",
        Title: "Escalation is encouraged",
      },
      {
        ChoiceId: "ops_org_culture_effective_comms",
        Description:
          "Mechanisms exist and are used to provide timely notice to team members of known risks and planned events. Necessary context, details, and time (when possible) are provided to support determining if action is necessary, what action is required, and to take action in a timely manner. For example, providing notice of software vulnerabilities so that patching can be expedited, or providing notice of planned sales promotions so that a change freeze can be implemented to avoid the risk of service disruption.\n            ",
        Title: "Communications are timely, clear, and actionable",
      },
      {
        ChoiceId: "ops_org_culture_team_enc_experiment",
        Description:
          "Experimentation accelerates learning and keeps team members interested and engaged. An undesired result is a successful experiment that has identified a path that will not lead to success. Team members are not punished for successful experiments with undesired results. Experimentation is required for innovation to happen and turn ideas into outcomes.\n            ",
        Title: "Experimentation is encouraged",
      },
      {
        ChoiceId: "ops_org_culture_team_enc_learn",
        Description:
          "Teams must grow their skill sets to adopt new technologies, and to support changes in demand and responsibilities in support of your workloads. Growth of skills in new technologies is frequently a source of team member satisfaction and supports innovation. Support your team members’ pursuit and maintenance of industry certifications that validate and acknowledge their growing skills. Cross train to promote knowledge transfer and reduce the risk of significant impact when you lose skilled and experienced team members with institutional knowledge. Provide dedicated structured time for learning.\n            ",
        Title:
          "Team members are enabled and encouraged to maintain and grow their skill sets",
      },
      {
        ChoiceId: "ops_org_culture_team_res_appro",
        Description:
          "Maintain team member capacity, and provide tools and resources, to support your workload needs. Overtasking team members increases the risk of incidents resulting from human error. Investments in tools and resources (for example, providing automation for frequently executed activities) can scale the effectiveness of your team, enabling them to support additional activities.\n            ",
        Title: "Resource teams appropriately",
      },
      {
        ChoiceId: "ops_org_culture_diverse_inc_access",
        Description:
          "Leverage cross-organizational diversity to seek multiple unique perspectives. Use this perspective to increase innovation, challenge your assumptions, and reduce the risk of confirmation bias. Grow inclusion, diversity, and accessibility within your teams to gain beneficial perspectives.\n            ",
        Title:
          "Diverse opinions are encouraged and sought within and across teams",
      },
      {
        ChoiceId: "ops_org_culture_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "org-culture",
    QuestionTitle:
      "How does your organizational culture support your business outcomes?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_telemetry_application_telemetry",
        Description:
          "Instrument your application code to emit information about its internal state, status, and achievement of business outcomes. For example, queue depth, error messages, and response times. Use this information to determine when a response is required.\n            ",
        Title: "Implement application telemetry",
      },
      {
        ChoiceId: "ops_telemetry_workload_telemetry",
        Description:
          "Design and configure your workload to emit information about its internal state and current status. For example, API call volume, HTTP status codes, and scaling events. Use this information to help determine when a response is required.\n            ",
        Title: "Implement and configure workload telemetry",
      },
      {
        ChoiceId: "ops_telemetry_customer_telemetry",
        Description:
          "Instrument your application code to emit information about user activity, for example, click streams, or started, abandoned, and completed transactions. Use this information to help understand how the application is used, patterns of usage, and to determine when a response is required.\n            ",
        Title: "Implement user activity telemetry",
      },
      {
        ChoiceId: "ops_telemetry_dependency_telemetry",
        Description:
          "Design and configure your workload to emit information about the status (for example, reachability or response time) of resources it depends on. Examples of external dependencies can include, external databases, DNS, and network connectivity. Use this information to determine when a response is required.\n            ",
        Title: "Implement dependency telemetry",
      },
      {
        ChoiceId: "ops_telemetry_dist_trace",
        Description:
          "Implement your application code and configure your workload components to emit information about the flow of transactions across the workload. Use this information to determine when a response is required and to assist you in identifying the factors contributing to an issue.\n            ",
        Title: "Implement transaction traceability",
      },
      {
        ChoiceId: "ops_telemetry_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "telemetry",
    QuestionTitle:
      "How do you design your workload so that you can understand its state?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_dev_integ_version_control",
        Description:
          "Use version control to enable tracking of changes and releases.\n            ",
        Title: "Use version control",
      },
      {
        ChoiceId: "ops_dev_integ_test_val_chg",
        Description:
          "Test and validate changes to help limit and detect errors.Automate testing to reduce errors caused by manual processes, and reduce the level of effort to test.\n            ",
        Title: "Test and validate changes",
      },
      {
        ChoiceId: "ops_dev_integ_conf_mgmt_sys",
        Description:
          "Use configuration management systems to make and track configuration changes. These systems reduce errors caused by manual processes and reduce the level of effort to deploy changes. \n            ",
        Title: "Use configuration management systems",
      },
      {
        ChoiceId: "ops_dev_integ_build_mgmt_sys",
        Description:
          "Use build and deployment management systems.These systems reduce errors caused by manual processes and reduce the level of effort to deploy changes. \n            ",
        Title: "Use build and deployment management systems",
      },
      {
        ChoiceId: "ops_dev_integ_patch_mgmt",
        Description:
          "Perform patch management to gain features, address issues, and remain compliant with governance. Automate patch management to reduce errors caused by manual processes, and reduce the level of effort to patch.\n            ",
        Title: "Perform patch management",
      },
      {
        ChoiceId: "ops_dev_integ_share_design_stds",
        Description:
          "Share best practices across teams to increase awareness and maximize the benefits of development efforts.\n            ",
        Title: "Share design standards",
      },
      {
        ChoiceId: "ops_dev_integ_code_quality",
        Description:
          "Implement practices to improve code quality and minimize defects. For example, test-driven development, code reviews, and standards adoption.\n            ",
        Title: "Implement practices to improve code quality",
      },
      {
        ChoiceId: "ops_dev_integ_multi_env",
        Description:
          "Use multiple environments to experiment, develop, and test your workload. Use increasing levels of controls as environments approach production to gain confidence your workload will operate as intended when deployed.\n            ",
        Title: "Use multiple environments",
      },
      {
        ChoiceId: "ops_dev_integ_freq_sm_rev_chg",
        Description:
          "Frequent, small, and reversible changes reduce the scope and impact of a change.This eases troubleshooting, enables faster remediation, and provides the option to roll back a change.\n            ",
        Title: "Make frequent, small, reversible changes",
      },
      {
        ChoiceId: "ops_dev_integ_auto_integ_deploy",
        Description:
          "Automate build, deployment, and testing of the workload. This reduces errors caused by manual processes and reduces the effort to deploy changes.\n            ",
        Title: "Fully automate integration and deployment",
      },
      {
        ChoiceId: "ops_dev_integ_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "dev-integ",
    QuestionTitle:
      "How do you reduce defects, ease remediation, and improve flow into production?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_mit_deploy_risks_plan_for_unsucessful_changes",
        Description:
          "Plan to revert to a known good state, or remediate in the production environment if a change does not have the desired outcome.This preparation reduces recovery time through faster responses.\n            ",
        Title: "Plan for unsuccessful changes",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_test_val_chg",
        Description:
          "Test changes and validate the results at all lifecycle stages to confirm new features and minimize the risk and impact of failed deployments.\n            ",
        Title: "Test and validate changes",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_deploy_mgmt_sys",
        Description:
          "Use deployment management systems to track and implement change. This reduces errors cause by manual processes and reduces the effort to deploy changes.\n            ",
        Title: "Use deployment management systems",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_test_limited_deploy",
        Description:
          "Test with limited deployments alongside existing systems to confirm desired outcomes prior to full scale deployment.For example, use deployment canary testing or one-box deployments.\n            ",
        Title: "Test using limited deployments",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_deploy_to_parallel_env",
        Description:
          "Implement changes onto parallel environments, and then transition over to the new environment. Maintain the prior environment until there is confirmation of successful deployment. Doing so minimizes recovery time by enabling rollback to the previous environment.\n            ",
        Title: "Deploy using parallel environments",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_freq_sm_rev_chg",
        Description:
          "Use frequent, small, and reversible changes to reduce the scope of a change.This results in easier troubleshooting and faster remediation with the option to roll back a change.\n            ",
        Title: "Deploy frequent, small, reversible changes",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_auto_integ_deploy",
        Description:
          "Automate build, deployment, and testing of the workload. This reduces errors cause by manual processes and reduces the effort to deploy changes.\n            ",
        Title: "Fully automate integration and deployment",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_auto_testing_and_rollback",
        Description:
          "Automate testing of deployed environments to confirm desired outcomes.Automate rollback to previous known good state when outcomes are not achieved to minimize recovery time and reduce errors caused by manual processes.\n            ",
        Title: "Automate testing and rollback",
      },
      {
        ChoiceId: "ops_mit_deploy_risks_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "mit-deploy-risks",
    QuestionTitle: "How do you mitigate deployment risks?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_ready_to_support_personnel_capability",
        Description:
          "Have a mechanism to validate that you have the appropriate number of trained personnel to provide support for operational needs. Train personnel and adjust personnel capacity as necessary to maintain effective support.\n            ",
        Title: "Ensure personnel capability",
      },
      {
        ChoiceId: "ops_ready_to_support_const_orr",
        Description:
          "Ensure you have a consistent review of your readiness to operate a workload. Reviews must include, at a minimum, the operational readiness of the teams and the workload, and security requirements. Implement review activities in code and trigger automated review in response to events where appropriate, to ensure consistency, speed of execution, and reduce errors caused by manual processes.\n            ",
        Title: "Ensure consistent review of operational readiness",
      },
      {
        ChoiceId: "ops_ready_to_support_use_runbooks",
        Description:
          "Runbooks are documented procedures to achieve specific outcomes. Enable consistent and prompt responses to well-understood events by documenting procedures in runbooks. Implement runbooks as code and trigger the execution of runbooks in response to events where appropriate,to ensure consistency, speed responses, and reduce errors caused by manual processes.\n            ",
        Title: "Use runbooks to perform procedures",
      },
      {
        ChoiceId: "ops_ready_to_support_use_playbooks",
        Description:
          "Enable consistent and prompt responses to issues that are not well understood, by documenting the investigation process in playbooks. Playbooks are the predefined steps performed to identify the factors contributing to a failure scenario. The results from any process step are used to determine the next steps to take until the issue is identified or escalated.\n            ",
        Title: "Use playbooks to investigate issues",
      },
      {
        ChoiceId: "ops_ready_to_support_informed_deploy_decisions",
        Description:
          "Evaluate the capabilities of the team to support the workload and the workload's compliance with governance.Evaluate these against the benefits of deployment when determining whether to transition a system or change into production.Understand the benefits and risks to make informed decisions.\n            ",
        Title: "Make informed decisions to deploy systems and changes",
      },
      {
        ChoiceId: "ops_ready_to_support_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "ready-to-support",
    QuestionTitle: "How do you know that you are ready to support a workload?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_workload_health_define_workload_kpis",
        Description:
          "Identify key performance indicators (KPIs) based on desired business outcomes (for example, order rate, customer retention rate, and profit versus operating expense) and customer outcomes (for example, customer satisfaction). Evaluate KPIs to determine workload success.\n            ",
        Title: "Identify key performance indicators",
      },
      {
        ChoiceId: "ops_workload_health_design_workload_metrics",
        Description:
          "Define workload metrics to measure the achievement of KPIs (for example, abandoned shopping carts, orders placed, cost, price, and allocated workload expense). Define workload metrics to measure the health of the workload (for example, interface response time, error rate, requests made, requests completed, and utilization). Evaluate metrics to determine if the workload is achieving desired outcomes, and to understand the health of the workload.\n            ",
        Title: "Define workload metrics",
      },
      {
        ChoiceId: "ops_workload_health_collect_analyze_workload_metrics",
        Description:
          "Perform regular proactive reviews of metricsto identify trends and determine where appropriate responses are needed.\n            ",
        Title: "Collect and analyze workload metrics",
      },
      {
        ChoiceId: "ops_workload_health_workload_metric_baselines",
        Description:
          "Establish baselines for metrics to provide expected values as the basis for comparison and identification of under and over performing components. Identify thresholds for improvement, investigation, and intervention.\n            ",
        Title: "Establish workload metrics baselines",
      },
      {
        ChoiceId: "ops_workload_health_learn_workload_usage_patterns",
        Description:
          "Establish patterns of workload activity to identify anomalous behavior so that you can respond appropriately if required.\n            ",
        Title: "Learn expected patterns of activity for workload",
      },
      {
        ChoiceId: "ops_workload_health_workload_outcome_alerts",
        Description:
          "Raise an alert when workload outcomes are at risk so that you can respond appropriately if necessary.\n            ",
        Title: "Alert when workload outcomes are at risk",
      },
      {
        ChoiceId: "ops_workload_health_workload_anomaly_alerts",
        Description:
          "Raise an alert when workload anomalies are detected so that you can respond appropriately if necessary.\n            ",
        Title: "Alert when workload anomalies are detected",
      },
      {
        ChoiceId: "ops_workload_health_biz_level_view_workload",
        Description:
          "Create a business-level view of your workload operationsto help you determine if you are satisfying needs and to identify areas that need improvement to reach business goals.Validate the effectiveness of KPIs and metrics and revise them if necessary.\n            ",
        Title:
          "Validate the achievement of outcomes and the effectiveness of KPIs and metrics\n            ",
      },
      {
        ChoiceId: "ops_workload_health_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "workload-health",
    QuestionTitle: "How do you understand the health of your workload?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_operations_health_define_ops_kpis",
        Description:
          "Identify key performance indicators (KPIs) based on desired business (for example, new features delivered) and customer outcomes (for example, customer support cases). Evaluate KPIs to determine operations success.\n            ",
        Title: "Identify key performance indicators",
      },
      {
        ChoiceId: "ops_operations_health_design_ops_metrics",
        Description:
          "Define operations metrics to measure the achievement of KPIs (for example, successful deployments, and failed deployments). Define operations metrics to measure the health of operations activities (for example, mean time to detect an incident (MTTD), and mean time to recovery (MTTR) from an incident). Evaluate metrics to determine if operations are achieving desired outcomes, and to understand the health of your operations activities.\n            ",
        Title: "Define operations metrics",
      },
      {
        ChoiceId: "ops_operations_health_collect_analyze_ops_metrics",
        Description:
          "Perform regular, proactive reviews of metrics to identify trends and determine where appropriate responses are needed.\n            ",
        Title: "Collect and analyze operations metrics",
      },
      {
        ChoiceId: "ops_operations_health_ops_metric_baselines",
        Description:
          "Establish baselines for metrics to provide expected values as the basis for comparison and identification of under and over performing operations activities.\n            ",
        Title: "Establish operations metrics baselines",
      },
      {
        ChoiceId: "ops_operations_health_learn_ops_usage_patterns",
        Description:
          "Establish patterns of operations activities to identify anomalous activity so that you can respond appropriately if necessary.\n            ",
        Title: "Learn the expected patterns of activity for operations",
      },
      {
        ChoiceId: "ops_operations_health_ops_outcome_alerts",
        Description:
          "Raise an alert when operations outcomes are at risk so that you can respond appropriately if necessary.\n            ",
        Title: "Alert when operations outcomes are at risk",
      },
      {
        ChoiceId: "ops_operations_health_ops_anomaly_alerts",
        Description:
          "Raise an alert when operations anomalies are detected so that you can respond appropriately if necessary.\n            ",
        Title: "Alert when operations anomalies are detected",
      },
      {
        ChoiceId: "ops_operations_health_biz_level_view_ops",
        Description:
          "Create a business-level view of your operations activitiesto help you determine if you are satisfying needs and to identify areas that need improvement to reach business goals.Validate the effectiveness of KPIs and metrics and revise them if necessary.\n            ",
        Title:
          "Validate the achievement of outcomes and the effectiveness of KPIs and metrics\n            ",
      },
      {
        ChoiceId: "ops_operations_health_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "operations-health",
    QuestionTitle: "How do you understand the health of your operations?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_event_response_event_incident_problem_process",
        Description:
          "Have processes to address observed events, events that require intervention (incidents), and events that require intervention and either recur or cannot currently be resolved (problems). Use these processes to mitigate the impact of these events on the business and your customers by ensuring timely and appropriate responses.\n            ",
        Title: "Use processes for event, incident, and problem management",
      },
      {
        ChoiceId: "ops_event_response_process_per_alert",
        Description:
          "Have a well-defined response (runbook or playbook), with a specifically identified owner, for any event for which you raise an alert.This ensures effective and prompt responses to operations events and prevents actionable events from being obscured by less valuable notifications.\n            ",
        Title: "Have a process per alert",
      },
      {
        ChoiceId: "ops_event_response_prioritize_events",
        Description:
          "Ensure that when multiple events require intervention, those that are most significant to the business are addressed first.For example, impacts can include loss of life or injury, financial loss, or damage to reputation or trust.\n            ",
        Title: "Prioritize operational events based on business impact",
      },
      {
        ChoiceId: "ops_event_response_define_escalation_paths",
        Description:
          "Define escalation paths in your runbooks and playbooks, including what triggers escalation, andprocedures for escalation. Specifically identify owners for each action to ensure effective and prompt responses to operations events.\n            ",
        Title: "Define escalation paths",
      },
      {
        ChoiceId: "ops_event_response_push_notify",
        Description:
          "Communicate directly with your users (for example, with email or SMS) when the services they use are impacted, and again when the services return to normal operating conditions, to enable users to take appropriate action.\n            ",
        Title: "Enable push notifications",
      },
      {
        ChoiceId: "ops_event_response_dashboards",
        Description:
          "Provide dashboards tailored to their target audiences (for example, internal technical teams, leadership, and customers)to communicate the current operating status of the business and provide metrics of interest. \n            ",
        Title: "Communicate status through dashboards",
      },
      {
        ChoiceId: "ops_event_response_auto_event_response",
        Description:
          "Automate responses to events to reduce errors caused by manual processes, and to ensure prompt and consistent responses. \n            ",
        Title: "Automate responses to events",
      },
      {
        ChoiceId: "ops_event_response_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "event-response",
    QuestionTitle: "How do you manage workload and operations events?",
    Reason: "NONE",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
  {
    ChoiceAnswerSummaries: [],
    Choices: [
      {
        ChoiceId: "ops_evolve_ops_process_cont_imp",
        Description:
          "Regularly evaluate and prioritize opportunities for improvementto focus efforts where they can provide the greatest benefits.\n            ",
        Title: "Have a process for continuous improvement",
      },
      {
        ChoiceId: "ops_evolve_ops_perform_rca_process",
        Description:
          "Review customer-impacting events, and identify the contributing factorsand preventative actions. Use this information to develop mitigations to limit or prevent recurrence. Develop procedures for prompt and effective responses. Communicate contributing factors and corrective actions as appropriate, tailored to target audiences.\n            ",
        Title: "Perform post-incident analysis",
      },
      {
        ChoiceId: "ops_evolve_ops_feedback_loops",
        Description:
          "Include feedback loops in your procedures and workloadsto help you identify issues and areas that need improvement.\n            ",
        Title: "Implement feedback loops",
      },
      {
        ChoiceId: "ops_evolve_ops_knowledge_management",
        Description:
          "Mechanisms exist for your team members to discover the information that they are looking for in a timely manner, access it, and identify that it’s current and complete. Mechanisms are present to identify needed content, content in need of refresh, and content that should be archived so that it’s no longer referenced.\n            ",
        Title: "Perform Knowledge Management",
      },
      {
        ChoiceId: "ops_evolve_ops_drivers_for_imp",
        Description:
          "Identify drivers for improvement to help you evaluate and prioritize opportunities.\n            ",
        Title: "Define drivers for improvement",
      },
      {
        ChoiceId: "ops_evolve_ops_validate_insights",
        Description:
          "Review your analysis results and responses with cross-functional teams and business owners. Use these reviews to establish common understanding, identify additional impacts, and determine courses of action. Adjust responses as appropriate.\n            ",
        Title: "Validate insights",
      },
      {
        ChoiceId: "ops_evolve_ops_metrics_review",
        Description:
          "Regularly perform retrospective analysis of operations metrics with cross-team participants from different areas of the business. Use these reviews to identify opportunities for improvement, potential courses of action, and to share lessons learned.\n            ",
        Title: "Perform operations metrics reviews",
      },
      {
        ChoiceId: "ops_evolve_ops_share_lessons_learned",
        Description:
          "Document and share lessons learned from the execution of operations activities so that you can use them internally and across teams.\n            ",
        Title: "Document and share lessons learned",
      },
      {
        ChoiceId: "ops_evolve_ops_allocate_time_for_imp",
        Description:
          "Dedicate time and resources within your processes to make continuous incremental improvements possible.\n            ",
        Title: "Allocate time to make improvements",
      },
      {
        ChoiceId: "ops_evolve_ops_no",
        Description: "",
        Title: "None of these",
      },
    ],
    IsApplicable: true,
    PillarId: "operationalExcellence",
    QuestionId: "evolve-ops",
    QuestionTitle: "How do you evolve operations?",
    Risk: "UNANSWERED",
    SelectedChoices: [],
  },
];

export const Edit_Workload_Summaries_Metadata = {
  ImprovementStatus: {
    Complete: "COMPLETE",
    "In Progress": "IN_PROGRESS",
    None: "NOT_APPLICABLE",
    "Not Started": "NOT_STARTED",
    "Risk Acknowledged": "RISK_ACKNOWLEDGED",
  },
  Industry: {
    Agriculture: {
      Agriculture: "Agriculture",
    },
    Automotive: {
      Automotive: "Automotive",
    },
    Design_And_Engineering: {
      "Architecture & Construction": "Architecture_Construction",
      "Design and Engineering - Other": "Design_And_Engineering_Other",
      "Electronic Design Automation": "Electronic_Design_Automation",
    },
    Digital_Advertising: {
      "Ad Exchange": "Ad_Exchange",
      "Ad Network": "Ad_Network",
      Advertiser: "Advertiser",
      Agency: "Agency",
      "Data Provider": "Data_Provider",
      "Digital Advertising - Other": "Digital_Advertising_Other",
      Display: "Display",
      Mobile: "Mobile",
      Publisher: "Publisher",
      Search: "Search",
      Social: "Social",
      Video: "Video",
    },
    Education: {
      "Education - Other": "Education_Other",
      "Higher Ed & Research": "Higher_Ed_Research",
      "Primary & K-12": "Primary_K_12",
      Publishers: "Publishers",
      "Technology & Tools": "Technology_Tools",
    },
    Environmental_Protection: {
      "Environmental Protection": "Environmental_Protection",
    },
    Financial_Services: {
      "Capital Markets/Securities": "Capital_Markets_Securities",
      "Commercial Banking & Payments": "Commercial_Banking_Payments",
      "Financial Services - Other": "Financial_Services_Other",
      "Insurance (other than health)": "Insurance_Other_Than_Health",
      "Service Providers": "Service_Providers",
    },
    Gaming: {
      "Advertising, User Acquisition, and Monetization":
        "Advertising_User_Acquisition_And_Monetization",
      "Game Distribution": "Game_Distribution",
      "Game Production & Tools": "Game_Production_Tools",
      "Game Publishing": "Game_Publishing",
      "Gaming - Other": "Gaming_Other",
      "Gaming Platforms": "Gaming_Platforms",
      "Live Ops and Business Intelligence":
        "Live_Ops_And_Business_Intelligence",
    },
    General_Public_Services: {
      "General Public Services": "General_Public_Services",
    },
    Healthcare: {
      "Healthcare - Other": "Healthcare_Other",
      "Healthcare Providers": "Healthcare_Providers",
      "Independent Software Vendor - Consumer":
        "Independent_Software_Vendor_Consumer",
      "Independent Software Vendor - Providers":
        "Independent_Software_Vendor_Providers",
      "Independent Software Vendor - Public, Private Health Insurer or Health Authority":
        "Independent_Software_Vendor_Public_Private_Health_Insurer_Or_Health_Authority",
      "Insurer - Public, Private Health Insurer or Health Authority":
        "Insurer_Public_Private_Health_Insurer_Or_Health_Authority",
      "Solution Integrator": "Solution_Integrator",
    },
    Hospitality: {
      "Food Services": "Food_Services",
      "Hospitality - Other": "Hospitality_Other",
      "Hotels & Accommodations": "Hotels_Accommodations",
    },
    InfoTech: {
      "Computer & Electronics": "Computer_Electronics",
      "Infotech - Other": "Infotech_Other",
      Internet: "Internet",
      Semiconductors: "Semiconductors",
      Software: "Software",
    },
    Justice_And_Public_Safety: {
      "Justice and Public Safety": "Justice_And_Public_Safety",
    },
    Life_Sciences: {
      BioPharma: "BioPharma",
      Genomics: "Genomics",
      "Independent Software Vendor - Biopharma, Medical Device":
        "Independent_Software_Vendor_Biopharma_Medical_Device",
      "Independent Software Vendor - Genomics":
        "Independent_Software_Vendor_Genomics",
      "Life Sciences - Other": "Life_Sciences_Other",
      "Medical Device Manufacturer": "Medical_Device_Manufacturer",
      "Solution Integrator": "Solution_Integrator",
    },
    Manufacturing: {
      Aerospace: "Aerospace",
      Chemicals: "Chemicals",
      "Consumer/Packaged Goods": "Consumer_Packaged_Goods",
      "Food & Beverage": "Food_Beverage",
      "High Tech Manufacturing": "High_Tech_Manufacturing",
      "Industrial Manufacturing": "Industrial_Manufacturing",
      "Manufacturing - Other": "Manufacturing_Other",
      Metals: "Metals",
    },
    Media_Entertainment: {
      "Content Delivery: Broadcast & Over-the-top (OTT)":
        "Content_Delivery_Broadcast_Over_The_Top_OTT",
      "Content Production": "Content_Production",
      "Digital Publishing": "Digital_Publishing",
      "Media & Entertainment- Other": "Media_Entertainment_Other",
    },
    Mining_Resources: {
      Mining: "Mining",
      "Mining & Resources - Other": "Mining_Resources_Other",
      "Natural Resources": "Natural_Resources",
    },
    Oil_Gas: {
      "Downstream Oil & Gas Operations": "Downstream_Oil_Gas_Operations",
      "Integrated Oil & Gas Operations": "Integrated_Oil_Gas_Operations",
      "Midstream Oil & Gas Operations": "Midstream_Oil_Gas_Operations",
      "Oil & Gas - Other": "Oil_Gas_Other",
      "Oilfield Services & Equipment": "Oilfield_Services_Equipment",
      "Upstream Oil & Gas Operations": "Upstream_Oil_Gas_Operations",
    },
    Other: {},
    Power_Utilities: {
      "Diversified Utilities": "Diversified_Utilities",
      "Electric Utilities": "Electric_Utilities",
      "Independent Power Producers (IPP)": "Independent_Power_Producers_IPP",
      "Natural Gas Utilities": "Natural_Gas_Utilities",
      "Power & Utilities - Other": "Power_Utilities_Other",
      "Utility Services & Equipment": "Utility_Services_Equipment",
    },
    Professional_Services: {
      Accounting: "Accounting",
      "Consulting services/outsourcing": "Consulting_Services_Outsourcing",
      "Customer care": "Customer_Care",
      Legal: "Legal",
      "Professional Services - Other": "Professional_Services_Other",
      "Real Estate": "Real_Estate",
    },
    Real_Estate_Construction: {
      Construction: "Construction",
      "Real Estate": "Real_Estate",
      "Real Estate & Construction - Other": "Real_Estate_Construction_Other",
    },
    Retail_Wholesale: {
      "General Retail": "General_Retail",
      Grocery: "Grocery",
      "Retail & Wholesale - Other": "Retail_Wholesale_Other",
      "Specialty/Luxury": "Specialty_Luxury",
      Wholesale: "Wholesale",
      eCommerce: "ECommerce",
    },
    Social_Protection: {
      "Social Protection": "Social_Protection",
    },
    Telecommunications: {
      "Communication Service Provider - Communication as a Service (CaaS)":
        "Communication_Service_Provider_Communication_As_A_Service_CaaS",
      "Communication Service Provider Carrier - Infrastructure operator":
        "Communication_Service_Provider_Carrier_Infrastructure_Operator",
      "Communication Service Provider Carrier - Network provider":
        "Communication_Service_Provider_Carrier_Network_Provider",
      "Communication Service Provider Carrier - Satellite":
        "Communication_Service_Provider_Carrier_Satellite",
      "Communication Service Provider Carrier - Telecom":
        "Communication_Service_Provider_Carrier_Telecom",
      "Supplier, End-user side": "Supplier_End_User_Side",
      "Supplier, Provider side": "Supplier_Provider_Side",
      "Telecom Systems Integrator (SI) & Managed Service Provider (MSP)":
        "Telecom_Systems_Integrator_SI_Managed_Service_Provider_MSP",
      "Telecommunications - Other": "Telecommunications_Other",
    },
    Travel_Transportation_Logistics: {
      Airlines: "Airlines",
      Airports: "Airports",
      "Highway and Motor": "Highway_And_Motor",
      "Marine & Ports": "Travel_Marine_Ports",
      "Metropolitan and National Transit": "Metropolitan_And_National_Transit",
      "Postal/Intermodal": "Postal_Intermodal",
      Rail: "Rail",
      "Travel, Transportation & Logistics - Other":
        "Travel_Transportation_Logistics_Other",
      "Warehousing & Distribution": "Warehousing_Distribution",
    },
  },
  IndustryTypes: {
    "-": "-",
    Agriculture: "Agriculture",
    Automotive: "Automotive",
    Defense: "Defense",
    "Design and Engineering": "Design_And_Engineering",
    "Digital Advertising": "Digital_Advertising",
    Education: "Education",
    "Environmental Protection": "Environmental_Protection",
    "Financial Services": "Financial_Services",
    Gaming: "Gaming",
    "General Public Services": "General_Public_Services",
    Healthcare: "Healthcare",
    Hospitality: "Hospitality",
    InfoTech: "InfoTech",
    "Justice and Public Safety": "Justice_And_Public_Safety",
    "Life Sciences": "Life_Sciences",
    Manufacturing: "Manufacturing",
    "Media & Entertainment": "Media_Entertainment",
    "Mining & Resources": "Mining_Resources",
    "Oil & Gas": "Oil_Gas",
    Other: "Other",
    "Power & Utilities": "Power_Utilities",
    "Professional Services": "Professional_Services",
    "Real Estate & Construction": "Real_Estate_Construction",
    "Retail & Wholesale": "Retail_Wholesale",
    "Social Protection": "Social_Protection",
    Telecommunications: "Telecommunications",
    "Travel, Transportation & Logistics": "Travel_Transportation_Logistics",
  },
  Reasons: {
    "-": "NONE",
    "Architecture Constraints": "ARCHITECTURE_CONSTRAINTS",
    "Business Priorities": "BUSINESS_PRIORITIES",
    Other: "OTHER",
    "Out of Scope": "OUT_OF_SCOPE",
  },
};

export const Edit_Workload_Summaries = {
  Limit: 10,
  PageNumber: 1,
  WorkloadSummaries: [
    {
      AnsweredQuestions: 0,
      CreatedAt: "2023-03-30 06:35:40",
      Description: "Wafr-tetsing",
      DiagramURL: null,
      Environment: "PREPRODUCTION",
      ImprovementStatus: "NOT_APPLICABLE",
      InSync: 1,
      Industry: null,
      IndustryType: null,
      Lenses: "AWS Well-Architected Framework",
      Owner: "Sathish",
      RegionCode: "us-east-1",
      RiskCounts: {
        High: 0,
        Medium: 0,
      },
      Scope: [
        {
          AccountNumber: "897930493710",
          Regions: ["us-east-1", "us-east-2"],
        },
      ],
      Status: "PENDING",
      TotalQuestions: 58,
      UpdatedAt: "2023-03-30 06:31:15",
      WorkloadArn:
        "arn:aws:wellarchitected:us-east-1:688736627613:workload/7f8638d12c1a86640275f3754b9b8dc6",
      WorkloadId: "7f8638d12c1a86640275f3754b9b8dc6",
      WorkloadName: "Wafr-tetsing",
    },
    {
      AnsweredQuestions: 0,
      CreatedAt: "2023-03-29 06:04:33",
      Description: "Nikhil Test Review",
      DiagramURL: null,
      Environment: "PREPRODUCTION",
      ImprovementStatus: "NOT_APPLICABLE",
      InSync: 1,
      Industry: null,
      IndustryType: null,
      Lenses: "AWS Well-Architected Framework",
      Owner: "Nikhil",
      RegionCode: "us-east-1",
      RiskCounts: {
        High: 0,
        Medium: 0,
      },
      Scope: [
        {
          AccountNumber: "897930493710",
          Regions: ["us-east-1", "us-east-2"],
        },
      ],
      Status: "PENDING",
      TotalQuestions: 58,
      UpdatedAt: "2023-03-29 05:52:25",
      WorkloadArn:
        "arn:aws:wellarchitected:us-east-1:688736627613:workload/562778467c078ed875d7247e62bf3fb4",
      WorkloadId: "562778467c078ed875d7247e62bf3fb4",
      WorkloadName: "Nikhil Test Review",
    },
    {
      AnsweredQuestions: 0,
      CreatedAt: "2023-03-28 12:46:23",
      Description: "Well architected review for HumanTech Production Workload",
      DiagramURL: null,
      Environment: "PREPRODUCTION",
      ImprovementStatus: "NOT_APPLICABLE",
      InSync: 1,
      Industry: null,
      IndustryType: null,
      Lenses: "AWS Well-Architected Framework",
      Owner: "Vignesh",
      RegionCode: "us-east-1",
      RiskCounts: {
        High: 0,
        Medium: 0,
      },
      Scope: [
        {
          AccountNumber: "897930493710",
          Regions: ["us-east-1", "us-east-2"],
        },
      ],
      Status: "PENDING",
      TotalQuestions: 58,
      UpdatedAt: "2023-03-28 12:17:32",
      WorkloadArn:
        "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
      WorkloadId: "c85724c7cd1392a22b3c0059064baf5e",
      WorkloadName: "HumanTech Production Workload",
    },
    {
      AnsweredQuestions: 2,
      CreatedAt: "2023-03-23 06:24:00",
      Description: "test",
      DiagramURL: null,
      Environment: "PREPRODUCTION",
      ImprovementStatus: "NOT_APPLICABLE",
      InSync: 1,
      Industry: null,
      IndustryType: null,
      Lenses: "AWS Well-Architected Framework",
      Owner: "Yameen",
      RegionCode: "us-east-1",
      RiskCounts: {
        High: 2,
        Medium: 0,
      },
      Scope: [
        {
          AccountNumber: "897930493710",
          Regions: ["us-east-1", "us-east-2"],
        },
      ],
      Status: "PENDING",
      TotalQuestions: 58,
      UpdatedAt: "2023-03-23 06:15:27",
      WorkloadArn:
        "arn:aws:wellarchitected:us-east-1:688736627613:workload/4431ee7ce5ea4fa383aa0785a75bbf92",
      WorkloadId: "4431ee7ce5ea4fa383aa0785a75bbf92",
      WorkloadName: "new-Workload-testing",
    },
    {
      AnsweredQuestions: 7,
      CreatedAt: "2023-03-20 15:10:04",
      Description: "test",
      DiagramURL: null,
      Environment: "PREPRODUCTION",
      ImprovementStatus: "NOT_APPLICABLE",
      InSync: 1,
      Industry: null,
      IndustryType: null,
      Lenses: "AWS Well-Architected Framework",
      Owner: "Vignesh",
      RegionCode: "ap-northeast-1",
      RiskCounts: {
        High: 7,
        Medium: 0,
      },
      Scope: [
        {
          AccountNumber: "897930493710",
          Regions: ["us-east-1", "us-east-2"],
        },
      ],
      Status: "PENDING",
      TotalQuestions: 58,
      UpdatedAt: "2023-03-20 15:09:40",
      WorkloadArn:
        "arn:aws:wellarchitected:ap-northeast-1:688736627613:workload/e663daa16ee04b94d4d33824ca9b52a9",
      WorkloadId: "e663daa16ee04b94d4d33824ca9b52a9",
      WorkloadName: "WAFR tokyo test",
    },
    {
      AnsweredQuestions: 0,
      CreatedAt: "2023-03-17 02:10:01",
      Description: "test",
      DiagramURL: null,
      Environment: "PRODUCTION",
      ImprovementStatus: "NOT_APPLICABLE",
      InSync: 1,
      Industry: null,
      IndustryType: null,
      Lenses: "AWS Well-Architected Framework",
      Owner: "yameen",
      RegionCode: "us-east-1",
      RiskCounts: {
        High: 0,
        Medium: 0,
      },
      Scope: [
        {
          AccountNumber: "897930493710",
          Regions: ["us-east-1", "us-east-2"],
        },
      ],
      Status: "PENDING",
      TotalQuestions: 58,
      UpdatedAt: "2023-03-17 02:08:48",
      WorkloadArn:
        "arn:aws:wellarchitected:us-east-1:688736627613:workload/a0dc80788145d9ff7f5ff2689b3daff5",
      WorkloadId: "a0dc80788145d9ff7f5ff2689b3daff5",
      WorkloadName: "test-yameen-new-review",
    },
    {
      AnsweredQuestions: 0,
      CreatedAt: "2023-03-13 14:14:46",
      Description: "test",
      DiagramURL: null,
      Environment: "PRODUCTION",
      ImprovementStatus: "NOT_APPLICABLE",
      InSync: 1,
      Industry: null,
      IndustryType: "Defense",
      Lenses: "AWS Well-Architected Framework",
      Owner: "Ritu",
      RegionCode: "us-east-1",
      RiskCounts: {
        High: 0,
        Medium: 0,
      },
      Scope: [
        {
          AccountNumber: "897930493710",
          Regions: ["us-east-1", "us-east-2"],
        },
      ],
      Status: "PENDING",
      TotalQuestions: 58,
      UpdatedAt: "2023-03-13 13:58:54",
      WorkloadArn:
        "arn:aws:wellarchitected:us-east-1:688736627613:workload/be5ee675b3dba8427602b5e4cea6a3c7",
      WorkloadId: "be5ee675b3dba8427602b5e4cea6a3c7",
      WorkloadName: "bug free",
    },
    {
      AnsweredQuestions: 0,
      CreatedAt: "2023-03-13 13:49:09",
      Description: "new-test",
      DiagramURL: null,
      Environment: "PREPRODUCTION",
      ImprovementStatus: "NOT_APPLICABLE",
      InSync: 1,
      Industry: "Infotech_Other",
      IndustryType: "InfoTech",
      Lenses: "AWS Well-Architected Framework",
      Owner: "Laxman",
      RegionCode: "us-east-1",
      RiskCounts: {
        High: 0,
        Medium: 0,
      },
      Scope: [
        {
          AccountNumber: "897930493710",
          Regions: ["us-east-1", "us-east-2"],
        },
      ],
      Status: "PENDING",
      TotalQuestions: 58,
      UpdatedAt: "2023-03-13 13:28:53",
      WorkloadArn:
        "arn:aws:wellarchitected:us-east-1:688736627613:workload/2db5baa71f8076f5069ddcb1ddc5074a",
      WorkloadId: "2db5baa71f8076f5069ddcb1ddc5074a",
      WorkloadName: "new-test",
    },
    {
      AnsweredQuestions: 0,
      CreatedAt: "2023-03-13 07:06:08",
      Description: "desc",
      DiagramURL: null,
      Environment: "PREPRODUCTION",
      ImprovementStatus: "NOT_APPLICABLE",
      InSync: 1,
      Industry: null,
      IndustryType: null,
      Lenses: "AWS Well-Architected Framework",
      Owner: "Gaurav Nadar",
      RegionCode: "us-east-1",
      RiskCounts: {
        High: 0,
        Medium: 0,
      },
      Scope: [
        {
          AccountNumber: "897930493710",
          Regions: ["us-east-1", "us-east-2"],
        },
      ],
      Status: "PENDING",
      TotalQuestions: 58,
      UpdatedAt: "2023-03-13 06:59:40",
      WorkloadArn:
        "arn:aws:wellarchitected:us-east-1:688736627613:workload/4a704678de9579b36842fdfa748e5495",
      WorkloadId: "4a704678de9579b36842fdfa748e5495",
      WorkloadName: "BUg Bash prep",
    },
    {
      AnsweredQuestions: 0,
      CreatedAt: "2023-03-13 06:27:47",
      Description: "test",
      DiagramURL: null,
      Environment: "PRODUCTION",
      ImprovementStatus: "NOT_APPLICABLE",
      InSync: 1,
      Industry: null,
      IndustryType: "Defense",
      Lenses: "AWS Well-Architected Framework",
      Owner: "Ritu",
      RegionCode: "us-east-1",
      RiskCounts: {
        High: 0,
        Medium: 0,
      },
      Scope: [
        {
          AccountNumber: "897930493710",
          Regions: ["us-east-1", "us-east-2"],
        },
      ],
      Status: "PENDING",
      TotalQuestions: 58,
      UpdatedAt: "2023-03-13 06:27:14",
      WorkloadArn:
        "arn:aws:wellarchitected:us-east-1:688736627613:workload/6a4cb5d1b936dd88d51a786466e25e5e",
      WorkloadId: "6a4cb5d1b936dd88d51a786466e25e5e",
      WorkloadName: "Mt review",
    },
  ],
};

export const Edit_Workload_Acc_Details = [
  {
    Accounts: [
      {
        AccountName: "Locker edit",
        AccountNumber: "897930493710",
        CustomerAccountId: "af49a2b8-e2d9-488d-af94-001995e72c9b",
        OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
        Regions: [
          {
            RegionCode: "eastus",
            Status: "FAILED TO CONNECT",
          },
          {
            RegionCode: "us-east-1",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-east-2",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-west-1",
            Status: "FAILED TO CONNECT",
          },
        ],
        Status: "CONNECTED",
      },
    ],
    Applications: 12,
    CreatedBy: "86d099b7-d215-4dbc-ace6-251fbad702f8",
    CreatedOn: "2023-02-14 10:15:21",
    Description: "",
    ID: "5d3a95d6-7a96-4dc1-8bf4-6a2849f1b1ba",
    Metadata: {
      BudgetExist: true,
      BudgetValue: 867324,
      GroupName: "",
      Owner: "",
      PointPerson: "",
    },
    ModifiedBy: null,
    ModifiedOn: "2023-04-05 10:25:46",
    Name: "Acme test",
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Preferences: null,
    Services: {
      Blueprints: [
        "5a40530a-dcc9-4e9d-84de-f20ca46665ee",
        "5838f0ee-8496-4dfc-88bb-f676dabf216d",
        "488c7b8e-57ed-4a95-95d0-d47b51e81039",
        "450604ef-aa07-460f-9a90-dbbe264eb66f",
        "3c7f394f-92c5-42d0-848f-2692a44f4b14",
        "2aa4a866-1e44-48b7-a7da-3ed0dfe06b2d",
        "2976bb96-df8b-4a59-90c9-0088b6faae1a",
        "28572d6a-680d-4a2a-8453-3162113a4b32",
        "2412bf76-208b-48c0-a70b-4b04d2561615",
        "24e69f99-d5a2-5a69-a2ac-babc2d6dbdca",
        "94e292b0-21f8-578a-890c-de7e872c0d28",
        "042e3d05-8c94-49e4-830a-f0083b091104",
        "c5b440c6-bcbd-4984-b142-fff9758c1131",
        "8dd3f91d-6a4a-46d0-8f78-85fddb75473b",
        "c15b08ba-a29c-48ad-ab37-ced52cb7e799",
        "7b7351f1-882e-469f-9312-2993232e97fb",
        "176bd608-255e-459a-ba15-409cb8eb2512",
        "214c0e08-0786-449a-8373-dc8cefde3f35",
        "ef83f475-d98e-46b6-bf39-3454ddb76d82",
        "5359d721-9a81-4518-bea1-73a30930138a",
      ],
      Other: null,
    },
    Type: null,
    Users: 29,
  },
  {
    Accounts: [],
    Applications: 0,
    CreatedBy: "9462ef18-3f7f-4c70-a833-95c42a821cf3",
    CreatedOn: "2023-01-10 06:51:22",
    Description: "",
    ID: "b076636c-6bd4-4aa7-a195-fe0906341100",
    Metadata: {
      BudgetExist: false,
      BudgetValue: 0,
      GroupName: "",
      Owner: "",
      PointPerson: "",
    },
    ModifiedBy: null,
    ModifiedOn: "2023-04-05 10:22:43",
    Name: "Backend Team",
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Preferences: null,
    Services: {
      Blueprints: [
        "94e292b0-21f8-578a-890c-de7e872c0d28",
        "042e3d05-8c94-49e4-830a-f0083b091104",
        "30c612cf-9ec3-41ec-bb89-e249e1c9d9df",
        "00db3318-a5d6-419c-927c-93c724560869",
        "7b7351f1-882e-469f-9312-2993232e97fb",
        "ef83f475-d98e-46b6-bf39-3454ddb76d82",
      ],
      Other: null,
    },
    Type: null,
    Users: 31,
  },
  {
    Accounts: [],
    Applications: 1,
    CreatedBy: "7944c3b1-2eb7-439f-8076-f69883c69ee1",
    CreatedOn: "2022-11-17 08:32:11",
    Description:
      "It is in London, and if you want to get into the Ministry of Magic you disappear down a London telephone box.",
    ID: "99dcc04a-2929-4ae6-af03-826dad7f680c",
    Metadata: {
      BudgetExist: false,
      BudgetValue: 0,
      GroupName: "",
      Owner: "Kulsum",
      PointPerson: "",
    },
    ModifiedBy: null,
    ModifiedOn: "2023-04-05 10:22:43",
    Name: "Diagon Alley",
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Preferences: null,
    Services: {
      Blueprints: [
        "08ba970e-c190-5bd5-8576-df5ac27bdf0b",
        "00db3318-a5d6-419c-927c-93c724560869",
        "7b7351f1-882e-469f-9312-2993232e97fb",
        "ef83f475-d98e-46b6-bf39-3454ddb76d82",
      ],
      Other: null,
    },
    Type: null,
    Users: 29,
  },
  {
    Accounts: [
      {
        AccountName: "Locker edit",
        AccountNumber: "897930493710",
        CustomerAccountId: "af49a2b8-e2d9-488d-af94-001995e72c9b",
        OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
        Regions: [
          {
            RegionCode: "eastus",
            Status: "FAILED TO CONNECT",
          },
          {
            RegionCode: "us-east-1",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-east-2",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-west-1",
            Status: "FAILED TO CONNECT",
          },
        ],
        Status: "CONNECTED",
      },
    ],
    Applications: 3,
    CreatedBy: "6c4140ff-e4d7-46b8-b3a3-4e7cb4163f7d",
    CreatedOn: "2023-03-20 10:53:40",
    Description: "",
    ID: "e30acfad-593f-4005-b4ae-392c5d917a4a",
    Metadata: {
      BudgetExist: false,
      BudgetValue: 0,
      GroupName: "",
      Owner: "",
      PointPerson: "",
    },
    ModifiedBy: null,
    ModifiedOn: "2023-04-10 12:07:35",
    Name: "Export Test GN",
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Preferences: null,
    Services: {
      Blueprints: [
        "bbe4019e-158f-5d37-ba55-8a0fb0836af4",
        "0c17105c-5a9d-5888-a3a1-49886721bcaa",
      ],
      Other: null,
    },
    Type: null,
    Users: 27,
  },
  {
    Accounts: [
      {
        AccountName: "Locker edit",
        AccountNumber: "897930493710",
        CustomerAccountId: "af49a2b8-e2d9-488d-af94-001995e72c9b",
        OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
        Regions: [
          {
            RegionCode: "eastus",
            Status: "FAILED TO CONNECT",
          },
          {
            RegionCode: "us-east-1",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-east-2",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-west-1",
            Status: "FAILED TO CONNECT",
          },
        ],
        Status: "CONNECTED",
      },
    ],
    Applications: 2,
    CreatedBy: "9ee358e8-e55a-4664-88b6-49d09761ce40",
    CreatedOn: "2023-02-20 04:29:23",
    Description: "",
    ID: "9b9d4531-695c-4fd1-8789-a736221de138",
    Metadata: {
      BudgetExist: false,
      BudgetValue: 0,
      GroupName: "",
      Owner: "",
      PointPerson: "",
    },
    ModifiedBy: null,
    ModifiedOn: "2023-04-05 10:22:43",
    Name: "God Mode On",
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Preferences: null,
    Services: {
      Blueprints: [
        "b053a609-b73b-5bc7-af60-d01b9467cdbd",
        "94e292b0-21f8-578a-890c-de7e872c0d28",
        "8af3eacb-92bf-5a5b-8c28-ab492226f12b",
        "84c5f11c-af6f-5bf0-97ef-a76b9f03c0bb",
        "24e69f99-d5a2-5a69-a2ac-babc2d6dbdca",
        "0b29c85a-5947-50c5-8ab0-6c242d491ab5",
        "00db3318-a5d6-419c-927c-93c724560869",
        "7b7351f1-882e-469f-9312-2993232e97fb",
        "dc19fae4-75ba-4e1a-a007-e437498e7507",
        "ef83f475-d98e-46b6-bf39-3454ddb76d82",
      ],
      Other: null,
    },
    Type: null,
    Users: 27,
  },
  {
    Accounts: [],
    Applications: 1,
    CreatedBy: "08ccebd4-f4a0-4ba2-97e8-40638c9426a2",
    CreatedOn: "2020-03-31 11:34:28",
    Description:
      "We’ve all got both light and dark inside us. What matters is the part we choose to act on. That’s who we really are.",
    ID: "310e2c7a-6b76-4caf-a037-8b05f713e167",
    Metadata: {
      BudgetExist: true,
      BudgetValue: 1000,
      Owner: "Kulsum",
    },
    ModifiedBy: null,
    ModifiedOn: "2023-04-05 10:22:43",
    Name: "Gryffindor",
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Preferences: null,
    Services: {
      Blueprints: [
        "8af3eacb-92bf-5a5b-8c28-ab492226f12b",
        "326d7cf5-9f6f-5170-85c8-2d1719bd3ec7",
        "84c5f11c-af6f-5bf0-97ef-a76b9f03c0bb",
        "b053a609-b73b-5bc7-af60-d01b9467cdbd",
        "94e292b0-21f8-578a-890c-de7e872c0d28",
        "0267d952-ab17-54ec-9e5b-b11af1285f4d",
        "0b29c85a-5947-50c5-8ab0-6c242d491ab5",
        "0c17105c-5a9d-5888-a3a1-49886721bcaa",
        "10d9a58e-3cc8-51ee-bfd9-8d39da171138",
        "2412bf76-208b-48c0-a70b-4b04d2561615",
        "2518b14a-951a-4772-8a15-2749bcd21843",
        "28572d6a-680d-4a2a-8453-3162113a4b32",
        "2976bb96-df8b-4a59-90c9-0088b6faae1a",
        "2aa4a866-1e44-48b7-a7da-3ed0dfe06b2d",
        "3c7f394f-92c5-42d0-848f-2692a44f4b14",
        "450604ef-aa07-460f-9a90-dbbe264eb66f",
        "5838f0ee-8496-4dfc-88bb-f676dabf216d",
        "5a40530a-dcc9-4e9d-84de-f20ca46665ee",
        "5e96ab29-abeb-56e1-b8f1-cf1895488199",
        "66e306eb-646d-43fd-b0d5-b4e532fea3b0",
        "76b9c64a-db20-4c71-8c5b-dfd69bb28a7b",
        "887f7a6c-427c-4a9b-8d68-08b9072d5017",
        "896f2af5-a09a-4bbb-a952-f0c12d72bb76",
        "8abee458-ac9d-4d33-be42-45e8c98ea172",
        "8ac90dde-ffb1-4177-b678-56f1c7478f3d",
        "98c9a8ef-79c4-4b9b-9013-7d8c4e857cfd",
        "9ab9922b-f8e8-4f51-89e0-39bbc7325451",
        "aa112a51-79d5-4f88-af59-526e86d2803f",
        "ab89f429-cea7-4ff2-9f30-8bed3499c092",
        "c80bfcc9-5482-4c2d-aa28-94d4384098ba",
        "cf53957c-2098-528d-b7e2-bef656582db2",
        "d182cd7b-15e2-4b49-a08e-24b5b36355b1",
        "d470daa7-668b-440d-beac-7b526179ec90",
        "da5adf8b-2263-4070-9a2b-7a6ce2296457",
        "f127e873-c7df-487c-8496-68bec677907b",
        "f5e9d355-9019-45f9-9bd2-c5620ad5c59a",
        "f91929b3-fca5-4cb4-922f-1fa0aae10f1f",
        "fe63f6bc-f503-4e93-9f05-f26a2b393692",
        "fb15c7c5-b104-44f8-9f47-4e4cec013686",
        "67c9c7d5-5e60-4b78-bc9c-c6e245ff2c3f",
        "bacda6cc-3ebf-4138-93cc-5173f78d0382",
        "6c4d62bd-4545-4f26-8ee9-4f0495967df8",
        "4f87c6eb-b580-452b-827b-cfbdf6a37a8f",
        "e1914a8f-48ef-4a05-9d0b-06c064cb93bd",
        "00db3318-a5d6-419c-927c-93c724560869",
        "7b7351f1-882e-469f-9312-2993232e97fb",
        "ef83f475-d98e-46b6-bf39-3454ddb76d82",
      ],
      Other: null,
    },
    Type: null,
    Users: 37,
  },
  {
    Accounts: [],
    Applications: 0,
    CreatedBy: "7944c3b1-2eb7-439f-8076-f69883c69ee1",
    CreatedOn: "2022-12-06 06:28:46",
    Description: "Hogsmeade looked like a Christmas card!!",
    ID: "244f8d31-876a-4a89-b64a-f02f87d0e617",
    Metadata: {
      BudgetExist: false,
      BudgetValue: 0,
      GroupName: "",
      Owner: "Kulsum",
      PointPerson: "",
    },
    ModifiedBy: null,
    ModifiedOn: "2023-04-05 10:22:43",
    Name: "Hogsmeade",
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Preferences: null,
    Services: {
      Blueprints: [
        "bbe4019e-158f-5d37-ba55-8a0fb0836af4",
        "0267d952-ab17-54ec-9e5b-b11af1285f4d",
        "29028135-5a54-5409-8081-8bd1c2eec2a3",
        "326d7cf5-9f6f-5170-85c8-2d1719bd3ec7",
        "66e306eb-646d-43fd-b0d5-b4e532fea3b0",
        "6c4d62bd-4545-4f26-8ee9-4f0495967df8",
        "74253a61-108b-5a8f-80f5-8b90479dd19c",
        "94e292b0-21f8-578a-890c-de7e872c0d28",
        "b053a609-b73b-5bc7-af60-d01b9467cdbd",
        "ff81cc4a-bb19-4fe7-8d16-0beaf2ef7e75",
        "00db3318-a5d6-419c-927c-93c724560869",
        "7b7351f1-882e-469f-9312-2993232e97fb",
        "ef83f475-d98e-46b6-bf39-3454ddb76d82",
      ],
      Other: null,
    },
    Type: null,
    Users: 28,
  },
  {
    Accounts: [],
    Applications: 0,
    CreatedBy: "08ccebd4-f4a0-4ba2-97e8-40638c9426a2",
    CreatedOn: "2022-04-29 12:31:00",
    Description:
      "It is not fair to ask of others what you are not willing to do yourself.",
    ID: "ce732a3b-2b96-45ff-ab97-505aa80efe08",
    Metadata: {
      BudgetValue: 0,
      Owner: "Kulsum",
      PointPerson: "Kulsum",
    },
    ModifiedBy: null,
    ModifiedOn: "2023-04-05 10:22:43",
    Name: "Hufflepuff",
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Preferences: null,
    Services: {
      Blueprints: [
        "0c17105c-5a9d-5888-a3a1-49886721bcaa",
        "8ac90dde-ffb1-4177-b678-56f1c7478f3d",
        "bbe4019e-158f-5d37-ba55-8a0fb0836af4",
        "df8a21c3-f645-569e-b92d-8f812bb4df9d",
        "026eebea-44ce-4cbc-a4e3-34ce64272411",
        "12605bf8-955b-497f-957d-891338d908a4",
        "8731d9f7-67b7-4119-9fba-0166074dba5f",
        "88d085d8-90b7-40e3-a839-804963feed1b",
        "8925ef4e-213d-43a6-a438-76ff4cc13c8f",
        "f5a15cf8-33d9-4e6c-bb05-7f9ce8b03572",
        "871bbf95-caef-46aa-ba87-59cd4a20896f",
        "5838f0ee-8496-4dfc-88bb-f676dabf216d",
        "0647f4ba-e4b6-4297-a542-26282d0f9836",
        "ab89f429-cea7-4ff2-9f30-8bed3499c092",
        "634ebc2c-d156-4a84-90a8-bf4f56604660",
        "fbe9b3f4-b88a-4b55-b7de-1c0ea3c442aa",
        "8d465ad5-5d13-4965-9b1f-6cc2e564ddfa",
        "f5e9d355-9019-45f9-9bd2-c5620ad5c59a",
        "d3e0feb0-5755-4079-8397-c010d46aadf1",
        "c682dda2-be25-4ddb-ac64-22cd66b99000",
        "488c7b8e-57ed-4a95-95d0-d47b51e81039",
        "bacda6cc-3ebf-4138-93cc-5173f78d0382",
        "6c4d62bd-4545-4f26-8ee9-4f0495967df8",
        "4f87c6eb-b580-452b-827b-cfbdf6a37a8f",
        "00db3318-a5d6-419c-927c-93c724560869",
        "7b7351f1-882e-469f-9312-2993232e97fb",
        "ef83f475-d98e-46b6-bf39-3454ddb76d82",
      ],
      Other: null,
    },
    Type: null,
    Users: 30,
  },
  {
    Accounts: [
      {
        AccountName: "Locker edit",
        AccountNumber: "897930493710",
        CustomerAccountId: "af49a2b8-e2d9-488d-af94-001995e72c9b",
        OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
        Regions: [
          {
            RegionCode: "eastus",
            Status: "FAILED TO CONNECT",
          },
          {
            RegionCode: "us-east-1",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-east-2",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-west-1",
            Status: "FAILED TO CONNECT",
          },
        ],
        Status: "CONNECTED",
      },
    ],
    Applications: 1,
    CreatedBy: "5c481e4a-8fef-4c31-86ad-1579c6261aa3",
    CreatedOn: "2023-03-06 12:44:51",
    Description: "kk",
    ID: "2877707b-a3d2-4772-80ec-f2f96ecbde6e",
    Metadata: {
      BudgetExist: false,
      BudgetValue: 0,
      GroupName: "kk",
      Owner: "",
      PointPerson: "kk",
    },
    ModifiedBy: null,
    ModifiedOn: "2023-04-05 10:22:43",
    Name: "kk",
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Preferences: null,
    Services: {
      Blueprints: [
        "0b29c85a-5947-50c5-8ab0-6c242d491ab5",
        "00db3318-a5d6-419c-927c-93c724560869",
        "7b7351f1-882e-469f-9312-2993232e97fb",
        "ef83f475-d98e-46b6-bf39-3454ddb76d82",
      ],
      Other: null,
    },
    Type: null,
    Users: 27,
  },
  {
    Accounts: [
      {
        AccountName: "Locker edit",
        AccountNumber: "897930493710",
        CustomerAccountId: "af49a2b8-e2d9-488d-af94-001995e72c9b",
        OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
        Regions: [
          {
            RegionCode: "eastus",
            Status: "FAILED TO CONNECT",
          },
          {
            RegionCode: "us-east-1",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-east-2",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-west-1",
            Status: "FAILED TO CONNECT",
          },
        ],
        Status: "CONNECTED",
      },
    ],
    Applications: 2,
    CreatedBy: "86d099b7-d215-4dbc-ace6-251fbad702f8",
    CreatedOn: "2023-03-14 10:11:21",
    Description: "",
    ID: "ae9e2d38-2e0c-4f8b-a77d-c0381d1f09e5",
    Metadata: {
      BudgetExist: false,
      BudgetValue: 0,
      GroupName: "",
      Owner: "",
      PointPerson: "",
    },
    ModifiedBy: null,
    ModifiedOn: "2023-04-05 10:22:43",
    Name: "MT test project",
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Preferences: null,
    Services: {
      Blueprints: [
        "0267d952-ab17-54ec-9e5b-b11af1285f4d",
        "e390f69e-7740-4b0e-ae2b-8d8c89d2984f",
        "00db3318-a5d6-419c-927c-93c724560869",
        "7b7351f1-882e-469f-9312-2993232e97fb",
        "ef83f475-d98e-46b6-bf39-3454ddb76d82",
      ],
      Other: null,
    },
    Type: null,
    Users: 27,
  },
  {
    Accounts: [
      {
        AccountName: "Locker edit",
        AccountNumber: "897930493710",
        CustomerAccountId: "af49a2b8-e2d9-488d-af94-001995e72c9b",
        OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
        Regions: [
          {
            RegionCode: "eastus",
            Status: "FAILED TO CONNECT",
          },
          {
            RegionCode: "us-east-1",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-east-2",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-west-1",
            Status: "FAILED TO CONNECT",
          },
        ],
        Status: "CONNECTED",
      },
    ],
    Applications: 1,
    CreatedBy: "9ee358e8-e55a-4664-88b6-49d09761ce40",
    CreatedOn: "2023-02-17 12:33:41",
    Description: "Only for testing",
    ID: "b2ed495e-e248-40ab-98d2-414085a681d0",
    Metadata: {
      BudgetExist: false,
      BudgetValue: 0,
      GroupName: "",
      Owner: "",
      PointPerson: "",
    },
    ModifiedBy: null,
    ModifiedOn: "2023-04-05 10:22:43",
    Name: "Multitenancy Test Storage",
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Preferences: null,
    Services: {
      Blueprints: [
        "8af3eacb-92bf-5a5b-8c28-ab492226f12b",
        "94e292b0-21f8-578a-890c-de7e872c0d28",
        "84c5f11c-af6f-5bf0-97ef-a76b9f03c0bb",
        "326d7cf5-9f6f-5170-85c8-2d1719bd3ec7",
        "24e69f99-d5a2-5a69-a2ac-babc2d6dbdca",
        "0b29c85a-5947-50c5-8ab0-6c242d491ab5",
        "00db3318-a5d6-419c-927c-93c724560869",
        "7b7351f1-882e-469f-9312-2993232e97fb",
        "ef83f475-d98e-46b6-bf39-3454ddb76d82",
      ],
      Other: null,
    },
    Type: null,
    Users: 27,
  },
  {
    Accounts: [
      {
        AccountName: "Locker edit",
        AccountNumber: "897930493710",
        CustomerAccountId: "af49a2b8-e2d9-488d-af94-001995e72c9b",
        OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
        Regions: [
          {
            RegionCode: "eastus",
            Status: "FAILED TO CONNECT",
          },
          {
            RegionCode: "us-east-1",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-east-2",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-west-1",
            Status: "FAILED TO CONNECT",
          },
        ],
        Status: "CONNECTED",
      },
    ],
    Applications: 1,
    CreatedBy: "08ccebd4-f4a0-4ba2-97e8-40638c9426a2",
    CreatedOn: "2023-02-10 08:09:44",
    Description: "For all the testing",
    ID: "3ce60be6-4827-48f6-8f38-2a500c872061",
    Metadata: {
      BudgetExist: false,
      BudgetValue: 0,
      GroupName: "TEsting",
      Owner: "Rajiv",
      PointPerson: "Rajiv",
    },
    ModifiedBy: null,
    ModifiedOn: "2023-04-05 10:22:43",
    Name: "Rajiv",
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Preferences: null,
    Services: {
      Blueprints: [
        "0c17105c-5a9d-5888-a3a1-49886721bcaa",
        "00db3318-a5d6-419c-927c-93c724560869",
        "7b7351f1-882e-469f-9312-2993232e97fb",
        "ef83f475-d98e-46b6-bf39-3454ddb76d82",
      ],
      Other: null,
    },
    Type: null,
    Users: 27,
  },
  {
    Accounts: [],
    Applications: 0,
    CreatedBy: "08ccebd4-f4a0-4ba2-97e8-40638c9426a2",
    CreatedOn: "2022-05-23 10:04:29",
    Description:
      "The things we lose have a way of coming back to us in the end, if not always in the way we expect.",
    ID: "7a2c605a-eb24-4dbd-990d-3df667c3ca22",
    Metadata: {
      Owner: "Kulsum",
    },
    ModifiedBy: null,
    ModifiedOn: "2023-04-05 10:22:43",
    Name: "Ravenclaw",
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Preferences: null,
    Services: {
      Blueprints: [
        "08ba970e-c190-5bd5-8576-df5ac27bdf0b",
        "0267d952-ab17-54ec-9e5b-b11af1285f4d",
        "0c17105c-5a9d-5888-a3a1-49886721bcaa",
        "026eebea-44ce-4cbc-a4e3-34ce64272411",
        "12605bf8-955b-497f-957d-891338d908a4",
        "8731d9f7-67b7-4119-9fba-0166074dba5f",
        "88d085d8-90b7-40e3-a839-804963feed1b",
        "8925ef4e-213d-43a6-a438-76ff4cc13c8f",
        "f5a15cf8-33d9-4e6c-bb05-7f9ce8b03572",
        "871bbf95-caef-46aa-ba87-59cd4a20896f",
        "5838f0ee-8496-4dfc-88bb-f676dabf216d",
        "0647f4ba-e4b6-4297-a542-26282d0f9836",
        "ab89f429-cea7-4ff2-9f30-8bed3499c092",
        "634ebc2c-d156-4a84-90a8-bf4f56604660",
        "fbe9b3f4-b88a-4b55-b7de-1c0ea3c442aa",
        "8d465ad5-5d13-4965-9b1f-6cc2e564ddfa",
        "f5e9d355-9019-45f9-9bd2-c5620ad5c59a",
        "d3e0feb0-5755-4079-8397-c010d46aadf1",
        "bacda6cc-3ebf-4138-93cc-5173f78d0382",
        "6c4d62bd-4545-4f26-8ee9-4f0495967df8",
        "4f87c6eb-b580-452b-827b-cfbdf6a37a8f",
        "00db3318-a5d6-419c-927c-93c724560869",
        "7b7351f1-882e-469f-9312-2993232e97fb",
        "ef83f475-d98e-46b6-bf39-3454ddb76d82",
      ],
      Other: null,
    },
    Type: null,
    Users: 27,
  },
  {
    Accounts: [
      {
        AccountName: "Locker edit",
        AccountNumber: "897930493710",
        CustomerAccountId: "af49a2b8-e2d9-488d-af94-001995e72c9b",
        OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
        Regions: [
          {
            RegionCode: "eastus",
            Status: "FAILED TO CONNECT",
          },
          {
            RegionCode: "us-east-1",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-east-2",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-west-1",
            Status: "FAILED TO CONNECT",
          },
        ],
        Status: "CONNECTED",
      },
    ],
    Applications: 0,
    CreatedBy: "08ccebd4-f4a0-4ba2-97e8-40638c9426a2",
    CreatedOn: "2023-04-03 14:33:35",
    Description: "",
    ID: "3703d826-10c1-4029-8cae-496433f32c4a",
    Metadata: {
      BudgetExist: false,
      BudgetValue: 0,
      GroupName: "",
      MeetingId: null,
      MeetingScheduledOn: "2023-04-03",
      MeetingScheduledWith: null,
      Owner: "",
      PointPerson: "",
      RequestedBy: "55f6d24b-f74c-4b04-b390-b8bd877d307a",
    },
    ModifiedBy: null,
    ModifiedOn: "2023-04-05 10:22:43",
    Name: "Req 8",
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Preferences: null,
    Services: {
      Blueprints: [
        "0c17105c-5a9d-5888-a3a1-49886721bcaa",
        "00db3318-a5d6-419c-927c-93c724560869",
        "7b7351f1-882e-469f-9312-2993232e97fb",
        "ef83f475-d98e-46b6-bf39-3454ddb76d82",
      ],
      Other: null,
    },
    Type: "PROJECT",
    Users: 27,
  },
  {
    Accounts: [
      {
        AccountName: "Locker edit",
        AccountNumber: "897930493710",
        CustomerAccountId: "af49a2b8-e2d9-488d-af94-001995e72c9b",
        OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
        Regions: [
          {
            RegionCode: "eastus",
            Status: "FAILED TO CONNECT",
          },
          {
            RegionCode: "us-east-1",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-east-2",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-west-1",
            Status: "FAILED TO CONNECT",
          },
        ],
        Status: "CONNECTED",
      },
    ],
    Applications: 0,
    CreatedBy: "5c481e4a-8fef-4c31-86ad-1579c6261aa3",
    CreatedOn: "2023-03-28 09:03:35",
    Description: "",
    ID: "64acb658-5ef9-47fe-95f7-1d492524f83a",
    Metadata: {
      BudgetExist: false,
      BudgetValue: 0,
      GroupName: "",
      Owner: "",
      PointPerson: "",
    },
    ModifiedBy: null,
    ModifiedOn: "2023-04-05 10:22:43",
    Name: "SathishSecurity",
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Preferences: null,
    Services: {
      Blueprints: [
        "0267d952-ab17-54ec-9e5b-b11af1285f4d",
        "00db3318-a5d6-419c-927c-93c724560869",
        "7b7351f1-882e-469f-9312-2993232e97fb",
        "ef83f475-d98e-46b6-bf39-3454ddb76d82",
      ],
      Other: null,
    },
    Type: null,
    Users: 27,
  },
  {
    Accounts: [
      {
        AccountName: "Locker edit",
        AccountNumber: "897930493710",
        CustomerAccountId: "af49a2b8-e2d9-488d-af94-001995e72c9b",
        OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
        Regions: [
          {
            RegionCode: "eastus",
            Status: "FAILED TO CONNECT",
          },
          {
            RegionCode: "us-east-1",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-east-2",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-west-1",
            Status: "FAILED TO CONNECT",
          },
        ],
        Status: "CONNECTED",
      },
    ],
    Applications: 0,
    CreatedBy: "5c481e4a-8fef-4c31-86ad-1579c6261aa3",
    CreatedOn: "2023-03-17 13:33:00",
    Description: "",
    ID: "c2f0036c-b597-47d3-a9cb-c441e19a7120",
    Metadata: {
      BudgetExist: false,
      BudgetValue: 0,
      GroupName: "",
      Owner: "",
      PointPerson: "",
    },
    ModifiedBy: null,
    ModifiedOn: "2023-04-05 10:22:43",
    Name: "SathishTesting",
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Preferences: null,
    Services: {
      Blueprints: [
        "08ba970e-c190-5bd5-8576-df5ac27bdf0b",
        "0267d952-ab17-54ec-9e5b-b11af1285f4d",
        "00db3318-a5d6-419c-927c-93c724560869",
        "7b7351f1-882e-469f-9312-2993232e97fb",
        "ef83f475-d98e-46b6-bf39-3454ddb76d82",
      ],
      Other: null,
    },
    Type: null,
    Users: 27,
  },
  {
    Accounts: [],
    Applications: 0,
    CreatedBy: "f510eab5-e663-43b2-bc03-ff3e8bfc1cfb",
    CreatedOn: "2023-02-20 12:52:34",
    Description:
      "Explicabo rerum nihil labore fugiat qui eos. Eos a corporis quaerat praesentium autem ut aperiam praesentium autem. Placeat praesentium non aut est non ipsum aliquid sequi.",
    ID: "52a903cd-caf3-423d-8f49-c8617f6830c1",
    Metadata: {
      BudgetExist: false,
      BudgetValue: 0,
      GroupName:
        "Provident illo explicabo maxime beatae sit inventore sed et possimus.",
      Owner: "Ottis Daugherty",
      PointPerson: "Sapiente aut nisi quo eaque dolore voluptate tempore.",
    },
    ModifiedBy: null,
    ModifiedOn: "2023-04-05 10:22:43",
    Name: "Task Schedule test",
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Preferences: null,
    Services: {
      Blueprints: [
        "0b29c85a-5947-50c5-8ab0-6c242d491ab5",
        "00db3318-a5d6-419c-927c-93c724560869",
        "7b7351f1-882e-469f-9312-2993232e97fb",
        "ef83f475-d98e-46b6-bf39-3454ddb76d82",
      ],
      Other: null,
    },
    Type: null,
    Users: 26,
  },
  {
    Accounts: [
      {
        AccountName: "Locker edit",
        AccountNumber: "897930493710",
        CustomerAccountId: "af49a2b8-e2d9-488d-af94-001995e72c9b",
        OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
        Regions: [
          {
            RegionCode: "eastus",
            Status: "FAILED TO CONNECT",
          },
          {
            RegionCode: "us-east-1",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-east-2",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-west-1",
            Status: "FAILED TO CONNECT",
          },
        ],
        Status: "CONNECTED",
      },
    ],
    Applications: 1,
    CreatedBy: "894612d3-232c-4d12-92f1-1658b5cc5c63",
    CreatedOn: "2023-03-03 08:54:20",
    Description: "",
    ID: "54b35bc5-b6e6-44b7-9d77-02192b81285c",
    Metadata: {
      BudgetExist: false,
      BudgetValue: 0,
      GroupName: "",
      Owner: "",
      PointPerson: "",
    },
    ModifiedBy: null,
    ModifiedOn: "2023-04-05 10:22:43",
    Name: "Test Project",
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Preferences: null,
    Services: {
      Blueprints: [
        "24e69f99-d5a2-5a69-a2ac-babc2d6dbdca",
        "0b29c85a-5947-50c5-8ab0-6c242d491ab5",
        "00db3318-a5d6-419c-927c-93c724560869",
        "7b7351f1-882e-469f-9312-2993232e97fb",
        "ef83f475-d98e-46b6-bf39-3454ddb76d82",
      ],
      Other: null,
    },
    Type: null,
    Users: 26,
  },
  {
    Accounts: [
      {
        AccountName: "Locker edit",
        AccountNumber: "897930493710",
        CustomerAccountId: "af49a2b8-e2d9-488d-af94-001995e72c9b",
        OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
        Regions: [
          {
            RegionCode: "eastus",
            Status: "FAILED TO CONNECT",
          },
          {
            RegionCode: "us-east-1",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-east-2",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-west-1",
            Status: "FAILED TO CONNECT",
          },
        ],
        Status: "CONNECTED",
      },
    ],
    Applications: 2,
    CreatedBy: "5c481e4a-8fef-4c31-86ad-1579c6261aa3",
    CreatedOn: "2023-03-06 12:14:04",
    Description: "test-demo",
    ID: "e9bb6592-e766-4688-bf48-06535af14130",
    Metadata: {
      BudgetExist: false,
      BudgetValue: 0,
      GroupName: "test-demo",
      Owner: "test-demo",
      PointPerson: "test-demo",
    },
    ModifiedBy: null,
    ModifiedOn: "2023-04-05 10:22:43",
    Name: "test-demo",
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Preferences: null,
    Services: {
      Blueprints: [
        "0b29c85a-5947-50c5-8ab0-6c242d491ab5",
        "00db3318-a5d6-419c-927c-93c724560869",
        "7b7351f1-882e-469f-9312-2993232e97fb",
        "ef83f475-d98e-46b6-bf39-3454ddb76d82",
      ],
      Other: null,
    },
    Type: null,
    Users: 26,
  },
  {
    Accounts: [
      {
        AccountName: "Locker edit",
        AccountNumber: "897930493710",
        CustomerAccountId: "af49a2b8-e2d9-488d-af94-001995e72c9b",
        OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
        Regions: [
          {
            RegionCode: "eastus",
            Status: "FAILED TO CONNECT",
          },
          {
            RegionCode: "us-east-1",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-east-2",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-west-1",
            Status: "FAILED TO CONNECT",
          },
        ],
        Status: "CONNECTED",
      },
    ],
    Applications: 0,
    CreatedBy: "5c481e4a-8fef-4c31-86ad-1579c6261aa3",
    CreatedOn: "2023-03-28 08:57:34",
    Description: "",
    ID: "094ca6ce-5cf7-41ca-8e52-22a9143dbcc1",
    Metadata: {
      BudgetExist: false,
      BudgetValue: 0,
      GroupName: "",
      Owner: "",
      PointPerson: "",
    },
    ModifiedBy: null,
    ModifiedOn: "2023-04-05 10:22:43",
    Name: "Test123",
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Preferences: null,
    Services: {
      Blueprints: [
        "08ba970e-c190-5bd5-8576-df5ac27bdf0b",
        "00db3318-a5d6-419c-927c-93c724560869",
        "7b7351f1-882e-469f-9312-2993232e97fb",
        "ef83f475-d98e-46b6-bf39-3454ddb76d82",
      ],
      Other: null,
    },
    Type: null,
    Users: 26,
  },
  {
    Accounts: [
      {
        AccountName: "Locker edit",
        AccountNumber: "897930493710",
        CustomerAccountId: "af49a2b8-e2d9-488d-af94-001995e72c9b",
        OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
        Regions: [
          {
            RegionCode: "eastus",
            Status: "FAILED TO CONNECT",
          },
          {
            RegionCode: "us-east-1",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-east-2",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-west-1",
            Status: "FAILED TO CONNECT",
          },
        ],
        Status: "CONNECTED",
      },
    ],
    Applications: 0,
    CreatedBy: "5c481e4a-8fef-4c31-86ad-1579c6261aa3",
    CreatedOn: "2023-03-07 13:09:22",
    Description: "",
    ID: "dc4c2518-b0fe-4af3-ac4a-a7452b151e71",
    Metadata: {
      BudgetExist: false,
      BudgetValue: 0,
      GroupName: "",
      Owner: "",
      PointPerson: "",
    },
    ModifiedBy: null,
    ModifiedOn: "2023-04-05 10:22:43",
    Name: "TestCustomProject12",
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Preferences: null,
    Services: {
      Blueprints: [
        "0b29c85a-5947-50c5-8ab0-6c242d491ab5",
        "08ba970e-c190-5bd5-8576-df5ac27bdf0b",
        "00db3318-a5d6-419c-927c-93c724560869",
        "7b7351f1-882e-469f-9312-2993232e97fb",
        "ef83f475-d98e-46b6-bf39-3454ddb76d82",
      ],
      Other: null,
    },
    Type: null,
    Users: 26,
  },
  {
    Accounts: [
      {
        AccountName: "Locker edit",
        AccountNumber: "897930493710",
        CustomerAccountId: "af49a2b8-e2d9-488d-af94-001995e72c9b",
        OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
        Regions: [
          {
            RegionCode: "eastus",
            Status: "FAILED TO CONNECT",
          },
          {
            RegionCode: "us-east-1",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-east-2",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-west-1",
            Status: "FAILED TO CONNECT",
          },
        ],
        Status: "CONNECTED",
      },
    ],
    Applications: 2,
    CreatedBy: "cef8eb95-6431-4b1d-a96a-4753315cec29",
    CreatedOn: "2023-03-03 06:28:31",
    Description: "",
    ID: "40569e5f-c7bb-4eb8-95b0-cbb2aba5619f",
    Metadata: {
      BudgetExist: false,
      BudgetValue: 0,
      GroupName: "",
      Owner: "",
      PointPerson: "",
    },
    ModifiedBy: null,
    ModifiedOn: "2023-04-05 10:22:43",
    Name: "testShravan5",
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Preferences: null,
    Services: {
      Blueprints: [
        "1341e4ff-7afe-408d-b072-ac8f1f528aaa",
        "00db3318-a5d6-419c-927c-93c724560869",
        "7b7351f1-882e-469f-9312-2993232e97fb",
        "ef83f475-d98e-46b6-bf39-3454ddb76d82",
      ],
      Other: null,
    },
    Type: null,
    Users: 28,
  },
  {
    Accounts: [],
    Applications: 0,
    CreatedBy: "08ccebd4-f4a0-4ba2-97e8-40638c9426a2",
    CreatedOn: "2023-02-01 06:14:06",
    Description: "",
    ID: "842c106e-8fab-43be-8e71-9a6ca9131189",
    Metadata: {
      BudgetExist: false,
      BudgetValue: 0,
      GroupName: "",
      Owner: "",
      PointPerson: "",
    },
    ModifiedBy: null,
    ModifiedOn: "2023-04-05 10:22:43",
    Name: "Test_Rajiv_SLU",
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Preferences: null,
    Services: {
      Blueprints: [
        "2ed84a19-39ef-56c7-9ded-2fb5ed877c6d",
        "4f87c6eb-b580-452b-827b-cfbdf6a37a8f",
        "00db3318-a5d6-419c-927c-93c724560869",
        "7b7351f1-882e-469f-9312-2993232e97fb",
        "ef83f475-d98e-46b6-bf39-3454ddb76d82",
      ],
      Other: null,
    },
    Type: null,
    Users: 26,
  },
  {
    Accounts: [
      {
        AccountName: "Locker edit",
        AccountNumber: "897930493710",
        CustomerAccountId: "af49a2b8-e2d9-488d-af94-001995e72c9b",
        OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
        Regions: [
          {
            RegionCode: "eastus",
            Status: "FAILED TO CONNECT",
          },
          {
            RegionCode: "us-east-1",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-east-2",
            Status: "CONNECTED",
          },
          {
            RegionCode: "us-west-1",
            Status: "FAILED TO CONNECT",
          },
        ],
        Status: "CONNECTED",
      },
    ],
    Applications: 3,
    CreatedBy: "08ccebd4-f4a0-4ba2-97e8-40638c9426a2",
    CreatedOn: "2023-04-03 09:48:11",
    Description: "",
    ID: "246db181-a207-4829-bd3f-572bc89306eb",
    Metadata: {
      BudgetExist: false,
      BudgetValue: 0,
      GroupName: "",
      Owner: "",
      PointPerson: "",
    },
    ModifiedBy: null,
    ModifiedOn: "2023-04-05 10:22:43",
    Name: "Yoga Bluenprint",
    OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
    Preferences: null,
    Services: {
      Blueprints: [
        "896f2af5-a09a-4bbb-a952-f0c12d72bb76",
        "0c17105c-5a9d-5888-a3a1-49886721bcaa",
        "00db3318-a5d6-419c-927c-93c724560869",
        "7b7351f1-882e-469f-9312-2993232e97fb",
        "ef83f475-d98e-46b6-bf39-3454ddb76d82",
      ],
      Other: null,
    },
    Type: null,
    Users: 26,
  },
];

//Data for New Workload

export const Workload_Pillar_Summary_MockData_Alpha = (workload, Id) => {
  return {
    LensAlias: "wellarchitected",
    LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
    LensName: "AWS Well-Architected Framework",
    LensStatus: "CURRENT",
    LensVersion: "2022-03-31",
    PillarReviewSummaries: [
      {
        PillarId: "security",
        PillarName: "Security",
        RiskCounts: {
          HIGH: 0,
          MEDIUM: 0,
          NONE: 0,
          NOT_APPLICABLE: 0,
          UNANSWERED: 10,
        },
      },
      {
        PillarId: "performance",
        PillarName: "Performance Efficiency",
        RiskCounts: {
          HIGH: 0,
          MEDIUM: 0,
          NONE: 0,
          NOT_APPLICABLE: 0,
          UNANSWERED: 8,
        },
      },
      {
        PillarId: "reliability",
        PillarName: "Reliability",
        RiskCounts: {
          HIGH: 0,
          MEDIUM: 0,
          NONE: 0,
          NOT_APPLICABLE: 0,
          UNANSWERED: 13,
        },
      },
      {
        PillarId: "costOptimization",
        PillarName: "Cost Optimization",
        RiskCounts: {
          HIGH: 0,
          MEDIUM: 0,
          NONE: 0,
          NOT_APPLICABLE: 0,
          UNANSWERED: 10,
        },
      },
      {
        PillarId: "sustainability",
        PillarName: "Sustainability",
        RiskCounts: {
          HIGH: 0,
          MEDIUM: 0,
          NONE: 0,
          NOT_APPLICABLE: 0,
          UNANSWERED: 6,
        },
      },
      {
        PillarId: "operationalExcellence",
        PillarName: "Operational Excellence",
        RiskCounts: {
          HIGH: 0,
          MEDIUM: 0,
          NONE: 0,
          NOT_APPLICABLE: 0,
          UNANSWERED: 11,
        },
      },
    ],
    RiskCounts: {
      HIGH: 0,
      MEDIUM: 0,
      NONE: 0,
      NOT_APPLICABLE: 0,
      UNANSWERED: 58,
    },
    UpdatedAt: "2023-04-03 09:36:21+00:00",
    WorkloadSummary: {
      AnsweredQuestions: 0,
      CreatedAt: "2023-04-03 09:14:19",
      Description: workload.Description,
      DiagramURL: null,
      Environment: workload.Environment,
      ImprovementStatus: "NOT_APPLICABLE",
      InSync: 1,
      Industry: null,
      IndustryType: null,
      Lenses: "AWS Well-Architected Framework",
      Owner: workload.ReviewOwner,
      RegionCode: workload.RegionCode,
      RiskCounts: {
        High: 0,
        Medium: 0,
      },
      Scope: [
        {
          AccountNumber: "897930493710",
          Regions: ["us-east-1", "us-east-2"],
        },
      ],
      Status: "PENDING",
      TotalQuestions: 58,
      UpdatedAt: "2023-04-03 09:12:56",
      WorkloadArn:
        "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
      WorkloadId: Id,
      WorkloadName: workload.WorkloadName,
    },
  };
};
